/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 123);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(130);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(144)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindModuleMethods; });
/* unused harmony export getComputedStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return classesToSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createElementIfNotDefined; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);


function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle(el) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PAGE_THREATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PAGE_OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PAGE_PRIVACY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE_LEGAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_EBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PAGE_WEBINAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_ABOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_ESTIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_PAGES; });
var PAGE_HOME='';var PAGE_THREATS='threats';var PAGE_OFFER='offer';var PAGE_CONTACT='contact';var PAGE_PRIVACY='privacy-policy';var PAGE_LEGAL='legal-notice';var PAGE_EBOOK='ebook';var PAGE_WEBINAR='webinar';var PAGE_ABOUT='about';var PAGE_ESTIMATION='estimation';var AVAILABLE_PAGES=[PAGE_HOME,PAGE_THREATS,PAGE_OFFER,PAGE_ESTIMATION,PAGE_ABOUT,PAGE_CONTACT,PAGE_PRIVACY,PAGE_LEGAL,PAGE_EBOOK,PAGE_WEBINAR];

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom7__ = __webpack_require__(410);

var Methods = {
  addClass: __WEBPACK_IMPORTED_MODULE_0_dom7__["b" /* addClass */],
  removeClass: __WEBPACK_IMPORTED_MODULE_0_dom7__["D" /* removeClass */],
  hasClass: __WEBPACK_IMPORTED_MODULE_0_dom7__["l" /* hasClass */],
  toggleClass: __WEBPACK_IMPORTED_MODULE_0_dom7__["G" /* toggleClass */],
  attr: __WEBPACK_IMPORTED_MODULE_0_dom7__["d" /* attr */],
  removeAttr: __WEBPACK_IMPORTED_MODULE_0_dom7__["C" /* removeAttr */],
  transform: __WEBPACK_IMPORTED_MODULE_0_dom7__["H" /* transform */],
  transition: __WEBPACK_IMPORTED_MODULE_0_dom7__["I" /* transition */],
  on: __WEBPACK_IMPORTED_MODULE_0_dom7__["t" /* on */],
  off: __WEBPACK_IMPORTED_MODULE_0_dom7__["r" /* off */],
  trigger: __WEBPACK_IMPORTED_MODULE_0_dom7__["K" /* trigger */],
  transitionEnd: __WEBPACK_IMPORTED_MODULE_0_dom7__["J" /* transitionEnd */],
  outerWidth: __WEBPACK_IMPORTED_MODULE_0_dom7__["v" /* outerWidth */],
  outerHeight: __WEBPACK_IMPORTED_MODULE_0_dom7__["u" /* outerHeight */],
  styles: __WEBPACK_IMPORTED_MODULE_0_dom7__["E" /* styles */],
  offset: __WEBPACK_IMPORTED_MODULE_0_dom7__["s" /* offset */],
  css: __WEBPACK_IMPORTED_MODULE_0_dom7__["g" /* css */],
  each: __WEBPACK_IMPORTED_MODULE_0_dom7__["h" /* each */],
  html: __WEBPACK_IMPORTED_MODULE_0_dom7__["m" /* html */],
  text: __WEBPACK_IMPORTED_MODULE_0_dom7__["F" /* text */],
  is: __WEBPACK_IMPORTED_MODULE_0_dom7__["o" /* is */],
  index: __WEBPACK_IMPORTED_MODULE_0_dom7__["n" /* index */],
  eq: __WEBPACK_IMPORTED_MODULE_0_dom7__["i" /* eq */],
  append: __WEBPACK_IMPORTED_MODULE_0_dom7__["c" /* append */],
  prepend: __WEBPACK_IMPORTED_MODULE_0_dom7__["y" /* prepend */],
  next: __WEBPACK_IMPORTED_MODULE_0_dom7__["p" /* next */],
  nextAll: __WEBPACK_IMPORTED_MODULE_0_dom7__["q" /* nextAll */],
  prev: __WEBPACK_IMPORTED_MODULE_0_dom7__["z" /* prev */],
  prevAll: __WEBPACK_IMPORTED_MODULE_0_dom7__["A" /* prevAll */],
  parent: __WEBPACK_IMPORTED_MODULE_0_dom7__["w" /* parent */],
  parents: __WEBPACK_IMPORTED_MODULE_0_dom7__["x" /* parents */],
  closest: __WEBPACK_IMPORTED_MODULE_0_dom7__["f" /* closest */],
  find: __WEBPACK_IMPORTED_MODULE_0_dom7__["k" /* find */],
  children: __WEBPACK_IMPORTED_MODULE_0_dom7__["e" /* children */],
  filter: __WEBPACK_IMPORTED_MODULE_0_dom7__["j" /* filter */],
  remove: __WEBPACK_IMPORTED_MODULE_0_dom7__["B" /* remove */]
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_dom7__["a" /* $ */].fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_dom7__["a" /* $ */]);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extend */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWindow; });
/* unused harmony export ssrDocument */
/* unused harmony export ssrWindow */
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}




/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(222);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* eslint-disable no-nested-ternary */var Link=function Link(_ref){var openPage=_ref.openPage,language=_ref.language,page=_ref.page,subpage=_ref.subpage,routeState=_ref.routeState,className=_ref.className,id=_ref.id,children=_ref.children,callback=_ref.callback,dangerousHTML=_ref.dangerousHTML,style=_ref.style,scroll=_ref.scroll,query=_ref.query,hash=_ref.hash;var slashedPage=page?'/'+page:'';var slashedSubpage=subpage?'/'+subpage:'';var hashWithSign=hash?'#'+hash:'';var linkClick=function linkClick(e){e.preventDefault();openPage(page,subpage,routeState,language,scroll,query,hash);if(typeof callback==='function'){callback();}};var queryString='';if(Object.keys(query).length>0){Object.keys(query).forEach(function(key){var value=query[key]?'='+query[key]:'';if(queryString===''){queryString='?'+key+value;}else{queryString=queryString+'&'+key+value;}});}var isExternal=page&&page.startsWith('http');return dangerousHTML?isExternal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:page,className:className,id:id,dangerouslySetInnerHTML:{__html:dangerousHTML},style:style,target:'_blank',rel:'noopener noreferrer'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:""+'/'+language+slashedPage+slashedSubpage+queryString+hashWithSign,className:className,id:id,onClick:linkClick,dangerouslySetInnerHTML:{__html:dangerousHTML},style:style}):isExternal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:page,className:className,id:id,style:style,target:'_blank',rel:'noopener noreferrer'},children):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:""+'/'+language+slashedPage+slashedSubpage+queryString+hashWithSign,className:className,id:id,onClick:linkClick,style:style},children);};Link.defaultProps={page:'',subpage:null,query:{},routeState:null,className:null,id:null,children:null,callback:null,dangerousHTML:null,style:null,scroll:true,hash:null};Link.propTypes={openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,query:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),routeState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,callback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,dangerousHTML:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),scroll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCMSCompany */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCmsStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companyInfoPropsType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCmsCompanyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCmsTopicList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPricings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCmsOffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCMSBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAboutContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCMSClientList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCMSEmployee; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_constants__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directusLink__ = __webpack_require__(18);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* eslint-disable */var clearNull=function clearNull(object){for(var key in object){if(object[key]===null||object[key]===undefined){delete object[key];}}return object;};var getCMSCompany=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_1_axios___default()(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items'+data_model_query);case 2:_ref2=_context.sent;data=_ref2.data;case 4:case'end':return _context.stop();}}},_callee,_this);}));return function getCMSCompany(){return _ref.apply(this,arguments);};}();var getCmsStatic=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(slug,language){var _ref4,staticPage,_data_model_query,_ref5,companyInfo,brandInfo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_1_axios___default()(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items/static_page?filter[translations][url][_eq]='+slug+'&fields=*,translations.*,brand.*,brand.brand_id.*&filter[brand][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);case 2:_ref4=_context2.sent;staticPage=_ref4.data;if(!staticPage.data[0].data_model_query){_context2.next=14;break;}_data_model_query=staticPage.data[0].data_model_query.replace(new RegExp('\\${brand}'),__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);_context2.next=8;return __WEBPACK_IMPORTED_MODULE_1_axios___default()(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items'+_data_model_query);case 8:_ref5=_context2.sent;companyInfo=_ref5.data;_context2.next=12;return getCMSBrand();case 12:brandInfo=_context2.sent;return _context2.abrupt('return',{staticPage:Object.assign({},staticPage.data[0],staticPage.data[0].translations.find(function(translation){return translation.languages_code==='en';}),clearNull(staticPage.data[0].translations.find(function(translation){return translation.languages_code===language;})),{brand_official_name:brandInfo.official_name}),companyInfo:Object.assign({},companyInfo.data[0].company_id,{brand:__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */],domain:__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]})});case 14:case'end':return _context2.stop();}}},_callee2,_this);}));return function getCmsStatic(_x,_x2){return _ref3.apply(this,arguments);};}();var companyInfoPropsType=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({phone:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,country:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,zip_code:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,town:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,street:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,full_name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,short_name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,company_registration_number:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({company:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,key:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,translations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({company_registration_number_id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,description:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,// null or string
number:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,languages_code:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}))}))});var getCmsCompanyInfo=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var link,response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:link=__WEBPACK_IMPORTED_MODULE_4__directusLink__["a" /* default */].generate('company',{fields:{'*':true,board:{'*':true,employee_profile_id:true},company_registration_number:{'*':true,translations:{'*':true}}},filter:'[brand][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]});_context3.next=3;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(link);case 3:response=_context3.sent;data=response.data.data;return _context3.abrupt('return',data[0]);case 6:case'end':return _context3.stop();}}},_callee3,_this);}));return function getCmsCompanyInfo(){return _ref6.apply(this,arguments);};}();var getCmsTopicList=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(language){var response,data,items;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items/contact_topic?fields=*,translations.*&filter[brands][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);case 2:response=_context4.sent;data=response.data.data;items=data.map(function(topic){return{id:topic.id,key:topic.key,position:topic.position,name:topic.translations.find(function(translation){return translation.languages_code===language;})?topic.translations.find(function(translation){return translation.languages_code===language;}).description||topic.translations.find(function(translation){return translation.languages_code==='en';}).description:topic.translations.find(function(translation){return translation.languages_code==='en';}).description};});return _context4.abrupt('return',items);case 6:case'end':return _context4.stop();}}},_callee4,_this);}));return function getCmsTopicList(_x3){return _ref7.apply(this,arguments);};}();var getPricings=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(language){var response,data,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items/pricing?fields=*,translations.*,brochure.file.*,brochure.translations.*,brochure.type.*,items.*,items.pricing_item_id.*,items.pricing_item_id.translations.*,items.pricing_item_id.features.*,items.pricing_item_id.features.pricing_features_id.translations.*&filter[brands][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);case 3:response=_context5.sent;data=response.data.data;result=data.map(function(pricing){return{id:pricing.id,key:pricing.key,icon:pricing.icon,translations:Object.assign({},pricing.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(pricing.translations.find(function(translation){return translation.languages_code===language;}))),items:pricing.items.map(function(pricingItem){return{id:pricingItem.id,order:pricingItem.order,translations:Object.assign({},pricingItem.pricing_item_id.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(pricingItem.pricing_item_id.translations.find(function(translation){return translation.languages_code===language;}))),features:pricingItem.pricing_item_id.features.map(function(feature){return{translations:Object.assign({},feature.pricing_features_id.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(feature.pricing_features_id.translations.find(function(translation){return translation.languages_code===language;})))};})};}),brochure:pricing.brochure?{file:pricing.brochure.file,translations:Object.assign({},pricing.brochure.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(pricing.brochure.translations.find(function(translation){return translation.languages_code===language;}))),type:pricing.brochure.type.key}:null};});return _context5.abrupt('return',result);case 9:_context5.prev=9;_context5.t0=_context5['catch'](0);console.log(_context5.t0);case 12:case'end':return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function getPricings(_x4){return _ref8.apply(this,arguments);};}();var getCmsOffer=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(language){var response,data,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items/offer?fields=*,translations.*,header.*,header.translations.*,brands.*.*,ctas.cta_id.*,ctas.cta_id.translations.*,items.offer_item_id.*,items.offer_item_id.translations.*,items.offer_item_id.ctas.cta_id.*,items.offer_item_id.ctas.cta_id.type.*,items.offer_item_id.ctas.cta_id.translations.*,items.offer_item_id.use_cases.tag_id.*,items.offer_item_id.use_cases.tag_id.translations.*&filter[brands][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);case 3:response=_context6.sent;data=response.data.data;result={header:{icon:data[0].header.icon,image:data[0].header.image,key:data[0].header.key,translations:Object.assign({},data[0].header.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(data[0].header.translations.find(function(translation){return translation.languages_code===language;})))},translations:Object.assign({},data[0].translations.find(function(translation){return translation.languages_code==='en';}),clearNull(data[0].translations.find(function(translation){return translation.languages_code===language;}))),ctas:data[0].ctas.map(function(cta){return{translations:Object.assign({},cta.cta_id.translations.find(function(translation){return translation.languages_code=='en';}),clearNull(cta.cta_id.translations.find(function(translation){return translation.languages_code==language;}))),type:cta.cta_id.type?cta.cta_id.type.key:null,file:cta.cta_id.file||null};}),items:data[0].items.map(function(item){return{icon:item.offer_item_id.icon,image:item.offer_item_id.image,key:item.offer_item_id.key,ctas:(item.offer_item_id.ctas||[]).map(function(cta){return{translations:Object.assign({},cta.cta_id.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(cta.cta_id.translations.find(function(translation){return translation.languages_code==language;}))),type:cta.cta_id.type?cta.cta_id.type.key:null,file:cta.cta_id.file,icon:cta.cta_id.icon,query:cta.cta_id.query};}),translations:Object.assign({},item.offer_item_id.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(item.offer_item_id.translations.find(function(translation){return translation.languages_code===language;}))),use_cases:item.offer_item_id.use_cases.map(function(tag){return{icon:tag.tag_id.icon,name:tag.tag_id.name,translations:Object.assign({},tag.tag_id.translations.find(function(translation){return translation.languages_code==='en';}),clearNull(tag.tag_id.translations.find(function(translation){return translation.languages_code===language;})))};})};})};return _context6.abrupt('return',result);case 9:_context6.prev=9;_context6.t0=_context6['catch'](0);console.log(_context6.t0);case 12:case'end':return _context6.stop();}}},_callee6,_this,[[0,9]]);}));return function getCmsOffer(_x5){return _ref9.apply(this,arguments);};}();var getFilterLink=function getFilterLink(_ref10){var _ref11=_slicedToArray(_ref10,2),key=_ref11[0],value=_ref11[1];var parentKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var fullKey=''+parentKey+key+'.';if(!key)return'';if(value===true)return fullKey+'*';var res=Object.entries(value).map(function(i){return getFilterLink(i,fullKey);});return res.join(',');};var getCMSBrand=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(language){var link,response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;link=__WEBPACK_IMPORTED_MODULE_4__directusLink__["a" /* default */].generate('brand',{filter:'[name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */],fields:{translations:{claim:true,languages_code:true}}});_context7.next=4;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(link);case 4:response=_context7.sent;data=response.data.data;return _context7.abrupt('return',data[0]);case 9:_context7.prev=9;_context7.t0=_context7['catch'](0);console.log(_context7.t0);case 12:case'end':return _context7.stop();}}},_callee7,_this,[[0,9]]);}));return function getCMSBrand(_x7){return _ref12.apply(this,arguments);};}();var getAboutContent=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var link,response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;link=__WEBPACK_IMPORTED_MODULE_4__directusLink__["a" /* default */].generate('brand',{filter:'[name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */],fields:{translations:{'*':true},values:{brand_value_id:{icon:true,translations:{id:true,description:true,languages_code:true,name:true}}}}});_context8.next=4;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(link);case 4:response=_context8.sent;data=response.data.data;return _context8.abrupt('return',data[0]);case 9:_context8.prev=9;_context8.t0=_context8['catch'](0);console.log(_context8.t0);case 12:case'end':return _context8.stop();}}},_callee8,_this,[[0,9]]);}));return function getAboutContent(){return _ref13.apply(this,arguments);};}();var clientsCache=[];var getCMSClientList=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;if(!(clientsCache.length>0)){_context9.next=3;break;}return _context9.abrupt('return',Promise.resolve(clientsCache));case 3:_context9.next=5;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items/client?fields=name,id,logo.id,position.number&filter[brands][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);case 5:response=_context9.sent;data=response.data.data;data.sort(function(a,b){return a.position.number-b.position.number;});clientsCache=data;return _context9.abrupt('return',data);case 12:_context9.prev=12;_context9.t0=_context9['catch'](0);throw new Error(' Failed Fetch ');case 15:case'end':return _context9.stop();}}},_callee9,this,[[0,12]]);}));return function getCMSClientList(){return _ref14.apply(this,arguments);};}();var getCMSEmployee=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;_context10.next=3;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_constants__["a" /* apiCms */]+'/items/employee_profile?fields=id,name,surname,icon,translations.position,translations.languages_code,linkedin,twitter,photo,photo2x&filter[brand][brand_id][name][_eq]='+__WEBPACK_IMPORTED_MODULE_2__config_constants__["b" /* brandName */]);case 3:response=_context10.sent;data=response.data.data;// data.sort((a, b) => a.position.number - b.position.number)
return _context10.abrupt('return',data);case 8:_context10.prev=8;_context10.t0=_context10['catch'](0);throw new Error(' Failed Fetch ');case 11:case'end':return _context10.stop();}}},_callee10,this,[[0,8]]);}));return function getCMSEmployee(){return _ref15.apply(this,arguments);};}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(74);
var isBuffer = __webpack_require__(233);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_preloader__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_social__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_about__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_offer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_estimation__ = __webpack_require__(256);
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({preloader:__WEBPACK_IMPORTED_MODULE_0__icons_preloader__["a" /* default */],social:__WEBPACK_IMPORTED_MODULE_1__icons_social__["a" /* default */],about:__WEBPACK_IMPORTED_MODULE_2__icons_about__["a" /* default */],offer:__WEBPACK_IMPORTED_MODULE_3__icons_offer__["a" /* default */],estimation:__WEBPACK_IMPORTED_MODULE_4__icons_estimation__["a" /* default */]});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(86);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(232);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FooterBottom__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_directusLink__ = __webpack_require__(18);
var getVatId=function getVatId(companyInfo,language){var vatIdItem=companyInfo&&companyInfo.company_registration_number.find(function(_ref){var key=_ref.key;return key==='vat_id';});return __WEBPACK_IMPORTED_MODULE_6__helpers_directusLink__["a" /* default */].getTranslationByLang(vatIdItem.translations,language);};var Footer=function Footer(_ref2){var t=_ref2.t,openPage=_ref2.openPage,language=_ref2.language,claim=_ref2.claim,companyInfo=_ref2.companyInfo;var vatId=companyInfo&&getVatId(companyInfo,language);var country=t('footer.headquarter.address.country');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-footer',id:'page-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-content clearfix',id:'footer-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-logo',id:'footer-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-image',id:'logo-image01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(280),alt:'Lemlock logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-text',id:'logo-text-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:claim}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact',id:'footer-contact-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-title',id:'footer-contact-title-01'},t('footer.contact.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-list',id:'footer-contact-list-01'},t('footer.contact.people').map(function(person,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-elem',id:'footer-contact-elem-01',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-avatar',id:'footer-contact-avatar-01'}, false?React.createElement('img',{src:require('../../../assets/images/footer/contact-'+(index+1)+'-avatar-64-de.jpg'),srcSet:require('../../../assets/images/footer/contact-'+(index+1)+'-avatar-64-de.jpg')+' 1x,\n                                                            '+require('../../../assets/images/footer/contact-'+(index+1)+'-avatar-128-de.jpg')+' 2x',alt:person.name+' - '+person.occupation}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(83)("./contact-"+(index+1)+'-avatar-64.jpg'),srcSet:__webpack_require__(83)("./contact-"+(index+1)+'-avatar-64.jpg')+' 1x,\n                                                            '+__webpack_require__(282)("./contact-"+(index+1)+'-avatar-128.jpg')+' 2x',alt:person.name+' - '+person.occupation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-details',id:'footer-contact-details-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-name',id:'footer-contact-name-01'},person.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-occupation',id:'footer-contact-occupation-01'},person.occupation),companyInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-text',id:'footer-contact-text-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('footer.contact.labels.mobile'),': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'tel:'+companyInfo.phone},companyInfo.phone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('footer.contact.labels.mail'),': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_5__config_pages__["c" /* PAGE_CONTACT */]},person.email))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact',id:'footer-contact-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-title',id:'footer-contact-title-02'},t('footer.headquarter.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-list',id:'footer-contact-list-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-elem',id:'footer-contact-elem-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-avatar',id:'footer-contact-avatar-02'}, false?React.createElement('img',{src:require('../../../assets/images/footer/headquarter-avatar-64-de.jpg'),srcSet:require('../../../assets/images/footer/headquarter-avatar-64-de.jpg')+' 1x,\n                                                    '+require('../../../assets/images/footer/headquarter-avatar-128-de.jpg')+' 2x',alt:t('footer.headquarter.address.company')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(84),srcSet:__webpack_require__(84)+' 1x,\n                                                    '+__webpack_require__(45)+' 2x',alt:t('footer.headquarter.address.company')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-details',id:'footer-contact-details-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-name',id:'footer-contact-name-02'},t('footer.headquarter.address.company')),companyInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-contact-text',id:'footer-contact-text-02'},companyInfo.street,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),companyInfo.zip_code+' '+companyInfo.town+(country&&', '+country),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),vatId?vatId.name+': '+vatId.number:'')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FooterBottom__["a" /* default */],{t:t,openPage:openPage,language:language}))));};Footer.defaultProps={companyInfo:null};Footer.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,claim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_3__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SentryWrapper=function(){function SentryWrapper(){_classCallCheck(this,SentryWrapper);this.isSentryLoaded=false;this.queue=[];// Dynamicznie dołącz skrypt Sentry
this.loadSentryScript();}_createClass(SentryWrapper,[{key:'loadSentryScript',value:function loadSentryScript(){var _this=this;var script=document.createElement('script');script.src='https://js.sentry-cdn.com/d9baef4f8fb01ff41c94776a9a5eaec4.min.js';script.crossOrigin='anonymous';script.async=true;script.defer=true;script.onload=function(){_this.isSentryLoaded=true;window.Sentry.onLoad(function(){window.Sentry.init({});_this.processQueue();});};document.head.appendChild(script);}},{key:'captureException',value:function captureException(exception){if(this.isSentryLoaded){window.Sentry.captureException(exception,{level:'error'});}else{this.queue.push(function(){return window.Sentry.captureException(exception,{level:'error'});});}}},{key:'setTag',value:function setTag(key,value){if(this.isSentryLoaded){window.Sentry.setTag(key,value);}else{this.queue.push(function(){return window.Sentry.setTag(key,value);});}}},{key:'processQueue',value:function processQueue(){while(this.queue.length>0){var action=this.queue.shift();action();}}}]);return SentryWrapper;}();var Sentry=new SentryWrapper();/* harmony default export */ __webpack_exports__["a"] = (Sentry);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__(82);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// eslint-disable-next-line prefer-destructuring
var DEFAULT_LANG="en";var Directus=function(){function Directus(){_classCallCheck(this,Directus);}_createClass(Directus,null,[{key:'generate',value:function generate(collection,options){var link=__WEBPACK_IMPORTED_MODULE_0__config_constants__["a" /* apiCms */]+'/items/'+collection;if(!options)return link;var filter=options.filter,fields=options.fields;var fieldsLink=fields?Object.entries(fields).map(function(field){return Directus.getFilterLink(field);}).join(','):'';if(!filter)return link+'?fields='+fieldsLink;if(!fields)return link+'?filter='+filter;return link+'?fields='+fieldsLink+'&filter'+filter;}}]);return Directus;}();Directus.getLinkImage=function(id){var extention=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return "https://directus.sagiton.pl"+'/assets/'+id+extention;};Directus.getFilterLink=function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];var parentKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if(!key)return'';if(value===true){return''+parentKey+(key==='*'?'*':''+key);}var fullKey=''+parentKey+key+'.';var res=Object.entries(value).map(function(i){return Directus.getFilterLink(i,fullKey);});return res.join(',');};Directus.getTranslationByLang=function(items,// directun translation items with languages_code property
language,requireds// arrya of strings with required fields name(there are cases that we have item with particular language, but without all required fields)
){var finded=items.find(function(i){return i.languages_code===language;});if(finded&&!requireds)return finded;var returnDefault=function returnDefault(){return items.find(function(i){return i.languages_code===DEFAULT_LANG;})||items[0];};if(finded&&Array.isArray(requireds)&&requireds.length){var hasAll=!requireds.find(function(property){return!finded[property];});return hasAll?finded:returnDefault();}return returnDefault();};/* harmony default export */ __webpack_exports__["a"] = (Directus);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(302),
    getValue = __webpack_require__(307);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ConsentPopup__ = __webpack_require__(272);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Consent=function(_Component){_inherits(Consent,_Component);function Consent(){_classCallCheck(this,Consent);var _this=_possibleConstructorReturn(this,(Consent.__proto__||Object.getPrototypeOf(Consent)).call(this));_this.state={popupOpen:false};_this.handleOpen=_this.handleOpen.bind(_this);_this.handleClose=_this.handleClose.bind(_this);return _this;}_createClass(Consent,[{key:'handleOpen',value:function handleOpen(e){e.preventDefault();this.setState({popupOpen:true});}},{key:'handleClose',value:function handleClose(e){e.preventDefault();this.setState({popupOpen:false});}},{key:'render',value:function render(){var _props=this.props,title=_props.title,t=_props.t,content=_props.content,linkColor=_props.linkColor,required=_props.required;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rodo-triggers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('rodo-trigger',{notblue:linkColor})},required&&'*',title.substring(0,title.indexOf('<a>')),'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{onClick:this.handleOpen,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('rodo-trigger active',{notblue:linkColor})},title.split('<a>').pop().split('</a>')[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('rodo-trigger',{notblue:linkColor})},title.substring(title.indexOf('</a>')+4))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ConsentPopup__["a" /* default */],{t:t,content:content,open:this.state.popupOpen,handleClose:this.handleClose}));}}]);return Consent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Consent.defaultProps={linkColor:null,required:false,title:'asd <a>asds</a>'};Consent.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,linkColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Consent);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export execute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_recaptcha__ = __webpack_require__(274);
var _this=this;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var hl={pl:'pl',en:'en',de:'de'};var execute=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(reCaptchaRef,formType){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(reCaptchaRef.current.props.grecaptcha){_context2.next=2;break;}return _context2.abrupt('return',new Promise(function(res){reCaptchaRef.current.props.ready(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.t0=res;_context.next=3;return execute(reCaptchaRef,formType);case 3:_context.t1=_context.sent;(0,_context.t0)(_context.t1);case 5:case'end':return _context.stop();}}},_callee,_this);})));}));case 2:return _context2.abrupt('return',reCaptchaRef.current.props.grecaptcha.execute(formType));case 3:case'end':return _context2.stop();}}},_callee2,_this);}));return function execute(_x,_x2){return _ref.apply(this,arguments);};}();var Recaptcha=Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function(_ref3,ref){var language=_ref3.language,props=_objectWithoutProperties(_ref3,['language']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_recaptcha__["a" /* default */],Object.assign({size:'invisible',sitekey:"6LeQNW8qAAAAAEgHDTp0iRlMeOxJQkAVKYMpINme",hl:hl[language]||hl.en},props,{ref:ref}));});/* harmony default export */ __webpack_exports__["a"] = (Recaptcha);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return needsNavigation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return needsPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return needsScrollbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return uniqueClasses; });
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}



/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ClarityService=function(){function ClarityService(){_classCallCheck(this,ClarityService);}_createClass(ClarityService,null,[{key:'getProjectId',value:function getProjectId(){if(window.clarity)return "jcyyg9ki6v"||'';return'';}},{key:'setCustomAttributes',value:function setCustomAttributes(path){var sessionId=sessionStorage.getItem('session_id');if(window.clarity){window.clarity('identify',__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('correlation_id'),sessionId,path);}}},{key:'setCorrelationId',value:function setCorrelationId(response){return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('correlation_id',response.headers['correlation-id'],{expires:365});}}]);return ClarityService;}();/* harmony default export */ __webpack_exports__["a"] = (ClarityService);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    getRawTag = __webpack_require__(303),
    objectToString = __webpack_require__(304);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(13);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(131);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(151)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(42);
var hasOwn = __webpack_require__(63);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(292),
    listCacheDelete = __webpack_require__(293),
    listCacheGet = __webpack_require__(294),
    listCacheHas = __webpack_require__(295),
    listCacheSet = __webpack_require__(296);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(47);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(316);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(88),
    baseAssignValue = __webpack_require__(89);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(90),
    baseKeys = __webpack_require__(327),
    isArrayLike = __webpack_require__(95);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(338),
    Map = __webpack_require__(48),
    Promise = __webpack_require__(339),
    Set = __webpack_require__(340),
    WeakMap = __webpack_require__(341),
    baseGetTag = __webpack_require__(26),
    toSource = __webpack_require__(87);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__esm_components_core_core_class__ = __webpack_require__(409);
/* unused harmony reexport Swiper */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__esm_components_core_core_class__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__esm_components_virtual_virtual__ = __webpack_require__(476);
/* unused harmony reexport Virtual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__esm_components_keyboard_keyboard__ = __webpack_require__(477);
/* unused harmony reexport Keyboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__esm_components_mousewheel_mousewheel__ = __webpack_require__(478);
/* unused harmony reexport Mousewheel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__esm_components_navigation_navigation__ = __webpack_require__(479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__esm_components_navigation_navigation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__esm_components_pagination_pagination__ = __webpack_require__(480);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__esm_components_scrollbar_scrollbar__ = __webpack_require__(481);
/* unused harmony reexport Scrollbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__esm_components_parallax_parallax__ = __webpack_require__(482);
/* unused harmony reexport Parallax */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__esm_components_zoom_zoom__ = __webpack_require__(483);
/* unused harmony reexport Zoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__esm_components_lazy_lazy__ = __webpack_require__(484);
/* unused harmony reexport Lazy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__esm_components_controller_controller__ = __webpack_require__(485);
/* unused harmony reexport Controller */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__esm_components_a11y_a11y__ = __webpack_require__(486);
/* unused harmony reexport A11y */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__esm_components_history_history__ = __webpack_require__(487);
/* unused harmony reexport History */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__esm_components_hash_navigation_hash_navigation__ = __webpack_require__(488);
/* unused harmony reexport HashNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__esm_components_autoplay_autoplay__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__esm_components_autoplay_autoplay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__esm_components_effect_fade_effect_fade__ = __webpack_require__(490);
/* unused harmony reexport EffectFade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__esm_components_effect_cube_effect_cube__ = __webpack_require__(491);
/* unused harmony reexport EffectCube */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__esm_components_effect_flip_effect_flip__ = __webpack_require__(492);
/* unused harmony reexport EffectFlip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__esm_components_effect_coverflow_effect_coverflow__ = __webpack_require__(493);
/* unused harmony reexport EffectCoverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__esm_components_thumbs_thumbs__ = __webpack_require__(494);
/* unused harmony reexport Thumbs */
/**
 * Swiper 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */






















/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(38);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(149);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(11);
var normalizeHeaderName = __webpack_require__(236);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(75);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(75);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Consent__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_clarity__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Recaptcha__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_sentry__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable camelcase *//* eslint-disable max-len */var Form=function(_Component){_inherits(Form,_Component);function Form(props){_classCallCheck(this,Form);var _this=_possibleConstructorReturn(this,(Form.__proto__||Object.getPrototypeOf(Form)).call(this,props));_this.state={formType:'LemlockContactForm',email:'',phone:'',agreement_rodo:false,agreement_data:false,errorEmail:false,errorPhone:false,erroragreement_rodo:false,erroragreement_data:false,responseType:null,errorType:null,sending:false};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleRecaptchaError=_this.handleRecaptchaError.bind(_this);_this.handleServerError=_this.handleServerError.bind(_this);_this.reCaptchaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();return _this;}_createClass(Form,[{key:'handleRecaptchaError',value:function handleRecaptchaError(){this.setState({responseType:'error',errorType:'recaptcha_error'});}},{key:'handleServerError',value:function handleServerError(){this.setState({responseType:'error',errorType:'server_error'});}},{key:'handleChange',value:function handleChange(e){switch(e.target.type){case'checkbox':{this.setState(_defineProperty({},e.target.name,e.target.checked));break;}default:{this.setState(_defineProperty({},e.target.name,e.target.value));break;}}}},{key:'handleSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _this2=this;var params,_props,language,formName,_state,email,phone,agreement_rodo,agreement_data,errorAll,emailRegExp,errorEmail,errorPhone,erroragreement_rodo,erroragreement_data,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();params={};if(window.location.search!==''){params=JSON.parse('{"'+decodeURI(window.location.search.substring(1)).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');}_props=this.props,language=_props.language,formName=_props.formName;_state=this.state,email=_state.email,phone=_state.phone,agreement_rodo=_state.agreement_rodo,agreement_data=_state.agreement_data;errorAll=false;emailRegExp=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;// eslint-disable-line max-len
errorEmail=!emailRegExp.test(email);this.setState({errorEmail:errorEmail});errorAll=errorAll||errorEmail;errorPhone=phone==='';this.setState({errorPhone:errorPhone});errorAll=errorAll||errorPhone;erroragreement_rodo=!agreement_rodo;this.setState({erroragreement_rodo:erroragreement_rodo});errorAll=errorAll||erroragreement_rodo;erroragreement_data=!agreement_data;this.setState({erroragreement_data:erroragreement_data});errorAll=errorAll||erroragreement_data;token='';if(!(errorAll===false&&this.state.sending===false)){_context.next=24;break;}_context.next=23;return this.reCaptchaRef.current.executeAsync();case 23:token=_context.sent;case 24:if(errorAll===false&&this.state.sending===false&&token!==''){this.setState({sending:true},function(){__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:Object.assign({form_name:'Krótki formularz wyceny',type:_this2.state.formType,email:email.substring(0,100),phone:phone.substring(0,20),agreement_rodo:agreement_rodo,agreement_data:agreement_data,language:language,formName:formName,clarity_project_id:__WEBPACK_IMPORTED_MODULE_6__helpers_clarity__["a" /* default */].getProjectId(),recaptcha:token,referrer:document.referrer,session_id:sessionStorage.getItem('session_id')},params),headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){__WEBPACK_IMPORTED_MODULE_6__helpers_clarity__["a" /* default */].setCorrelationId(response);__WEBPACK_IMPORTED_MODULE_6__helpers_clarity__["a" /* default */].setCustomAttributes(window.location.pathname);if(response.data&&response.data.success){_this2.setState({email:'',phone:'',agreement_rodo:false,agreement_data:false,errorEmail:false,errorPhone:false,erroragreement_rodo:false,erroragreement_data:false,responseType:'success',errorType:null});}else{_this2.setState({errorEmail:!!response.data.error_email,errorPhone:!!response.data.error_phone,erroragreement_rodo:!!response.data.error_agreement_rodo,erroragreement_data:!!response.data.error_agreement_data,responseType:'error',errorType:response.data.error});}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_8__lib_sentry__["a" /* default */].captureException(err);var response=err.response;if(response.data.error==='RECAPTCHA_LOW_SCORE'||'RECAPTCHA_VALIDATION_ERROR'){_this2.handleRecaptchaError();}else{_this2.handleServerError();}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{form_info:JSON.stringify(Object.assign({form_name:'Krótki formularz wyceny',type:_this2.state.formType,email:email.substring(0,100),phone:phone.substring(0,20),agreement_rodo:agreement_rodo,agreement_data:agreement_data,language:language,formName:formName,recaptcha:token,referrer:document.referrer},params))},headers:{'X-Requested-With':'XMLHttpRequest'}});}).finally(function(){_this2.setState({sending:false});if(_this2.reCaptchaRef)_this2.reCaptchaRef.current.reset();});});}else{this.setState({responseType:'error',errorType:'general_error'});}case 25:case'end':return _context.stop();}}},_callee,this);}));function handleSubmit(_x){return _ref.apply(this,arguments);}return handleSubmit;}()},{key:'render',value:function render(){var _state2=this.state,responseType=_state2.responseType,errorType=_state2.errorType,agreement_rodo=_state2.agreement_rodo,agreement_data=_state2.agreement_data;var _props2=this.props,type=_props2.type,typeButton=_props2.typeButton,t=_props2.t,formName=_props2.formName,linkColor=_props2.linkColor,breakpoint=_props2.breakpoint,consents=_props2.consents,language=_props2.language;var formClassName=__WEBPACK_IMPORTED_MODULE_4_classnames___default()('container-form',{'container-form-bottom':type==='bottom'});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:formClassName,id:'container-form-'+type},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{method:'post',action:'',acceptCharset:'utf-8',className:'page-form',onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-title',id:'page-form-title',dangerouslySetInnerHTML:{__html:t('form.title.'+type)}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-fieldset',id:'page-form-fieldset'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:'page-form-input-email-1-'+formName,type:'email',name:'email',value:this.state.email,placeholder:t('form.placeholder.email'),className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:this.state.errorEmail}),onChange:this.handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:'page-form-input-phone-1-'+formName,type:'tel',name:'phone',value:this.state.phone,placeholder:t('form.placeholder.phone'),className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:this.state.errorPhone}),onChange:this.handleChange,maxLength:20})),breakpoint!=='phone'&&(errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-button',id:'contact-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'contact-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('form.button.refresh'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-button',id:'contact-form-button-submit-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:this.state.sending||this.state.responseType==='success',type:'submit',id:'page-form-button-button-'+formName},t('form.button.'+typeButton))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-checkboxes'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-checkbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_data',id:'page-form-checkbox-data-'+formName,checked:agreement_data,onChange:this.handleChange,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('checkbox-input',{error:this.state.erroragreement_data})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'page-form-checkbox-data-'+formName,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('checkbox-label',{error:this.state.erroragreement_data})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.contact.text,title:consents.contact.label,linkColor:linkColor})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-checkbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_rodo',id:'page-form-checkbox-rodo-'+formName,checked:agreement_rodo,onChange:this.handleChange,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('checkbox-input',{error:this.state.erroragreement_rodo})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'page-form-checkbox-rodo-'+formName,className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('checkbox-label',{error:this.state.erroragreement_rodo})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.rodo.text,title:consents.rodo.label,linkColor:linkColor}))),breakpoint==='phone'&&(errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-button',id:'contact-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'contact-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('form.button.refresh'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-form-button',id:'contact-form-button-submit-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:this.state.sending||this.state.responseType==='success',type:'submit',id:'page-form-button-button-'+formName},t('form.button.'+typeButton))))),responseType&&(responseType==='success'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('page-form-message',responseType),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('page-form-message',responseType)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+responseType))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('page-form-message','error'),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('page-form-message','error')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+errorType)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Recaptcha__["a" /* default */],{ref:this.reCaptchaRef,language:language}))));}}]);return Form;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Form.defaultProps={typeButton:null,linkColor:null,breakpoint:null};Form.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,typeButton:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,formName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,linkColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,breakpoint:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(30),
    stackClear = __webpack_require__(297),
    stackDelete = __webpack_require__(298),
    stackGet = __webpack_require__(299),
    stackHas = __webpack_require__(300),
    stackSet = __webpack_require__(301);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(308),
    mapCacheDelete = __webpack_require__(315),
    mapCacheGet = __webpack_require__(317),
    mapCacheHas = __webpack_require__(318),
    mapCacheSet = __webpack_require__(319);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(13),
    stubFalse = __webpack_require__(325);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module)))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(86);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module)))

/***/ }),
/* 55 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(335),
    stubArray = __webpack_require__(97);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(103);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var List=function List(_ref){var data=_ref.data,listType=_ref.listType;if(listType==='ol'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{id:'list-ol'},data.map(function(elem){return Array.isArray(elem)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,{data:elem,key:elem,listType:listType}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:elem,dangerouslySetInnerHTML:{__html:elem}});}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'list-ul'},data.map(function(elem){return Array.isArray(elem)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,{data:elem,key:elem,listType:listType}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:elem,dangerouslySetInnerHTML:{__html:elem}});}));};List.defaultProps={listType:'ul'};List.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,listType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(38);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(126);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(42);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(42);
var GetIntrinsic = __webpack_require__(29);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(153);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(155);
var ToString = __webpack_require__(157);
var callBound = __webpack_require__(158);
var $replace = callBound('String.prototype.replace');

/* eslint-disable no-control-regex */
var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */

module.exports = function trim() {
	var S = ToString(RequireObjectCoercible(this));
	return $replace($replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(67);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LANG_PL */
/* unused harmony export LANG_EN */
/* unused harmony export LANG_DE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_LANGUAGES; });
/* eslint-disable */var LANG_PL='pl';var LANG_EN='en';var LANG_DE='de';var AVAILABLE_LANGUAGES=eval("['pl','en','de']");

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(71);

var _PropTypes = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(71);

var _ChildMapping = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var settle = __webpack_require__(237);
var buildURL = __webpack_require__(239);
var parseHeaders = __webpack_require__(240);
var isURLSameOrigin = __webpack_require__(241);
var createError = __webpack_require__(76);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(242);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(243);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(238);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBottom__ = __webpack_require__(80);
var FooterSmall=function FooterSmall(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,type=_ref.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-footer-small',type),id:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-footer-small',type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FooterBottom__["a" /* default */],{t:t,openPage:openPage,language:language})));};FooterSmall.defaultProps={type:'general'};FooterSmall.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (FooterSmall);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Link__ = __webpack_require__(8);
var FooterBottom=function FooterBottom(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-bottom',id:'footer-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'copyright',id:'copyright',dangerouslySetInnerHTML:{__html:t('footer.copyright')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pipe',id:'pipe-01'},' | '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_2__config_pages__["i" /* PAGE_PRIVACY */],id:'footer-link-privacy'},t('footer.privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pipe',id:'pipe-02'},' | '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_2__config_pages__["g" /* PAGE_LEGAL */],id:'footer-link-legal'},t('footer.legal')));};FooterBottom.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FooterBottom);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReCAPTCHA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _excluded = ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);
  function ReCAPTCHA() {
    var _this;
    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ReCAPTCHA.prototype;
  _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
    if (this.props.grecaptcha) {
      if (this.props.grecaptcha.enterprise) {
        return this.props.grecaptcha.enterprise[fnName];
      }
      return this.props.grecaptcha[fnName];
    }
    return null;
  };
  _proto.getValue = function getValue() {
    var getResponse = this.getCaptchaFunction("getResponse");
    if (getResponse && this._widgetId !== undefined) {
      return getResponse(this._widgetId);
    }
    return null;
  };
  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }
    return null;
  };
  _proto.execute = function execute() {
    var execute = this.getCaptchaFunction("execute");
    if (execute && this._widgetId !== undefined) {
      return execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };
  _proto.executeAsync = function executeAsync() {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;
      _this2.execute();
    });
  };
  _proto.reset = function reset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter && this._widgetId !== undefined) {
      resetter(this._widgetId);
    }
  };
  _proto.forceReset = function forceReset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter) {
      resetter();
    }
  };
  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };
  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }
    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };
  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }
    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };
  _proto.explicitRender = function explicitRender() {
    var render = this.getCaptchaFunction("render");
    if (render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      });
      this.captcha.appendChild(wrapper);
    }
    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };
  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };
  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
      sitekey = _this$props.sitekey,
      onChange = _this$props.onChange,
      theme = _this$props.theme,
      type = _this$props.type,
      tabindex = _this$props.tabindex,
      onExpired = _this$props.onExpired,
      onErrored = _this$props.onErrored,
      size = _this$props.size,
      stoken = _this$props.stoken,
      grecaptcha = _this$props.grecaptcha,
      badge = _this$props.badge,
      hl = _this$props.hl,
      isolated = _this$props.isolated,
      childProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    /* eslint-enable no-unused-vars */
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };
  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onErrored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return brandName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiCms; });
var brandName="lemlock.com";var apiCms="https://directus.sagiton.pl";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./contact-1-avatar-64.jpg": 281
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObject = __webpack_require__(20);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89),
    eq = __webpack_require__(47);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(321);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(323),
    isArguments = __webpack_require__(91),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(50),
    isIndex = __webpack_require__(92),
    isTypedArray = __webpack_require__(93);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(324),
    isObjectLike = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(326),
    baseUnary = __webpack_require__(53),
    nodeUtil = __webpack_require__(54);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(85),
    isLength = __webpack_require__(52);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(90),
    baseKeysIn = __webpack_require__(330),
    isArrayLike = __webpack_require__(95);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(99),
    getPrototype = __webpack_require__(100),
    getSymbols = __webpack_require__(56),
    stubArray = __webpack_require__(97);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(94);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(102),
    getSymbols = __webpack_require__(56),
    keys = __webpack_require__(35);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(99),
    isArray = __webpack_require__(14);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(13);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__List__ = __webpack_require__(58);
var Text=function Text(_ref){var data=_ref.data,className=_ref.className,listType=_ref.listType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,id:'text-container'},data.map(function(elem,index){return Array.isArray(elem)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__List__["a" /* default */],{data:elem,key:index,listType:listType}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:index,dangerouslySetInnerHTML:{__html:elem}});}));};Text.defaultProps={className:null,listType:'ul'};Text.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)])).isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,listType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-1.600cf087.svg";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-2.1c88da04.svg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-3.91721b22.svg";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg.ccc03eba.svg";

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);

var support;

function calcSupport() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}



/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paramsList; });
/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(callback, deps);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(callback, deps);
}



/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ContactDropdown=function ContactDropdown(_ref){var topic=_ref.topic,topics=_ref.topics,setSelectedTopic=_ref.setSelectedTopic,error=_ref.error,t=_ref.t;var wrapperRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),dropdownOpen=_useState2[0],setDropdownOpen=_useState2[1];var toggleDropdownOpen=function toggleDropdownOpen(){setDropdownOpen(!dropdownOpen);};var selectTopic=function selectTopic(index){setDropdownOpen(false);setSelectedTopic(index);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){function handleClickOutside(event){if(wrapperRef.current&&!wrapperRef.current.contains(event.target)){setDropdownOpen(false);}}document.addEventListener('mousedown',handleClickOutside);return function(){document.removeEventListener('mousedown',handleClickOutside);};},[wrapperRef]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'selected_topic',name:'selected_topic',value:topic>-1?topics[topic].name:'Wybierz temat',hidden:true,readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-content '+(error?'error':''),ref:wrapperRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-label',onClick:function onClick(){return toggleDropdownOpen(true);}},(topic>-1?topics[topic].name:t('contact.form.placeholder.topic'))+' '+(topic===-1?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'dropdown-list '+(dropdownOpen?'open':'closed')},topics&&topics.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'dropdown-item',key:item.id,onClick:function onClick(){return selectTopic(index);}},item.name);}))));};ContactDropdown.propTypes={topic:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,topics:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(Object).isRequired,setSelectedTopic:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactDropdown);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(515),
    baseIteratee = __webpack_require__(516),
    toInteger = __webpack_require__(545);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(519),
    isObjectLike = __webpack_require__(21);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(520),
    arraySome = __webpack_require__(523),
    cacheHas = __webpack_require__(524);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(119),
    toKey = __webpack_require__(39);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(14),
    isKey = __webpack_require__(59),
    stringToPath = __webpack_require__(532),
    toString = __webpack_require__(535);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return regexContent; });
/* eslint-disable */var regexContent=function regexContent(data,language){var registration_numbers_keys=data.companyInfo.company_registration_number.flatMap(function(data){return[data.key,data.key+"_desc"];});var registration_numbers_data=data.companyInfo.company_registration_number.flatMap(function(data){return[data.translations.find(function(translation){return translation.languages_code===language;}).number,data.translations.find(function(translation){return translation.languages_code===language;}).description];});var registration_numbers={};registration_numbers_keys.forEach(function(key,data){return registration_numbers[key]=registration_numbers_data[data];});var companyInfo=Object.assign({},data.staticPage,data.companyInfo,registration_numbers,{board:data.companyInfo.board.map(function(item){return item.employee_profile_id;}).map(function(profile){return profile.name+" "+profile.surname;}).join(", ")});var companyInfoKeys=Object.keys(companyInfo).map(function(item){return"{"+item+"}";});var newRegex=new RegExp(companyInfoKeys.map(function(item){return"\\$"+item;}).join("|"),"gi");Object.keys(data.staticPage).forEach(function(key){if(typeof data.staticPage[key]==="string"){data.staticPage[key]=data.staticPage[key].replace(newRegex,function(matched){return companyInfo[matched.substring(2,matched.length-1)];});}});return data.staticPage;};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clutch-desktop.e47878f1.png";

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToElement; });
/* eslint-disable */var scrollToElement=function scrollToElement(id){var element=document.getElementById(id);element.scrollIntoView({block:'start',inline:'nearest',behavior:'smooth'});};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124);
module.exports = __webpack_require__(129);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(125).enable();
  window.Promise = __webpack_require__(127);
}

// fetch() polyfill for making API calls.
__webpack_require__(128);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(40);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(60);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(60);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_index_scss__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(143);
// import { init } from '@sentry/react';
// init({
//     dsn: 'https://9dd6548f721e41cc8fc470addf4250fe@o1261391.ingest.us.sentry.io/4504882623545344',
//     integrations: []
// });
var history=__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */],{history:history}),document.getElementById('root'));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(40),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(40),r=__webpack_require__(132);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(133);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(135);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(136);

var _PathUtils = __webpack_require__(62);

var _createTransitionManager = __webpack_require__(139);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(137);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(138);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg@2x.2f5b15a3.jpg";

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_polyglot__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_languages__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(221);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
var parsePathname=function parsePathname(location){var fullPathname=location.pathname;var basename="";var appPathname=basename?fullPathname.replace(basename,''):fullPathname;var pathParts=appPathname.split('/').slice(1);var language=__WEBPACK_IMPORTED_MODULE_4__config_languages__["a" /* AVAILABLE_LANGUAGES */].indexOf(pathParts[0])!==-1?pathParts[0]:"en";var page=__WEBPACK_IMPORTED_MODULE_5__config_pages__["a" /* AVAILABLE_PAGES */].indexOf(pathParts[1])!==-1?pathParts[1]:__WEBPACK_IMPORTED_MODULE_5__config_pages__["f" /* PAGE_HOME */];var subpage=pathParts[2]?pathParts[2]:null;var queryString=location.search[0]==='?'?location.search.substr(1):location.search;var queryPairs=queryString.split('&');var query={};queryPairs.forEach(function(pair){var pairArray=pair.split('=');var key=decodeURIComponent(pairArray[0]);var value=decodeURIComponent(pairArray[1]||'');if(key||value){query[key]=value;}});var hash=window.location.hash.replace('#','');return{language:language,page:page,subpage:subpage,query:query,hash:hash};};var Router=function(_Component){_inherits(Router,_Component);function Router(props){_classCallCheck(this,Router);var _this=_possibleConstructorReturn(this,(Router.__proto__||Object.getPrototypeOf(Router)).call(this,props));_this.state={language:"en",page:__WEBPACK_IMPORTED_MODULE_5__config_pages__["f" /* PAGE_HOME */],subpage:null,query:{},routeState:null,firstLoad:true,hash:null};_this.init=_this.init.bind(_this);_this.openPage=_this.openPage.bind(_this);_this.updateUrl=_this.updateUrl.bind(_this);_this.historyListen=_this.historyListen.bind(_this);_this.translate=_this.translate.bind(_this);_this.historyUnlisten=null;_this.polyglot=new __WEBPACK_IMPORTED_MODULE_3__lib_polyglot___default.a();return _this;}_createClass(Router,[{key:'componentWillMount',value:function componentWillMount(){this.init();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.historyUnlisten();}},{key:'init',value:function init(){var history=this.props.history;var _parsePathname=parsePathname(history.location),language=_parsePathname.language,page=_parsePathname.page,subpage=_parsePathname.subpage,query=_parsePathname.query,hash=_parsePathname.hash;this.polyglot.replace(__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */][language]);this.setState({language:language,page:page,subpage:subpage,query:query,hash:hash});// , this.updateUrl);
this.historyUnlisten=history.listen(this.historyListen);}},{key:'historyListen',value:function historyListen(location,action){if(action==='POP'){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('html, body').scrollTop(0);},400);var _parsePathname2=parsePathname(location),language=_parsePathname2.language,page=_parsePathname2.page,subpage=_parsePathname2.subpage,query=_parsePathname2.query,hash=_parsePathname2.hash;if(language!==this.state.language){this.polyglot.replace(__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */][language]);}this.setState({language:language,page:page,subpage:subpage,query:query,hash:hash,routeState:null,firstLoad:false});}}},{key:'openPage',value:function openPage(page){var subpage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var routeState=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var language=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var scroll=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;var query=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};var hash=arguments[6];if(scroll&&__WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).scrollTop()>0){if(page===this.state.page){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').animate({scrollTop:0},400);}else{setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('html, body').scrollTop(0);},400);}}if(language!==null&&__WEBPACK_IMPORTED_MODULE_4__config_languages__["a" /* AVAILABLE_LANGUAGES */].indexOf(language)!==-1){if(language!==this.state.language){this.polyglot.replace(__WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */][language]);}this.setState({language:language,page:page,subpage:subpage,query:query,routeState:routeState,firstLoad:false,hash:hash},this.updateUrl);}else{this.setState({page:page,subpage:subpage,query:query,routeState:routeState,firstLoad:false,hash:hash},this.updateUrl);}}},{key:'updateUrl',value:function updateUrl(){var _props$history=this.props.history,push=_props$history.push,replace=_props$history.replace;var _state=this.state,language=_state.language,page=_state.page,subpage=_state.subpage,query=_state.query,firstLoad=_state.firstLoad,hash=_state.hash;var slashedPage=page?'/'+page:__WEBPACK_IMPORTED_MODULE_5__config_pages__["f" /* PAGE_HOME */];var slashedSubpage=subpage?'/'+subpage:'';var hashWithSign=hash?'#'+hash:'';var queryString='';if(Object.keys(query).length>0){Object.keys(query).forEach(function(key){var value=query[key]?'='+query[key]:'';if(queryString===''){queryString='?'+key+value;}else{queryString=queryString+'&'+key+value;}});}if(firstLoad){replace(""+'/'+language+slashedPage+slashedSubpage+queryString+hashWithSign);}else{push(""+'/'+language+slashedPage+slashedSubpage+queryString+hashWithSign);}}},{key:'translate',value:function translate(key){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return this.polyglot.t(key,options);}},{key:'render',value:function render(){var _state2=this.state,language=_state2.language,page=_state2.page,subpage=_state2.subpage,query=_state2.query,firstLoad=_state2.firstLoad,routeState=_state2.routeState,hash=_state2.hash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],{language:language,page:page,subpage:subpage,query:query,routeState:routeState,firstLoad:firstLoad,openPage:this.openPage,hash:hash,t:this.translate});}}]);return Router;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Router.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(145);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* eslint-disable *//*
    Piotr Bochniak
    - changed Polyglot.prototype.t to support Arrays
    - changed Polyglot.prototype.extend to support Arrays
*///     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//
var forEach=__webpack_require__(147);var warning=__webpack_require__(41);var has=__webpack_require__(63);var trim=__webpack_require__(150);var warn=function warn(message){warning(false,message);};var replace=String.prototype.replace;var split=String.prototype.split;// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter='||||';// Mapping from pluralization group plural logic.
var pluralTypes={arabic:function arabic(n){// http://www.arabeyes.org/Plural_Forms
if(n<3){return n;}if(n%100>=3&&n%100<=10)return 3;return n%100>=11?4:5;},chinese:function chinese(){return 0;},german:function german(n){return n!==1?1:0;},french:function french(n){return n>1?1:0;},russian:function russian(n){if(n%10===1&&n%100!==11){return 0;}return n%10>=2&&n%10<=4&&(n%100<10||n%100>=20)?1:2;},czech:function czech(n){if(n===1){return 0;}return n>=2&&n<=4?1:2;},polish:function polish(n){if(n===1){return 0;}return n%10>=2&&n%10<=4&&(n%100<10||n%100>=20)?1:2;},icelandic:function icelandic(n){return n%10!==1||n%100===11?1:0;}};// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages={arabic:['ar'],chinese:['fa','id','ja','ko','lo','ms','th','tr','zh'],german:['da','de','en','es','fi','el','he','hu','it','nl','no','pt','sv'],french:['fr','tl','pt-br'],russian:['hr','ru','lt'],czech:['cs','sk'],polish:['pl'],icelandic:['is']};function langToTypeMap(mapping){var ret={};forEach(mapping,function(langs,type){forEach(langs,function(lang){ret[lang]=type;});});return ret;}function pluralTypeName(locale){var langToPluralType=langToTypeMap(pluralTypeToLanguages);return langToPluralType[locale]||langToPluralType[split.call(locale,/-/,1)[0]]||langToPluralType.en;}function pluralTypeIndex(locale,count){return pluralTypes[pluralTypeName(locale)](count);}var dollarRegex=/\$/g;var dollarBillsYall='$$';var tokenRegex=/%\{(.*?)\}/g;// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase,substitutions,locale){if(typeof phrase!=='string'){throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');}if(substitutions==null){return phrase;}var result=phrase;// allow number as a pluralization shortcut
var options=typeof substitutions==='number'?{smart_count:substitutions}:substitutions;// Select plural form: based on a phrase text that contains `n`
// plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
// choose the correct plural form. This is only done if `count` is set.
if(options.smart_count!=null&&result){var texts=split.call(result,delimeter);result=trim(texts[pluralTypeIndex(locale||'en',options.smart_count)]||texts[0]);}// Interpolate: Creates a `RegExp` object for each interpolation placeholder.
result=replace.call(result,tokenRegex,function(expression,argument){if(!has(options,argument)||options[argument]==null){return expression;}// Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
return replace.call(options[argument],dollarRegex,dollarBillsYall);});return result;}// ### Polyglot class constructor
function Polyglot(options){var opts=options||{};this.phrases={};this.extend(opts.phrases||{});this.currentLocale=opts.locale||'en';var allowMissing=opts.allowMissing?transformPhrase:null;this.onMissingKey=typeof opts.onMissingKey==='function'?opts.onMissingKey:allowMissing;this.warn=opts.warn||warn;}// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale=function(newLocale){if(newLocale)this.currentLocale=newLocale;return this.currentLocale;};// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend=function(morePhrases,prefix){forEach(morePhrases,function(phrase,key){var prefixedKey=prefix?prefix+'.'+key:key;if(Array.isArray(phrase)){this.phrases[prefixedKey]=phrase;}else if((typeof phrase==='undefined'?'undefined':_typeof(phrase))==='object'){this.extend(phrase,prefixedKey);}else{this.phrases[prefixedKey]=phrase;}},this);};// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset=function(morePhrases,prefix){if(typeof morePhrases==='string'){delete this.phrases[morePhrases];}else{forEach(morePhrases,function(phrase,key){var prefixedKey=prefix?prefix+'.'+key:key;if((typeof phrase==='undefined'?'undefined':_typeof(phrase))==='object'){this.unset(phrase,prefixedKey);}else{delete this.phrases[prefixedKey];}},this);}};// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear=function(){this.phrases={};};// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace=function(newPhrases){this.clear();this.extend(newPhrases);};// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t=function(key,options){var phrase,result;var opts=options==null?{}:options;if(typeof this.phrases[key]==='string'){phrase=this.phrases[key];}else if(Array.isArray(this.phrases[key])){result=this.phrases[key];}else if(typeof opts._==='string'){phrase=opts._;}else if(this.onMissingKey){var onMissingKey=this.onMissingKey;result=onMissingKey(key,opts,this.currentLocale);}else{this.warn('Missing translation for key: "'+key+'"');result=key;}if(typeof phrase==='string'){result=transformPhrase(phrase,opts,this.currentLocale);}return result;};// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has=function(key){return has(this.phrases,key);};// export transformPhrase
Polyglot.transformPhrase=transformPhrase;module.exports=Polyglot;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(148);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(64);
var define = __webpack_require__(65);

var implementation = __webpack_require__(67);
var getPolyfill = __webpack_require__(68);
var shim = __webpack_require__(159);

var boundTrim = callBind(getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(152);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(66);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(154);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(66); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(156);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(29);

var $TypeError = GetIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(29);

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(29);

var callBind = __webpack_require__(64);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(65);
var getPolyfill = __webpack_require__(68);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, {
		trim: function testTrim() {
			return String.prototype.trim !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pl__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__de__ = __webpack_require__(201);
/* harmony default export */ __webpack_exports__["a"] = ({pl:__WEBPACK_IMPORTED_MODULE_0__pl__["a" /* default */],en:__WEBPACK_IMPORTED_MODULE_1__en__["a" /* default */],de:__WEBPACK_IMPORTED_MODULE_2__de__["a" /* default */]});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pl_cookie__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pl_header__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pl_footer__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pl_form__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pl_consent_common_json__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pl_consent_common_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pl_consent_common_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pl_consent_rodo_json__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pl_consent_rodo_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pl_consent_rodo_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pl_consent_data_json__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pl_consent_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pl_consent_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pl_consent_marketing_json__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pl_consent_marketing_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pl_consent_marketing_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pl_home__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pl_threats__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pl_offer__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pl_contact__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pl_ebook__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pl_privacy__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pl_legal__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pl_modals__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pl_webinar__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pl_about__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pl_estimation__ = __webpack_require__(180);
/* harmony default export */ __webpack_exports__["a"] = ({cookie:__WEBPACK_IMPORTED_MODULE_0__pl_cookie__["a" /* default */],header:__WEBPACK_IMPORTED_MODULE_1__pl_header__["a" /* default */],footer:__WEBPACK_IMPORTED_MODULE_2__pl_footer__["a" /* default */],form:__WEBPACK_IMPORTED_MODULE_3__pl_form__["a" /* default */],consent:{common:__WEBPACK_IMPORTED_MODULE_4__pl_consent_common_json___default.a,rodo:__WEBPACK_IMPORTED_MODULE_5__pl_consent_rodo_json___default.a,data:__WEBPACK_IMPORTED_MODULE_6__pl_consent_data_json___default.a,marketing:__WEBPACK_IMPORTED_MODULE_7__pl_consent_marketing_json___default.a},home:__WEBPACK_IMPORTED_MODULE_8__pl_home__["a" /* default */],threats:__WEBPACK_IMPORTED_MODULE_9__pl_threats__["a" /* default */],offer:__WEBPACK_IMPORTED_MODULE_10__pl_offer__["a" /* default */],contact:__WEBPACK_IMPORTED_MODULE_11__pl_contact__["a" /* default */],ebook:__WEBPACK_IMPORTED_MODULE_12__pl_ebook__["a" /* default */],privacy:__WEBPACK_IMPORTED_MODULE_13__pl_privacy__["a" /* default */],legal:__WEBPACK_IMPORTED_MODULE_14__pl_legal__["a" /* default */],modals:__WEBPACK_IMPORTED_MODULE_15__pl_modals__["a" /* default */],webinar:__WEBPACK_IMPORTED_MODULE_16__pl_webinar__["a" /* default */],about:__WEBPACK_IMPORTED_MODULE_17__pl_about__["a" /* default */],estimation:__WEBPACK_IMPORTED_MODULE_18__pl_estimation__["a" /* default */]});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({text:'Strona korzysta z plików cookie w celu realizacji usług zgodnie z',privacy:'Polityką prywatności.',button:'OK'});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({logo:'Lemlock - legal and technical support for your cybersecurity',menu:{scanner:'Skaner',threats:'Zagrożenia',offer:'Oferta',blog:'Blog',contact:'Kontakt',video:'Video',about:'O nas',estimation:'Cennik'}});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({copyright:'lemlock.com | &copy; All rights reserved 2017',privacy:'Polityka Prywatności',legal:'O firmie',contact:{title:'Kontakt:',labels:{mobile:'mobile',mail:'mail'},people:[{name:'Grzegorz Mąkosa',occupation:'Business Development Partner',phone:'+48 71 700 03 01',email:'Wygeneruj e-mail'}]},headquarter:{title:'Adres:',address:{company:'Lemlock',country:''}}});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:{threats:'Dowiedz się jak możesz zabezpieczyć swoje dane.',offer:'Dowiedz się jakie narzędzia zapewnią Ci kompleksowe bezpieczeństwo.',minimize:'Czy chcesz zminimalizować ryzyko cyberataków w Twojej organizacji?',estimate:'Czy chcesz zwiększyć bezpieczeństwo swoich aplikacji? ',breach:'Czy jesteś ofiarą cyberataku?',// risk: 'Czy chcesz przygotować swoją organizację do zgodności z RODO?',
audit:'Czy chcesz, aby Twoja aplikacja/system informatyczny były zgodne z RODO?',bottom:'Interesuje Cię kompleksowe rozwiązanie związane z bezpieczeństwem zasobów i gromadzonych przez Ciebie danych?',contact:'Jak najszybciej skontaktuj się z nami!'},placeholder:{email:'Twój firmowy email',phone:'Telefon'},button:{offer:'Umów się na konsultacje',consultation:'Umów bezpłatną konsultację',breach:'Sprawdź, jakie kroki musisz podjąć po incydencie',refresh:'Odśwież'// risk: 'Uzyskaj analizę ryzyka'
},message:{general_error:'Proszę wypełnić prawidłowo wszystkie pola.',domain_error:'Nie akceptujemy tymczasowych adresów email. Podaj poprawny adres email',recaptcha_error:'Coś poszło nie tak, proszę wcisnąć przycisk odśwież i spróbować ponownie.',server_error:'Tymczasowy bład serwera. Umów rozmowę wysyłając wiadomość na contact@lemlock.com',success:'Wiadomość została wysłana'},link:{breach:'https://www.lemlock.com/procedury-reagowania-na-cyberataki/'}});

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {"button":"Zamknij","rodoStart":"Potwierdzam, że zapoznałem/am się z","rodoEnd":"klauzulą informacyjną Sagiton Sp. z o.o.","dataStart":"Zgoda na","dataEnd":"przetwarzanie danych w celu kontaktu","marketingEnd":"przetwarzanie danych w celach marketingowych"}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = {"general":["Zgodnie z art. 13 ust. 1 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016r., (RODO), informujemy, iż administratorem Pana/Pani danych osobowych jest Sagiton Sp. z o.o. z siedzibą przy ul. Fabrycznej 19, 53-609 Wrocław, e-mail: grzegorz.makosa@lemlock.com.","Pana/Pani dane osobowe przetwarzane będą w zakresie imię i nazwisko, adres email i/lub numer telefonu w celu odpowiedzi na Pana/Pani zapytanie/prośbę o kontakt i wystosowanie informacji zwrotnej– na podstawie art. 6 ust. 1 lit a RODO tj. zgody na przetwarzanie danych osobowych.","Administrator danych informuje, że Pana/Pani dane osobowe nie będą udostępniane podmiotom trzecim.","Pana/Pani dane nie będą przekazywane poza Europejski Obszar Gospodarczy lub do organizacji międzynarodowych.","Pana/Pani dane osobowe będą przetwarzane do wycofania przez Pana/Panią zgody na przetwarzanie danych a także w przypadku ustania celów przetwarzania tych danych.","Ma Pan/Pani prawo dostępu do swoich danych osobowych, ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia oraz prawo do wniesienia sprzeciwu.","W przypadku wyrażenia zgody ma Pan/Pani prawo wycofania zgody w dowolnym momencie. Skorzystanie z prawa do wycofania zgody nie ma wpływu na przetwarzanie, które miało miejsce do momentu wycofania zgody.","Przysługuje Panu/Pani prawo do wniesienia skargi do organu nadzorczego tj. Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.","Podanie przez Pana/Panią danych osobowych jest warunkiem nawiązania z Panem/Panią kontaktu przez Sagiton Sp. z o.o. z siedziba przy ul. Fabrycznej 19, 53-609 Wrocław. W przypadku niepodania danych osobowych, Sagiton Sp. z o.o., nie będzie w stanie nawiązać z Panem/Panią kontaktu.","Administrator Danych Sagiton Sp. z o.o. informuje, iż nie będzie wykorzystywał Pana/Pani danych osobowych do zautomatyzowanego podejmowania decyzji, które opiera się wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu, i wywołuje wobec Pana/Pani skutki prawne lub w podobny sposób istotnie na Pana/Panią wpływa."],"ebook":["Zgodnie z art. 13 ust. 1 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016r., (RODO), informujemy, iż administratorem Pana/i danych osobowych jest Sagiton Sp. z o.o. z siedzibą przy ul. Fabrycznej 19, 53-609 Wrocław, e-mail: grzegorz.makosa@lemlock.com.","Pana/Pani dane osobowe przetwarzane będą w zakresie imię i nazwisko oraz adres email w celu umożliwienia Panu/Pani pobranie bezpłatnego ebooka udostępnionego przez Sagiton Sp. z o.o. – na podstawie art. 6 ust. 1 lit a RODO tj. zgody na przetwarzanie danych osobowych.","Administrator danych informuje, że Pana/Pani dane osobowe nie będą udostępniane podmiotom trzecim.","Pana/Pani dane nie będą przekazywane poza Europejski Obszar Gospodarczy lub do organizacji międzynarodowych.","Pana/Pani dane osobowe będą przetwarzane do czasu wycofania udzielonej przez Pana/Panią zgody.","Ma Pan/Pani prawo dostępu do swoich danych osobowych, ich sprostowania, usunięcia, ograniczenia prztewarzania, prawo do przenoszenia oraz prawo do wniesienia sprzeciwu.","Ma Pan/Pani prawo wycofania zgody w dowolnym momencie. Skorzystanie z prawa do wycofania zgody nie ma wpływu na przetwarzanie, które miało miejsce do momentu wycofania zgody.","Przysługuje Panu/Pani prawo do wniesienia skargi do organu nadzorczego tj. Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.","Podanie przez Pana/Panią danych osobowych jest warunkiem możliwości pobrania bezpłatnego ebooka udostępnianego przez Sagiton Sp. z o.o. z siedzibą przy ul. Fabrycznej 19, 53-609 Wrocław. W przypadku niepodania danych osobowych, Sagiton Sp. z o.o., nie będzie w stanie świadczyć Pana/Pani wskazanych usług.","Administrator Sagiton Sp. z o.o. informuje, iż nie będzie wykorzystywał Pana/Pani danych osobowych do zautomatyzowanego podejmowania decyzji, które opiera się wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu, i wywołuje wobec Pana/Pani skutki prawne lub w podobny sposób istotnie na Pana/Panią wpływa."],"webinar":["Zgodnie z art. 13 ust. 1 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016r., (RODO), informujemy, iż administratorem Pana/i danych osobowych jest Sagiton Sp. z o.o. z siedzibą przy ul. Fabrycznej 19, 53-609 Wrocław, e-mail: grzegorz.makosa@lemlock.com.","Pana/Pani dane osobowe przetwarzane będą w zakresie imię i nazwisko oraz adres email w celu zorganizowania oraz umożliwienia Panu/Pani wzięcie udziału w bezpłatnym webinarze organizowanym przez Sagiton Sp. z o.o. – na podstawie art. 6 ust. 1 lit a RODO tj. zgody na przetwarzanie danych osobowych.","Administrator danych informuje, że Pana/Pani dane osobowe nie będą udostępniane podmiotom trzecim.","Pana/Pani dane nie będą przekazywane poza Europejski Obszar Gospodarczy lub do organizacji międzynarodowych.","Pana/Pani dane osobowe będą przetwarzane do czasu wycofania udzielonej przez Pana/Panią zgody.","Ma Pan/Pani prawo dostępu do swoich danych osobowych, ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia oraz prawo do wniesienia sprzeciwu.","Ma Pan/Pani prawo wycofania zgody w dowolnym momencie. Skorzystanie z prawa do wycofania zgody nie ma wpływu na przetwarzanie, które miało miejsce do momentu wycofania zgody.","Przysługuje Panu/Pani prawo do wniesienia skargi do organu nadzorczego tj. Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.","Podanie przez Pana/Panią danych osobowych jest warunkiem wzięcia udziału w bezpłatnym webinarze organizowanym przez Sagiton Sp. z o.o. z siedziba przy ul. Fabrycznej 19, 53-609 Wrocław. W przypadku niepodania danych osobowych, Sagiton Sp. z o.o., nie będzie w stanie świadczyć Pana/Pani wskazanych usług.","Administrator Sagiton Sp. z o.o. informuje, iż nie będzie wykorzystywał Pana/Pani danych osobowych do zautomatyzowanego podejmowania decyzji, które opiera się wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu, i wywołuje wobec Pana/Pani skutki prawne lub w podobny sposób istotnie na Pana/Panią wpływa."]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {"general":["Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych przez Administratora Danych Osobowych (dalej: „ADO”) – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, w zakresie: imię i nazwisko, adres email lub telefon, w celach sprzedaży produktów i usług Sagiton Sp. z o.o. oraz w celu przesłania do mnie informacji zwrotnej i nawiązania ze mną kontaktu przez Sagiton Sp. z o.o.","Jednocześnie przyjmuję do wiadomości, że: w każdej chwili mogę zażądać usunięcia moich danych osobowych z bazy ADO Sagiton Sp. z o.o., poprzez wysłanie na adres poczty elektronicznej grzegorz.makosa@lemlock.com. lub na piśmie, na adres Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, oświadczenia zawierającego stosowne żądanie co skutkować będzie usunięciem moich danych osobowych z bazy danych ADO Sagiton Sp. z o.o.; mam prawo dostępu do treści swoich danych; podanie moich danych jest dobrowolne, aczkolwiek odmowa ich podania jest równoznaczna z nieotrzymywaniem informacji dotyczących sprzedaży produktów i usług Sagiton Sp. z o.o., a także z nieotrzymaniem informacji zwrotnej  i nawiązaniem ze mną kontaktu przez Sagiton Sp. z o.o."],"ebook":["Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych przez Administratora Danych Osobowych (dalej: „ADO”) – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, w zakresie: imię i nazwisko oraz adres email, w celu pobrania darmowego ebooka udostępnianego przez Sagiton Sp. z o.o.","Jednocześnie przyjmuję do wiadomości, że: w każdej chwili mogę zażądać usunięcia moich danych osobowych z bazy ADO Sagiton Sp. z o.o., poprzez wysłanie na adres poczty elektronicznej grzegorz.makosa@lemlock.com. lub na piśmie, na adres Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, oświadczenia zawierającego stosowne żądanie co skutkować będzie usunięciem moich danych osobowych z bazy danych ADO Sagiton Sp. z o.o.; mam prawo dostępu do treści swoich danych; podanie moich danych jest dobrowolne, aczkolwiek odmowa ich podania jest równoznaczna niemożnością pobrania darmowego ebooka udostępnianego przez Sagiton Sp. z o.o."],"webinar":["Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych przez Administratora Danych Osobowych (dalej: „ADO”) – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, w zakresie: imię i nazwisko oraz adres email, w celu zapisania się na darmowy webinar organizowany przez Sagiton Sp. z o.o.","Jednocześnie przyjmuję do wiadomości, że: w każdej chwili mogę zażądać usunięcia moich danych osobowych z bazy ADO Sagiton Sp. z o.o., poprzez wysłanie na adres poczty elektronicznej grzegorz.makosa@lemlock.com. lub na piśmie, na adres Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, oświadczenia zawierającego stosowne żądanie co skutkować będzie usunięciem moich danych osobowych z bazy danych ADO Sagiton Sp. z o.o.; mam prawo dostępu do treści swoich danych; podanie moich danych jest dobrowolne, aczkolwiek odmowa ich podania jest równoznaczna niemożnością wzięcia udziału w darmowy webinarze realizowanym przez Sagiton Sp. z o.o."]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = {"list":["Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych przez Administratora Danych Osobowych (dalej: „ADO”) – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, w zakresie: imię i nazwisko, adres email lub telefon, w celach marketingowych, przez Sagiton Sp. z o.o.","Jednocześnie przyjmuję do wiadomości, że: w każdej chwili mogę zażądać usunięcia moich danych osobowych z bazy ADO Sagiton Sp. z o.o., poprzez wysłanie na adres poczty elektronicznej grzegorz.makosa@lemlock.com. lub na piśmie, na adres Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, oświadczenia zawierającego stosowne żądanie co skutkować będzie usunięciem moich danych osobowych z bazy danych ADO Sagiton Sp. z o.o.; mam prawo dostępu do treści swoich danych; podanie moich danych jest dobrowolne, aczkolwiek odmowa ich podania jest równoznaczna z nieotrzymywaniem informacji handlowych od Sagiton Sp. z o.o."]}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({threats:{excerpt:{title:'Nie masz pewności, czy Twoje zasoby cyfrowe i aplikacje wymagają wsparcia w zakresie cyberbezpieczeństwa?',list:['Dlaczego ryzyko ataku na Twoje dane jest tak duże?','Co dokładnie stracisz w przypadku udanego ataku?','Dlaczego kradzież danych może Cię kosztować aż 4% rocznego obrotu?','Jakie działania i technologie zagwarantują Ci pełne bezpieczeństwo?'],button:'Sprawdź to'},content:{title:'Czy zasoby Twojej organizacji są bezpieczne?',description:'Liczba ataków na infrastrukturę organizacji i kradzieży danych w ostatnich latach rośnie w zastraszającym tempie.',button:'Zobacz wideo'}},offer:{excerpt:{title:'Dlaczego warto wybrać Lemlock jako partnera w kwestii cyberbezpieczeństwa?',list:['Dlaczego kompleksowe bezpieczeństwo wymaga interdyscyplinarnego podejścia?','Jakie rozwiązania oferuje lemlock?','Jak ochronić raport przed wyciekiem zawartych w nim informacji?','W jaki sposób udowodnisz, że dobrze zabezpieczasz dane?'],button:'Oferta',button_pricing:'Cennik'},content:{title:'Zabezpiecz swoje aplikacje i zasoby cyfrowe.',description:'Ochrona zasobów organizacji to wyzwanie, które wymaga wiedzy i działań z obszarów prawnych oraz technologicznych.',button:'Oferta'}},popup:{text:'Podejrzewasz, że Twoja organizacja została zhakowana? Skontaktuj się z nami natychmiast!',link:'https://www.lemlock.com/procedury-reagowania-na-cyberataki/'}});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({one:{section:{title:'Dlaczego <strong>ryzyko ataku</strong> na Twoje zasoby<br/> jest tak wysokie?'},image:{title:'Główne motywacje ataków',tags:['Ideologiczne','Polityczne','Religijne','Test umiejętności','Finansowe','Zabawa']},paragraphs:['Przeprowadzanie ataków na infrastrukturę organizacji i dokonywanie kradzieży danych to w ostatnich latach coraz częstsze zjawiska.','Według <a href="https://www2.deloitte.com/content/dam/Deloitte/tr/Documents/risk/security-and-privacy-noexp.pdf" target="_blank" rel="noopener noreferrer">raportu</a> Deloitte w 2017 roku cyberprzestępcy w sposób szczególny interesowali się branżą motoryzacyjną, finansową, telecom czy medyczną. Obecnie wciąż pojawiają się kolejne motywy ich działania, a obiektem ataku cybernetycznego może stać się każda firma czy instytucja posiadająca atrakcyjne zasoby lub gromadząca i przetwarzająca wartościowe dane.','W Internecie stale pojawiają się nowe materiały szkoleniowe z dziedziny bezpieczeństwa, które wykorzystywane są nie tylko w celach etycznych. Ponad 25% ataków kończy się zarówno wyciekiem danych, jak i ich całkowitą utratą (również kopii zapasowej).','Skutki udanego ataku ciężko bagatelizować. Utrata informacji, dewastacja systemów informatycznych czy zablokowanie strony to nie tylko uszczerbek na wizerunku organizacji i utrata reputacji, ale także olbrzymie straty finansowe. Od 25 maja 2018 r. wystąpienie wymienionych sytuacji może Cię kosztować znacznie więcej - nawet do 20 mln euro lub 4% globalnego obrotu. Wiąże się to ściśle z obowiązkami w zakresie ochrony danych wymienionymi w Rozporządzeniu o Ochronie Danych Osobowych (RODO).'],note:'Bezpieczeństwo systemów i danych to nieustający proces, który wiąże się nie tylko z wdrażaniem standardów i zabezpieczeń, ale z ich ciągłym monitorowaniem oraz testowaniem. W tej dziedzinie nie ma miejsca na ustępstwa czy kompromisy.'},two:{section:{title:'Co możesz stracić, jeśli prawidłowo nie zabezpieczysz</br> swoich aplikacji i zasobów cyfrowych?'},boxes:['Utrata danych','Zablokowanie bieżącej działalności organizacji i przychodów','Utrata reputacji','Zniszczenie systemów informatycznych','Kary finansowe do 20 milionów euro lub 4% globalnego rocznego obrotu'],text:'Przyczyną zagrożeń są coraz częstsze i coraz bardziej wyrafinowane cyberataki na systemy organizacji oraz niedostosowanie się do nowych wytycznych związanych z bezpieczeństwem danych, jakie wprowadza <span class="blue">RODO</span>.'},three:{section:{title:'Z jakich <strong>strategii</strong> korzystają cyberprzestępcy?'},text:'Średnio ¾ przypadków włamań do systemów dokonuje się w przeciągu kilku minut, a wykrycie, że doszło do ataku w ponad połowie przypadków następuje po ponad miesiącu.',buttons:{more:'Czytaj dalej',less:'Pokaż mniej'},boxes:[{title:'Na szeroką skalę',text:'Cyberprzestępcy, łącząc się w grupy są w stanie przeprowadzać ataki na szeroką skalę. Spektakularny akt agresji, do którego doszło w połowie maja 2017 roku, dotknął prawie 100 państw na całym świecie. Hakerzy wykorzystali narzędzie ETERNALBLUE, skradzione agencji National Security Agency. Robak blokował ekrany komputerów i szyfrował pliki twardego dysku, żądając za ich odblokowanie zapłaty w bitcoinach. Zmasowany, ogólnoświatowy atak oprogramowania ransomware o nazwie WannaCry najwięcej szkód spowodował w rosyjskich komputerach podłączonych do wewnętrznych sieci MSW i Komitetu Śledczego Federacji Rosyjskiej. Spore utrudnienia wprowadził również w brytyjskiej służbie zdrowia, blokując dostęp do danych pacjentów oraz w niemieckich kolejach czy fabrykach Renault. Nie wiadomo, kto stoi za atakiem zakrojonym na tak szeroka skalę, ale wiadomo, że luka, którą posłużyli się hakerzy, była doskonale znana i można było ją wykryć już na pierwszym etapie wykonywania testu penetracyjnego.'},{title:'Branżowo',text:'Ataków o mniejszym zasięgu lub wycelowanych w konkretną branżę dostrzega się coraz więcej. Niezwykle wrażliwym sektorem są instytucje bankowe. Na początku 2017 roku w Polsce celami ataków stały się właśnie banki. Zainfekowana została strona Komisji Nadzoru Finansowego, a dokładniej podstrona adresowana pracownikom banków. Tym sposobem na ich komputerach rozprzestrzeniało się złośliwe oprogramowanie, którego celem była kradzież danych oraz infiltracja infrastruktury banków.'},{title:'W konkretny cel',text:'Ofiarą cyberataków padają również bardzo konkretne firmy, i nie są to tylko duże korporacje, ale także małe, lokalne biznesy. Najczęściej te, które gromadzą i przetwarzają dane użyteczne z punktu widzenia przestępców. Tak właśnie było w przypadku japońskiej agencji podróżniczej JTB Corp. W wyniku włamania do bazy danych firmy skradziono prawie 8 mln rekordów zawierających dane osobowe, w tym między innymi nazwiska, adresy zamieszkania oraz numery paszportów klientów.'}]},four:{section:{title:'Dlaczego zaniedbanie cyberzagrożeń może kosztować Cię</br> 20 milionów EUR lub 4% rocznego obrotu?',desc:'<p><span class="blue">RODO</span> (Rozporządzenie Ogólne o Danych Osobowych) lub z ang. <span class="blue">GDPR</span> (General Data Protection Regulation), czyli nowa regulacja unijna w zakresie ochrony danych osobowych, <span class="blue">wchodząca w życie 25 maja 2018 r.</span></p>'},text:['Rozporządzenie nadaje nowe uprawnienia krajowym organom kontrolującym przetwarzanie danych osobowych, między innymi nakładanie kar za niedostosowanie się do wytycznych <a href="https://blog.lemlock.com/pl/blog/categories/rodo/">RODO</a>, sięgające nawet 20 mln euro lub 4% rocznego globalnego obrotu. W związku z tym wiele firm rozpoczęło już wdrażanie zmian.','<a href="https://blog.lemlock.com/pl/blog/categories/rodo/">RODO</a> wprowadza nowe wytyczne dotyczące między innymi:',['przejrzystości danych i procedur,','zgody na przetwarzanie danych od osób fizycznych i usuwanie danych,','projektowania narzędzi do przetwarzania informacji,','zakresu i dostępności danych,','powołania Administratora Danych Osobowych (ADO) i jego zadań.'],'Wchodząca w życie regulacja prawna dotyczyć będzie nie tylko podmiotów mających siedzibę na terenie Unii Europejskiej, ale również tych spoza UE, jeśli oferują towary i usługi w UE (nawet nieodpłatnie) lub monitorują zachowania klientów w UE.','W przypadku naruszeń lub ich podejrzeń organ kontrolujący będzie sprawdzał, jakie środki zapobiegawcze zostały wprowadzone. Odpowiednie przygotowanie systemów zabezpieczeń danych może znacznie zminimalizować wysokość kar finansowych. W związku z tym wprowadzanie zabezpieczeń i testowanie ich skuteczności będzie istotna kwestią dla wielu organizacji już od maja 2018 r.'],icon:'rodo',boxes:{title:'Od momentu wejścia RODO w życie:',list:['Administrator Danych Osobowych, przy określaniu sposobów przetwarzania danych osobowych, zobowiązany jest wdrożyć odpowiednie techniczne i organizacyjne środki zabezpieczające.','Wymagany jest stały monitoring, reagowanie na incydenty i alarmowanie o naruszeniach prywatności w czasie rzeczywistym.','Istnieje obowiązek zgłaszania organowi nadzoru oraz właścicielowi danych wystąpienia zdarzenia w postaci naruszenia/kradzieży danych osobowych, a przez to zaburzenia procesu przetwarzania.']}},five:{section:{title:'Dlaczego <strong>rozwiązania</strong> muszą<br/> być <strong>kompleksowe</strong>?',desc:'<p>Zagrożenia związane z naruszeniem bezpieczeństwa i prywatności danych oraz karami nakładanymi przez nowe przepisy, wymagają odpowiednich środków zapobiegawczych.</p>'},text:'Ochrona zasobów organizacji to ciągły proces, który potrzebuje wiedzy i działań z obszarów prawnych i technologicznych, a więc:',boxes:['weryfikowania bezpieczeństwa i jego aktywnego monitoringu','dostosowywania norm oraz procedur do obowiązujących przepisów prawa','wprowadzania odpowiednich rozwiązań technologicznych zapewniających bezpieczeństwo danych'],button:'Sprawdź, jakie działania i narzędzia zapewnią Ci wysoki poziom bezpieczeństwa.'},video:{text:'Obejrzyj wideo',file:'threats-pl.mp4',link:'4gzisBJRwkk'}});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({one:{section:{title:'Jak skorzystasz <strong>na partnerstwie</strong> z Lemlock?'},button:'Dowiedz się więcej o Lemlock',icons:[{align:'right',title:'Specjaliści trzech branż',title_2_lines:'Specjaliści<br/> trzech branż',desc:'Lemlock to synergia płynąca z połączenia kompetencji testerów bezpieczeństwa, prawników oraz inżynierów oprogramowania.'},{align:'right',title:'Nadzór i testy weryfikacyjne',title_2_lines:'Nadzór i testy<br/> weryfikacyjne',desc:'Zespół Lemlock sprawuje nadzór podczas wprowadzania zmian do Twojej infrastruktury, oprogramowań czy systemów informatycznych. Po przeprowadzonych testach weryfikacyjnych zyskujesz pewność, że naniesione poprawki lub ulepszenia będą kompatybilne z dokumentacją/raportem z badań stanu bezpieczeństwa pod względem prawnym i technicznym.'},{align:'right',title:'Metodologia i kompetencje',title_2_lines:'Metodologia<br> i kompetencje',desc:'Testy i audyty Lemlock prowadzone są według wytycznych OWASP i NIST oraz spełniają standardy ISO 27000. Testerzy posiadają certyfikaty ABW potwierdzające wiarygodność, a nad całym procesem czuwa kancelaria prawna.'},{align:'right',title:'Aktywny Monitoring',title_2_lines:'Aktywny<br> Monitoring',desc:'Ciągłość bezpieczeństwa danych bez względu na pojawiające się zagrożenia wymaga stałego, aktywnego monitoringu. Lemlock jest jak alarm, który poinformuje Cię o każdym wykrytym zagrożeniu.'},{align:'left',title:'Start w 48h',title_2_lines:'Start<br/> w 48h',desc:'Uruchomienie procesu testowania w niecałe dwie doby jest możliwe. Gwarancja szybkiego startu i dostęp do postępów prac pozwalają kontrolować cały proces na bieżąco.'},{align:'left',title:'Certyfikaty Bezpieczeństwa',title_2_lines:'Certyfikaty<br/> Bezpieczeństwa',desc:'Lemlock standard, Lemlock platinum i certyfikat zgodności z RODO pomogą Ci zwiększyć wiarygodność i zaufanie wśród klientów, partnerów biznesowych i pracowników.'}]},two:{section:{title:'Proces naszej pracy krok po kroku:'},icons:['zgłoszenie','konsultacja','monitoring','raport','nadzór','certyfikat'],bonus:'<span>BONUS:</span> Bezpłatne konsultacje z ekspertem w zakresie wdrażania lub modyfikacji zabezpieczeń.'},three:{button:'Zabezpiecz swoje aplikacje i zasoby cyfrowe',section:{title:'W jaki sposób udowodnisz,<br/> że <strong>dobrze zabezpieczasz</strong> dane?',desc:'<p>Współczesny klient to osoba coraz bardziej świadoma swoich praw w zakresie ochrony danych osobowych. Firmy i instytucje gromadzące lub przetwarzające dane zyskują dużą przewagę udowadniając, że do kwestii bezpieczeństwa podchodzą poważnie.</p><p>Korzystając z rozwiązań Lemlock, możesz w łatwy sposób zakomunikować Twoim klientom, partnerom biznesowym i pracownikom, że stosujesz odpowiednie zabezpieczenia.</p>'},boxes:[{title:'Lemlock STANDARD',textTop:'test penetracyjny<br/> audyt bezpieczeństwa',textBottom:'sprawdzono poziom zabezpieczeń i usunięto wykryte luki'},{title:'Lemlock PLATINIUM',textTop:'monitoring sieci<br/> i serwerów',textBottom:'prowadzony jest stały monitoring i natychmiastowa korekcja pojawiających się podatności'},{title:'Certyfikat zgodności z RODO',textTop:'audyt zgodności<br/> z RODO',textBottom:'wdrożono zmiany zgodnie z wytycznymi RODO'}]},general:{cybersecurity_title:'Cyberbezpieczeństwo oprogramowania i aplikacji',consulting_title:'Konsulting prawny i techniczny',read_more:'Czytaj dalej',back:'Powrót',button1:'Określ swoje potrzeby',button2:'Uzyskaj bezpłatną konsultację'},clients:{title:'Zaufali nam'},list:[{slug:'application-security-audits-penetration-tests',title:'Audyty bezpieczeństwa i Testy penetracyjne',subtitle:'Dowiedz się o błędach w Twoich systemach, aplikacjach internetowych oraz aplikacjach server-side.',icon:'icon01',content:{title:'Audyty bezpieczeństwa i Testy penetracyjne',subtitle:'aby wykryć słabe punkty aplikacji i systemów IT',text:['Przeprowadzenie kontrolowanych prób ataków na Twoje aplikacje i systemy IT. Takie symulacje ataków hakerskich to doskonały sposób na sprawdzenie, czy dane są bezpieczne.','W przeciwieństwie do prawdziwego ataku, testy penetracyjne oraz audyty są wykorzystywane zarówno do wskazywania wyraźnych nieprawidłowości, jak i tych, które są ukryte i ledwo zauważalne. Głównym celem jest przede wszystkim przeprowadzenie dokładnego procesu poszukiwania podatności, a nie koncentrowanie się na pierwszej napotkanej luce.','Zespół Lemlock w Twoim imieniu może nadzorować wprowadzanie do Twoich systemów IT oraz aplikacji niezbędnych korekt czy ulepszeń na podstawie wygenerowanego raportu z opisami zidentyfikowanych podatności: ich rodzajem, złożonością oraz wagą.'],icons_title:'Audyty opierają się na standardach <b>OWASP</b> oraz <b>OWASP Mobile</b> i są dostosowane do ochrony Twoich:',icons:[{icon:'web',title:'Aplikacji Webowych'},{icon:'server',title:'Aplikacji Server-Side/Cloud'},{icon:'important',title:'Aplikacji Mobilnych'}]},cta:[{text:'Cennik',icon:'get',page:'estimation'},{text:'Pobierz broszurę',icon:'download',pdf_lp:""+'/pdfs/brochures/pl/Audyty_bezpieczenstwa_i_Testy_penetracyjne.pdf'},{text:'Zapytaj o szczegóły',icon:'ask',page:'contact'}]},{slug:'application-gdpr-compliant-audits',title:'Audyt Zgodności aplikacji z RODO',subtitle:'Sprawdź, czy Twoje aplikacje webowe, mobilne i server-side spełniają techniczne i prawne wymagania nowego rozporządzenia Unii Europejskiej.',icon:'icon02',content:{title:'Audyt Zgodności aplikacji z RODO',subtitle:'aby Twoja aplikacja była zgodna z nowym prawem UE w zakresie ochrony prywatności',icons_title:'Szczegółowy audyt zgodności dla Twoich:',icons:[{icon:'web',title:'Aplikacji Webowych'},{icon:'server',title:'Aplikacji Server-Side/Cloud'},{icon:'important',title:'Aplikacji Mobilnych'}],list_numbered_title:'Biorąc pod uwagę trzy perspektywy:',list_numbered:[{title:'Prawną',text:'Prawnicy specjalizujący się w branży IT identyfikują dane osobowe, oceniają ryzyko związane z ich przetwarzaniem w oparciu o standard <b>ISO 27000</b> i - w razie potrzeby - analizują warunki korzystania z usług w ramach aplikacji.  '},{title:'Inżynieryjną',text:'Architekci systemów i inżynierowie oprogramowania analizują architekturę aplikacji za pośrednictwem kodu źródłowego, aby sprawdzić, czy spełniane są przepisy RODO, a jeśli nie są, dostarczają oni odpowiednie zalecenia.'},{title:'Cyberbezpieczeństwa',text:'Eksperci ds. Bezpieczeństwa weryfikują, czy dane osobowe i wszelkie mechanizmy utworzone w ramach RODO są właściwie zabezpieczone.'}],list_numbered_text:'Eksperci Lemlock są w stanie nadzorować proces wdrażania rekomendowanych  mechanizmów ochrony i koniecznych poprawek pod względem prawnym, dzięki czemu zostanie zmniejszone ryzyko naruszenia lub utraty danych.'},cta:[{text:'Cennik',icon:'get',page:'estimation'},{text:'Pobierz broszurę',icon:'download',pdf_lp:""+'/pdfs/brochures/pl/Audyt_Zgodnosci_aplikacji_z_RODO.pdf'},{text:'Zapytaj o szczegóły',icon:'ask',page:'contact'}]},{slug:'continuous-pentesting',title:'Continuous Pentesting & RODO',subtitle:'Każda modyfikacja aplikacji ze stałą kontrolą cyberbezpieczeństwa.',icon:'icon03',content:{title:'Continuous Pentesting & RODO',subtitle:'Dodawanie nowych funkcji do aplikacji z ciągłą weryfikacją cyberbezpieczeństwa i zgodności z RODO\n',text:['Twoja firma stale się rozwija, podobnie jak Twoje rozwiązania IT. Aby Twój produkt był atrakcyjny dla wciąż zmieniającego się rynku, musisz dodawać do niego nowe funkcje. Jednak w momencie jakiejkolwiek modyfikacji systemu istnieje ryzyko pojawienia się nowej podatności lub niezgodności z RODO. Oczywiście, że przed wydaniem nowej wersji aplikacji możesz zamówić<span class="offer-details-blue"> audyt bezpieczeństwa lub zgodności z RODO</span>, ale może to okazać się czasochłonne i kosztowne. Zamiast tego warto rozważyć usługę Continuous Pentesting i zgodności z RODO Twojego systemu. ','Dzięki usłudze Continuous Pentesting & RODO, Twoje rozwiązanie zostanie objęte procesem, będzie zawierał w sobie: ',['bieżące kontrole bezpieczeństwa,','bieżące techniczne kontrole RODO,','doradztwo w zakresie bezpieczeństwa dla zespołu programistów,','szybkie powiadomienia o wykrytych naruszeniach i lukach w zabezpieczeniach,','natychmiastową korektę środków bezpieczeństwa,','ciągłe monitorowanie luk w zabezpieczeniach bibliotek open source, których używasz,','weryfikację integralności środowiska produkcyjnego systemu.'],'\n'+'Bezpieczeństwo danych i aplikacji jest procesem nieprzerwanym, dlatego warto zapewnić bezpieczeństwo procesowi Ciągłego Dostarczania wraz z zespołem Lemlock. Twój zespół będzie mógł w każdej chwili poprosić o wsparcie eksperta ds. Bezpieczeństwa, dzięki czemu szybciej zostaną rozwiązane problemy z zakresu bezpieczeństwa, a także zostanie zmniejszone prawdopodobieństwo powstania nowych luk.','Ponadto integralność środowiska produkcyjnego może być stale monitorowana, co pomoże szybciej wykryć, czy aplikacja została zmodyfikowana (zmienione konto bankowe, zmiany treści, niewidzialne iniekcje skryptów ze złośliwym oprogramowaniem, które infekują komputery pracowników i Klientów), a tym samym zapobiegać stratom finansowym i reputacji.']},cta:[{text:'Cennik',icon:'get',page:'estimation'},{text:'Pobierz broszurę',icon:'download',pdf_lp:""+'/pdfs/brochures/pl/Monitoring_Bezpieczenstwa_Aplikacji.pdf'},{text:'Zapytaj o szczegóły',icon:'ask',page:'contact'}]},{slug:'risk-management-security-policy',title:'Zarządzanie ryzykiem i polityki bezpieczeństwa',subtitle:'Dostosuj polityki bezpieczeństwa Twojej organizacji do stopnia ryzyka posiadanych zasobów IT.',icon:'icon04',content:{title:'Zarządzanie ryzykiem i polityki bezpieczeństwa',subtitle:'aby dokonać oceny ryzyka zasobów cyfrowych należących do Twojej organizacji i zapewnić odpowiednie środki do zarządzania nim',text:['Sprawdź, jakie rodzaje danych w ramach zasobów cyfrowych (serwerów, baz danych, aplikacji) są przetwarzane w organizacji. Zyskaj wiedzę na temat działań, jakie należy podjąć, aby odpowiednio zabezpieczyć zasoby bez względu na to, czy są one związane z:',['danymi osobowymi (RODO),','know how, przepisami i tajemnicą handlową,','listą płac czy wynagrodzeniami.'],'Proces ten będzie przeprowadzony zgodnie z <span class="offer-details-blue">ISO 2700x, RODO</span> i innymi obowiązującymi przepisami prawnymi.','Eksperci Lemlock mogą nadzorować proces wdrażania rekomendowanych zmian do strategii Zarządzania ryzykiem i do polityk bezpieczeństwa oraz wesprzeć budowanie świadomości organizacji w tych kwestiach.']},cta:[{text:'Cennik',icon:'get',page:'estimation',hash:'decrease'},{text:'Pobierz broszurę',icon:'download',pdf_lp:""+'/pdfs/brochures/pl/Zarzadzanie_ryzykiem_i_polityki_bezpieczenstwa.pdf'},{text:'Zapytaj o szczegóły',icon:'ask',page:'contact'}]},{slug:'incident-handling-and-post-breach-analysis',title:'Obsługa incydentów i analiza powłamaniowa',subtitle:'Zyskaj pewność, że w sytuacji ataku na Twoje zasoby IT masz wsparcie partnera, który zastosuje adekwatne procedury prawne i techniczne.',icon:'icon05',content:{title:'Obsługa incydentów i analiza powłamaniowa',subtitle:'aby wesprzeć Cię w przypadku cyberataku',text:['Incydenty związane z naruszeniem bezpieczeństwa danych wymagają szybkiej oraz przemyślanej reakcji obejmującej szereg działań <span class="offer-details-blue">prawnych i technicznych</span>, takich jak:',['potwierdzenie incydentu i jego przerwanie,','zabezpieczenie systemu i określenie skali ataku,','zebranie dowodów,','poinformowanie zainteresowanych stron, m.in. policji, inspektora danych osobowych, CERT (Computer Emergency Response Team) i CSIRT (Computer Security Incident Response Team).'],'W czasach cyberzagrożeń warto mieć kogoś, na kim można zawsze polegać.']},cta:[{text:'Działaj natychmiast, jeśli jesteś ofiarą cyberataku!',icon:'act',pdf_lp:'https://www.lemlock.com/procedury-reagowania-na-cyberataki/'},{text:'Pobierz broszurę',icon:'download',pdf_lp:""+'/pdfs/brochures/pl/Obsluga_incydentow_i_analiza_powlamaniowa.pdf'}]},{slug:'staff-training',title:'Szkolenia personelu',subtitle:'Przygotuj członków swojej organizacji do pracy zgodnej z zasadami bezpieczeństwa zarówno w kontekście prawnym, jak i technicznym.',icon:'icon06',content:{title:'Szkolenia personelu',subtitle:'aby mieć pewność, że pracownicy będą realizować swoje zadania zgodnie ze standardami bezpieczeństwa i odpowiednio zareagują w sytuacji krytycznej',text:['Aby zapewnić Twojej organizacji pełną zgodność z zasadami bezpieczeństwa i przepisami prawa (w tym także z RODO), zostaną przeprowadzone specjalne <span class="offer-details-blue">szkolenia dla personelu</span>.'],list_numbered_title:'Z obserwacji ekspertów Lemlock wynika, że w szkoleniach powinni obowiązkowo uczestniczyć:',list_numbered:[{icon:'network',title:'Administratorzy sieci',text:'Aby wiedzieli, jak zarządzać sieciami i konfigurować je z uwzględnieniem aspektu bezpieczeństwa.'},{icon:'database',title:'Deweloperzy oraz administratorzy baz danych',text:'Aby pracowali w sposób odpowiedzialny i zapewniali aplikacjom, systemom czy bazom danych wysoki poziom ochrony podczas ich tworzenia, aktualizowania lub codziennego zarządzania.'},{icon:'nonTech',title:'Personel nietechniczny',text:'Aby jego przedstawiciele byli świadomi procedur, narzędzi oraz polityk, które zmniejszają ryzyko infiltracji organizacji.'}],bottom_text:['Dzięki przeprowadzonym szkoleniom, osoby na wyżej wymienionych stanowiskach będą świadomie przestrzegać zasad związanych z bezpieczeństwem oraz wykonywać zadania w sposób nienarażający firmy na straty materialne/niematerialne.']},cta:[{text:'Pobierz broszurę',icon:'download',pdf_lp:""+'/pdfs/brochures/pl/Szkolenia_personelu.pdf'},{text:'Zapytaj o szczegóły',icon:'ask',page:'contact'}]}]});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Kontakt',form:{title:'Zostaw wiadomość, z chęcią odpowiemy.',placeholder:{name:'Imię',surname:'Nazwisko',email:'Twój firmowy email',phone:'Numer telefonu',message:'Wiadomość',topic:'Wybierz temat'},label:{checkbox:'Dane administrowane są przez Sagiton Sp. z o.o., zostały przekazane dobrowolnie i będą przetwarzane przez administratora zgodnie z przepisami ustawy z dnia 29 sierpnia 1997r. o ochronie danych osobowych (Dz. U. z 2002r. nr 101, poz. 926 z późn. zm.) w celach marketingowych, sprzedaży produktów i usług Sagiton Sp.z o.o. Zostałem/am poinformowany/a o prawie dostępu do treści swoich danych, ich poprawiania oraz prawie wniesienia w każdym czasie sprzeciwu wobec ich przetwarzania.',checkbox2:'Wyrażam zgodę na otrzymywanie od Sagiton Sp.z o.o. informacji handlowej za pomocą poczty elektronicznej.',button:'Wyślij',refresh:'Odśwież',showEmail:'Odkryj Email',mailToTitle:'zapytanie',mailToDisclaimerText:'Aby mieć pewność, że Twoje zgłoszenie nie zostanie uznane za ruch typu SPAM/BOT, użyj poniższego adresu e-mail, który zawiera unikalny token przydzielony Tobie'}},people:{title:'Nie czekaj i wyślij e-mail teraz',button:'Rozmowa z konsultantem',labels:{mobile:'mobile',mail:'mail'},list:[{name:'Grzegorz Mąkosa',occupation:'Business Development Partner',phone:'+48 71 700 03 01',email:'grzegorz.makosa@lemlock.com'}]},headquarter:{title:'Adres',address:{company:'Lemlock',note:'Marka lemlock jest własnością Sagiton sp. z o.o.',country:''}},map:{placeId:'ChIJj0OamfvBD0cR2pqv0Y9-3UQ',infowindow:{navigate_text:'Wskazówki dojazdu',navigate_url:'https://www.google.com/maps?ll=51.1124,16.985984&z=16&t=m&hl=pl&gl=PL&mapclient=embed&daddr=Lemlock+-+Testy+Penetracyjne+Fabryczna+19+53-609+Wroc%C5%82aw@51.1124002,16.9859843',review_text:'Zobacz opinie',review_url:'http://www.google.pl/search?q=Lemlock+-+Testy+Penetracyjne,+Fabryczna+19,+53-609+Wroc%C5%82aw&ludocid=4962261520595524314#lrd=0x470fc1fb999a438f:0x44dd7e8fd1af9ada,1',large_map_text:'Wyświetl większą mape'}}});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({tooltip:'Aby pobrać ebook, wypełnij formularz.',form:{title:'Wypełnij formularz, aby pobrać e-booka',placeholder:{name:'Imię',surname:'Nazwisko',email:'Twój email firmowy',company:'Firma'},label:{checkbox:'Dane administrowane są przez Sagiton Sp. z o.o., zostały przekazane dobrowolnie i będą przetwarzane przez administratora zgodnie z przepisami ustawy z dnia 29 sierpnia 1997r. o ochronie danych osobowych (Dz. U. z 2002r. nr 101, poz. 926 z późn. zm.) w celach marketingowych, sprzedaży produktów i usług Sagiton Sp.z o.o. Zostałem/am poinformowany/a o prawie dostępu do treści swoich danych, ich poprawiania oraz prawie wniesienia w każdym czasie sprzeciwu wobec ich przetwarzania.',checkbox2:'Wyrażam zgodę na otrzymywanie od Sagiton Sp.z o.o. informacji handlowej za pomocą poczty elektronicznej.',button:'Pobierz e-book za darmo',refresh:'Odśwież'}},footer:{title:'Interesuje Cię kompleksowe rozwiązanie,<br/> związane z bezpieczeństwem gromadzonych przez Ciebie danych?',button:'Sprawdź naszą ofertę'},download:{text:'Dziękujemy za wypełnienie formularza. Link pozwalający na pobranie ebooka wysłaliśmy na podany email.'},list:[{id:'gdpr_all_about',slug:'wszystko-o-rodo',header:{title:'Pobierz darmowy ebook',subtitle:'Wszystko co musisz wiedzieć na temat RODO',cover:{image:'wszystko-o-rodo-cover-pl.jpg',alt:'Pobierz darmowy ebook - Wszystko co musisz wiedzieć na temat RODO/GDPR'}},content:{title:'Z naszego przewodnika dowiesz się:',list:['Czy RODO/GDPR dotyczy Ciebie lub Twojej firmy?','Jakie dane będą pod ochroną i czy istnieją rodzaje danych, których przetwarzanie będzie zakazane?','Jakie kary, związane z niewłaściwym przetwarzaniem danych, mogą spotkać Twoją Firmę?','I najważniejsze, jak w przypadku ewentualnej kontroli udowodnić, że dobrze zabezpieczasz dane.']}},{id:'gdpr_for_marketing',slug:'rodo-w-marketingu',header:{title:'Pobierz darmowy poradnik',subtitle:'Marketing zgodny z RODO',cover:{image:'rodo-w-marketingu-cover-pl.png',alt:'Pobierz darmowy poradnik - Marketing zgodny z RODO/GDPR'}},content:{title:'Z naszego przewodnika dowiesz się:',list:['Jak przeprowadzać proces profilowania zgodnie z RODO/GDPR?','Jak powinna wyglądać zgoda na przetwarzanie danych osobowych?','W jaki sposób dział marketingu może chronić informacje?','A także poznasz pięć zasad współpracy między działem marketingu a bezpieczeństwa']}},{id:'views_on_cybersecurity',slug:'podejscia-do-cyberbezpieczenstwa',header:{title:'Poradnik ekspercki',subtitle:'Trzy podejścia do cyberbezpieczeństwa',cover:{image:'podejscia-do-cyberbezpieczenstwa-cover-pl.png',alt:'Pobierz darmowy poradnik - Trzy podejścia do cyberbezpieczeństwa'}},content:{title:'Z naszego e-booka dowiesz się:',list:['jakie dane w firmie powinny być zabezpieczane,','jak działają cyberprzestępcy i kto może paść ich ofiarą,','na ile organizacje są świadome swoich słabości i konieczności dostosowania się do przepisów RODO,','czym jest systemowe podejście do bezpieczeństwa.']}}]});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Polityka prywatności',sections:[{title:'Postanowienia ogólne',list:['Administrator danych – Sagiton Sp. z o.o. z siedzibą przy ul. Strzegomskiej 138, 54-429 Wrocław, NIP: 8943044096, REGON: 022069799, wpisanej do Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Wrocławia-Fabrycznej we Wrocławiu, VI Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS: 0000449601, zarządzająca Serwisem dostępnym pod adresem internetowym https://lemlock.com, chroni prywatność swoich Użytkowników stosując odpowiednie zaplecze merytoryczne oraz techniczne wymagane przepisami prawa obowiązującymi na terenie Rzeczpospolitej Polskiej.','Użytkownikiem Serwisu https://lemlock.com jest każdy podmiot, korzystający z usług świadczonych przez Serwis.','Zbiory danych osobowych Użytkowników Serwisu podlegają ochronie fizycznej oraz prawnej dzięki zastosowaniu odpowiedniej infrastruktury technicznej, informatycznej oraz stosowaniu procedur wymaganych przez Ustawę z dnia 29 sierpnia 1997 roku o ochronie danych osobowych (Dz.U. 1997 Nr 133, poz. 883) oraz Ustawę z dnia 18 lipca 2002 roku o świadczeniu usług drogą elektroniczną (Dz.U. 2002 Nr 144 poz. 1204.).','Administrator danych osobowych szanuje prawo Użytkowników do prywatności dbając o bezpieczeństwo wszelkich przekazywanych informacji za pośrednictwem Serwisu https://lemlock.com.','Niniejszy dokument określa sposób gromadzenia oraz przetwarzania wszelkich informacji w tym danych osobowych, uzyskanych od osób odwiedzających oraz korzystających z Serwisu funkcjonującego pod adresem https://lemlock.com.']},{title:'Dane gromadzone przez administratora danych',list:['Administrator gromadzi, przetwarza oraz wykorzystuje dane osobowe dobrowolnie przekazywane przez swoich Użytkowników, wyłącznie kiedy wyrażą oni zgodę na ich przetwarzanie.','Wszelkie informacje przekazywane przez Użytkowników przetwarzane są przede wszystkim w celu realizacji w sposób prawidłowy usług świadczonych przez Serwis.','Administrator gromadzi oraz przetwarza:',['dane niezbędne w celu rejestracji i założenia konta – adres poczty elektronicznej e-mail, imię i nazwisko, a w przypadku Użytkownika – przedsiębiorcy, także nazwa i siedziba firmy,','dane niezbędne w celu wysłania Zamówienia (zapytania ofertowego) – adres poczty elektronicznej e-mail, imię i nazwisko, a w przypadku Użytkownika – przedsiębiorcy, także nazwa i siedziba firmy,','dane niezbędne w przypadku świadczenia usług, których katalog w zależności od świadczonych usług może ulec zmianie – adres poczty elektronicznej,','dane niezbędne w celu wystawienia faktury VAT – imię i nazwisko, nazwa firmy, dane adresowe, nr NIP oraz adres e-mail,','dane niezbędne w celu przeprowadzenia procesu reklamacji – imię i nazwisko, oraz adres e-mail.'],'Administrator przetwarza dane osobowe Użytkowników niezbędne do nawiązania, ukształtowania treści, zmiany lub rozwiązania stosunku prawnego w ramach usług świadczonych przez Serwis, oraz inne dane, podane przez Użytkownika, niezbędne ze względu na właściwość świadczonej usługi (zgodnie z art. 18 ust. 1 i 2 ustawy z dnia 18 lipca 2002 roku o świadczeniu usług drogą elektroniczną).','Administrator gwarantuje wszystkim Użytkownikom realizację uprawnień jakie wynikają z ustawy z dnia 29 sierpnia 1997 r. o ochronie danych osobowych (Dz. U. z 2002 r. Nr 101, poz. 926 z późn. zm.) w tym m.in. prawo do wglądu do własnych danych osobowych, prawo żądania aktualizacji lub usunięcia danych osobowych, prawo wniesienia sprzeciwu w przypadkach określonych w przepisach wspomnianej ustawy. Powyższe Użytkownik dokonać może bezpośrednio pod adresem e-mail: contact@lemlock.com.','Zbiór danych osobowych Serwisu został zgłoszony do rejestracji Generalnemu Inspektorowi Ochrony Danych Osobowych.']},{title:'Sposób wykorzystania danych osobowych',list:['Administrator może wykorzystywać informacje przekazane przez Użytkownika wyłącznie w sposób określony w niniejszym dokumencie. Każdorazowe wykorzystanie informacji w inny sposób niż określony w niniejszym dokumencie będzie wiązało się z poinformowaniem Użytkownika o sposobie i celu ich wykorzystania oraz będzie wymagało od Użytkownika każdorazowego wyrażenia zgody na ich wykorzystanie.','Dane osobowe Użytkownika wykorzystywane są przede wszystkim w celu właściwego prowadzenia i funkcjonowania Serwisu oraz świadczenia usług drogą elektroniczną.','Dane osobowe przekazane przez Użytkownika mogą być wykorzystywane w celu przesyłania mu informacji handlowych pochodzących bezpośrednio od Administratora oraz celem przesyłania newslettera zawierającego informacje związane z Serwisem, w tym dotyczące nowości pojawiających się w Serwisie oraz inne informacje związane z tematyką Serwisu. Na takie działanie Administratora Użytkownik wyraża odrębną zgodę na stronie Serwisu https://lemlock.com.','Dane osobowe Użytkownika przechowywane są przez okres korzystania z usług świadczonych przez Serwis. Administrator nie przekazuje danych osobowych swoich Użytkowników wbrew prawu podmiotom trzecim nie ujętym w niniejszym dokumencie. Przekazanie danych możliwe jest wyłącznie na żądanie uprawnionych do tego organów państwowych, w szczególności po wskazaniu podstawy prawnej oraz uzasadnienia potrzeby posiadania wspomnianych danych.','Administrator danych osobowych zastrzega sobie możliwość powierzenia przetwarzania danych osobowych Użytkownika innym firmom na podstawie pisemnych umów zawartych zgodnie z art. 31 Ustawy z dnia 29 sierpnia 1997 roku o ochronie danych osobowych (Dz. U. 1997 Nr 133, poz. 883) w celu wykonania przez te firmy usług na rzecz Serwisu prowadzących do jego poprawnego działania, w szczególności usług związanych z hostingiem, utrzymaniem oraz zarządzaniem serwerów, na których funkcjonuje Serwis, administracją Serwisu, prowadzeniem prac konserwacyjnych Serwisu, a także dochodzeniem roszczeń oraz wyjaśnianiem okoliczności niedozwolonego korzystania z usług świadczonych drogą elektroniczną.','Administrator zastrzega sobie prawo do przekazania wszystkich zgromadzonych informacji o Użytkownikach w przypadku restrukturyzacji Serwisu, jego sprzedaży, fuzji, wejścia w spółkę, przypisania, przeniesienia lub zmiany przeznaczenia jakiejkolwiek części Serwisu. O przeprowadzeniu procesu Użytkownik będzie informowany każdorazowo w przypadku zaistnienia wspomnianego, dzięki czemu będzie mógł zadecydować o dalszym korzystaniu lub tez zaprzestaniu korzystania z Serwisu.','Administrator wykorzystuje technologię Cookies w celu dostosowania Serwisu do potrzeb Użytkownika. Użytkownik może nie wyrażać zgody na to, aby wpisane przez niego dane zostały zapamiętane i aby mógł bez powtórnego wpisywania korzystać z nich przy następnych odwiedzinach Serwisu. Właściciele innych witryn nie będą mieli dostępu do danych określonych w niniejszym punkcie. Jeżeli Użytkownik nie zgadza się na personalizowanie Serwisu, może wyłączyć obsługę Cookies w opcjach przeglądarki internetowej.','Administrator wykorzystuje dane zgromadzone w logach systemowych wynikające z ogólnych zasad połączeń realizowanych w sieci Internet np. adres IP Użytkownika. Wszelkie dane zgromadzone w logach systemowych w tym dane eksploatacyjne, określające aktywność Użytkownika w serwisie wykorzystywane są przez Serwis w zgodzie z obowiązującymi przepisami prawa, szczególnie w celach technicznych oraz statystycznych.']},{title:'Zasady przekierowania oraz udostępniania',list:['W Serwisie mogą znajdować się lub też Serwis może przekazywać swojemu Użytkownikowi łącza do stron internetowych, adresów e-mail, aplikacji. Wspomniane nie są kontrolowane przez Administratora.','Użytkownik powinien mieć świadomość, iż korzystając ze wspomnianych powinien każdorazowo zapoznać się z warunkami świadczenia usług oraz polityką prywatności podmiotów odpowiedzialnych za strony internetowe lub aplikacje do których prowadzą łącza.','Administrator nie ponosi odpowiedzialności za prawidłowość działania systemów informatycznych, stron internetowych i aplikacji oraz za poprawność adresów e-mail do których łącza znajdują się w Serwisie.','Administrator nie ponosi odpowiedzialności za treści reklamowe oraz informacje udostępniane przez kontrahentów za jego pośrednictwem.']},{title:'Zabezpieczenia',list:['Administrator dokłada najwyższych starań w celu jak najlepszego zabezpieczenia danych Użytkowników w tym danych osobowych w szczególności przed utratą, nieodpowiednim użyciem, dostępem przez podmioty nieuprawnione oraz ujawnieniem danych.','Użytkownik odpowiada za utrzymanie poufności swoich danych dostępowych do świadczonych usług. Wszelkie podejrzenia dotyczące występowania zagrożenia dotyczącego ujawnienia danych lub dostępu podmiotów nieuprawnionych, należy niezwłocznie zgłaszać do Administratora danych osobowych na adres e-mail: contact@lemlock.com.','Mimo zastosowania zaawansowanych środków technicznych Administrator danych nie może w pełni zagwarantować tajemnicy składowanych i przesyłanych danych w sieci Internet.']},{title:'Postanowienia końcowe',list:['Jeżeli Użytkownik nie akceptuje postanowień zawartych w niniejszym dokumencie powinien zaprzestać korzystania z Serwisu.','Użytkownik wypełniając i wysyłając zapytanie ofertowe wyraża zgodę na przetwarzanie swoich danych osobowych przez Administratora danych, zgodnie z Ustawą z dnia 29 sierpnia 1997 roku o ochronie danych osobowych (Dz. U. nr 133, poz. 883).','Administrator zastrzega sobie prawo do zmian w niniejszym dokumencie. W przypadku dokonania zmian, o których mowa powyżej Użytkownik będzie każdorazowo informowany oraz będzie mógł je zaakceptować lub odmówić ich akceptacji.','Niniejszy dokument obowiązuje od dnia 1.09.2017 roku.']}]});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'O firmie',text:['Ta strona zawiera informację na temat Lemlock.','<strong>Siedziba i dane adresowe</strong>','<strong>Sagiton Sp. z o.o.</strong>','Fabryczna 19<br/> 53-609 Wrocław<br/> Polska','Mobile: +48 71 758 00 70<br/> E-mail: contact@sagiton.pl','NIP: PL8943044096<br/> REGON: 022069799<br/> KRS: 0000449601<br/> Zarząd: Marcin Michalski, Grzegorz Mąkosa, Adam Końca','Lemlock jest znakiem towarowym należącym do Sagiton Sp. z o.o.<br/> Wszystkie prawa zastrzeżone, powielanie informacji zawartych na tej stronie zabronione.']});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({video:{copy:'Kopiuj',copied:'Skopiowano',video_id:'4gzisBJRwkk',subject:'Lemlock Video'}});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({form:{title:'Wypełnij formularz i pobierz ebooka',placeholder:{name:'Imię',surname:'Nazwisko',email:'Twój email firmowy',company:'Firma'},label:{checkbox:'Dane administrowane są przez Sagiton Sp. z o.o., zostały przekazane dobrowolnie i będą przetwarzane przez administratora zgodnie z przepisami ustawy z dnia 29 sierpnia 1997r. o ochronie danych osobowych (Dz. U. z 2002r. nr 101, poz. 926 z późn. zm.) w celach marketingowych, sprzedaży produktów i usług Sagiton Sp.z o.o. Zostałem/am poinformowany/a o prawie dostępu do treści swoich danych, ich poprawiania oraz prawie wniesienia w każdym czasie sprzeciwu wobec ich przetwarzania.',checkbox2:'Wyrażam zgodę na otrzymywanie od Sagiton Sp.z o.o. informacji handlowej za pomocą poczty elektronicznej.',button:'Zapisz się!',refresh:'Odśwież'}},footer:{title:'Interesuje Cię kompleksowe rozwiązanie,<br/> związane z bezpieczeństwem gromadzonych przez Ciebie danych?',button:'Sprawdź naszą ofertę'},subscribed:{text:'Dziękujemy za rejestrację na webinar.<br/> Szczegóły zostaną przesłane na wskazany adres email. Prosimy o sprawdzenie skrzynki mailowej.'},list:[{slug:'jak-zabezpieczyc-swoje-zasoby-cyfrowe-przed-cyberprzestepcami',header:{title:'Zapisz się na darmowy webinar!',subtitle:'Jak zabezpieczyć swoje zasoby cyfrowe przed cyberprzestępcami?',date:'Data: 23 Kwietnia 12:00 CEST'},content:{title:'W trakcie webinaru dowiesz się:',list:['Jakie są zagrożenia i kto może stać się celem cyberprzestępców?','Czym są luki zero-day i one-day?','Jak zmniejszyć ryzyko infiltracji?','Dlaczego dbanie o cyberbezpieczeństwo jest procesem ciągłym?'],bottom_text:'Webinar poprowadzi Bartłomiej Balcerek, ekspert <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'}},{slug:'jak-prowadzic-dzialania-marketingowe-zgodne-z-rodo',header:{title:'Zapisz się na darmowy webinar!',subtitle:'Jak prowadzić działania marketingowe zgodne z RODO?',date:'Data: 12 Kwietnia 12:00 CEST'},content:{title:'W trakcie webinaru dowiesz się:',list:['Jak profilować użytkowników zgodnie z RODO?','Jak powinny wyglądać zgody na przetwarzanie danych osobowych?','Jak zarządzać uzyskanymi zgodami?','Jak działy marketingu mogą zabezpieczać zbierane informacje?','O 5 zasadach, które stoją za pomyślną współpracą miedzy działami marketingu a bezpieczeństwa.'],bottom_text:'Webinar poprowadzi Jarosław Greser i Marcin Michalski, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'}},{slug:'zostalem-zhackowany-co-powinienem-zrobic',header:{title:'Zapisz się na darmowy webinar!',subtitle:'Zostałem zhackowany… Co powinienem zrobić?',date:'Data: 24 Marca 12:00 CET'},content:{title:'W trakcie webinaru dowiesz się:',list:['Dlaczego większość firm, jeśli nawet zorientuje się, że została zaatakowana dowiaduje się o tym długo po dokonaniu ataku?','Jakie procedury techniczne należy uruchomić w organizacji po doświadczeniu ataku?','Jakie obowiązki prawne spoczywają na organizacjach, które zostały zaatakowane?','Jakie są konsekwencje zaniedbania cyberbezpieczeństwa i aspektów ochrony danych?','I najważniejsze, jak możesz się zabezpieczyć przed atakiem cyberprzestępców?'],bottom_text:'Webinar poprowadzi Bartłomiej Balecerk i Jarosław Greser, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'}},{slug:'live-hacking-zobacz-jak-dzialaja-hakerzy-i-zwieksz-swoja-swiadomosc',header:{title:'Zapisz się na darmowy webinar!',subtitle:'Live Hacking - Zobacz jak działają hakerzy i zwiększ swoją świadomość.',date:'Data: 14 Marca 12:00 CET'},content:{title:'W trakcie webinaru dowiesz się:',list:['Jakie są zagrożenia i kto może może stać się celem cyberprzestępców?','Jak hakerzy mogą zaatakować Ciebie i Twoją organizację? - przykłady na żywo','W jaki sposób Twoje zasoby cyfrowe mogą zostać wykorzystane do kradzieży pieniędzy, przejęcia kontroli nad komputerami użytkowników lub infiltracji kont administratora?','I najważniejsze, jak możesz się zabezpieczyć przed atakiem cyberprzestępców?'],bottom_text:'Webinar poprowadzi Bartłomiej Balcerek, ekspert <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'}},{slug:'jak-przygotowac-aplikacje-zgodna-z-rodo',header:{title:'Zapisz się na darmowy webinar!',subtitle:'Jak przygotować aplikację zgodną z RODO?',date:'Data: 31 Marca 12:00 CEST'},content:{title:'W trakcie webinaru dowiesz się:',list:['Czym jest RODO i jakie przepisy nakłada na organizację?','Jakie aspekty związane z RODO są zwykle zaniedbywane lub pomijane przy tworzeniu aplikacji?','Jak przygotować system i aplikację zgodną z RODO już na etapie projektowania?','Jak dostosować gotowe już systemy i aplikacje do wymagań RODO?'],bottom_text:'Webinar poprowadzi Jarosław Greser i Grzegorz Mąkosa, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'}},{slug:'jak-tworzyc-bezpieczne-systemy-i-aplikacje-it',header:{title:'Zapisz się na darmowy webinar!',subtitle:'Jak tworzyć bezpieczne systemy i aplikacje IT?',date:'Data: 5 Kwietnia 12:00 CEST'},content:{title:'W trakcie webinaru dowiesz się:',list:['Jakie są zagrożenia i kto może stać się celem cyberprzestępców?','Czym są koncepcje Security by Design i Security by Default oraz dlaczego należy o nich pamiętać przy tworzeniu aplikacji?','Jak zwiększyć bezpieczeństwo aplikacji nie zmniejszając jej użyteczności?','Jak sprawić, by dane użytkowników były nieużyteczne dla tych, którzy będą próbowali je wykraść?'],bottom_text:'Webinar poprowadzi Jarosław Greser i Grzegorz Mąkosa, eksperci <a href="https://www.lemlock.com" target="_blank">Lemlock</a>'}}]});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'O nas',subtitle:'Lemlock został stworzony w odpowiedzi na zwiększone zapotrzebowanie na posiadanie sprawdzonych oraz cyberbezpiecznych produktów zarówno pod względem technicznym, jak i prawnym.',values:{title:'Wartości'},mission_vision:{mission:{title:'Misja',text:'Zapewnienie, że systemy i rozwiązania naszych klientów są zabezpieczone w odpowiedni sposób, mając na uwadze zarówno aspekty prawne, jak i techniczne.'},vision:{title:'Wizja',text:'Lemlock chce być brakującym ogniwem między procedurami prawnymi a nadzorem technicznym, tworząc efekt pełnej synergii na korzyść naszych klientów.'},verified:{text:'Verified by Lemlock'}},perspectives:{title:'Poznaj nas'},team:{title:'Team',subtitle:'Zespół Lemlock tworzą testerzy bezpieczeństwa, prawnicy oraz inżynierowie oprogramowania.',text:['Ich doświadczenie i kompetencje w zakresie cyberbezpieczeństwa potwierdzają liczne projekty, publikacje naukowe i wystąpienia na krajowych oraz międzynarodowych konferencjach, takich jak Secure Polska, Sieci Komputerowe - Polska czy MMM-ACNS Rosja.','O praktycznej znajomości zagadnień bezpieczeństwa świadczy także znalezienie szeregu podatności w powszechnie używanym oprogramowaniu, np: <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1086" target="_blank" rel="noopener noreferrer">CVE-2013-1086</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1087" target="_blank" rel="noopener noreferrer">CVE-2013-1087</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2015-2802" target="_blank" rel="noopener noreferrer">CVE-2015-2802</a>. Każdemu działaniu przyświeca idea rozwijania biznesu w sposób odpowiedzialny oraz zwiększania świadomości z istniejących zagrożeń w przestrzeni online i offline.']},clutch:{title:'Oni nam zaufali'}});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({header:{title:'Wypełnij poniższy formularz',subtitle:'Nasz zespół skontaktuje się z Tobą niezwłocznie, aby omówić kolejne kroki.',main:'Wybierz usługę która cię interesuje'},list:{improve_title:'Popraw bezpieczeństwo i/lub zgodność aplikacji z przepisami RODO',decrease_title:'Zmniejsz ryzyko cyberataku w Twojej organizacji (Zarządzanie danymi)'},improve:[{title:'Chcę sprawdzić bezpieczeństwo moich aplikacji pod kątem:',slug:'improve-one',number:'1/4',option:[{text:'Web',slug:'web',icon:'improve11'},{text:'Mobile',slug:'mobile',icon:'improve12'},{text:'Serwer',slug:'server',icon:'improve13'}]},{title:'Chcę, aby zostało sprawdzone bezpieczeństwo:',slug:'improve-two',number:'2/4',option:[{text:'istniejącej aplikacji',slug:'running',icon:'improve21'},{text:'kodu źródłowego aplikacji',slug:'application',icon:'improve22'},{text:'konfiguracji serwera produkcyjnego',slug:'production',icon:'improve23'}]},{title:'Chcę mieć pewność, że aplikacja jest zgodna z RODO z perspektywy:',slug:'improve-three',number:'3/4',option:[{text:'prawnej (identyfikacja danych osobowych, warunki korzystania z usługi)',slug:'legal',icon:'improve31'},{text:'architektury systemu (przystosowanie do przepisów RODO)',slug:'system',icon:'improve32pl'},{text:'cyberbezpieczeństwa (bezpieczeństwo danych osobowych)',slug:'cybersecurity',icon:'improve33'}]},{title:'Po weryfikacji pragnę uzyskać:',slug:'improve-four',number:'4/4',option:[{text:'wsparcie w fazie nanoszenia poprawek',slug:'support',icon:'common1'},{text:'ponowne sprawdzenie po zastosowaniu poprawek',slug:'re-check',icon:'common2'},{text:'ciągły monitoring działającej aplikacji i jej kodu źródłowego',slug:'monitor',icon:'improve43'}]}],decrease:[{title:'Zasoby cyfrowe w mojej organizacji wymagają:',slug:'decrease-one',number:'1/3',option:[{text:'nagrania i utrwalenia',slug:'recording',icon:'decrease11'},{text:'obliczenia ryzyka',slug:'calculation',icon:'decrease12'},{text:'polityki zarządzania ryzykiem/polityki bezpieczeństwa',slug:'management',icon:'decrease13'}]},{title:'Aby ochronić:',slug:'decrease-two',number:'2/3',option:[{text:'dane osobowe',slug:'personal',icon:'decrease21'},{text:'know how, przepisy i tajemnice handlowe',slug:'know-how',icon:'decrease22'},{text:'listy płac i wynagrodzeń',slug:'payroll',icon:'decrease23'}]},{title:'Po weryfikacji pragnę uzyskać:',slug:'decrease-three',number:'3/3',option:[{text:'wsparcie w fazie nanoszenia poprawek',slug:'correction',icon:'common1'},{text:'ponowne sprawdzenie po zastosowaniu poprawek',slug:'applying',icon:'common2'},{text:'przygotowany raport weryfikacyjny',slug:'verification',icon:'decrease33'}]}],form:{name:'Imię i nazwisko',mail:'Mail',phone:'Telefon',message:'Wiadomość',send:'Wyślij',refresh:'Odśwież'}});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_cookie__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_header__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_footer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_form__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en_consent_common_json__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en_consent_common_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__en_consent_common_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_consent_rodo_json__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_consent_rodo_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__en_consent_rodo_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__en_consent_data_json__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__en_consent_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__en_consent_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__en_consent_marketing_json__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__en_consent_marketing_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__en_consent_marketing_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__en_home__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__en_threats__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__en_offer__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__en_contact__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__en_ebook__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__en_privacy__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__en_legal__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__en_modals__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__en_webinar__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__en_about__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__en_estimation__ = __webpack_require__(200);
/* harmony default export */ __webpack_exports__["a"] = ({cookie:__WEBPACK_IMPORTED_MODULE_0__en_cookie__["a" /* default */],header:__WEBPACK_IMPORTED_MODULE_1__en_header__["a" /* default */],footer:__WEBPACK_IMPORTED_MODULE_2__en_footer__["a" /* default */],form:__WEBPACK_IMPORTED_MODULE_3__en_form__["a" /* default */],consent:{common:__WEBPACK_IMPORTED_MODULE_4__en_consent_common_json___default.a,rodo:__WEBPACK_IMPORTED_MODULE_5__en_consent_rodo_json___default.a,data:__WEBPACK_IMPORTED_MODULE_6__en_consent_data_json___default.a,marketing:__WEBPACK_IMPORTED_MODULE_7__en_consent_marketing_json___default.a},home:__WEBPACK_IMPORTED_MODULE_8__en_home__["a" /* default */],threats:__WEBPACK_IMPORTED_MODULE_9__en_threats__["a" /* default */],offer:__WEBPACK_IMPORTED_MODULE_10__en_offer__["a" /* default */],contact:__WEBPACK_IMPORTED_MODULE_11__en_contact__["a" /* default */],ebook:__WEBPACK_IMPORTED_MODULE_12__en_ebook__["a" /* default */],privacy:__WEBPACK_IMPORTED_MODULE_13__en_privacy__["a" /* default */],legal:__WEBPACK_IMPORTED_MODULE_14__en_legal__["a" /* default */],modals:__WEBPACK_IMPORTED_MODULE_15__en_modals__["a" /* default */],webinar:__WEBPACK_IMPORTED_MODULE_16__en_webinar__["a" /* default */],about:__WEBPACK_IMPORTED_MODULE_17__en_about__["a" /* default */],estimation:__WEBPACK_IMPORTED_MODULE_18__en_estimation__["a" /* default */]});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({text:'This webpage uses cookies to provide services in accordance with our',privacy:'Privacy policy.',button:'OK'});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({logo:'Lemlock - legal and technical support for your cybersecurity',menu:{scanner:'Scanner',threats:'Threats',offer:'Offer',blog:'Blog',contact:'Contact',video:'Video',about:'About',estimation:'Pricing'}});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({copyright:'lemlock.com | &copy; All rights reserved 2017',privacy:'Privacy Policy',legal:'Legal Notice',contact:{title:'Contact:',labels:{mobile:'mobile',mail:'mail'},people:[{name:'Grzegorz Makosa',occupation:'Business Development Partner',phone:'+48 71 700 03 01',email:'Generate e-mail'}]},headquarter:{title:'Headquarter:',address:{company:'Lemlock',country:'Poland'}}});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:{threats:'Learn more about securing your data.',offer:'Learn more about the tools for your comprehensive data security.',minimize:'Do you want to minimize the risk of cyber attacks in your organization?',estimate:'Do you want to increase security of your applications?',breach:'Are you a victim of cyber attack?',// risk: 'Do you want to prepare your organization to become GDPR compliant?',
audit:'Do you want to prepare your application/IT system to become GDPR compliant?',bottom:'Are you interested in a comprehensive solution for your data security?',contact:'Contact us as soon as possible!'},placeholder:{email:'Your company email',phone:'Phone'},button:{offer:'Schedule a meeting',consultation:'Arrange a free consultation',breach:'Check post-breach incident steps',refresh:'Refresh'// risk: 'Get risk analysis'
},message:{general_error:'Please fill in all required fields correctly.',domain_error:'We don\'t accept temporary email addresses. Type in the correct email address',recaptcha_error:'Something went wrong, please hit the refresh button and try again.',server_error:'Temporary server error. Schedule a meeting sending a message to contact@lemlock.com',success:'Message was sent'},link:{breach:'https://www.lemlock.com/post-breach-steps/'}});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = {"button":"Close","rodoStart":"I confirm that I have read","rodoEnd":"the information clause of Sagiton Sp. z o.o.","dataStart":"Consent to","dataEnd":"data processing for contact purposes","marketingEnd":"data processing for marketing purposes"}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = {"general":["In accordance with Art. 13 section 1 of the General Data Protection Regulation of 27 April 2016, (GDPR), we would like to inform you that the controller of your personal data is Sagiton Sp. z o.o. with its registered office at ul. Fabryczna 19, 53-609 Wrocław, e-mail: grzegorz.makosa@lemlock.com.","Your personal data shall be processed within the scope of: full name, e-mail address and/or phone number in order to answer your question/request for contact and send feedback – pursuant to Art. 6 section 1 (a) of the GDPR, i.e. consent to the processing of personal data.","The data controller would like to inform you that your personal data shall not be disclosed to third parties.","Your data shall not be transferred outside of the European Economic Area or to international organizations.","Your personal data shall be processed until you withdraw your consent to the processing of data, as well as if the purpose for processing this data shall no longer be applicable.","You have the right to access your personal data, rectify it, delete it, restrict its processing, the right to transfer it, as well as the right to object.","In the case of giving your consent, you have the right to withdraw it at any time. Exercising the right to withdraw the consent does not affect the processing carried out before the consent was withdrawn.","You have the right to lodge a complaint with the supervisory body, i.e. the President of the Office for Personal Data Protection, ul. Stawki 2, 00-193 Warsaw.","Providing your personal data is a prerequisite for making contact with you by Sagiton Sp. z o.o. with its registered office at ul. Fabryczna 19, 53-609 Wrocław. In the case of not providing your personal data, Sagiton Sp. z o.o., shall not be able to contact you.","The Data Controller, Sagiton Sp. z o.o., would like to inform you that they shall not use your personal data for automated decision-making, which is based solely on automated processing, including profiling, and has legal effects for you or affects you significantly in a similar way."],"ebook":["In accordance with Art. 13 section 1 of the General Data Protection Regulation of 27 April 2016, (GDPR), we would like to inform you that the controller of your personal data is Sagiton Sp. z o.o. with its registered office at ul. Fabryczna 19, 53-609 Wrocław, e-mail: grzegorz.makosa@lemlock.com.","Your personal data shall be processed within the scope of full name and e-mail address in order to enable you to download the free e-book made available by Sagiton Sp. z o.o. – pursuant to Art. 6 section 1 (a) of the GDPR, i.e. consent to the processing of personal data.","The data controller would like to inform you that your personal data shall not be disclosed to third parties.","Your data shall not be transferred outside of the European Economic Area or to international organizations.","Your personal data shall be processed until your consent is withdrawn.","You have the right to access your personal data, rectify it, delete it, restrict its processing, the right to transfer it, as well as the right to object.","You have the right to withdraw your consent at any time. Exercising the right to withdraw the consent does not affect the processing carried out before the consent was withdrawn.","You have the right to lodge a complaint with the supervisory body, i.e. the President of the Office for Personal Data Protection, ul. Stawki 2, 00-193 Warsaw.","Providing your personal data is a prerequisite for being able to download the free e-book made available by Sagiton Sp. z o.o. with its registered office at ul. Fabryczna 19, 53-609 Wrocław. In the case of not providing your personal data, Sagiton Sp. z o.o., shall not be able to render you these services.","The Controller, Sagiton Sp. z o.o., would like to inform you that they shall not use your personal data for automated decision-making, which is based solely on automated processing, including profiling, and has legal effects for you or affects you significantly in a similar way."],"webinar":["In accordance with Art. 13 section 1 of the General Data Protection Regulation of 27 April 2016, (GDPR), we would like to inform you that the controller of your personal data is Sagiton Sp. z o.o. with its registered office at ul. Fabryczna 19, 53-609 Wrocław, e-mail: grzegorz.makosa@lemlock.com.","Your personal data shall be processed within the scope of full name and e-mail address in order to organize and enable you to participate in the free webinar organized by Sagiton Sp. z o.o. – pursuant to Art. 6 section 1 (a) of the GDPR, i.e. consent to the processing of personal data.","The data controller would like to inform you that your personal data shall not be disclosed to third parties.","Your data shall not be transferred outside of the European Economic Area or to international organizations.","Your personal data shall be processed until your consent is withdrawn.","You have the right to access your personal data, rectify it, delete it, restrict its processing, the right to transfer it, as well as the right to object.","You have the right to withdraw your consent at any time. Exercising the right to withdraw the consent does not affect the processing carried out before the consent was withdrawn.","You have the right to lodge a complaint with the supervisory body, i.e. the President of the Office for Personal Data Protection, ul. Stawki 2, 00-193 Warsaw.","Providing your personal data is a prerequisite for participating in the free webinar organized by Sagiton Sp. z o.o. with its registered office at ul. Fabryczna 19, 53-609 Wrocław. In the case of not providing your personal data, Sagiton Sp. z o.o., shall not be able to render you these services.","The Controller, Sagiton Sp. z o.o., would like to inform you that they shall not use your personal data for automated decision-making, which is based solely on automated processing, including profiling, and has legal effects for you or affects you significantly in a similar way."]}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = {"general":["I hereby give consent to the processing of my personal data by the Personal Data Controller (hereinafter: \"PDC\") – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, within the scope of: full name, e-mail address or phone number, for the purpose of sale of products and services of Sagiton Sp. z o.o. and for the purpose of sending me feedback and making contact with me by Sagiton Sp. z o.o.","At the same time, I acknowledge that: at any time I can request the removal of my personal data from the PDC Sagiton Sp. z o.o. database, by sending an e-mail to grzegorz.makosa@lemlock.com, or a letter to Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, with a statement containing the relevant request, which shall result in the deletion of my personal data from the PDC Sagiton Sp. z o.o. database; I have the right to access my data; providing my data is voluntary, however refusal to provide it is tantamount to not receiving information regarding sale of products and services of Sagiton Sp. z o.o., as well as not receiving feedback and making contact with me by Sagiton Sp. z o.o."],"ebook":["I hereby give consent to the processing of my personal data by the Personal Data Controller (hereinafter: \"PDC\") – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, within the scope of: full name and  e-mail address, in order to download the free e-book made available by Sagiton Sp. z o.o.","At the same time, I acknowledge that: at any time I can request the removal of my personal data from the PDC Sagiton Sp. z o.o. database, by sending an e-mail to grzegorz.makosa@lemlock.com, or a letter to Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, with a statement containing the relevant request, which shall result in the deletion of my personal data from the PDC Sagiton Sp. z o.o. database; I have the right to access my data; providing my data is voluntary, however refusal to provide it is tantamount to inability to download the free e-book made available by Sagiton Sp. z o.o."],"webinar":["I hereby give consent to the processing of my personal data by the Personal Data Controller (hereinafter: \"PDC\") – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, within the scope of: full name and  e-mail address, in order to sign up for a free webinar organized by Sagiton Sp. z o.o.","At the same time, I acknowledge that: at any time I can request the removal of my personal data from the PDC Sagiton Sp. z o.o. database, by sending an e-mail to grzegorz.makosa@lemlock.com, or a letter to Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, with a statement containing the relevant request, which shall result in the deletion of my personal data from the PDC Sagiton Sp. z o.o. database; I have the right to access my data; providing my data is voluntary, however refusal to provide it is tantamount to inability to participate in the free webinar conducted by Sagiton Sp. z o.o."]}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = {"list":["I hereby give consent to the processing of my personal data by the Personal Data Controller (hereinafter: \"PDC\") – Sagiton Sp. z o.o. ul. Fabryczna 19, 53-609 Wrocław, within the scope of: full name, e-mail address or phone number, for marketing purposes, by Sagiton Sp. z o.o.","At the same time, I acknowledge that I can at any time request the removal of my personal data from the PDC Sagiton Sp. z o.o. database, by sending an e-mail to grzegorz.makosa@lemlock.com, or a letter to Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław, with a statement containing the relevant request, which shall result in the deletion of my personal data from the PDC Sagiton Sp. z o.o. database; I have the right to access my data; providing my data is voluntary, however refusal to provide it is tantamount to not receiving commercial information from Sagiton Sp. z o.o."]}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({threats:{excerpt:{title:'Are you not sure if your digital assets and applications require cybersecurity support?',list:['Why is the risk of an attack on data so great?','What exactly will you lose in case of a successful attack?','Why can data theft cost you as much as 4% of your annual turnover?','What actions and tools will ensure your complete security?'],button:'See more'},content:{title:'Are the data you collect secure?',description:'The number of attacks on the organization\'s infrastructure and data theft has been growing at a breathtaking speed in the recent years.',button:'See a video'}},offer:{excerpt:{title:'Why should you consider Lemlock as your cybersecurity partner?',list:['Why does comprehensive security require an interdisciplinary approach?','What are the solutions offered by lemlock?','How to protect the report against data leakage?','How can you prove that your data are well protected?'],button:'Check offer',button_pricing:'Pricing'},content:{title:'Secure your applications and digital assets.',description:'Protection of the organization\'s resources is a challenge that requires knowledge and actions requiring both legal and technological expertise.',button:'Check offer'}},popup:{text:'Do you suspect that your organization has been hacked? Contact us immediately!',link:'https://www.lemlock.com/post-breach-steps/'}});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({one:{section:{title:'Why is the <strong>risk of an attack</strong> on data<br/> so great?'},image:{title:'Main reasons for attacks',tags:['political','religious','ideological','financial','testing abilities','entertainment']},paragraphs:['Carrying out attacks on the organization\'s infrastructure and data theft has been on the rise in the past few years.','According to Deloitte’s <a href="https://www2.deloitte.com/content/dam/Deloitte/tr/Documents/risk/security-and-privacy-noexp.pdf" target="_blank" rel="noopener noreferrer">report</a>, such areas as the motor industry, as well as the financial, telecom and medical sectors proved to be the most popular among cybercriminals in 2017. Currently, there are still more motives for their devastating activity, and any company or institution that has attractive resources or that collects and processes valuable data can become a target of a cyber attack.','The Internet is constantly updated with new training materials concerning security, sometimes also used for unethical reasons. More than 25% of attacks end up not only in data leakage, but their loss as well (often also with the loss of the backup copy).','Consequences of a successful attack cannot be underestimated. Loss of information, destruction of information systems or a blocked website means not only damage to the organization\'s image and loss of reputation, but it may also cause enormous financial losses. From 25 May 2018, the occurrence of these situations may cost you much more - even up to 20 million euros or 4% of global turnover. This is closely related to the data protection requirements listed in the General Data Protection Regulation (GDPR).'],note:'Systems and data security is a continuous process that involves not only the implementation of standards and security, but also their continuous monitoring and testing. In this area, you can not afford concessions or compromises.'},two:{section:{title:'What can you lose if you won’t secure your</br> applications and digital assets properly?'},boxes:['Data loss','Blockage of organization’s activity and its revenue','Loss of reputation','Destruction of IT systems','Financial penalties up to 20 million euros or 4% of the annual global turnover'],text:'The reason for the threats are the increasingly frequent and more sophisticated cyberattacks on the organization\'s systems and the failure to comply with the new data security requirements introduced by <span class="blue">GDPR</span>.'},three:{section:{title:'What <strong>strategies</strong> are used by cybercriminals?'},text:'On average, ¾ of system intrusions are carried out in a matter of minutes. In 50% of cases it takes more than a month to actually detect the attack.',buttons:{more:'See more',less:'Show less'},boxes:[{title:'On a large scale',text:'Cybercriminals are able to carry out large-scale attacks by joining groups. A spectacular attack which took place in May 2017, affected nearly 100 countries. The hackers used an exploit called ETERNALBLUE which had been stolen from the National Security Agency. The bug hijacked computer screens and encrypted hard drive data, demanding bitcoins to unblock them. A massaged, worldwide attack of ransomware software called WannaCry caused the most damage in Russian computers connected to the internal networks of the Ministry of the Interior and the Investigative Committee of the Russian Federation. It also took its toll in the British healthcare system, blocking all patient data, and in the German railway or Renault factoriest. It is still unclear who the attackers were, but the attacked vulnerability was quite obvious and it could have been prevented in the first stage of penetration tests.'},{title:'Sector-specific',text:'These days, there are more and more sector-specific or small-scale attacks. Banking institutions are a very attack-prone area and at the beginning of 2017, Poland saw a rise in attacks on this sector. The website of the Polish Financial Supervision Authority, or rather its subpage for bank employees, was infected. Thanks to that, the malware spread on their computers, stealing personal and financial data, as well as infiltrating the bank’s infrastructure.'},{title:'Target-oriented',text:'Victims of cyberattacks are quite often very specific companies, not only large corporations. Small, local businesses which collect and process data useful for criminals are the most prone to attacks. A Japanese travel agency, JTB Corp., can serve as a good example: a database infiltration attack resulted in the theft of almost 8 million records with sensitive data including client names, addresses and passport numbers.'}]},four:{section:{title:'Why neglecting cyber threats can cost you</br> 20 million EUR or 4% annual turnover?',desc:'<p><span class="blue">GDPR</span> (General Data Protection Regulation) is a new EU regulation concerning personal data protection to <span class="blue">come into force on May 25th 2018</span>.</p>'},text:['It confers new powers on national authorities who control the processing of personal data, e.g. penalizing non-conformity with GDPR requirements, charging as much as 20 million euros or 4% of the annual global turnover. Owing to this, many companies have already started introducing changes to their activity.','<a href="https://blog.lemlock.com/en/blog/categories/gdpr/">GDPR</a> introduces new regulations regarding e.g.:',['transparency of data and procedures,','consent for the processing of personal data and their deletion from legal persons,','designing tools for the processing of data,','the scope and availability of data','the appointment of a Personal Data Administrator and new responsibilities.'],'The legal regulation concerns not only entities established in the EU, but also those from outside of the EU who offer goods and services in the EU (even free of charge) or monitor customers’ behavior on the European market.','In cases of breaches or even suspected incidents, the inspection body will assess the introduced preventive measures. The right choice of data security systems may help to significantly minimize the financial penalties. Introducing security measures and testing their efficiency will prove to be of much greater importance starting in May 2018.'],icon:'gdpr',boxes:{title:'Since the entry of GDPR into force:',list:['Personal Data Administrator is obligated to introduce appropriate technical and organizational security measures while specifying the processing method.','Constant monitoring is required, as well as a swift reaction to incidents and real-time notifications about privacy.','Obligation to notify the supervisory authorities and the data owner about an incident resulting in a personal data security breach.']}},five:{section:{title:'Why do <strong>solutions</strong> have to be<br/> <strong>comprehensive</strong>?',desc:'<p>Threats related to breaches of security and privacy of data, as well as financial penalties for non-conformity to the new regulations, require appropriate preventive measures.</p>'},text:'The protection of organization resources is a continuous process which requires both legal and technological knowledge and actions, and thus:',boxes:['verifying the security and its constant monitoring','adapting norms and procedures to existing provisions of law','introducing appropriate technological solutions ensuring data security'],button:'Find out what actions and tools will ensure your complete security.'},video:{text:'Watch the video',file:'threats-en.mp4',link:'B7LaL0OL9MA'}});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({one:{section:{title:'How you can benefit from <strong>a partnership</strong> with Lemlock?'},button:'Find out more about Lemlock',icons:[{align:'right',title:'Experts from three different sectors',title_2_lines:'Experts from three<br/> different sectors',desc:'Lemlock is synergy which combines expertise from the following three sectors: security testers, lawyers and software engineers.'},{align:'right',title:'Surveillance and Verification Tests',title_2_lines:'Security and<br/> Verification Tests',desc:'Lemlock supervises changes made to your infrastructure, software or information systems. After the verification tests you can be sure that the patches or improvements will be legally and technically compliant with documentation/report on safety status tests.'},{align:'right',title:'Methodology and competence',title_2_lines:'Methodology<br> and competence',desc:'Lemlock’s tests and audits are performed in accordance with OWASP and NIST standards, as well as with ISO 27000. Our testers hold ABW certificates confirming their reliability, and the whole process is supervised by a law firm.'},{align:'right',title:'Active monitoring',title_2_lines:'Active<br> monitoring',desc:'Continuity of data security irrespective of occurring threats requires continuous and active monitoring. Lemlock is like an alarm which will inform you about every single detected threat.'},{align:'left',title:'Start within 48 hours',title_2_lines:'Start within<br/> 48 hours',desc:'Starting the testing process is possible within the first 48 hours. A quick start guarantee and the progress report allow to monitor the entire process in real time.'},{align:'left',title:'Security certificates',title_2_lines:'Security<br/> certificates',desc:'Lemlock standard, Lemlock platinum and GDPR compliance certificate help the holder boost their reliability and trust among clients, business partners and employees.'}]},two:{section:{title:'How our work is done?'},icons:['contact','consultation','progress','report','surveillance','certificates'],bonus:'<span>BONUS:</span> Free consultations with an expert regarding the implementation or modification of security measures.'},three:{button:'Start securing your applications and digital assets',section:{title:'How will you be sure<br/> that your data are <strong>safe</strong> with Lemlock?',desc:'<p>Modern clients are people more and more aware of their rights concerning personal data protection. Companies and institutions which collect or process data gain a significant competitive advantage by proving that they treat security measures seriously.</p><p>Using Lemlock solutions you can easily notify your clients, business partners and employees that you use the right security measures.</p>'},boxes:[{title:'Lemlock STANDARD',textTop:'a penetration test<br/> and a security audit',textBottom:'checking the level of security and eliminating detected breaches'},{title:'Lemlock PLATINIUM',textTop:'monitoring of networks<br/> and services',textBottom:'constant monitoring and immediate correction of detected vulnerabilities'},{title:'GDPR compliance certificate',textTop:'a GDPR compliance<br/> audit',textBottom:'implementing changes in compliance with GDPR requirements'}]},general:{cybersecurity_title:'Software & Application Cybersecurity',consulting_title:'Legal and Technical Consulting',read_more:'See more',back:'Back',button1:'Tell us what you need',button2:'Arrange a free consultation'},clients:{title:'We\'ve been trusted by'},list:[{slug:'application-security-audits-penetration-tests',title:'Application Security Audits & Penetration Tests',subtitle:'Find out about flaws in your web, mobile and server-side applications.',icon:'icon01',content:{title:'Penetration Tests and Security Audits',subtitle:'to detect the vulnerabilities of your applications and IT systems',text:['Let us run controlled attempts of attacks on your applications and IT systems. Such simulations of hacker attacks are a perfect way to find out whether your data are secure.','Unlike a real attack, the pentest and audit are used both to detect obvious vulnerabilities, as well as those which are hidden and barely perceptible. They do not focus on the first encountered gap, but on a thorough search.','The Lemlock’s team on your behalf can supervise the introduction of necessary corrections or improvements to your IT systems and applications based on the generated report with descriptions of identified vulnerabilities: their type, complexity and seriousness.'],icons_title:'Audits relies on <b>OWASP</b> and <b>OWASP Mobile</b> standards and are tailored to protect your:',icons:[{icon:'web',title:'Web Applications'},{icon:'server',title:'Server-Side/Cloud Applications'},{icon:'important',title:'Mobile Applications'}]},cta:[{text:'Pricing',icon:'get',page:'estimation'},{text:'Download brochure',icon:'download',pdf_lp:""+'/pdfs/brochures/en/Lemlock_Security_Audits_and_Penetration_Tests.pdf'},{text:'Ask for details',icon:'ask',page:'contact'}]},{slug:'application-gdpr-compliant-audits',title:'Application GDPR Compliant Audits',subtitle:'Check whether your web, mobile and server-side applications meets technical and legal requirements of new EU law.',icon:'icon02',content:{title:'Application GDPR Compliant Audits',subtitle:'to have your application compliant with new EU privacy law',icons_title:'Detailed GDPR compliance audit for your:',icons:[{icon:'web',title:'Webanwendungen'},{icon:'server',title:'Server-/Cloud-Anwendungen'},{icon:'important',title:'Mobilen Anwendungen'}],list_numbered_title:'Address 3 perspectives:',list_numbered:[{title:'Legal',text:'IT lawyers identifies personal information, assess the risk of processing them basing on <b>ISO 27000</b> standard and when necessary analysing your application Terms of Service.'},{title:'Engineering',text:'System architecture and software engineers analysis application architecture their source code to check whether GDPR provisions can be met and in case they can’t, appropriate recommendations are provided.'},{title:'Cybersecurity',text:'Security experts verifies whether personal information and GDPR provision mechanism are secured properly.'}],list_numbered_text:'Lemlock experts are able to supervise the implementation of recommended protection mechanisms and necessary legal adjustments, thus reducing the risk of data breach or loss.'},cta:[{text:'Pricing',icon:'get',page:'estimation'},{text:'Download brochure',icon:'download',pdf_lp:""+'/pdfs/brochures/en/Lemlock_Audit_of_applications_compliance_with_the_GDPR.pdf'},{text:'Ask for details',icon:'ask',page:'contact'}]},{slug:'continuous-pentesting',title:'Continuous Pentesting & GDPR',subtitle:'Each modification of the application with constant cybersecurity control.',icon:'icon03',content:{title:'Continuous Pentesting & GDPR',subtitle:'Adding new features to your system with the ongoing cybersecurity and GDPR verification process',text:['Your  business needs to evolve and so does your IT solution. You need to keep adding new functionalities so that your product can be attractive for constant changing market. However, at the time of any modification of the system, there is a risk of introducing a new vulnerability or incompatibility with GDPR. It is obvious that before the release of the new version of the application, you can order a <span class="offer-details-blue">security or GDPR audit</span>, but it can be quite time-consuming and expensive. Instead, you can manage security and GDPR privacy of your system in an ongoing way. ','Thanks to Lemlock Continuous Pentesting & GDPR, you can introduce a process which may include:',['ongoing security checks,','ongoing technical GDPR checks,','security consulting for your development team,','swift notifications about detected breaches and vulnerabilities,','immediate correction of security measures,','ongoing monitoring of vulnerabilities of open source libraries you are using,','integrity verification of your system production environment.'],'The security of data and applications is a continuous process, so it is worth ensuring the safety of the Continuous Delivery process together with the Lemlock security team. This will not only help you solve security problems more quickly, but also reduce the number of new vulnerabilities, as the developer team will have a Security expert to ask for assistance. ','In addition, the integrity of the production environment can be constantly monitored, which will help detect whether the application has been modified (changed bank account, content changes, invisible malware scripts injections that infect employees and client computers) and consequently preventing financial and reputation losses. ']},cta:[{text:'Pricing',icon:'get',page:'estimation'},{text:'Download brochure',icon:'download',pdf_lp:""+'/pdfs/brochures/en/Lemlock_Application_Security_Monitoring.pdf'},{text:'Ask for details',icon:'ask',page:'contact'}]},{slug:'risk-management-security-policy',title:'Risk management & security policy',subtitle:'Assess the importance of your IT assets and adjust security strategies.',icon:'icon04',content:{title:'Risk Analysis & Security Policies / Data Governance',subtitle:'to assess the risk of digital assets in your organization and provide appropriate measures to manage it',text:['Find out what kind of data digital assets (servers, databases, applications) are processed in your organization and learn what measures should be undertaken to properly secure them. No matter whether they relate to:',['personal information (GDPR),','know how, recipes and trade secrets,','payroll and wages.'],'This process will be held in accordance with <span class="offer-details-blue">ISO 2700x, GDPR</span> and other binding legal provisions.','Lemlock experts can oversee the implementation of recommended changes to the Risk Management strategy and security policies and can support building the organization\'s awareness of these issues.']},cta:[{text:'Pricing',icon:'get',page:'estimation',hash:'decrease'},{text:'Download brochure',icon:'download',pdf_lp:""+'/pdfs/brochures/en/Lemlock_Risk_management_and_security_policy.pdf'},{text:'Ask for details',icon:'ask',page:'contact'}]},{slug:'incident-handling-and-post-breach-analysis',title:'Incident handling and post-breach analysis',subtitle:'Be sure that you run correct legal and technical procedures in the event of a security breach.',icon:'icon05',content:{title:'Incident handling and Post-breach analysis',subtitle:'to help you in the event of a cyber attack',text:['Incidents related to data security breaches require a fast and adequate reaction involving a number of <span class="offer-details-blue">legal and technical</span> actions like:',['incident confirmation and interruption,','securing the system  and specifying the scale of the attack,','collecting the evidence,','informing interested parties (police, state personal data inspector, CERT and CSIRT)'],'In these hard times trust someone who you can rely on.']},cta:[{text:'Act immediately if you are a victim of cyber attack!',icon:'act',pdf_lp:'https://www.lemlock.com/post-breach-steps/'},{text:'Download brochure',icon:'download',pdf_lp:""+'/pdfs/brochures/en/Lemlock_Incident_handling_and_post_breach_analysis.pdf'}]},{slug:'staff-training',title:'Staff training',subtitle:'Prepare members of your organization to work in accordance with the principles of security in both legal and technical context.',icon:'icon06',content:{title:'Staff training',subtitle:'to ensure that employees carry out their tasks in accordance with safety standards and react accordingly in a critical situation',text:['Special <span class="offer-details-blue">staff training</span> will be carried out to ensure that your organization is fully compliant with the security rules and legal regulations (including the GDPR guidelines).'],list_numbered_title:'Numerous Lemlock experts\' observations show that in training should participate:',list_numbered:[{icon:'network',title:'Network administrators',text:'They know how to administer networks and configure them taking into account the security aspect.'},{icon:'database',title:'Developers and database administrators',text:'They work in a responsible manner and provide applications, systems or databases with a high level of protection during the creation, updating or daily management.'},{icon:'nonTech',title:'Non-technical staff',text:'They are aware of the procedures, tools and policies that reduce the risk of infiltrating the organization.'}],bottom_text:['Thanks to the conducted trainings, people at the above-mentioned positions will consciously obey the rules related to security and perform tasks in a manner that would not harm the company against material/non-material losses.']},cta:[{text:'Download brochure',icon:'download',pdf_lp:""+'/pdfs/brochures/en/Lemlock_Staff_training.pdf'},{text:'Ask for details',icon:'ask',page:'contact'}]}]});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Contact',form:{title:'Leave us a message',placeholder:{name:'Name',surname:'Surname',email:'Your corporate email',phone:'Phone number',message:'Message',topic:'Select topic'},label:{checkbox:'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',checkbox2:'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',button:'Send',refresh:'Refresh',showEmail:'Show Email',mailToTitle:'Contact Request',mailToDisclaimerText:'In order to make sure your request won’t be considered as a SPAM/BOT traffic, please use the email below that contains unique token assigned for you'}},people:{title:'Do not wait and e-mail us now',button:'Chat with a consultant',labels:{mobile:'mobile',mail:'mail'},list:[{name:'Grzegorz Makosa',occupation:'Business Development Partner',phone:'+48 71 700 03 01',email:'grzegorz.makosa@lemlock.com'}]},headquarter:{title:'Headquarter',address:{company:'Lemlock',note:'The lemlock brand is owned by Sagiton sp. z o.o (LLC)',country:'Poland'}},map:{placeId:'ChIJj0OamfvBD0cR2pqv0Y9-3UQ',infowindow:{navigate_text:'Driving directions',navigate_url:'https://www.google.com/maps?ll=51.1124,16.985984&z=16&t=m&hl=pl&gl=PL&mapclient=embed&daddr=Lemlock+-+Testy+Penetracyjne+Fabryczna+19+53-609+Wroc%C5%82aw@51.1124002,16.9859843',review_text:'Reviews',review_url:'http://www.google.pl/search?q=Lemlock+-+Testy+Penetracyjne,+Fabryczna+19,+53-609+Wroc%C5%82aw&ludocid=4962261520595524314#lrd=0x470fc1fb999a438f:0x44dd7e8fd1af9ada,1',large_map_text:'Show large map'}}});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({tooltip:'Complete the form and download the ebook.',form:{title:'Complete the form and download the ebook',placeholder:{name:'Name',surname:'Surname',email:'Your corporate email',company:'Company'},label:{checkbox:'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',checkbox2:'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',button:'Download e-book for free',refresh:'Refresh'}},footer:{title:'Are you interested in a comprehensive solution<br/> for your data security?',button:'Find out our offer'},download:{text:'Thank you for completing the form. Link that allows you to download the ebook was send to your email address.'},list:[{id:'gdpr_all_about',slug:'gdpr-all-about',header:{title:'Download free ebook',subtitle:'Everything you should know about GDPR',cover:{image:'gdpr-all-about-cover-en.jpg',alt:'Download free ebook - Everything you should know about GDPR'}},content:{title:'In our guidebook you will find the following information:',list:['Does GDPR apply to you or your organization?','What kind of data will be under protection and if processing of some data will be forbidden?','What penalties can your organization face in case of wrong data processing?','And the most importantly, how to prove you&apos;re protecting your data properly in case of control audit.']}},{id:'gdpr_for_marketing',slug:'gdpr-for-marketing',header:{title:'Download free guidebook',subtitle:'Marketing compatible with GDPR',cover:{image:'gdpr-for-marketing-cover-en.png',alt:'Download free ebook - Marketing compatible with GDPR'}},content:{title:'From our guidebook you will learn:',list:['How to conduct the profiling process compatible with GDPR?','What the consent to the processing of personal data should look like?','How the marketing department can protect the information?','And also you will find out about the five principles of cooperation between marketing and security']}},{id:'views_on_cybersecurity',slug:'views-on-cybersecurity',header:{title:'Expert guidebook',subtitle:'Three views on cybersecurity',cover:{image:'views-on-cybersecurity-cover-en.png',alt:'Download free ebook - Three views on cybersecurity'}},content:{title:'From our e-book you will learn:',list:['what data in the company should be secured,','how cybercriminals work and who can be targeted by them,','find out if organizations are aware of their own weaknesses and the need to adapt to the provisions of the GDPR,','what is a systemic approach to security.']}}]});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Privacy policy',sections:[{title:'General provisions',list:['The Administrator of https://lemlock.com (the “Website”) – Sagiton Sp. z o.o. with registered office at 19 Fabryczna street, 53-609 Wroclaw, registered under: NIP (VAT Id. No.) PL8943044096, REGON (National Business Registry No.) 022069799, registered in the National Court Register maintained by the District Court for Wrocław-Fabryczna in Wrocław as KRS No. 0000449601 – protects the security of Users’ personal data and information using substantive background and technical resources required by the law in force in the Republic of Poland.','Every beneficent of services provided by the Website is considered a User.','Personal data of the Website Users are subjected to physical and legal protection through the use of appropriate technical infrastructure, information technology and procedures required by the Act of August 29, 1997 on the Protection of Personal Data (Journal of Laws of 1997, No. 133, item 883) and the Act of July 18, 2002 on the Providing Services by Electronic Means (Journal of Laws of 2002, No. 144, item 1204).','The Administrator respects Users’ privacy rights by protecting the security of any personal data or information transmitted through the website https://lemlock.com','The present document defines the methods of collecting and processing any information, including personal data, obtained from Users of the Website.']},{title:'Data collected by the administrator',list:['The Administrator collects, processes and uses personal data provided by Users only in the case of their voluntary consent.','Any data or information provided by Users are processed primarily for the purpose of proper execution of services provided by the Website.','The Administrator collects and processes:',['data necessary to register and create an account – full name and email address; in the case of companies – company name and legal address,','data necessary to send a request for quotation (RFQ) – full name and email address; in the case of companies – company name and legal address,','data necessary to provide services, which catalogue, depending on the service type, may be subjected to changes – name, email address, phone number, residence address; in the case of companies – company name, legal address and VAT Identification Number,','data necessary to issue a VAT invoice – company name, legal and email address and VAT Identification Number,','data necessary for the complaint procedure – name and email address.'],'The Administrator processes Users’ personal data necessary to establish, determine the contents, amend or terminate legal relationship associated with the services provided by the Website, or other data provided by Users, necessary due to the type of service provided (according to the Act of July 18, 2002 on the Providing Services by Electronic Means).','The Administrator guarantees to exercise Users’ rights required by the Act of August 29, 1997 on the Protection of Personal Data (Journal of Laws of 2002, No. 101, item 926 with amendments), including the Users’ right of access to their personal data, the right to request an update or removal of these data, the right to object in the cases specified in the mentioned Act. The foregoing can be accomplished directly at contact@lemlock.com.','The personal data file of the Website was submitted to the register kept by the Inspector General for Personal Data Protection.']},{title:'Use of personal data',list:['The Administrator can use data provided by Users only as specified herein. Every use of the data in any other way than specified herein will entail informing Users of the way and purpose of using the data and will require from them a separate consent.','Users’ personal data are used primarily for the proper functioning of the Website and for providing services by electronic means.','Personal data provided by Users may be used to deliver commercial information directly from the Administrator and to deliver newsletter containing information related to the Website, including news. A separate consent at https://lemlock.com for this activity of the Administrator is needed from Users.','Users’ personal data will be kept for the period of providing services by the Website.','The Administrator does not transmit Users’ personal data against the law to third parties not recognised in this document. Transfer of data is possible only on the request of legally empowered state authorities, in particular after the indication of legal basis and justification of the need for mentioned data.','The Administrator reserves the right to authorise another subject to carry out personal data processing pursuant to a contract concluded in writing according to Art. 31 of the Act of August 29, 1997 on the Protection of Personal Data (Journal of Laws of 1997, No. 133, item 883) for execution by mentioned subject services leading to correct functioning of the Website, in particular services related to hosting, maintenance and management of servers storing and delivering the Website, services related to the Website administration and maintenance, as well as connected with pursuing claims and explanation of the circumstances of unauthorised use of the services provided by electronic means.','The Administrator reserves the right to transfer all the collected information about Users in the case of restructuring, sale, merger, entry into a cooperation, assignment, transfer or reassignment the Website or its any part. Users will be informed of every mentioned process to be able to decide on further use of the Website.','The Administrator uses Cookies technology to adjust the Website to Users’ needs. Users can express no consent for saving entered data and for their use without re-entering them by the next visit on the Website. Owners of other Websites will not have access to data referred to in this section. If Users do not agree to personalise the Website, they may disable Cookies in their web browser options.','The Administrator uses data stored in the system log files such as User’s IP address, resulting from the general principles of communication using Internet protocols. All data stored in the system log files, including operating data defining Users’ activity on the Website, are used by the Website in accordance with the applicable law, especially for technical and statistical purposes.']},{title:'Third-party websites and applications',list:['Third-party websites, email addresses or applications may be linked on the Website or transferred to Users. These are not controlled by the Administrator. Users should be aware that before using these they should always read the terms of service and privacy policies of third-parties responsible for linked websites and applications.','The Administrator is not responsible for the proper operation of information systems, websites and applications and for the correctness of e-mail addresses linked on the Website.','The Administrator is not responsible for advertising content and information disseminated by the counterparties through the Website.']},{title:'Website security',list:['The Administrator strives for the best possible protection of Users’ data, including personal data, in particular against loss, misuse, disclosure of the data or unauthorised access.','Users are responsible for maintaining the confidentiality of their authentication data to services provided by the Website.','Any suspicion on the occurrence of threat concerning data disclosure or unauthorised access must be reported immediately to the Administrator at contact@lemlock.com.','Despite the use of advanced technical means, the Administrator cannot fully guarantee the confidentiality of data stored and transferred across the Internet.']},{title:'Final provisions',list:['If Users do not accept the provisions contained herein, they should discontinue using the Website.','By completing and submitting a request for quotation (RFQ), Users agree to the processing of their personal data by the Administrator, according to the Act of August 29, 1997 on the Protection of Personal Data (Journal of Laws of 1997, No. 133, item 883).','The Administrator reserves the right to amend present document. In case of mentioned amendments, Users will be informed and will be able to accept them or refuse their acceptance.','The present document is effective from 1 September 2017.']}]});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Legal notice',text:['This website supplies information about Lemlock.','<strong>Head office and postal address</strong>','<strong>Sagiton Sp. z o.o.</strong>','Fabryczna 19<br/> 53-609 Wrocław<br/> Poland','Mobile: +48 71 758 00 70<br/> E-mail: contact@sagiton.pl','VAT-ID: PL8943044096<br/> TAX: 022069799<br/> Company number 0000449601 (Register of Entrepreneurs of the National Court Register)<br/> Managing Directors: Marcin Michalski, Grzegorz Mąkosa, Adam Końca','Lemlock is trademark of Sagiton Sp. z o.o.<br/> The product name and logo quoted or displayed on this website are trademark or service marks of their respective owners.']});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({video:{copy:'Copy',copied:'Copied',video_id:'B7LaL0OL9MA',subject:'Lemlock Video'}});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({form:{title:'Complete the form and download the ebook',placeholder:{name:'Name',surname:'Surname',email:'Your corporate email',company:'Company'},label:{checkbox:'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',checkbox2:'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',button:'Sign Up',refresh:'Refresh'}},footer:{title:'Are you interested in a comprehensive solution<br/> for your data security?',button:'Find out our offer'},subscribed:{text:'Thank you for registering for the webinar. For more info please check your email inbox.'},list:[{slug:'can-i-really-secure-my-digital-assets-from-cybercriminals',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'Can I really secure my digital assets from cybercriminals?',date:'Data: 23rd of April 14:00 CEST'},content:{title:'During the webinar you will find out:',list:['what the threats are and who can become cybercriminals’ target','what zero/one day vulnerabilities are','how to decrease the risk of infiltration','why cybersecurity is a continuous process'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security expert Bartłomiej Balcerek'}},{slug:'how-to-make-my-marketing-compliant-with-gdpr',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'How to make my marketing compliant with GDPR?',date:'Date: 12th of April 14:00 CEST'},content:{title:'In the webinar you will find out:',list:['how to conduct the profiling process compatible with GDPR','what the consent to the processing of personal data should look like','how to manage obtained consents','how the marketing department can protect the information','about the five principles of cooperation between marketing and security'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Marcin Michalski (Marketing Technology)'}},{slug:'i-was-hacked-what-should-i-do',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'I was hacked … What should I do?',date:'Date: 24th of March 14:00 CET'},content:{title:'During the webinar you will learn about:',list:['why most companies, if they even realize that they have been attacked, find out about the attack long time after it','what technical procedures need to be conducted by your organization to properly address post-breach incidents','what your legal obligations are','what the consequences are when you neglect cybersecurity and data privacy aspects','what you can do to prevent such incidents from happening'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Bartłomiej Balcerek and Jarosław Greser'}},{slug:'live-hacking-experience-attacks-and-increase-your-awareness',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'Live Hacking - Experience attacks and increase your awareness',date:'Date: 14th of March 14:00 CET'},content:{title:'In the webinar you will find out:',list:['what the threats may be and who can become cybercriminals’ target','in live examples, how hacker can attack you and your organization digital assets','how your digital assets can be used for e.g. stealing money, taking control over your users’ computers or infiltrating your admin accounts','what you can do to prevent it from happening'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security expert Bartłomiej Balcerek'}},{slug:'what-to-do-if-i-want-to-create-gdpr-compliant-apps',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'What to do if I want to create GDPR compliant apps?',date:'Date: 31st of March 14:00 CEST'},content:{title:'In the webinar you will find out:',list:['what GDPR is and what provisions it mandates for organizations','what usually is neglected or overlooked when you think about creating an app','how to prepare your systems and applications for GDPR compliance in design phase','how to adapt already developed systems and applications to the requirements of the GDPR'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Grzegorz Mąkosa (System Architect)'}},{slug:'what-to-do-if-i-want-to-create-secured-it-systems-and-apps',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'What to do if I want to create secured IT systems and apps?',date:'Date: 5th of April 14:00 CEST'},content:{title:'During the webinar you will find out:',list:['what the threats are and who can become cybercriminals’ target','what is Security by Design and Security by Default and why you should keep that in mind when thinking of creating an application','how to increase the security of applications without decreasing its usability','how to make your data useless for those who will try to steal them'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Grzegorz Mąkosa (System Architect)'}}]});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'About us',subtitle:'Lemlock was founded as a response to increased demand for providing cyber-secured software solutions.',values:{title:'Values'},mission_vision:{mission:{title:'Mission',text:'Making sure that our clients\' systems and solutions are secure while having both legal and technical aspects in mind.'},vision:{title:'Vision',text:'Lemlock wants to become the missing link between legal procedures and technical surveillance creating full synergy for the benefit of our clients.'},verified:{text:'Verified by Lemlock'}},perspectives:{title:'Meet us',list:[{image:'bartlomiej',icon:'hacker',occupation:'<span class="bold">Hacker’s perspective</span><br/> Chief Security Officer',name:'Bartłomiej Balcerek',linkedin:'https://www.linkedin.com/in/bartlomiej-balcerek-4b229a1/'},{image:'grzegorz',icon:'developer',occupation:'<span class="bold">Software engineer’s perspective</span><br/> System architect',name:'Grzegorz Mąkosa',linkedin:'https://www.linkedin.com/in/grzegorzmakosa/'},{image:'marcin',icon:'developer',occupation:'<span class="bold">Software engineer’s perspective</span><br/> System architect',name:'Marcin Michalski',linkedin:'https://www.linkedin.com/in/marcin-michalski-0053016/'}]},team:{title:'Team',subtitle:'The Lemlock team is made up of security testers, lawyers and software engineers.',text:['Their experience and competences in the field of cybersecurity are confirmed by numerous projects, scientific publications and presentations at domestic and international conferences  such as Secure Poland, Computer Networks - Poland or MMM-ACNS Russia.','Practical knowledge of security issues is also evidenced by finding a number of vulnerabilities in commonly used software e.g.: <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1086" target="_blank" rel="noopener noreferrer">CVE-2013-1086</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1087" target="_blank" rel="noopener noreferrer">CVE-2013-1087</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2015-2802" target="_blank" rel="noopener noreferrer">CVE-2015-2802</a>. Each activity is guided by the idea of developing a business in a responsible manner and raising awareness of existing threats in online and offline space.']},clutch:{title:'They already trusted us'}});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({header:{title:'Fill out this simple form',subtitle:'Our team will contact you promptly to discuss next steps.',main:'Select service you are interested in'},list:{improve_title:'Improve security and/or GDPR compliance of your application',decrease_title:'Decrease the risk of cyber attack in your organization (Data Governance)'},improve:[{title:'I want to have security of my applications checked for:',slug:'improve-one',number:'1/4',option:[{text:'Web',slug:'web',icon:'improve11'},{text:'Mobile',slug:'mobile',icon:'improve12'},{text:'Server',slug:'server',icon:'improve13'}]},{title:'I want you to check security of:',slug:'improve-two',number:'2/4',option:[{text:'running application',slug:'running',icon:'improve21'},{text:'application source code',slug:'application',icon:'improve22'},{text:'production server configuration',slug:'production',icon:'improve23'}]},{title:'I want to be sure that application is compliant with GDPR from:',slug:'improve-three',number:'3/4',option:[{text:'legal perspective (personal data identification, terms of service)',slug:'legal',icon:'improve31'},{text:'system architecture perspective (addressing GDPR provisions)',slug:'system',icon:'improve32en'},{text:'cybersecurity perspective (security of personal information)',slug:'cybersecurity',icon:'improve33'}]},{title:'After verification I need you to:',slug:'improve-four',number:'4/4',option:[{text:'support me in correction phase',slug:'support',icon:'common1'},{text:'re-check it after applying corrections',slug:'re-check',icon:'common2'},{text:'constantly monitor running application and their source code',slug:'monitor',icon:'improve43'}]}],decrease:[{title:'Digital assets in my organization require:',slug:'decrease-one',number:'1/3',option:[{text:'recording',slug:'recording',icon:'decrease11'},{text:'risk calculation',slug:'calculation',icon:'decrease12'},{text:'risk management/security policies',slug:'management',icon:'decrease13'}]},{title:'To protect:',slug:'decrease-two',number:'2/3',option:[{text:'personal information',slug:'personal',icon:'decrease21'},{text:'know-how, recipes and trade secrets',slug:'know-how',icon:'decrease22'},{text:'payroll and wages',slug:'payroll',icon:'decrease23'}]},{title:'After verification I need you to:',slug:'decrease-three',number:'3/3',option:[{text:'support me in correction phase',slug:'correction',icon:'common1'},{text:'re-check it after applying corrections',slug:'applying',icon:'common2'},{text:'prepare verification report',slug:'verification',icon:'decrease33'}]}],form:{name:'First name and last name',mail:'Mail',phone:'Phone',message:'Message',send:'Send',refresh:'Refresh'}});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_cookie__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__de_header__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__de_footer__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__de_form__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__de_consent_common_json__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__de_consent_common_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__de_consent_common_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__de_consent_rodo_json__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__de_consent_rodo_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__de_consent_rodo_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__de_consent_data_json__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__de_consent_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__de_consent_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__de_consent_marketing_json__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__de_consent_marketing_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__de_consent_marketing_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__de_home__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__de_threats__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__de_offer__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__de_contact__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__de_ebook__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__de_privacy__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__de_legal__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__de_modals__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__de_webinar__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__de_about__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__de_estimation__ = __webpack_require__(220);
/* harmony default export */ __webpack_exports__["a"] = ({cookie:__WEBPACK_IMPORTED_MODULE_0__de_cookie__["a" /* default */],header:__WEBPACK_IMPORTED_MODULE_1__de_header__["a" /* default */],footer:__WEBPACK_IMPORTED_MODULE_2__de_footer__["a" /* default */],form:__WEBPACK_IMPORTED_MODULE_3__de_form__["a" /* default */],consent:{common:__WEBPACK_IMPORTED_MODULE_4__de_consent_common_json___default.a,rodo:__WEBPACK_IMPORTED_MODULE_5__de_consent_rodo_json___default.a,data:__WEBPACK_IMPORTED_MODULE_6__de_consent_data_json___default.a,marketing:__WEBPACK_IMPORTED_MODULE_7__de_consent_marketing_json___default.a},home:__WEBPACK_IMPORTED_MODULE_8__de_home__["a" /* default */],threats:__WEBPACK_IMPORTED_MODULE_9__de_threats__["a" /* default */],offer:__WEBPACK_IMPORTED_MODULE_10__de_offer__["a" /* default */],contact:__WEBPACK_IMPORTED_MODULE_11__de_contact__["a" /* default */],ebook:__WEBPACK_IMPORTED_MODULE_12__de_ebook__["a" /* default */],privacy:__WEBPACK_IMPORTED_MODULE_13__de_privacy__["a" /* default */],legal:__WEBPACK_IMPORTED_MODULE_14__de_legal__["a" /* default */],modals:__WEBPACK_IMPORTED_MODULE_15__de_modals__["a" /* default */],webinar:__WEBPACK_IMPORTED_MODULE_16__de_webinar__["a" /* default */],about:__WEBPACK_IMPORTED_MODULE_17__de_about__["a" /* default */],estimation:__WEBPACK_IMPORTED_MODULE_18__de_estimation__["a" /* default */]});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({text:'Diese Seite verwendet Cookies, zwecks der Erbringung von Leistungen gemäß den',privacy:'Datenschutzbestimmungen.',button:'OK'});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({logo:'Lemlock - legal and technical support for your cybersecurity',menu:{threats:'Bedrohungen',offer:'Angebot',contact:'Kontakt',video:'Video',about:'Über uns',estimation:'Preise'}});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({copyright:'lemlock.de | &copy; All rights reserved 2018',privacy:'Datenschutzbestimmungen.',legal:'Impressum',contact:{title:'Kontakt:',labels:{mobile:'mobile',mail:'mail'},people:[{name:'Grzegorz Makosa',occupation:'Business Development Partner',phone:'+48 71 700 03 01',email:'E-Mail erstellen'}]},headquarter:{title:'Adresse:',address:{company:'Lemlock',country:'Polen'}}});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:{threats:'Erfahren Sie, wie Sie Ihre Daten schützen können.',offer:'Finden Sie heraus, welche Tools Ihnen umfassende Sicherheit bieten.',minimize:'Möchten Sie das Risiko von Cyberangriffen in Ihrem Unternehmen minimieren?',estimate:'Möchten Sie die Sicherheit Ihrer Anwendungen erhöhen?',breach:'Sind Sie Opfer eines Cyberangriffs?',// risk: 'Möchten Sie Ihr Unternehmen auf die DSGVO-Konformität vorbereiten?',
audit:'Möchten Sie, dass Ihre Anwendung / Ihr IT-System DSGVO-konform ist?',bottom:'Sind Sie an einer umfassenden Lösung<br/> in Bezug auf die Sicherheit Ihrer Ressourcen und gesammelten Daten interessiert?',contact:'Kontaktieren Sie uns so schnell wie möglich!'},placeholder:{email:'Ihre geschäftliche E-Mail-Adresse',phone:'Telefon '},button:{offer:'Vereinbaren Sie eine Beratung',consultation:'Vereinbaren Sie eine kostenlose Beratung',breach:'Erfahren Sie, welche Schritte Sie nach einem Angriff unternehmen müssen',refresh:'Neu Laden'// risk: 'Erhalten Sie eine Risikoanalyse'
},message:{general_error:'Bitte füllen Sie alle Felder korrekt aus',domain_error:'Wir akzeptieren keine temporären E-Mail-Adressen. Geben Sie eine korrekte E-Mail-Adresse ein',recaptcha_error:'Es ist ein Fehler aufgetreten. Bitte klicken Sie auf die Schaltfläche Neu Laden und versuchen Sie es erneut.',server_error:'Temporärer Serverfehler. Senden Sie eine Nachricht an contact@lemlock.com',success:'Nachricht wurde gesendet'},link:{breach:'https://www.lemlock.de/verfahren-bei-cyberangriffen/'}});

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = {"button":"Schließen","rodoStart":"Ich bestätige, dass ich","rodoEnd":"die Informationsklausel von Lemlock gelesen habe","dataStart":"Einwilligung zur","dataEnd":"Datenverarbeitung zwecks Kontaktaufnahme","marketingEnd":"Datenverarbeitung zu Marketingzwecken"}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = {"general":["Gemäß Artikel 13 Absatz 1 Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der Richtlinie 95/46/EG (Datenschutz-Grundverordnung) teilen wir Ihnen mit, dass der Administrator Ihrer personenbezogenen Daten das Unternehmen Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 ist. Sie erreichen es per E-Mail unter: grzegorz.makosa@lemlock.com.","Ihre persönlichen Daten (darunter: Vor- und Nachname, E-Mail-Adresse und / oder Telefonnummer) werden zur Beantwortung Ihrer Anfragen sowie für eine Rückmeldung zu Ihrem Anliegen gemäß Art. 6 Abs. 1 lit. b DSGVO (Zustimmung zur Verarbeitung personenbezogener Daten) verwendet.","Der Administrator persönlicher Daten informiert, dass Ihre persönlichen Daten nicht an Dritte weitergegeben werden.","Eine Übermittlung Ihrer Daten in ein Drittland außerhalb des europäischen Wirtschaftsraums oder eine internationale Organisation findet nicht statt.","Ihre personenbezogenen Daten werden solange verarbeitet, bis Ihre Einwilligung widerrufen wird.","Sie haben das Recht auf Zugriff, Berichtigung, Löschung, Einschränkung der Verarbeitung, auf Datenübertragbarkeit und auf Widerruf erteilter Einwilligungen.","Sie haben im Fall der Verarbeitung aufgrund Ihrer Einwilligung das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.","Sie haben das Recht auf eine Beschwerde bei der Aufsichtsbehörde, d.h. dem Präsidenten des Amtes für den Schutz personenbezogener Daten in 00-193 Warschau an der ul. Stawki 2.","Die Bereitstellung Ihrer persönlichen Daten ist Voraussetzung für den Kontakt mit Ihnen durch Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19. Die Nichtangabe von personenbezogenen Daten führt dazu, dass Sagiton Sp. z o.o. Sie nicht kontaktieren kann.","Der Administrator persönlicher Daten von Sagiton Sp. z o.o. informiert, dass er Ihre personenbezogenen Daten nicht für automatisierte Entscheidungen verwendet, die ausschließlich auf einer automatisierten Verarbeitung - einschließlich Profiling - beruhen und die Ihnen gegenüber rechtliche Wirkung entfalten oder Sie in ähnlicher Weise erheblich beeinträchtigen."],"ebook":["Gemäß Artikel 13 Absatz 1 Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der Richtlinie 95/46/EG (Datenschutz-Grundverordnung) teilen wir Ihnen mit, dass der Administrator Ihrer personenbezogenen Daten das Unternehmen Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 ist. Sie erreichen es per E-Mail unter: grzegorz.makosa@lemlock.com.","Ihre persönlichen Daten (darunter: Vor- und Nachname sowie E-Mail-Adresse) werden verwendet, damit Sie ein kostenloses E-Book herunterladen können, das von Sagiton Sp. z o.o. gemäß Art. 6 Abs. 1 lit. a DSGVO (Zustimmung zur Verarbeitung personenbezogener Daten) bereitgestellt wird.","Der Administrator persönlicher Daten informiert, dass Ihre persönlichen Daten nicht an Dritte weitergegeben werden.","Eine Übermittlung Ihrer Daten in ein Drittland außerhalb des europäischen Wirtschaftsraums oder eine internationale Organisation findet nicht statt.","Ihre personenbezogenen Daten werden solange verarbeitet, bis Ihre Einwilligung widerrufen wird.","Sie haben das Recht auf Zugriff, Berichtigung, Löschung, Einschränkung der Verarbeitung, auf Datenübertragbarkeit und auf Widerruf erteilter Einwilligungen.","Sie haben im Fall der Verarbeitung aufgrund Ihrer Einwilligung das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.","Sie haben das Recht auf eine Beschwerde bei der Aufsichtsbehörde, d.h. dem Präsidenten des Amtes für den Schutz personenbezogener Daten in 00-193 Warschau an der ul. Stawki 2.","Die Bereitstellung Ihrer persönlichen Daten ist Voraussetzung für das Herunterladen des von Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 kostenlos zur Verfügung gestellten E-Books. Die Nichtangabe von personenbezogenen Daten führt dazu, dass Sagiton Sp. z o.o. Ihnen die angegebenen Dienstleistungen nicht anbieten kann.","Der Administrator persönlicher Daten von Sagiton Sp. z o.o. informiert, dass er Ihre personenbezogenen Daten nicht für automatisierte Entscheidungen verwendet, die ausschließlich auf einer automatisierten Verarbeitung - einschließlich Profiling - beruhen und die Ihnen gegenüber rechtliche Wirkung entfalten oder Sie in ähnlicher Weise erheblich beeinträchtigen."],"webinar":["Gemäß Artikel 13 Absatz 1 Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der Richtlinie 95/46/EG (Datenschutz-Grundverordnung) teilen wir Ihnen mit, dass der Administrator Ihrer personenbezogenen Daten das Unternehmen Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 ist. Sie erreichen es per E-Mail unter: grzegorz.makosa@lemlock.com.","Ihre persönlichen Daten (darunter: Vor- und Nachname sowie E-Mail-Adresse) werden verwendet, um Ihnen die Teilnahme an einem kostenlosen Webinar zu ermöglichen, das von Sagiton Sp. z o.o. gemäß Art. 6 Abs. 1 lit. a DSGVO (Zustimmung zur Verarbeitung personenbezogener Daten) organisiert wird.","Der Administrator persönlicher Daten informiert, dass Ihre persönlichen Daten nicht an Dritte weitergegeben werden.","Eine Übermittlung Ihrer Daten in ein Drittland außerhalb des europäischen Wirtschaftsraums oder eine internationale Organisation findet nicht statt.","Ihre personenbezogenen Daten werden solange verarbeitet, bis Ihre Einwilligung widerrufen wird.","Sie haben das Recht auf Zugriff, Berichtigung, Löschung, Einschränkung der Verarbeitung, auf Datenübertragbarkeit und auf Widerruf erteilter Einwilligungen.","Sie haben im Fall der Verarbeitung aufgrund Ihrer Einwilligung das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.","Sie haben das Recht auf eine Beschwerde bei der Aufsichtsbehörde, d.h. dem Präsidenten des Amtes für den Schutz personenbezogener Daten in 00-193 Warschau an der ul. Stawki 2.","Die Bereitstellung Ihrer persönlichen Daten ist Voraussetzung für die Teilnahme am kostenlosen Webinar von Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19. Die Nichtangabe von personenbezogenen Daten führt dazu, dass Sagiton Sp. z o.o. Ihnen die angegebenen Dienstleistungen nicht anbieten kann.","Der Administrator persönlicher Daten von Sagiton Sp. z o.o. informiert, dass er Ihre personenbezogenen Daten nicht für automatisierte Entscheidungen verwendet, die ausschließlich auf einer automatisierten Verarbeitung - einschließlich Profiling - beruhen und die Ihnen gegenüber rechtliche Wirkung entfalten oder Sie in ähnlicher Weise erheblich beeinträchtigen."]}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = {"general":["Ich stimme hiermit der Verarbeitung meiner persönlichen Daten (darunter: Vor- und Nachname, E-Mail-Adresse oder Telefonnummer) durch den Administrator persönlicher Daten (im Folgenden: „ApD”) Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 zwecks Verkauf von Produkten und Dienstleistungen von Sagiton Sp. z o.o., der Übermittlung von Rückmeldungen sowie der Kontaktaufnahme zu.","Gleichzeitig nehme ich zur Kenntnis, dass ich jederzeit die Löschung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. fordern kann, indem ich eine E-Mail an grzegorz.makosa@lemlock.com oder einen Brief an Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław schicke. Eine solche Erklärung enthält einen entsprechenden Antrag, der zur Entfernung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. führt; ich habe Zugriffsrecht auf meine Daten; die Angabe meiner Daten ist freiwillig, jedoch führt ihre Nichtbereitstellung zum Ausbleiben von Informationen in Bezug auf den Verkauf von Produkten und Dienstleistungen von Sagiton Sp. z o.o. sowie zum Ausbleiben von Rückmeldungen und Kontaktaufnahmen mit mir."],"ebook":["Ich stimme hiermit der Verarbeitung meiner persönlichen Daten (darunter: Vor- und Nachname sowie E-Mail-Adresse) durch den Administrator persönlicher Daten (im Folgenden: „ApD”) Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 zu, um das von Sagiton Sp. z o.o. kostenlos bereitgestellte E-Book herunterzuladen.","Gleichzeitig nehme ich zur Kenntnis, dass ich jederzeit die Löschung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. fordern kann, indem ich eine E-Mail an grzegorz.makosa@lemlock.com oder einen Brief an Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław schicke. Eine solche Erklärung enthält eine entsprechende Forderung, die zur Entfernung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. führt; ich habe Zugriffsrecht auf meine Daten; die Angabe meiner Daten ist freiwillig, jedoch führt ihre Nichtbereitstellung dazu, dass das von Sagiton Sp. z o.o. kostenlos bereitgestellte E-Book nicht heruntergeladen werden kann."],"webinar":["Ich stimme hiermit der Verarbeitung meiner persönlichen Daten (darunter: Vor- und Nachname sowie E-Mail-Adresse) durch den Administrator persönlicher Daten (im Folgenden: „ApD”) Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 zu, um mich für ein kostenloses Webinar anzumelden, das von Sagiton Sp. z o.o. organisiert wird.","Gleichzeitig nehme ich zur Kenntnis, dass ich jederzeit die Löschung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. fordern kann, indem ich eine E-Mail an grzegorz.makosa@lemlock.com oder einen Brief an Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław schicke. Eine solche Erklärung enthält eine entsprechende Forderung, die zur Entfernung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. führt; ich habe Zugriffsrecht auf meine Daten; die Angabe meiner Daten ist freiwillig, jedoch führt ihre Nichtbereitstellung dazu, dass am von Sagiton Sp. z o.o. realisierten, kostenlosen Webinar nicht teilgenommen werden kann."]}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = {"list":["Ich stimme hiermit der Verarbeitung meiner persönlichen Daten (darunter: Vor- und Nachname, E-Mail-Adresse oder Telefonnummer) durch den Administrator persönlicher Daten (im Folgenden: „ApD”) Sagiton Sp. z o.o. mit Sitz in 53-609 Wrocław an der ul. Fabryczna 19 zu Marketingzwecken zu.","Gleichzeitig nehme ich zur Kenntnis, dass ich jederzeit die Löschung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. fordern kann, indem ich eine E-Mail an grzegorz.makosa@lemlock.com oder einen Brief an Sagiton Sp. z o.o., ul. Fabryczna 19, 53-609 Wrocław schicke. Eine solche Erklärung enthält eine entsprechende Forderung, die zur Entfernung meiner persönlichen Daten aus der Datenbank ApD Sagiton Sp. z o.o. führt; ich habe Zugriffsrecht auf meine Daten; die Angabe meiner Daten ist freiwillig, jedoch führt ihre Nichtbereitstellung dazu, dass keine kommerziellen Informationen von Sagiton Sp. z o.o. erhalten werden können."]}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({threats:{excerpt:{title:'Sind Sie sich unsicher, ob Ihre digitalen Ressourcen und Anwendungen Unterstützung im Bereich Cyber-Sicherheit benötigen?',list:['Warum ist das Risiko eines Angriffs auf Ihre Daten so groß?','Was genau verliert man im Falle eines erfolgreichen Angriffs?','Warum kann Sie der Diebstahl Ihrer Daten bis zu 4% Ihres Jahresumsatzes kosten?','Welche Tätigkeiten und Technologien garantieren Ihnen volle Sicherheit?'],button:'Finden Sie es heraus'},content:{title:'Sind die Ressourcen Ihres Unternehmens sicher?',description:'Die Zahl der Angriffe auf die IT-Infrastruktur in Unternehmen und der Datendiebstähle ist in den letzten Jahren in einem alarmierenden Tempo gewachsen.',button:'VIDEO ANSEHEN'}},offer:{excerpt:{title:'Warum sollte Lemlock Ihr Partner in Sachen Cyber-Sicherheit sein?',list:['Warum erfordert eine umfassende Sicherheit  einen interdisziplinären Ansatz?','Welche Lösungen bietet Lemlock?','Wie kann man den Bericht vor Informationen enthaltenden Leckagen schützen?','Wie weisen Sie nach, dass Ihre Daten gut geschützt sind?'],button:'Angebot',button_pricing:'Pricing'},content:{title:'Sichern Sie Ihre Anwendungen und digitalen Ressourcen.',description:'Der Schutz von Unternehmensressourcen ist eine Herausforderung, für die Wissen und Handlungen in den Bereichen Recht und Technologie gefordert sind.',button:'Angebot'}},popup:{text:'Haben Sie den Verdacht, dass Ihre Organisation gehackt wurde? Kontaktieren Sie uns sofort!',link:'https://www.lemlock.de/verfahren-bei-cyberangriffen/'}});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({one:{section:{title:'Warum ist <strong>das Risiko so hoch</strong>, dass Ihre Ressourcen <br/> angegriffen werden?'},image:{title:'GRÜNDE FÜR EINEN ANGRIFF:',tags:['ideologische','politische','religiöse','Fähigkeitstest','finanzielle','Spaß']},paragraphs:['Angriffe auf die IT-Infrastruktur von Unternehmen und Datendiebstähle wurden in den letzten Jahren immer häufiger durchgeführt.','Laut dem Deloitte-Bericht waren Cyberkriminelle im Jahr 2017 besonders an der Automobil-, Finanz-, Telekommunikations- und Pharmabranche interessiert. Derzeit tauchen noch mehr Motivationsgründe für ihr Handeln auf und jedes Unternehmen oder jede Institution, die attraktive Ressourcen hat oder wertvolle Daten sammelt und verarbeitet, kann zum Ziel eines Cyberangriffs werden.','Im Internet erscheinen ständig neue Trainingsmaterialien aus der Sicherheitsbranche, die nicht nur für ethische Zwecke genutzt werden. Über 25 % der Angriffe enden mit Datenlecks und deren Totalverlust (einschließlich Backup).','Die Auswirkungen eines erfolgreichen Angriffs sind nicht zu bagatellisieren. Informationsverlust, Zerstörung von IT-Systemen oder die Sperrung einer Website bedeuten nicht nur Image- und Reputationsschäden, sondern auch enorme finanzielle Verluste. Ab dem 25. Mai 2018 kann das Auftreten dieser Situationen Sie viel mehr kosten - sogar bis zu 20 Millionen Euro oder 4 % Ihres globalen Umsatzes. Dies steht in engem Zusammenhang mit den Verpflichtungen im Bereich Datenschutz bezüglich der Verordnung über den Schutz personenbezogener Daten (DSGVO).'],note:'Die Sicherheit von Systemen und Daten ist ein kontinuierlicher Prozess, der nicht nur die Implementierung von Standards und Sicherheit beinhaltet, sondern auch deren langfrsitige Überwachung und Tests. In diesem Bereich ist kein Platz für Zugeständnisse oder Kompromisse.'},two:{section:{title:'Was können Sie verlieren, wenn Sie Ihre Anwendungen</br> und digitalen Ressourcen nicht ordnungsgemäß sichern? '},boxes:['Datenverlust','Blockade der laufenden wirtschaftlichen Tätigkeiten und der Einnahmen','Reputationsverlust','Zerstörung von IT-Systemen','Geldstrafen bis zu 20 Millionen Euro oder 4 % des globalen Jahresumsatzes'],text:'Der Grund für die Bedrohungen sind die immer häufigeren und komplexeren Cyberangriffe auf die Systeme der Unternehmen sowie die Nichteinhaltung der neuen Datenschutzrichtlinien, die mit der <span class="blue">DSGVO</span> eingeführt wurden.'},three:{section:{title:'Welche <strong>Strategien</strong> wenden Cyberkriminelle an?'},text:'Im Durchschnitt werden ¾ der Systemeinbrüche innerhalb weniger Minuten durchgeführt, die Erkennung eines Angriffs dagegen erfolgt in mehr als der Hälfte der Fälle nach einem Monat.',buttons:{more:'MEHR ANZEIGEN',less:'WENIGER ANZEIGEN'},boxes:[{title:'In großem Stil',text:'Cyberkriminelle können groß angelegte Angriffe durchführen, indem sie sich Gruppen anschließen. Ein spektakulärer Angriff, der Mitte Mai 2017 stattfand, betraf fast 100 Länder auf der ganzen Welt. Hacker benutzten das ETERNALBLUE-Tool, das der National Security Agency gestohlen wurde. Ein Wurm blockierte Computerbildschirme und verschlüsselte Dateien auf den Festplatten und verlangte für ihre Entschlüsselung eine Bezahlung in Bitcoins. Ein massiver, weltweiter Angriff der Lösegeld-Software namens WannaCry verursachte den größten Schaden an russischen Computern, die mit den internen Netzwerken des Innenministeriums und des Ermittlungskomitees der Russischen Föderation verbunden waren. Dieser Angriff verursachte auch große Unannehmlichkeiten in britischen Gesundheitsdiensten, da der Zugang zu Patientendaten blockierte wurde, und in deutschen Eisenbahnen oder Renault-Fabriken. Es ist nicht bekannt, wer hinter einem Angriff in so großem Stil steckt, aber es steht fest, dass die Schwachstelle, die die Hacker nutzten, bekannt war und bereits in der ersten Phase des Penetrationstests entdeckt werden konnte.'},{title:'Branchenbezogen',text:'Angriffe mit kleinerer Reichweite oder solche, die auf eine bestimmte Branche ausgerichtet sind, werden immer häufiger. Banken sind ein extrem sensibler Sektor. Anfang 2017 wurden eben Banken zum Angriffsziel in Polen. Die Website der polnischen Finanzaufsichtsbehörde wurde infiziert, insbesondere die Unterseite für Bankangestellte. Auf diese Weise verbreitete sich Malware auf ihren Computern, deren Ziel es war, Daten zu stehlen und die Bankinfrastruktur zu infiltrieren.'},{title:'Zweckgerichtet',text:'Zum Opfer eines Cyberangriffs werden auch sehr spezifische Firmen, nicht nur Großkonzerne, sondern auch kleine, lokale Unternehmen. In erster Linie solche, die aus Sicht der Kriminellen, nützliche Daten sammeln und verarbeiten. So war es bei JTB Corp., einem japanischen Reisebüro. Als Folge eines Hackerangriffs auf die Datenbank des Unternehmens wurden fast 8 Millionen Datensätze mit personenbezogenen Daten gestohlen, darunter Nachnamen, Adressen und Passnummern der Kunden.'}]},four:{section:{title:'Warum kann die Vernachlässigung von Cyber-Bedrohungen</br> Sie 20 Millionen EUR oder 4% Ihres Jahresumsatzes kosten?',desc:'<p><span class="blue">Die DSGVO</span> (Datenschutz-Grundverordnung) oder aus dem Englischen DSGVO (General Data Protection Regulation) ist eine neue EU-Verordnung zum Schutz personenbezogener Daten, die am <span class="blue">25. Mai 2018</span> in Kraft getreten ist.</p>'},text:['Die Verordnung räumt den nationalen Behörden, die die Verarbeitung personenbezogener Daten kontrollieren, neue Befugnisse ein, einschließlich der Verhängung von Strafen für die Nichteinhaltung der DSGVO-Richtlinien in Höhe von bis zu 20 Mio. EUR oder 4 % des jährlichen globalen Umsatzes. Daher haben viele Unternehmen bereits mit der Umsetzung der Richtlinien begonnen.','Die DSGVO führt neue Richtlinien ein, wie z.B. in Bezug auf:',['die Transparenz von Daten und Prozessen,','die Einwilligung zur Verarbeitung von Daten von Einzelpersonen und ihre Löschung,','das Entwerfen von Werkzeugen für die Informationsverarbeitung,','der Umfang und die Verfügbarkeit von Daten,','die Ernennung eines Administrators persönlicher Daten (ApD) und seine Aufgaben.'],'Das Inkrafttreten der Rechtsvorschriften betrifft nicht nur Unternehmen mit Sitz in der Europäischen Union, sondern auch Unternehmen außerhalb der EU, sofern sie Waren und Dienstleistungen in der EU anbieten (sogar kostenlos) oder das Kundenverhalten in der EU überwachen.','Bei Verstößen oder Verdacht prüft die Kontrollbehörde, welche Vorsorgemaßnahmen getroffen wurden. Die richtige Vorbereitung von Datensicherheitssystemen kann die Höhe der Geldstrafen erheblich reduzieren. Daher ist die Einführung von Schutzvorkehrungen und das Testen ihrer Wirksamkeit seit Mai 2018 für viele Unternehmen ein wichtiges Thema.'],icon:'dsgvo',boxes:{title:'Nach Inkrafttreten der DSGVO:',list:['Der Administrator persönlicher Daten ist verpflichtet, die Art der Verarbeitung personenbezogener Daten zu definieren und angemessene technische und organisatorische Sicherheitsmaßnahmen zu implementieren.','Erforderlich ist die ständige Überwachung, Reaktion auf Vorfälle und das Alarmieren bei Datenschutzverletzungen in Echtzeit.','Es besteht die Pflicht, dem Aufsichtsorgan und dem Dateneigentümer den Eintritt eines Ereignisses in Form eines Verstoßes/Diebstahls personenbezogener Daten und damit Störungen in der Verarbeitung, zu melden.']}},five:{section:{title:'Warum müssen <strong>Lösungen umfassend</strong> sein?',desc:'<p>Bedrohungen in Form von Datenschutzverletzungen und Strafen, die durch die neuen Vorschriften auferlegt werden, erfordern angemessene Vorbeugemaßnahmen.</p>'},text:'Der Schutz der Unternehmensressourcen ist ein kontinuierlicher Prozess, der Wissen und Maßnahmen aus den Bereichen Recht und Technologie benötigt, wie z.B.:',boxes:['die Überprüfung der Sicherheit und ihre aktive Überwachung','Anpassung der Standards und Verfahren an die geltenden gesetzlichen Bestimmungen','Implementierung geeigneter technologischer Lösungen zur Gewährleistung der Datensicherheit'],button:'Finden Sie heraus, welche Aktivitäten und Tools Ihnen ein hohes Maß an Sicherheit bieten.'},video:{text:'VIDEO ANSEHEN',file:'threats-de.mp4',link:'gNV8LEfg-UE'}});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({one:{section:{title:'Wie profitieren Sie von <strong>der Partnerschaft</strong> mit Lemlock?'},button:'Erfahren Sie mehr über Lemlock',icons:[{align:'right',title:'Experten dreier branchen',title_2_lines:'Experten dreier<br/> branchen',desc:'Lemlock ist eine Synergie, die die Kompetenz von Sicherheitstestern, Anwälten und Software-Ingenieuren vereint.'},{align:'right',title:'Überwachung und verifikation',title_2_lines:'Überwachung und<br/> verifikation',desc:'Lemlocks Team überwacht die Einführung von Veränderungen an Ihrer Infrastruktur, Software oder Informationssystemen. Nach der durchgeführten Verifikation können Sie sicher sein, dass vorgenommene Korrekturen oder Verbesserungen mit der Dokumentation/dem Bericht über den Sicherheitsstatus in rechtlicher und technischer Hinsicht kompatibel sind.'},{align:'right',title:'Methodik und kompetenzen',title_2_lines:'Methodik <br> und kompetenzen',desc:'Lemlocks Tests und Prüfungen werden gemäß Richtlinien der OWASP und NIST durchgeführt und entsprechen den Standards der ISO 27000. Die Tester besitzen Zertifikate des polnischen Inlandsgeheimdienstes, die die Glaubwürdigkeit bestätigen und die Anwaltskanzlei überwacht den gesamten Prozess.'},{align:'right',title:'Aktive überwachung',title_2_lines:'Aktive<br> überwachung',desc:'Die Kontinuität der Datensicherheit, unabhängig von neuen Bedrohungen, erfordert eine ständige, aktive Überwachung. Lemlock ist wie ein Alarm, der Sie über jede erkannte Bedrohung informiert.'},{align:'left',title:'Start in 48 stunden',title_2_lines:'Start in<br/> 48 stunden',desc:'Das Starten des Testprozesses ist in weniger als zwei Tagen möglich. Die Garantie für einen schnellen Start und  die Transparenz über Arbeitsfortschritte ermöglicht Ihnen die Kontrolle über den gesamten Prozess.'},{align:'left',title:'Sicherheitszertifikate',title_2_lines:'Sicherheitszertifikate',desc:'Lemlock Standard, Lemlock Platin und das DSGVO-Konformitätszertifikat werden Ihnen helfen, Ihre Glaubwürdigkeit und Ihr Vertrauen bei Kunden, Geschäftspartnern und Angestellten zu erhöhen.'}]},two:{section:{title:'Wie wir arbeiten?'},icons:['anfrage','beratung','monitoring','bericht','aufsicht','zertifikat'],bonus:'<span>BONUS:</span> Kostenlose Beratung mit einem Experten zur Implementierung und Modifikation von Schutzmaßnahmen.'},three:{button:'Sichern Sie Ihre Anwendungen und digitalen Ressourcen',section:{title:'Wie beweisen Sie,<br/> dass Sie Ihre Daten <strong>gut sichern</strong>?',desc:'<p>Ein moderner Kunde ist sich seiner Rechte in Bezug auf den Schutz personenbezogener Daten mehr und mehr bewusst. Unternehmen und Institutionen, die Daten sammeln oder verarbeiten, gewinnen einen großen Vorteil, wenn sie beweisen, dass sie das Thema Sicherheit ernst nehmen.</p><p>Indem Sie Lemlocks Lösungen verwenden, können Sie Ihren Kunden, Geschäftspartnern und Mitarbeitern ganz einfach mitteilen, dass Sie angemessene Sicherheitsvorkehrungen getroffen haben.</p>'},boxes:[{title:'Lemlock STANDARD',textTop:'penetrationstest<br/> sicherheitsaudit',textBottom:'überprüfung des Sicherheitsniveaus und Entfernung entdeckter Lücken'},{title:'Lemlock PLATINIUM',textTop:'netzwerk- und<br/> Serverüberwachung',textBottom:'permanente Überwachung und sofortige Korrektur auftretender Schwachstellen'},{title:'DSGVO-Konformitätszertifikat',textTop:'DSGVO-Konformitätsaudit',textBottom:'implementiert Veränderungen gemäß den DSGVO-Richtlinien'}]},general:{cybersecurity_title:'Cybersicherheit von Software und Anwendungen',consulting_title:'Rechtliche und technische Beratung',read_more:'Lesen Sie mehr',back:'Zurück',button1:'Mehr erfahren',button2:'Lassen Sie sich kostenlos beraten'},clients:{title:'Vertraut von'},list:[{slug:'application-security-audits-penetration-tests',title:'Sicherheitsaudits und Penetrationstests',subtitle:'Informieren Sie sich über Fehler in Ihren Systemen, Webanwendungen und serverseitigen Anwendungen',icon:'icon01',content:{title:'Sicherheitsaudits und Penetrationstests',subtitle:'zur Erkennung der Schwachstellen von Anwendungen und IT-Systemen',text:['Durchführung kontrollierter Angriffe auf Ihre Anwendungen und IT-Systeme. Solche simulierten Hackerangriffe sind eine großartige Möglichkeit zur Überprüfung der Datensicherheit.','Im Gegensatz zu einem echten Angriff werden Penetrationstests und Audits verwendet, um sowohl deutliche als auch kaum wahrnehmbare Unregelmäßigkeiten aufzuzeigen. Der Hauptzweck besteht in erster Linie darin, einen gründlichen Suchprozess nach Schwachstellen durchzuführen, der sich nicht nur auf die zuerst in Erscheinung getretene Schwachstelle konzentriert.','Das Team von Lemlock kann, basierend auf dem generierten Bericht, identifizierte Schwachstellen (Art, Komplexität und Gewicht) überwachen. Anhand der Beschreibung werden notwendige Korrekturen oder Verbesserungen an Ihren IT-Systemen und Anwendungen durchgeführt.'],icons_title:'Die Audits basieren auf den Standards der <b>OWASP</b> und <b>OWASP Mobile</b> und sind angepasst an den Schutz Ihrer:',icons:[{icon:'web',title:'Webanwendungen'},{icon:'server',title:'Server-/Cloud-Anwendungen'},{icon:'important',title:'Mobilen Anwendungen'}]},cta:[{text:'Fordern Sie einen Kostenvoranschlag an',icon:'get',page:'estimation'},{text:'Laden Sie unsere Broschüre herunter',icon:'download',pdf_lp:""+'/pdfs/brochures/de/Security_Audits_and_Penetration_Tests.pdf'},{text:'Fragen Sie uns nach Einzelheiten',icon:'ask',page:'contact'}]},{slug:'application-gdpr-compliant-audits',title:'DSGVO-Konformitätsprüfung',subtitle:'Finden Sie heraus, ob Ihre webbasierten, mobilen und serverseitigen Anwendungen die technischen und rechtlichen Anforderungen der neuen EU-Verordnung erfüllen',icon:'icon02',content:{title:'DSGVO-Konformitätsprüfung',subtitle:'damit Ihre Anwendung dem neuen EU-Datenschutzgesetz entspricht',icons_title:'Detaillierte Konformitätsprüfung für Ihre:',icons:[{icon:'web',title:'Webanwendungen'},{icon:'server',title:'Server-/Cloud-Anwendungen'},{icon:'important',title:'Mobilen Anwendungen'}],list_numbered_title:'Unter Berücksichtigung dreier Perspektiven:',list_numbered:[{title:'Die rechtliche Perspektive',text:'Rechtsanwälte, die auf die IT-Branche spezialisiert sind, identifizieren personenbezogene Daten, bewerten das mit ihrer Verarbeitung verbundene Risiko basierend auf der <b">ISO 27000</b> und analysieren gegebenenfalls die Nutzungsbedingungen der Dienstleistungen im Rahmen der Anwendung.'},{title:'Die Ingenieursperspektive',text:'Systemarchitekten und Softwareingenieure analysieren die Anwendungsarchitektur anhand des Quellcodes, um festzustellen, ob die Regeln der DSGVO eingehalten werden. Falls nicht, liefern sie entsprechende Empfehlungen.'},{title:'Die Cyber-Sicherheitsperspektive',text:'Sicherheitsexperten verifizieren, ob personenbezogene Daten und alle Mechanismen, die im Rahmen der DSGVO geschaffen wurden, ordnungsgemäß gesichert sind.'}],list_numbered_text:'Lemlocks Experten sind in der Lage, die Implementierung empfohlener Schutzmechanismen und notwendiger gesetzlicher Änderungen zu überwachen, um so das Risiko einer Datenverletzung oder eines Datenverlusts zu reduzieren.'},cta:[{text:'Fordern Sie einen Kostenvoranschlag an',icon:'get',page:'estimation'},{text:'Laden Sie unsere Broschüre herunter',icon:'download',pdf_lp:""+'/pdfs/brochures/de/Audit_of_applications_compliance_with_the_GDPR.pdf'},{text:'Fragen Sie uns nach Einzelheiten',icon:'ask',page:'contact'}]},{slug:'continuous-pentesting',title:'Continuous Pentesting & DSGVO',subtitle:'Jede Änderung der Anwendung mit fortlaufende Kontrolle der Cybersicherheit',icon:'icon03',content:{title:'Continuous Pentesting & DSGVO',subtitle:'Erweitern Sie Ihr System um neue Funktionen mit kontinuierlicher Überprüfung der Cybersicherheit und Einhaltung der DSGVO\n',text:['Ihr Unternehmen, sowie Ihre IT Lösungen entwickeln sich ständig weiter. Um Ihr Produkt für einen sich ständig ändernden Markt attraktiv zu machen, müssen Sie neue Funktionen hinzufügen. Zum Zeitpunkt einer Systemänderung besteht jedoch das Risiko einer neuen Sicherheitslücke oder der Nichteinhaltung der DSGVO. Natürlich können Sie vor der Veröffentlichung der neuen Version der Anwendung eine Sicherheitsüberprüfung, <span class="offer-details-blue">oder die DSGVO-Konformitätsprüfung anordnen</span>, dies kann jedoch zeitaufwändig und teuer sein. Berücksichtigen Sie stattdessen den Continuous Pentesting und DSGVO-Dienst.','Dank Continuous Pentesting & DSGVO wird Ihre Lösung durch einen Prozess abgedeckt, der folgendes umfasst:',['aktuelle Sicherheitsüberprüfungen,','aktuelle technische Inspektionen der DSGVO,','Sicherheitsberatung für Ihr Entwicklerteam,','schnelle Benachrichtigungen über festgestellte Verstöße und Schwachstellen,','sofortige Korrektur von Sicherheitsmaßnahmen,','laufende Überwachung der Schwachstellen der von Ihnen verwendeten Open Source-Bibliotheken,','Integritätsüberprüfung Ihrer Systemproduktionsumgebung.'],'Die Sicherheit von Daten und Anwendungen ist ein kontinuierlicher Prozess. Daher lohnt es sich, die Sicherheit des Continuous Delivery-Prozesses zusammen mit dem Lemlock-Sicherheitsteam zu gewährleisten. Dies hilft Ihnen nicht nur die Sicherheitsprobleme schneller zu lösen, sondern verringert auch die Anzahl neuer Sicherheitslücken, da das Entwicklerteam einen Sicherheitsexperten an der Seite hat.','Darüber hinaus kann die Integrität der Produktionsumgebung ständig überwacht werden, um festzustellen, ob die Anwendung geändert wurde (geändertes Bankkonto, Inhaltsänderungen, unsichtbare bösartige Software, die Mitarbeiter und Client-Computer infizieren), und so Finanzielle- und Ruf-Verluste vermeiden.']},cta:[{text:'Fordern Sie einen Kostenvoranschlag an',icon:'get',page:'estimation'},{text:'Laden Sie unsere Broschüre herunter',icon:'download',pdf_lp:""+'/pdfs/brochures/de/Application_Security_Monitoring.pdf'},{text:'Fragen Sie uns nach Einzelheiten',icon:'ask',page:'contact'}]},{slug:'risk-management-security-policy',title:'Risiko- und Sicherheitspolitik-Management',subtitle:'Passen Sie die Sicherheitsrichtlinien Ihres Unternehmens an das Risiko von IT-Ressourcen an',icon:'icon04',content:{title:'Risiko- und Sicherheitspolitik-Management',subtitle:'um das Risiko Ihrer digitalen Ressourcen zu bewerten und angemessene Mittel zu ihrer Verwaltung bereitzustellen',text:['Überprüfen Sie, welche Arten von Daten im Rahmen Ihrer digitalen Ressourcen (Server, Datenbanken, Anwendungen) in Ihrem Unternehmen verarbeitet werden. Gewinnen Sie Kenntnisse über die Maßnahmen, die ergriffen werden müssen, um Ressourcen angemessen zu sichern, unabhängig davon, ob sie in Bezug stehen zu:',['persönliche Daten (DSGVO),','Know-how, Vorschriften und Geschäftsgeheimnis,','Lohn- oder Gehaltsabrechnung.'],'Dieser Prozess wird in Übereinstimmung mit der <span class="offer-details-blue">ISO 2700x, DSGVO</span> und anderen anwendbaren gesetzlichen Bestimmungen durchgeführt.','Lemlocks Experten können die Umsetzung empfohlener Änderungen der Risikomanagementstrategie und der Sicherheitsrichtlinien überwachen und das Unternehmen dabei unterstützen, das Bewusstsein für diese Probleme zu schärfen.']},cta:[{text:'ordern Sie einen Kostenvoranschlag an',icon:'get',page:'estimation',hash:'decrease'},{text:'Laden Sie unsere Broschüre herunter',icon:'download',pdf_lp:""+'/pdfs/brochures/de/Risk_management_and_security_policy.pdf'},{text:'Fragen Sie uns nach Einzelheiten',icon:'ask',page:'contact'}]},{slug:'incident-handling-and-post-breach-analysis',title:'Störungsmanagement und Analyse nach einem Angriff',subtitle:'Stellen Sie sicher, dass Sie im Fall eines Angriffs auf Ihre IT-Ressourcen von einem Partner unterstützt werden, der angemessene rechtliche und technische Verfahren einleitet',icon:'icon05',content:{title:'Störungsmanagement und Analyse nach einem Angriff',subtitle:'um Sie im Falle eines Cyberangriffs zu unterstützen',text:['Vorfälle im Zusammenhang mit der Verletzung der Datensicherheit erfordern eine schnelle und gut durchdachte Reaktion, einschließlich einer Reihe von <span class="offer-details-blue">rechtlichen und technischen</span> Aktivitäten, wie:',['Bestätigung des Vorfalls und seine Unterbrechung,','Sicherung des Systems und Bestimmung der Angriffsskala,','Sammeln von Beweisen,','Inkenntnissetzung der interessierten Parteien, u.a. Polizei, der Inspektor personenbezogener Daten, CERT (Computer Emergency Response Team) und CSIRT (Computer Security Incident Response Team)'],'In Zeiten von Cyber-Bedrohungen lohnt es sich, jemanden zu haben, auf den man sich immer verlassen kann.']},cta:[{text:'Handeln Sie sofort, wenn Sie Opfer eines Cyberangriffs sind!',icon:'act',pdf_lp:'https://www.lemlock.de/verfahren-bei-cyberangriffen/'},{text:'Laden Sie unsere Broschüre herunter',icon:'download',pdf_lp:""+'/pdfs/brochures/de/Incident_handling_and_post_breach_analysis.pdf'}]},{slug:'staff-training',title:'Schulung des Personals',subtitle:'Bereiten Sie das Personal in Ihrem Unternehmen darauf vor, gemäß den Sicherheitsvorschriften sowohl im rechtlichen als auch im technischen Kontext zu arbeiten',icon:'icon06',content:{title:'Schulung des Personals',subtitle:'um sicherzustellen, dass die Mitarbeiter ihre Aufgaben gemäß den Sicherheitsstandards erfüllen und in einer kritischen Situation entsprechend reagieren',text:['Um sicherzustellen, dass Ihr Unternehmen die Sicherheitsregeln und -gesetze (einschließlich der DSGVO) vollständig einhält, werden spezielle <span class="offer-details-blue">Schulungen für Mitarbeiter</span> durchgeführt.'],list_numbered_title:'Laut Lemlocks Experten sollten Personen mit folgenden Posten obligatorisch am Training teilnehmen:',list_numbered:[{icon:'network',title:'Netzwerkadministratoren',text:'Damit sie wissen, wie man Netzwerke verwaltet und sie unter Berücksichtigung der Sicherheitsaspekte konfiguriert.'},{icon:'database',title:'Entwickler und Datenbankadministratoren',text:'Damit sie verantwortungsvoll arbeiten und Anwendungen, Systeme und Datenbanken bei der Erstellung, Aktualisierung oder dem täglichen Management mit einem hohen Schutzniveau ausstatten.'},{icon:'nonTech',title:'Nichttechnisches Personal',text:'Damit alle Mitarbeiter sich der Verfahren, Werkzeuge und Richtlinien bewusst sind, die das Risiko der Infiltration eines Unternehmens verringern.'}],bottom_text:['Dank der durchgeführten Schulungen werden Mitarbeiter der oben genannten Posten Sicherheitsregeln bewusst einhalten und Aufgaben so ausführen, dass das Unternehmen vor materiellen / immateriellen Schäden geschützt wird.']},cta:[{text:'Laden Sie unsere Broschüre herunter',icon:'download',pdf_lp:""+'/pdfs/brochures/de/Staff_training.pdf'},{text:'Fragen Sie uns nach Einzelheiten',icon:'ask',page:'contact'}]}]});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Kontakt',form:{title:'Hinterlassen Sie uns eine Nachricht, wir antworten Ihnen gerne.',placeholder:{name:'Vorname',surname:'Nachname',email:'Ihre geschäftliche E-Mail-Adresse',phone:'Ihre Telefonnummer',message:'Ihre Nachricht',topic:'Thema wählen'},label:{checkbox:'Die Daten werden von Sagiton Sp. z o.o. verwaltet. Sie wurden freiwillig zur Verfügung gestellt und werden vom Verwalter gemäß den Bestimmungen des polnischen Datenschutzgesetzes vom 29. August 1997 (Gesetzblatt von 2002 Nr. 101, Pos. 926, mit spät. Änd.) für Marketingzwecke, Verkauf von Produkten und Dienstleistungen der Sagiton Sp. z o.o. verarbeitet. Ich wurde über das Recht auf Zugang zu meinen Daten, auf ihre Korrektur und über das Recht, jederzeit Einwände gegen ihre Verarbeitung erheben zu können, informiert.',checkbox2:'Ich bin damit einverstanden, mir durch Sagiton Sp. z o.o. kommerzielle Informationen per E-Mail zusenden zu lassen.',button:'Senden',refresh:'Neu Laden',showEmail:'E-Mail anzeigen',mailToTitle:'Kontaktanfrage',mailToDisclaimerText:'Um sicherzustellen, dass Ihre Anfrage nicht als SPAM/BOT-Verkehr betrachtet wird, verwenden Sie bitte die unten stehende E-Mail mit dem Ihnen zugewiesenen eindeutigen Token'}},people:{title:'Warten Sie nicht und schicken Sie uns jetzt eine E-Mail',button:'Chat mit einem Berater',labels:{mobile:'mobile',mail:'mail'},list:[{name:'Jürgen Frücht',occupation:'Business Development Partner',phone:'+49 175 689 7058',email:'fruecht@lemlock.de'}]},headquarter:{title:'Adresse',address:{company:'Lemlock',note:'Die Marke lemlock ist Eigentum der Sagiton sp. z o.o (LLC)',country:'Polen'}},map:{placeId:'ChIJYcIQWkPPCUcRUpk4bRrJV6E',infowindow:{navigate_text:'Anfahrtsbeschreibung',navigate_url:'https://maps.google.com/maps?ll=51.039943,13.729172&z=16&t=m&hl=pl&gl=PL&mapclient=embed&daddr=Lemlock%20-%20Cyber%20Sicherheit%20Bayrische%20Str.%208%2001069%20Dresden%20Niemcy@51.0399432,13.7291719',review_text:'',review_url:'',large_map_text:'Große Karte'}}});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({tooltip:'Füllen Sie das Formular aus, um das E-Book herunterzuladen.',form:{title:'Füllen Sie das Formular aus um das E-Book herunterzuladen',placeholder:{name:'Vorname',surname:'Nachname',email:'Ihre geschäftliche E-Mail-Adresse',company:'Unternehmen'},label:{checkbox:'Die Daten werden von Sagiton Sp. z o.o. verwaltet; sie wurden freiwillig zur Verfügung gestellt und werden vom Administrator gemäß dem Gesetz über den Schutz personenbezogener Daten vom 29. August 1997 (Gesetzblatt 2002, Nr. 101, Pos. 926, in der geänderten Fassung) für Marketingzwecke, Verkauf von Produkten und Dienstleistungen von Sagiton Sp.z o.o. verarbeitet. Ich bin über das Recht auf Zugang zu meinen Daten, deren Berichtigung und das Recht, jederzeit ihrer Verarbeitung zu widersprechen, informiert worden.',checkbox2:'Ich bin damit einverstanden, dass ich von Sagiton Sp. z o.o. kommerzielle Informationen per E-Mail erhalte.',button:'E-Book kostenlos herunterladen',refresh:'Neu Laden'}},footer:{title:'Interessiert Sie eine umfassende Lösung <br/> zur Sicherheit der von Ihnene gesammelten Daten?',button:'Lernen Sie unser Angebot kennen'},download:{text:'Danke, dass Sie das Formular ausgefüllt haben. Wir haben einen Link an die von Ihnen angegebene E-Mail-Adresse gesendet, unter dem Sie das E-Book herunterladen können.'},list:[{id:'gdpr_all_about',slug:'alles-uber-die-dsgvo',header:{title:'Kostenloses E-Book herunterladen',subtitle:'Alles, was Sie über die DSGVO wissen müssen',cover:{image:'gdpr-all-about-cover-de.jpg',alt:'Kostenloses E-Book herunterladen - Alles, was Sie über die DSGVO wissen müssen'}},content:{title:'In unserem Leitfaden erfahren Sie:',list:['Betrifft die DSGVO Sie oder Ihr Unternehmen?','Welche Daten werden geschützt und gibt es Daten, die von der Verarbeitung ausgeschlossen sind?','Wie hoch sind die Strafen für eine unsachgemäße Datenverarbeitung, die Ihr Unternehmen bekommen kann?','Und am wichtigsten: wie können Sie im Fall einer möglichen Kontrolle beweisen, dass Sie Ihre Daten gut sichern?']}},{id:'gdpr_for_marketing',slug:'dsgvo-im-marketing',header:{title:'Kostenloses E-Book herunterladen',subtitle:'DSGVO-konformes Marketing',cover:{image:'gdpr-for-marketing-cover-de.png',alt:'Kostenloses E-Book herunterladen - DSGVO-konformes Marketing'}},content:{title:'In unserem Leitfaden erfahren Sie:',list:['Wie führt man einen Profiling-Prozess gemäß der DSGVO durch?','Wie sollte die Einwilligung in die Verarbeitung personenbezogener Daten aussehen?','Wie kann die Marketingabteilung Informationen schützen?','Sie lernen auch fünf Prinzipien für die Zusammenarbeit zwischen der Marketing- und Sicherheitsabteilung kennen']}},{id:'views_on_cybersecurity',slug:'perspektiven-auf-cyber-sicherheit',header:{title:'Experten-Ratgeber',subtitle:'drei Perspektiven auf Cyber-Sicherheit',cover:{image:'views-on-cybersecurity-cover-de.png',alt:'Download free ebook - Three views on cybersecurity'}},content:{title:'Von unserem E-book erfahren Sie:',list:['welche Daten im Unternehmen gesichert werden sollten,','wie Cyber-Kriminelle handeln und wer zum Opfer fallen kann,','sind Unternehmen sich ihrer eigenen Schwächen bewusst und dass sich an die Bestimmungen der DSGVO anpassen müssen,','was ist ein systemischer Sicherheitsansatz.']}}]});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Datenschutzbestimmungen',sections:[{title:'Allgemeine bestimmungen',list:['Der Verantwortliche die für Datenverarbeitung – Sagiton Sp. z o.o. mit Sitz in ul. Fabryczna 19, 53-609 Wrocław, NIP (Umsatzsteuer-Identifikationsnummer): 8943044096, REGON (Statistische Firmen-Identifikationsnummer): 022069799, eingetragen in das durch das Regionalgericht Wrocław-Fabryczna in Wrocław, 6. Wirtschaftsabteilung des Staatlichen Gerichtsregisters (Sąd Rejonowy dla Wrocławia-Fabrycznej we Wrocławiu, VI Wydział Gospodarczy Krajowego Rejestru Sądowego) geführte Unternehmensregister unter der Nummer KRS: 0000449601, der den Service unter der zugänglichen Internet-Adresse  https://lemlock.com verwaltet, schützt die Privatsphäre der Nutzer, indem er inhaltliche und technische Einrichtungen anwendet, die durch die in der Republik Polen geltenden rechtlichen Vorschriften erforderlich sind.','Nutzer des Services https://lemlock.com ist jede Person oder Einrichtung, die die durch den Service erbrachte Leistungen in Anspruch nimmt.','Die Dateien mit personenbezogenen Daten von Nutzern des Services unterliegen dem physischem und rechtlichem Schutz durch die Verwendung entsprechender technischen Infrastruktur und IT-Lösungen und der Anwendung der Verfahren, die durch das polnische Datenschutzgesetz vom 29. August 1997 (GBl. 1997 Nr. 133, Pos. 883) und das polnische Gesetz über die Erbringung von Dienstleistungen auf dem elektronischen Weg vom 18. Juli 2002 (GBl. 2002 Nr. 144, Pos. 1204) gefordert werden.','Der Verantwortliche für die Verarbeitung der personenbezogenen Daten respektiert das Recht der Nutzer auf die Privatsphäre, indem er auf die Sicherheit, der durch den Service https://lemlock.com. weitergeleiteten Informationen achtet.','Dieses Dokument bestimmt die Art und Weise der Aufbewahrung und Verarbeitung jeglicher Informationen, darunter personenbezogener Daten, die von den Besucher und Nutzer des Services unter der Adresse https://lemlock.com. kommen.']},{title:'Durch den für die verarbeitung verantwortlichen erhobene daten',list:['Der Verantwortliche für die Verarbeitung erhebt, verarbeitet und nutzt freiwillig übermittelte personenbezogene Daten seiner Nutzer ausschließlich, wenn diese der Verarbeitung zugestimmt haben.','Sämtliche Informationen, die durch Nutzer übermittelt werden, werden primär zum Zweck der korrekten Durchführung der Leistungen, die durch den Anbieter erbracht werden, genutzt.','Der Verantwortliche für die Datenverarbeitung erhebt und verarbeitet:',['zur Registrierung und Eröffnung des Kontos benötigte Daten: E-Mail-Adresse, Vor- und Nachname, und im Falle, der Nutzer ist ein Unternehmen, ebenfalls den Namen und den Sitz der Firma,','zur Übersendung der Bestellung (Angebotsanfrage) benötigte Daten: E-Mail-Adresse, Vor- und Nachname, und im Falle, dass der Nutzer ein Unternehmen ist, ebenfalls den Namen und der Sitz der Firma,','zur Erbringung der Leistung, deren Auflistung, abhängig von den erbrachten Leistungen geändert werden kann - E-Mail-Adresse, Vor- und Nachname, Telefonnummer, Wohnsitz oder Aufenthaltsort, und im Falle, der Nutzer ist ein Unternehmen, ebenfalls den Namen und den Sitz der Firma, sowie die Steuernummer,','Angaben zur Erstellung einer Rechnung mit ausgewiesener MwSt.:  Vor- und Nachname, Firmenname, Anschrift, Steuernummer und E-Mail-Adresse,','zur Durchführung einer Reklamation benötigte Daten: Vor- und Nachname und E-Mail-Adresse.'],'Der Verantwortliche verarbeitet die personenbezogene Daten der Nutzer, die benötigt werden, um die Rechtsbeziehungen im Rahmen der erbrachten Leistung inhaltlich zu gestalten, zu ändern oder aufzulösen, sowie andere aufgrund der Merkmalen der zu erbringenden Leistung erforderliche Daten, die durch den Nutzer angegeben worden sind (gemäß Art. 18 Abs. 1 und 2 des polnischen Gesetzes über die Erbringung von Dienstleistungen auf dem elektronischen Weg vom 18. Juli 2002).','Der Verantwortliche für die Datenverarbeitung garantiert allen Nutzern die Umsetzung aller Ansprüche, die aus dem polnischen Datenschutzgesetz vom 29. August 1997 (GBl. 2002 Nr. 101, Pos. 926 mit sp. Änd. resultieren), darunter beispielsweise das Recht auf den Zugang zu den eigenen personenbezogenen Daten, das Recht, die Aktualisierung oder die Löschung der personenbezogenen Daten zu verlangen, das Recht auf Widerspruch in den Fällen, die in den Bestimmungen des erwähnten Gesetzes festgehalten sind. Die oben erwähnten Handlungen kann der Nutzer unter folgender E-Mail-Adresse vornehmen: contact@lemlock.com.','Die Datei mit personenbezogenen Daten wurde zwecks Registrierung dem polnischen Beauftragten für den Schutz der personenbezogenen Daten gemeldet.']},{title:'Verwendungsweise der personenbezogenen daten',list:['Der Verantwortliche für Datenverarbeitung kann die durch den Nutzer angegebenen Informationen ausschließlich so nutzen, wie es in diesem Dokument bestimmt wird. Jedwede andere Nutzung der Informationen als in diesem Dokument bestimmt, wird mit einer Benachrichtigung des Nutzers über die Art und Weise und über den Zweck dieser Nutzung verbunden sein und wird vom Nutzer jeweils eine Zustimmung für diese Nutzung verlangen.','Die personenbezogenen Daten des Nutzers werden vor allem zwecks der richtigen Durchführung und dem Funktionieren des Services sowie zur Erbringung von Leistungen auf dem elektronischen Weg genutzt.','Die durch den Nutzer angegebenen personenbezogenen Daten können zur Übersendung von geschäftlichen Informationen, die direkt vom Verantwortlichen für Datenverarbeitung kommen, genutzt werden, sowie zur Übersendung eines Newsletters, der Informationen zu dem Service beinhaltet, darunter Neuigkeiten, die im Service erscheinen und andere Informationen, die mit der Thematik des Services verbunden sind. Mit diesem Handeln der Verantwortlichen für die Datenverarbeitung erklärt sich der Nutzer separat auf der Seite des Services https://lemlock.com. einverstanden.','Die personenbezogene Daten des Nutzers werden aufbewahrt, solange die Leistungen durch den Anbieter erbracht werden.','Der Verantwortliche für Datenverarbeitung übergibt keine personenbezogenen Daten eigener Nutzer rechtswidrig an Drittpersonen, die in diesem Dokument nicht erwähnt worden sind.  Die Übergabe der Daten ist nur auf Verlangen der dazu befugten staatlichen Organe möglich, insbesondere nach Angabe der Rechtsgrundlage sowie nach Begründung der Notwendigkeit des Besitzes dieser Daten.','Der Verantwortliche für die Datenverarbeitung behält sich vor, anderen Firmen die Möglichkeit der Verarbeitung von personenbezogenen Daten anzuvertrauen, aufgrund der schriftlichen Verträge, die gem. Art. 31 des polnischen Datenschutzgesetz vom 29. August 1997 (GBl. 1997 Nr. 133, Pos. 883) geschlossen wurden, zwecks der Erbringung von Leistungen für den Service, die zu dem richtigen Funktionieren des Services führen, insbesondere von Leistungen, die mit Hosting, Wartung und Verwaltung von Servern verbunden sind, auf deren der Service funktioniert, Administration des Anbieters sowie Durchführung von Wartungsarbeiten, und Beitreibung von Forderungen und Klärung von Umständen der unbefugten Nutzung von Leistungen, die auf dem elektronischen Weg erbracht werden.','Der Verantwortliche für die Datenverarbeitung behält sich das Recht vor, im Falle der Umstrukturierung des Services, des Verkaufs, der Fusion, des Eintritts in eine Gesellschaft, des Umschreibens, der Übertragung oder der Änderung der Bestimmung einer der Teile des Services alle gesammelten Informationen über Nutzer weiterzuleiten. Beim Auftreten eines dieser Fälle wird der Nutzer über diesen Prozess  jeweils benachrichtigt. Dadurch wird er über die weitere Nutzung des Services oder über die Einstellung der Nutzung entscheiden können.','Der Verantwortliche für Datenverarbeitung nutzt Cookies, um den Service an die Bedürfnisse des Nutzers anzupassen. Der Nutzer kann sein Einverständnis verweigern, dass die Daten, die er angibt, gespeichert werden und dass diese ohne erneutes Eintragen bei der wiederholten Nutzung des Services verwendet werden. Inhaber ander Websites werden keinen Zugang zu den in diesem Punkt bezeichneten Daten haben. Wenn der Nutzer nicht mit der Personalisierung des Services einverstanden ist, kann er die Nutzung von Cookies in den Einstellungen des Internet-Browsers ausschalten.','Der Verantwortliche für Datenverarbeitung verwendet die Daten, die in den Logdateien gesammelt wurden, die sich aus den allgemeinen Regeln für Verbindungen im Internet ergeben, z.B. die IP-Adresse des Nutzers. Alle in den Logdateien erfassten Daten, einschließlich Betriebsdaten, die die Aktivität des Nutzers auf der Website beschreiben, werden vom Service gemäß geltender Rechtsbestimmungen verwendet, insbesondere für technische und statistische Zwecke.']},{title:'Regeln für weiterleitung und freigabe',list:['Verlinkungen zu Websites , E-Mail-Adressen und Apps können sich im Service befinden oder an den Nutzer durch den Service weitergeleitet werden. Die oben erwähnte Links werden nicht von dem Verantwortlichen für Datenverarbeitung kontrolliert. Der Nutzer soll sich dessen bewusst sein, dass er jedesmal die Allgemeinen Geschäftsbedingungen sowie die Datenschutzbestimmungen der Betreiber von Websites und Apps, zu den die Verlinkungen führen, zur Kenntnis nehmen soll, wenn er diese benutzt.','Der Verantwortliche für Datenverarbeitung haftet nicht für das richtige Funktionieren der Datenverarbeitungssysteme, Websites und Apps und die Richtigkeit der E-Mail-Adressen, zu denen Verlinkungen sich im Service befinden.','Der Verantwortliche für Datenverarbeitung haftet nicht für Werbeinhalte und Informationen, die durch Vertragspartner unter seiner Vermittlung veröffentlicht werden.']},{title:'Sicherungsmaßnahmen',list:['Der Verantwortliche für Datenverarbeitung ist im höchsten Maße bestrebt, den bestmöglichen Schutz der Daten des Nutzers einschließlich personenbezogener Daten insbesondere vor Verlust, vor missbräuchlicher Verwendung, unbefugtem Zugriff und vor Offenlegung zu gewährleisten.','Der Nutzer haftet für die Einhaltung der Vertraulichkeit im Bezug auf die Zugangsdaten zu den in Anspruch genommenen Leistungen.','Jeder Verdacht auf eine Gefährdung durch Offenlegung der Daten oder unbefugten Zugriff auf diese sollte dem Verantwortlichen unverzüglich unter der folgenden E-Mail-Adresse mitgeteilt werden: contact@lemlock.com.','Trotz der Verwendung fortschrittlicher technischer Lösungen kann der Verantwortliche für die Datenverarbeitung die Vertraulichkeit, der im Internet gespeicherten und übertragenen Daten nicht vollständig gewährleisten.']},{title:'Schlussbestimmungen',list:['Sollte der Nutzer mit den Bestimmungen, die in dem vorliegenden Dokument festgehalten wurden, nicht einverstanden sein, hat er von der Nutzung des Services abzusehen.','Indem der Nutzer eine Angebotsanfrage ausfüllt und abschickt, stimmt er zu, dass seine personenbezogene Daten durch den Verantwortlichen verarbeitet werden, gemäß dem polnischen Datenschuzgesetzes vom 29. August 1997 (GBl. Nr. 133, Pos. 883).','Der Verantwortliche für die Datenverarbeitung behält sich das Recht vor, Änderungen an diesem Dokument vorzunehmen. Im Fall von Änderungen, die oben erwähnt wurden, wird der Nutzer jedes mal informiert und kann diese akzeptieren oder ablehnen.','Das vorliegende Dokument gilt seit dem 1.09.2017.']}]});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Impressum',text:['Diese Website ist ein Informationsangebot der Lemlock.','<strong>Anschrift</strong>','<strong>Lemlock</strong>','Bayrische Straße 8<br/> 01069 Dresden','Phone +49 175 689 7058<br/> E-mail: info@lemlock.de','Amtsgericht Dresden HRB 37754<br/> Umsatzsteuer-ID: DE 319124529<br/> Finanzamt: Stuttgart<br/> Geschäftsführer: Jürgen Frücht, Marcin Michalski, Grzegorz Mąkosa']});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({video:{copy:'Kopieren',copied:'Kopiert',video_id:'gNV8LEfg-UE',subject:'Lemlock Video'}});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({form:{title:'Complete the form and download the ebook',placeholder:{name:'Name',surname:'Surname',email:'Your corporate email',company:'Company'},label:{checkbox:'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',checkbox2:'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',button:'Sign Up',refresh:'Neu Laden'}},footer:{title:'Are you interested in a comprehensive solution<br/> for your data security?',button:'Find out our offer'},subscribed:{text:'Thank you for registering for the webinar. For more info please check your email inbox.'},list:[{slug:'can-i-really-secure-my-digital-assets-from-cybercriminals',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'Can I really secure my digital assets from cybercriminals?',date:'Data: 23rd of April 14:00 CEST'},content:{title:'During the webinar you will find out:',list:['what the threats are and who can become cybercriminals’ target','what zero/one day vulnerabilities are','how to decrease the risk of infiltration','why cybersecurity is a continuous process'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security expert Bartłomiej Balcerek'}},{slug:'how-to-make-my-marketing-compliant-with-gdpr',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'How to make my marketing compliant with GDPR?',date:'Date: 12th of April 14:00 CEST'},content:{title:'In the webinar you will find out:',list:['how to conduct the profiling process compatible with GDPR','what the consent to the processing of personal data should look like','how to manage obtained consents','how the marketing department can protect the information','about the five principles of cooperation between marketing and security'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Marcin Michalski (Marketing Technology)'}},{slug:'i-was-hacked-what-should-i-do',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'I was hacked … What should I do?',date:'Date: 24th of March 14:00 CET'},content:{title:'During the webinar you will learn about:',list:['why most companies, if they even realize that they have been attacked, find out about the attack long time after it','what technical procedures need to be conducted by your organization to properly address post-breach incidents','what your legal obligations are','what the consequences are when you neglect cybersecurity and data privacy aspects','what you can do to prevent such incidents from happening'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Bartłomiej Balcerek and Jarosław Greser'}},{slug:'live-hacking-experience-attacks-and-increase-your-awareness',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'Live Hacking - Experience attacks and increase your awareness',date:'Date: 14th of March 14:00 CET'},content:{title:'In the webinar you will find out:',list:['what the threats may be and who can become cybercriminals’ target','in live examples, how hacker can attack you and your organization digital assets','how your digital assets can be used for e.g. stealing money, taking control over your users’ computers or infiltrating your admin accounts','what you can do to prevent it from happening'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security expert Bartłomiej Balcerek'}},{slug:'what-to-do-if-i-want-to-create-gdpr-compliant-apps',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'What to do if I want to create DSGVO compliant apps?',date:'Date: 31st of March 14:00 CEST'},content:{title:'In the webinar you will find out:',list:['what DSGVO is and what provisions it mandates for organizations','what usually is neglected or overlooked when you think about creating an app','how to prepare your systems and applications for DSGVO compliance in design phase','how to adapt already developed systems and applications to the requirements of the GDPR'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Grzegorz Mąkosa (System Architect)'}},{slug:'what-to-do-if-i-want-to-create-secured-it-systems-and-apps',header:{title:'Subscribe to Lemlock webinar Today',subtitle:'What to do if I want to create secured IT systems and apps?',date:'Date: 5th of April 14:00 CEST'},content:{title:'During the webinar you will find out:',list:['what the threats are and who can become cybercriminals’ target','what is Security by Design and Security by Default and why you should keep that in mind when thinking of creating an application','how to increase the security of applications without decreasing its usability','how to make your data useless for those who will try to steal them'],bottom_text:'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Grzegorz Mąkosa (System Architect)'}}]});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({title:'Über uns',subtitle:'"Lemlock wurde als Antwort auf die steigende Nachfrage nach cyber-sicheren Softwarelösungen gegründet.',values:{title:'Werte'},mission_vision:{mission:{title:'Mission',text:'Lemlock stellt sicher , dass die Systeme und Lösungen unserer Kunden unter Berücksichtigung rechtlicher und technischer Aspekte, in angemessener Weise gesichert sind.'},vision:{title:'Vision',text:'Lemlock möchte das fehlende Bindeglied zwischen den rechtlichen Verfahren und der technischen Überwachung sein, wodurch eine volle Synergie zugunsten unserer Kunden entsteht.'},verified:{text:'Verified by Lemlock'}},perspectives:{title:'Lemlock - drei Perspektiven bzgl. Cyber-Sicherheit',list:[{image:'bartlomiej',icon:'hacker',occupation:'<span class="bold">Perspektive eines Hackers</span><br/> Chief Security Officer',name:'Bartłomiej Balcerek',linkedin:'https://www.linkedin.com/in/bartlomiej-balcerek-4b229a1/'},{image:'grzegorz',icon:'developer',occupation:'<span class="bold">Perspektive eines Software-Ingenieurs</span><br/> Systemarchitekt',name:'Grzegorz Mąkosa',linkedin:'https://www.linkedin.com/in/grzegorzmakosa/'},{image:'marcin',icon:'developer',occupation:'<span class="bold">Perspektive eines Software-Ingenieurs</span><br/> Systemarchitekt',name:'Marcin Michalski',linkedin:'https://www.linkedin.com/in/marcin-michalski-0053016/'}]},team:{title:'Team',subtitle:'Das Team von Lemlock besteht aus Sicherheitstestern, Anwälten und Software-Ingenieuren.',text:['Ihre Erfahrungen und Kompetenzen im Bereich der Cyber-Sicherheit werden durch zahlreiche Projekte, wissenschaftliche Publikationen und Präsentationen auf nationalen und internationalen Konferenzen wie Secure Poland, Computer Networks - Polen oder MMM-ACNS Russland bestätigt.','Das Auffinden einer Reihe von Schwachstellen in einer häufig verwendeten Software, z.B. <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1086" target="_blank" rel="noopener noreferrer">CVE-2013-1086</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1087" target="_blank" rel="noopener noreferrer">CVE-2013-1087</a> und <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2015-2802" target="_blank" rel="noopener noreferrer">CVE-2015-2802</a>zeugt vom praktischen Wissen über Sicherheitsprobleme. Jede Tätigkeit wird von der Idee geleitet, ein Unternehmen verantwortungsvoll weiterzuentwickeln und das Bewusstsein für bestehende Bedrohungen im Online- und Offline-Bereich zu erhöhen.']},clutch:{title:'SIE VERTRAUEN UNS'}});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = ({header:{title:'Füllen Sie das folgende Formular aus.',subtitle:'Unser Team wird sich umgehend mit Ihnen in Verbindung setzen, um die nächsten Schritte zu besprechen.',main:'Wählen Sie den gewünschten Dienst'},list:{improve_title:'Verbessern Sie die Sicherheit und/oder die DSGVO-Konformität der Anwendung',decrease_title:'Reduzieren Sie das Risiko von Cyberangriffen in Ihrem Unternehmen (Datenmanagement)'},improve:[{title:'Ich möchte die Sicherheit meiner Anwendungen in Bezug auf Folgendes überprüfen:',slug:'improve-one',number:'1/4',option:[{text:'Web',slug:'web',icon:'improve11'},{text:'Mobile',slug:'mobile',icon:'improve12'},{text:'Server',slug:'server',icon:'improve13'}]},{title:'Ich möchte die Sicherheitsüberprüfung:',slug:'improve-two',number:'2/4',option:[{text:'der bestehenden Anwendung',slug:'running',icon:'improve21'},{text:'des Quellcodes der Anwendung',slug:'application',icon:'improve22'},{text:'der Konfiguration des Produktionsservers',slug:'production',icon:'improve23'}]},{title:'Ich möchte sicher sein, dass die Anwendung DSGVO-konform ist:',slug:'improve-three',number:'3/4',option:[{text:'aus rechtlicher Sicht (Identifizierung personenbezogener Daten, Nutzungsbedingungen)',slug:'legal',icon:'improve31'},{text:'hinsichtlich der Systemarchitektur (Anpassung an die DSGVO-Vorschriften)',slug:'system',icon:'improve32de'},{text:'hinsichtlich der Cyber-Sicherheit (Sicherheit personenbezogener Daten)',slug:'cybersecurity',icon:'improve33'}]},{title:'Nach der Überprüfung benötige ich:',slug:'improve-four',number:'4/4',option:[{text:'Unterstützung in der Korrekturphase',slug:'support',icon:'common1'},{text:'eine erneute Überprüfung nach der vorgenommenen Korrektur',slug:'re-check',icon:'common2'},{text:'eine kontinuierliche Überwachung der laufenden Anwendung und ihres Quellcodes',slug:'monitor',icon:'improve43'}]}],decrease:[{title:'Die digitalen Ressourcen in meinem Unternehmen erfordern:',slug:'decrease-one',number:'1/3',option:[{text:'Aufnahme und Aufzeichnung',slug:'recording',icon:'decrease11'},{text:'Risikoberechnung',slug:'calculation',icon:'decrease12'},{text:'Risikomanagementpolitik/Sicherheitspolitik',slug:'management',icon:'decrease13'}]},{title:'Zum Schutz von:',slug:'decrease-two',number:'2/3',option:[{text:'persönlichen Daten',slug:'personal',icon:'decrease21'},{text:'Know-how, Vorschriften und Geschäftsgeheimnissen',slug:'know-how',icon:'decrease22'},{text:'Lohn- und Gehaltslisten',slug:'payroll',icon:'decrease23'}]},{title:'Nach der Überprüfung benötige ich:',slug:'decrease-three',number:'3/3',option:[{text:'Unterstützung in der Korrekturphase',slug:'correction',icon:'common1'},{text:'eine erneute Überprüfung nach der vorgenommenen Korrektur',slug:'applying',icon:'common2'},{text:'einen vorbereiteten Verifizierungsbericht',slug:'verification',icon:'decrease33'}]}],form:{name:'Vor- und Nachname',mail:'E-Mail',phone:'Telefon',message:'Nachricht',send:'Senden',refresh:'Neu Laden'}});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_sentry__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Preloader__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_header_Header__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Switch__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BackToTop__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Cover__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_VideoModal__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_content_MainContent__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_content_Contact__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_content_ebook_Ebook__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_content_ebook_EbookDownload__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_content_PrivacyPolicy__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_content_LegalNotice__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_content_webinar_Webinar__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_content_webinar_WebinarSubscribed__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_content_About__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_content_Estimation__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_helpers_directusLink__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable import/no-unresolved *//* eslint-disable import/first */var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.fetchConsents=function(lang){var t=_this.props.t;var consentsDefault={contact:{id:2,label:t('consent.common.dataStart')+' <a>'+t('consent.common.dataEnd')+'</a>',name:'CONTACT',text:t('consent.data.general').join(', ')},marketing:{id:3,label:t('consent.common.dataStart')+' <a>'+t('consent.common.marketingEnd')+'</a>',name:'MARKETING',text:t('consent.marketing.list').join(', ')},rodo:{id:4,label:t('consent.common.rodoStart')+' <a>'+t('consent.common.rodoEnd')+'</a>',name:'INFORMATION_CLAUSE',text:t('consent.rodo.general').join(', ')}};_this.setState({consents:consentsDefault});__WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:"https://opportunity.sagiton.pl/api/consents"+'/?brandDomain=lemlock.pl&language='+lang,headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){var consentsToSave={contact:response.data.find(function(x){return x.name==='CONTACT';}),marketing:response.data.find(function(x){return x.name==='MARKETING';}),rodo:response.data.find(function(x){return x.name==='INFORMATION_CLAUSE';})};_this.setState({consents:consentsToSave});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_7__lib_sentry__["a" /* default */].captureException(err);_this.setState({consents:consentsDefault});});};_this.state={breakpoint:'',disableTransitionTimeout:null,preloaderDone:false,noTransition:false,companyInfo:null,consents:{contact:{id:2,label:'<a></a>',name:'CONTACT',text:''},marketing:{id:3,label:'<a></a>',name:'MARKETING',text:''},rodo:{id:4,label:'<a></a>',name:'INFORMATION_CLAUSE',text:''}},brandCmsContent:''};_this.updateBreakpoint=_this.updateBreakpoint.bind(_this);_this.disableTransition=_this.disableTransition.bind(_this);_this.preloaderFinished=_this.preloaderFinished.bind(_this);_this.scrollLiveChat=_this.scrollLiveChat.bind(_this);_this.fetchConsents=_this.fetchConsents.bind(_this);_this.generateSessionId=_this.generateSessionId.bind(_this);_this.fetchCmsBrand=_this.fetchCmsBrand.bind(_this);_this.liveChatReady=false;return _this;}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){this.fetchConsents(this.props.language);this.generateSessionId();if(this.props.page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["k" /* PAGE_WEBINAR */]||this.props.page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["d" /* PAGE_EBOOK */]||!this.props.firstLoad||document.referrer.indexOf('blog.lemlock.com')!==-1||document.referrer.indexOf('scanner.lemlock.com')!==-1){this.setState({preloaderDone:true});}}},{key:'componentDidMount',value:function componentDidMount(){this.fetchCmsBrand();this.fetchCmsCompanyInfo();if(this.state.breakpoint===''){this.updateBreakpoint();}window.addEventListener('resize',this.updateBreakpoint);window.addEventListener('resize',this.disableTransition);window.addEventListener('resize',this.scrollLiveChat);window.addEventListener('scroll',this.scrollLiveChat);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var language=this.props.language;if(language!==nextProps.language){this.fetchConsents(nextProps.language);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateBreakpoint);window.removeEventListener('resize',this.disableTransition);window.removeEventListener('resize',this.scrollLiveChat);window.removeEventListener('scroll',this.scrollLiveChat);}},{key:'updateBreakpoint',value:function updateBreakpoint(){var _this2=this;var breakpoint=window.getComputedStyle(document.querySelector('body'),':before').getPropertyValue('content').replace(/"/g,'');if(breakpoint==='phone'&&window.innerWidth>=768){setTimeout(this.updateBreakpoint,10);}this.setState({breakpoint:breakpoint},function(){if(_this2.state.breakpoint===''){setTimeout(function(){_this2.updateBreakpoint();},10);}});}},{key:'disableTransition',value:function disableTransition(){var _this3=this;clearTimeout(this.state.disableTransitionTimeout);this.setState({noTransition:true});var timeout=setTimeout(function(){_this3.setState({noTransition:false});},100);this.setState({disableTransitionTimeout:timeout});}},{key:'scrollLiveChat',value:function scrollLiveChat(){if(this.state.breakpoint==='phone'&&typeof window.LC_API!=='undefined'){if(window.LC_API.chat_window_maximized()){return;}var documentHeight=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(document).height();var windowHeight=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).height();var scrollTop=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).scrollTop();var footerHeight=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.container-footer-small').length>0?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.container-footer-small').outerHeight(true):__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.container-footer').outerHeight(true);var hidePoint=documentHeight-windowHeight-footerHeight;try{if(scrollTop>hidePoint){window.LC_API.hide_chat_window();}else{window.LC_API.minimize_chat_window();}}catch(e){__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.noop(e);}}}},{key:'preloaderFinished',value:function preloaderFinished(){this.setState({preloaderDone:true});}// eslint-disable-next-line class-methods-use-this
},{key:'generateSessionId',value:function generateSessionId(){var id=new Date().toISOString().replaceAll(/[. ,:-]+/g,'')+Math.random().toString().slice(2,6);sessionStorage.setItem('session_id',id);if(id){__WEBPACK_IMPORTED_MODULE_7__lib_sentry__["a" /* default */].setTag('session_id',id);}}},{key:'fetchCmsBrand',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var brandCmsContent;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_24__components_helpers_fetchCmsContent__["c" /* getCMSBrand */])();case 2:brandCmsContent=_context.sent;this.setState({brandCmsContent:brandCmsContent});case 4:case'end':return _context.stop();}}},_callee,this);}));function fetchCmsBrand(){return _ref.apply(this,arguments);}return fetchCmsBrand;}()},{key:'fetchCmsCompanyInfo',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var companyInfo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_24__components_helpers_fetchCmsContent__["f" /* getCmsCompanyInfo */])();case 2:companyInfo=_context2.sent;this.setState({companyInfo:companyInfo});case 4:case'end':return _context2.stop();}}},_callee2,this);}));function fetchCmsCompanyInfo(){return _ref2.apply(this,arguments);}return fetchCmsCompanyInfo;}()},{key:'claim',value:function claim(){var brandCmsContent=this.state.brandCmsContent;if(!brandCmsContent||!brandCmsContent.translations)return'';var translation=__WEBPACK_IMPORTED_MODULE_25__components_helpers_directusLink__["a" /* default */].getTranslationByLang(brandCmsContent.translations,this.props.language,['claim']);if(translation)return translation.claim||'';return'';}},{key:'render',value:function render(){var _this4=this;var _state=this.state,breakpoint=_state.breakpoint,preloaderDone=_state.preloaderDone,noTransition=_state.noTransition,companyInfo=_state.companyInfo;var _props=this.props,language=_props.language,page=_props.page,subpage=_props.subpage,query=_props.query,firstLoad=_props.firstLoad,openPage=_props.openPage,t=_props.t,hash=_props.hash;var claim=this.claim();var transitionClasses={appear:'app-page-hide',appearActive:'app-page-hide',enter:'app-page-hide',enterActive:'app-page-hide',exit:'app-page-show',exitActive:'app-page-show'};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,!preloaderDone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Preloader__["a" /* default */],{preloaderFinished:this.preloaderFinished,noTransition:noTransition,claim:claim}),page!==__WEBPACK_IMPORTED_MODULE_6__config_pages__["k" /* PAGE_WEBINAR */]&&page!==__WEBPACK_IMPORTED_MODULE_6__config_pages__["d" /* PAGE_EBOOK */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_header_Header__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,breakpoint:breakpoint,noTransition:noTransition}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Switch__["a" /* default */],{type:'prev',t:t,openPage:openPage,language:language,page:page,noTransition:noTransition}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Switch__["a" /* default */],{type:'next',t:t,openPage:openPage,language:language,page:page,noTransition:noTransition}),breakpoint!=='phone'&&page!==__WEBPACK_IMPORTED_MODULE_6__config_pages__["f" /* PAGE_HOME */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_BackToTop__["a" /* default */],{page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Cover__["a" /* default */],{type:'prev',page:page,firstLoad:firstLoad}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Cover__["a" /* default */],{type:'next',page:page,firstLoad:firstLoad}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_content_ebook_EbookDownload__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,query:query,claim:claim}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_content_webinar_WebinarSubscribed__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,query:query}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["TransitionGroup"],{className:'app-transition',id:'app-transition'},page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["f" /* PAGE_HOME */]||page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["h" /* PAGE_OFFER */]||page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["j" /* PAGE_THREATS */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:'main-content',classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_content_MainContent__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,preloaderDone:preloaderDone,pageTransitionState:state,breakpoint:breakpoint,noTransition:noTransition,consents:_this4.state.consents,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["d" /* PAGE_EBOOK */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["d" /* PAGE_EBOOK */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_content_ebook_Ebook__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,breakpoint:breakpoint,pageTransitionState:state,consents:_this4.state.consents,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["k" /* PAGE_WEBINAR */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["k" /* PAGE_WEBINAR */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_content_webinar_Webinar__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,pageTransitionState:state,consents:_this4.state.consents,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["c" /* PAGE_CONTACT */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["c" /* PAGE_CONTACT */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_content_Contact__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,pageTransitionState:state,consents:_this4.state.consents,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["b" /* PAGE_ABOUT */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["b" /* PAGE_ABOUT */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_content_About__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,pageTransitionState:state,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["e" /* PAGE_ESTIMATION */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["e" /* PAGE_ESTIMATION */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_content_Estimation__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,pageTransitionState:state,preloaderDone:preloaderDone,firstLoad:firstLoad,breakpoint:breakpoint,hash:hash,consents:_this4.state.consents,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["i" /* PAGE_PRIVACY */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["i" /* PAGE_PRIVACY */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_content_PrivacyPolicy__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,pageTransitionState:state,claim:claim,companyInfo:companyInfo});}):null,page===__WEBPACK_IMPORTED_MODULE_6__config_pages__["g" /* PAGE_LEGAL */]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{timeout:500,key:__WEBPACK_IMPORTED_MODULE_6__config_pages__["g" /* PAGE_LEGAL */],classNames:transitionClasses},function(state){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_content_LegalNotice__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,pageTransitionState:state,claim:claim,companyInfo:companyInfo});}):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_modals_VideoModal__["a" /* default */],{t:t,breakpoint:breakpoint,openPage:openPage,language:language,page:page,subpage:subpage,query:query,claim:claim}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);App.defaultProps={subpage:null,query:{},hash:null};App.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,query:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),firstLoad:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,hash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(223);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(225);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(230);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(73);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(70);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(226);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(229);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(70);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(227);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(228));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 227 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _TransitionGroup = __webpack_require__(73);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var bind = __webpack_require__(74);
var Axios = __webpack_require__(234);
var defaults = __webpack_require__(43);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(78);
axios.CancelToken = __webpack_require__(249);
axios.isCancel = __webpack_require__(77);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(250);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(43);
var utils = __webpack_require__(11);
var InterceptorManager = __webpack_require__(244);
var dispatchRequest = __webpack_require__(245);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(76);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var transformData = __webpack_require__(246);
var isCancel = __webpack_require__(77);
var defaults = __webpack_require__(43);
var isAbsoluteURL = __webpack_require__(247);
var combineURLs = __webpack_require__(248);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(78);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_icons__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable max-len */var Preloader=function(_Component){_inherits(Preloader,_Component);function Preloader(props){_classCallCheck(this,Preloader);var _this=_possibleConstructorReturn(this,(Preloader.__proto__||Object.getPrototypeOf(Preloader)).call(this,props));_this.state={showLogo:false,hide:false};_this.eventShowLogo=_this.eventShowLogo.bind(_this);_this.closePreloader=_this.closePreloader.bind(_this);_this.eventTransitionEndPreloader=_this.eventTransitionEndPreloader.bind(_this);_this.mounted=false;_this.timer=null;return _this;}_createClass(Preloader,[{key:'componentDidMount',value:function componentDidMount(){this.mounted=true;window.requestAnimationFrame(this.eventShowLogo);this.timer=setTimeout(this.closePreloader,3000);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.preloader').on('transitionend',this.eventTransitionEndPreloader);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mounted=false;clearTimeout(this.timer);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.preloader').off('transitionend',this.eventTransitionEndPreloader);}},{key:'eventShowLogo',value:function eventShowLogo(){if(this.mounted){this.setState({showLogo:true});}}},{key:'closePreloader',value:function closePreloader(){if(this.mounted){if(!this.state.hide){clearTimeout(this.timer);this.setState({hide:true});}}}},{key:'eventTransitionEndPreloader',value:function eventTransitionEndPreloader(e){if(this.mounted&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()(e.target).hasClass('preloader')){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.preloader').off('transitionend',this.eventTransitionEndPreloader);this.props.preloaderFinished();}}},{key:'render',value:function render(){var _state=this.state,showLogo=_state.showLogo,hide=_state.hide;var _props=this.props,noTransition=_props.noTransition,claim=_props.claim;var letters=[];for(var i=1;i<=7;i+=1){var className=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('svg-'+i,{'no-transition':noTransition});var icon='letter'+i;letters.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:className,dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_4__data_icons__["a" /* default */].preloader[icon]},key:icon}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('preloader',{hide:hide})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('preloader-box',{show:showLogo})},letters,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preloader-logo-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:claim}}))));}}]);return Preloader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Preloader.defaultProps={claim:'legal and technical support for your cybersecurity'};Preloader.propTypes={preloaderFinished:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,noTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,claim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Preloader);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */var letter14='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 464.4"><path d="M0,0H145V464.4H0Z"/></svg>';var letter2='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 349.3 347.7"><path d="M349.3,176.9c0,5.3-0.1,10.8-0.3,16.3s-0.5,10.1-0.9,13.8H130.6c0.3,5.6,2.4,10.9,5.8,15.4c3.6,4.6,7.9,8.5,12.9,11.6c5.3,3.4,11.1,5.9,17.2,7.4c6.3,1.6,12.8,2.5,19.4,2.5c13.1,0,24.1-2.4,32.9-7.1s15.5-9.9,20-15.7l100.7,51c-14.3,23.3-35.1,41.8-62.4,55.3c-27.2,13.5-58.9,20.3-94.9,20.3c-23.2,0-46.2-3.7-68.2-11c-21.5-7-41.4-18.2-58.7-32.9c-17-14.5-30.6-32.7-40.9-54.4s-15.4-46.9-15.4-75.6c0-26.6,4.7-50.7,14.1-72.2C22.7,80.2,35.5,61.9,51.7,47c16.6-15.2,36-27,57.1-34.7C131.3,4,155.1-0.2,179.1,0c25.4,0,48.5,4.4,69.4,13.2c20.3,8.4,38.6,21,53.8,36.9c14.9,15.8,26.5,34.5,34.7,56.2S349.3,151.5,349.3,176.9z M227,130.8c0-11.5-4.2-20.9-12.6-28.3c-8.4-7.4-19.8-11.1-34.1-11.1c-15.6,0-27.6,4.3-36.2,12.9c-8.6,8.6-13.5,17.4-14.7,26.4L227,130.8z"/></svg>';var letter3='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 537.5 331.7"><path d="M197.8,331.7V162.2c0-16.4-2-28.2-6.1-35.6c-4.1-7.4-10.9-11.1-20.3-11.1c-7,0-13.6,3.3-20,9.8c-6.4,6.6-9.5,18.2-9.5,35v171.4H0V8.6h138.2v35.6h1.2c4.5-5.7,9.5-11,15-15.7c6.3-5.4,13.1-10.1,20.3-14.1c8-4.5,16.6-8,25.5-10.4c10-2.7,20.3-4.1,30.7-4c21.3,0,39.7,3.8,55.3,11.4c15.6,7.6,27.9,19.3,36.9,35.3c11-13.4,24.3-24.6,39.3-33.2C378,4.5,397.6,0,421.4,0c22.9,0,41.9,4.5,56.8,13.5c14.9,9,26.8,20.3,35.6,33.8c8.8,13.4,15,28.3,18.4,43.9c3.3,14.4,5.1,29.1,5.2,43.9v196.6H395.6v-172c0-17.6-2.2-29.4-6.5-35.3c-4.3-5.9-11-8.9-20-8.9c-8.2,0-15.2,3.8-20.9,11.4s-8.6,18.7-8.6,33.5v171.4H197.8z"/></svg>';var letter56='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.2 17.2"><path d="M8.8,0C4.1,0,0.3,3.8,0.2,8.5c0,0,0,0.1,0,0.1c0,4.7,3.9,8.6,8.6,8.6c3.5,0,6.4-2.1,7.8-5c0-0.1,0-0.1,0.1-0.1c0.1-0.3,0.2-0.7,0.3-1l-6.1-0.9c-0.1,0.1-0.2,0.2-0.3,0.4c-0.5,0.5-1.2,0.7-1.9,0.7c-0.7,0-1.3-0.2-1.8-0.7C6.4,10,6.1,9.4,6.1,8.6c0-0.8,0.3-1.4,0.8-1.9C7.4,6.3,8,6,8.7,6c0.7,0,1.4,0.2,1.9,0.7c0.1,0.1,0.2,0.2,0.3,0.4l6-0.9c-0.1-0.3-0.2-0.7-0.3-1c0-0.1-0.1-0.2-0.1-0.3C15.2,2,12.2,0,8.8,0z"/></svg>';var letter7='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 385.2 464.4"><path d="M141.9,323.7v140.7H0V0h141.9v264.8h1.8l76.8-123.5h164.6L280.7,286.9l103.8,177.5H219.3l-75.6-140.7H141.9z"/></svg>';/* harmony default export */ __webpack_exports__["a"] = ({letter1:letter14,letter2:letter2,letter3:letter3,letter4:letter14,letter5:letter56,letter6:letter56,letter7:letter7});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */var email='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 14"><g fill="#13A5E1" fill-rule="nonzero" opacity=".9"><path d="M1.726383 4.333017c.227531.158655.913394.629861 2.057625 1.413375 1.144265.783514 2.020851 1.3868 2.629793 1.80989.066902.046378.209039.147192.42648.302582.217477.155493.39818.281146.541969.376992.143895.095811.317848.203295.522035.322278.204117.118878.396527.208298.577195.267494.180704.059682.347977.089245.501856.089245h.020215c.153879 0 .321222-.029598.501926-.089245.180597-.059196.373183-.14872.577125-.267494.204046-.119122.378-.226501.521894-.322278.143895-.095846.324457-.221499.542004-.376992.217406-.155529.359719-.256204.426621-.302581.615516-.423092 2.18148-1.497618 4.697402-3.223474.488461-.337077.896555-.743807 1.224387-1.21991.328078-.475897.491942-.975137.491942-1.497445 0-.436466-.159012-.81009-.476895-1.120834-.317848-.310814-.6943-.466134-1.129113-.466134H1.605902c-.515214 0-.911707.171891-1.189406.515673C.138832.888009 0 1.317806 0 1.833514c0 .41656.184078.867965.552059 1.353935.367945.486005.759515.867896 1.174324 1.145568z"/><path d="M16.983 5.394169c-2.194594 1.467776-3.861 2.608481-4.99841 3.42187-.38141.277604-.69082.494308-.928442.649594-.23762.15539-.55364.31408-.948515.476-.394735.162164-.76261.243002-1.103942.243002H8.983371c-.341262 0-.709348-.080839-1.104082-.243002-.394734-.16192-.710965-.32061-.948516-.476-.23748-.155286-.546996-.37199-.92837-.649593-.90341-.654561-2.566231-1.795335-4.988532-3.421871C.632355 5.143072.294434 4.855256 0 4.53131v7.874913c0 .436675.157184.81009.471727 1.120869.314472.310883.692613.466273 1.13428.466273h14.774977c.441563 0 .819668-.15539 1.134176-.466273.314613-.310884.471727-.684159.471727-1.120869V4.53131c-.28779.31724-.622266.605057-1.003887.862859z"/></g></svg>';var facebook='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 349 349"><path d="M128.9,114.4H92.2v59.9h36.7v175.8h70.5V173.5h49.2l5.2-59.1h-54.4c0,0,0-22.1,0-33.7c0-13.9,2.8-19.5,16.3-19.5c10.9,0,38.2,0,38.2,0V-0.1c0,0-40.2,0-48.8,0C152.6-0.1,129,23,129,67.2C128.9,105.8,128.9,114.4,128.9,114.4z"/></svg>';var googleplus='<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.635 10.909v2.619h4.335c-.173 1.125-1.31 3.295-4.331 3.295-2.604 0-4.731-2.16-4.731-4.823 0-2.662 2.122-4.822 4.728-4.822 1.485 0 2.479.633 3.045 1.178l2.073-1.994c-1.33-1.245-3.056-1.995-5.115-1.995C3.412 4.365 0 7.785 0 12s3.414 7.635 7.635 7.635c4.41 0 7.332-3.098 7.332-7.461 0-.501-.054-.885-.12-1.265H7.635zm16.365 0h-2.183V8.726h-2.183v2.183h-2.182v2.181h2.184v2.184h2.189V13.09H24"/></svg>';var linkedin='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280.5 280.5"><path d="M68.4,35.4c0,19-15.3,34.5-34.2,34.5S0,54.5,0,35.4c0-19,15.3-34.5,34.2-34.5C53.1,0.9,68.4,16.4,68.4,35.4z M63.4,94.3H5.6v186.8h57.8V94.3z M155.8,94.3h-55.4v186.8h55.4c0,0,0-69.3,0-98c0-26.3,12.1-41.9,35.2-41.9c21.3,0,31.5,15,31.5,41.9s0,98,0,98H280c0,0,0-68.2,0-118.3c0-50-28.3-74.2-68-74.2c-39.6,0-56.3,30.9-56.3,30.9L155.8,94.3L155.8,94.3L155.8,94.3z"/></svg>';var twitter='<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"/></svg>';var whatsapp='<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.498 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.101-.473-.15-.673.15-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.174-.3-.019-.465.13-.615.136-.135.301-.345.451-.523.146-.181.194-.301.297-.496.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.172-.015-.371-.015-.571-.015-.2 0-.523.074-.797.359-.273.3-1.045 1.02-1.045 2.475s1.07 2.865 1.219 3.075c.149.195 2.105 3.195 5.1 4.485.714.3 1.27.48 1.704.629.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345m-5.446 7.443h-.016c-1.77 0-3.524-.48-5.055-1.38l-.36-.214-3.75.975 1.005-3.645-.239-.375c-.99-1.576-1.516-3.391-1.516-5.26 0-5.445 4.455-9.885 9.942-9.885 2.654 0 5.145 1.035 7.021 2.91 1.875 1.859 2.909 4.35 2.909 6.99-.004 5.444-4.46 9.885-9.935 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c1.746.943 3.71 1.444 5.71 1.447h.006c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.495-8.411"/></svg>';var xing='<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.188 0c-.517 0-.741.325-.927.66 0 0-7.455 13.224-7.702 13.657.015.024 4.919 9.023 4.919 9.023.17.308.436.66.967.66h3.454c.211 0 .375-.078.463-.22.089-.151.089-.346-.009-.536l-4.879-8.916c-.004-.006-.004-.016 0-.022L22.139.756c.095-.191.097-.387.006-.535C22.056.078 21.894 0 21.686 0h-3.498zM3.648 4.74c-.211 0-.385.074-.473.216-.09.149-.078.339.02.531l2.34 4.05c.004.01.004.016 0 .021L1.86 16.051c-.099.188-.093.381 0 .529.085.142.239.234.45.234h3.461c.518 0 .766-.348.945-.667l3.734-6.609-2.378-4.155c-.172-.315-.434-.659-.962-.659H3.648v.016z"/></svg>';var sms='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 1C5.66 1 0 5.23 0 11c0 2.06.74 4.07 2.05 5.63.05 1.83-1.03 4.46-2 6.37 2.6-.47 6.3-1.5 7.98-2.54C17.27 22.71 24 17.06 24 11.01 24 5.19 18.3 1 12 1zM7.3 13.47c-.42.33-1 .5-1.74.5-.64 0-1.2-.12-1.7-.37l.28-1.08c.5.25 1 .37 1.5.37.3 0 .52-.05.69-.16a.54.54 0 0 0 .02-.9c-.15-.11-.4-.23-.77-.35-1.1-.37-1.64-.94-1.64-1.72 0-.5.2-.91.6-1.24.4-.33.94-.49 1.61-.49.59 0 1.1.1 1.54.3l-.3 1.05c-.4-.19-.82-.28-1.25-.28-.27 0-.48.05-.63.15-.3.2-.3.57-.04.79.13.1.43.24.91.41.54.2.92.42 1.17.7.25.28.37.62.37 1.04 0 .52-.2.95-.62 1.28zm6.63.4c-.09-2.28-.13-3.82-.13-4.64h-.03c-.14.61-.6 2.13-1.4 4.55h-1.03c-.47-1.67-1.18-4.55-1.18-4.55h-.01l-.2 4.65H8.7l.37-5.76h1.8l1 3.97 1.23-3.96h1.81l.31 5.74h-1.3zm5.57-.37c-.42.33-1.01.5-1.76.5-.6 0-1.18-.1-1.73-.38l.3-1.15c.47.25.97.4 1.51.4.29 0 .51-.06.67-.17.3-.2.31-.61.02-.84-.14-.11-.4-.23-.75-.35-1.11-.37-1.67-.96-1.67-1.75 0-.5.2-.94.61-1.27.41-.32.96-.49 1.63-.49.6 0 1.11.1 1.55.3l.03.01-.32 1.11a2.9 2.9 0 0 0-1.27-.3c-.26 0-.47.06-.61.16-.28.19-.28.53-.03.73.12.1.42.25.9.41.53.2.93.43 1.18.71.25.28.37.64.37 1.05 0 .54-.21.98-.63 1.32z"/></svg>';var phone='<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><path fill="#13A5E1" d="M16.575 13.419l-2.619-2.627c-.521-.52-1.385-.505-1.924.037l-1.32 1.323-.26-.146c-.833-.463-1.973-1.097-3.173-2.301-1.203-1.207-1.837-2.352-2.3-3.188-.048-.089-.095-.174-.141-.255l.885-.887.435-.437c.54-.542.556-1.408.035-1.93L3.575.38C3.055-.14 2.19-.125 1.65.417l-.738.745.02.02a4.283 4.283 0 0 0-.608 1.076 4.47 4.47 0 0 0-.27 1.09c-.346 2.875.964 5.502 4.518 9.067 4.914 4.928 8.874 4.555 9.045 4.537a4.414 4.414 0 0 0 1.09-.275 4.25 4.25 0 0 0 1.07-.607l.015.015.748-.735c.54-.542.555-1.408.035-1.931z" opacity=".9"/></svg>';var popup='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73 73"><g fill="none" fill-rule="evenodd"><rect width="73" height="73" rx="36.5" fill="#13A5E1"/><path d="M31.025952 21.822615C31.3852 16.047027 33.921183 15 36.724984 15c2.803801 0 5.087126 1.603632 5.087126 6.822615 0 5.218984-3.179117 22.063898-3.599879 24.876165-.420762 2.812267-2.983806 2.974005-3.524646 0-.54084-2.974004-4.02088-19.100577-3.661632-24.876165zM36 58c-1.656854 0-3-1.343146-3-3s1.343146-3 3-3 3 1.343146 3 3-1.343146 3-3 3z" fill="#FFF"/></g></svg>';/* harmony default export */ __webpack_exports__["a"] = ({email:email,facebook:facebook,googleplus:googleplus,linkedin:linkedin,twitter:twitter,whatsapp:whatsapp,xing:xing,sms:sms,phone:phone,popup:popup});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */var lemlock='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 187 41"><path d="M186.2 11.7h-13.6l-6.3 10.2h-.2V0h-11.7v19.7c-.6-1.7-1.6-3.2-2.8-4.5-1.2-1.3-2.8-2.4-4.5-3.2-1.8-.8-3.8-1.2-6.1-1.2s-4.3.4-6.1 1.2-3.3 1.9-4.5 3.2c-1.2 1.4-2.2 3-2.8 4.7-.3.9-.6 1.9-.7 2.8-.2-1.3-.5-2.6-1.1-3.8-.8-1.7-1.9-3.2-3.4-4.5-1.4-1.2-3.1-2.2-4.9-2.8-3.8-1.3-7.8-1.3-11.6 0-1.8.6-3.4 1.5-4.8 2.8-1.4 1.2-2.5 2.7-3.3 4.5-.4.9-.7 1.8-.9 2.7V0h-12v20.6l-.3-2.1c-.3-1.3-.8-2.5-1.5-3.6s-1.7-2-2.9-2.8c-1.2-.7-2.8-1.1-4.7-1.1-2 0-3.6.4-4.9 1.1-1.2.7-2.3 1.6-3.2 2.7-.7-1.3-1.8-2.3-3-2.9-1.4-.6-3-.9-4.7-.9-.9 0-1.7.1-2.5.3-.7.2-1.4.5-2.1.9-.6.3-1.2.7-1.7 1.2-.5.4-.9.8-1.2 1.3H52v-2.9H40.6v12.7c-.1-1.7-.4-3.3-1-4.9-.7-1.8-1.6-3.3-2.9-4.6-1.3-1.3-2.8-2.4-4.4-3-1.7-.7-3.6-1.1-5.7-1.1-2 0-4 .3-5.8 1-1.7.6-3.4 1.6-4.7 2.9-1.3 1.2-2.4 2.7-3.2 4.5-.4.9-.7 1.8-.8 2.7V0H0v38.4h12v-10c.2 1 .5 2 1 2.9.8 1.8 2 3.3 3.4 4.5 1.4 1.2 3.1 2.1 4.8 2.7 1.8.6 3.7.9 5.6.9 3 0 5.6-.6 7.8-1.7 2.3-1.1 4-2.6 5.2-4.6l-8.3-4.2c-.4.5-.9.9-1.7 1.3-.7.4-1.6.6-2.7.6-.5 0-1.1-.1-1.6-.2s-1-.3-1.4-.6c-.4-.3-.8-.6-1.1-1-.3-.4-.5-.8-.5-1.3h18c0-.3.1-.7.1-1.1v-.1 11.8h11.7V24.2c0-1.4.3-2.4.8-2.9s1.1-.8 1.7-.8c.8 0 1.3.3 1.7.9.3.6.5 1.6.5 2.9v14h11.7V24.2c0-1.2.2-2.1.7-2.8s1-.9 1.7-.9 1.3.2 1.7.7.5 1.5.5 2.9v14.2h23.6v-10c.2.9.5 1.8.9 2.7.8 1.8 1.9 3.3 3.3 4.5 1.4 1.2 3.1 2.2 4.8 2.8.6.2 1.1.4 1.7.5l1.6-10.2c-.2-.2-.4-.3-.6-.5-.8-.9-1.2-1.9-1.2-3.2 0-1.1.4-2.3 1.2-3.1.8-.9 1.8-1.3 3.1-1.3s2.3.4 3.2 1.3c.8.9 1.2 1.9 1.2 3.1 0 1.3-.4 2.3-1.2 3.2-.2.2-.4.4-.6.5l1.6 10.2c.6-.1 1.1-.3 1.7-.5 1.8-.6 3.5-1.6 4.9-2.8 1.4-1.3 2.6-2.8 3.4-4.5.5-1.1.8-2.2 1-3.4.1 1.1.4 2.2.8 3.3.6 1.7 1.5 3.3 2.8 4.7 1.2 1.3 2.7 2.4 4.5 3.2 1.8.8 3.8 1.2 6.1 1.2s4.3-.4 6.1-1.2c1.8-.8 3.3-1.9 4.5-3.2 1.2-1.3 2.1-2.8 2.8-4.5v7.2h11.7V26.8h.2l6.2 11.6h13.7l-8.6-14.7 8.5-12zM22.4 21.5c.1-.7.5-1.5 1.2-2.2s1.7-1.1 3-1.1c1.2 0 2.1.3 2.8.9.7.6 1 1.4 1 2.3h-8zm132 7.8l-9.7-1.4c-.2.2-.3.4-.5.6-.9.8-1.9 1.2-3.2 1.2-1.1 0-2.2-.4-3.1-1.1-.9-.8-1.3-1.8-1.3-3s.4-2.3 1.3-3c.8-.8 1.9-1.2 3.1-1.2 1.3 0 2.3.4 3.2 1.2.2.2.4.4.5.6l9.7-1.4v7.5z"/></svg>';var lock='<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><g fill="#13A5E1" fill-rule="nonzero"><path d="M2.595951 37.6a1.259478 1.259478 0 0 0 .350176-.056184c.532143-.190776.810279-.775356.622536-1.308432C.225775 26.943459 2.439236 16.787169 9.33901 9.718824 19.207373-.370723 35.38896-.552607 45.48176 9.312571l.157795.146942-3.094306.033494c-.548744.027904-.978495.48232-.975603 1.031595.002892.549276.437403.999143.98641 1.021272h.010809l5.567157-.068069c.271862-.00186.531889-.111434.72305-.304688.19036-.192198.29617-.452364.293975-.722826l-.06809-5.56543c-.002276-.272604-.113163-.533055-.308107-.72368-.194945-.190626-.457862-.295697-.730534-.29195-.564742.01234-1.016079.473617-1.015944 1.03832l.033505 3.093346-.153473-.143701C41.76349 2.802139 34.832253-.021052 27.618436.000118H27.2942C14.347156.153356 3.243866 9.275964.585679 21.944188c-1.045438 5.002425-.686345 10.196454 1.03756 15.007538.164086.392178.54748.647694.972712.648274zM54.356399 19.080276c-.122935-.344642-.42052-.597563-.780659-.66349-.360138-.065928-.728115.065153-.965318.343867-.237203.278714-.307595.662717-.18466 1.007358 3.329727 9.284967 1.117112 19.433652-5.778943 26.484828-9.872171 10.066248-26.034944 10.247844-36.131094.405947l-.157735-.146831 3.093123-.03347c.548535-.027883.978121-.481958.97523-1.030822-.00289-.548865-.437236-.998395-.986034-1.020507h-.010803l-5.56503.068017c-.564526.012331-1.01569.473262-1.015555 1.037541l.068064 5.561264c.00709.562165.46485 1.014322 1.02744 1.014868h.010803c.564527-.01233 1.01569-.473261 1.015556-1.037541l-.033492-3.09103.159896.144673c9.192247 8.996937 23.386815 10.450743 34.2142 3.504213 10.827387-6.94653 15.413256-20.449306 11.053654-32.546726l-.008643-.002159z"/><path d="M28.201984 11.6c-4.561322.002979-8.258254 3.664497-8.261261 8.182125v4.085122h-.32718c-1.48645.000595-2.691476 1.193594-2.69268 2.665806v11.2033c.002402 1.470105 1.205086 2.661268 2.689409 2.663647h17.182334c1.484323-.002379 2.687007-1.193542 2.689408-2.663646v-11.2033c-.002401-1.470105-1.205085-2.661268-2.689408-2.663647h-.327179v-4.088362c-.00361-4.51805-3.701694-8.179258-8.263443-8.181045zm-6.186949 8.182125c-.029634-2.212668 1.14525-4.269934 3.075222-5.384827 1.929973-1.114894 4.316384-1.114894 6.246356 0 1.929973 1.114893 3.104857 3.17216 3.075223 5.384827v4.085122h-12.3968v-4.086202.00108zm15.393757 6.736886v11.205461c.000582.161747-.064035.317036-.179514.431409-.11548.114373-.27227.178371-.435582.177795H19.62227c-.163312.000577-.320102-.063422-.435582-.177795-.115479-.114373-.180096-.269662-.179514-.431409v-11.20546c-.000583-.161748.064035-.317036.179514-.43141.11548-.114373.27227-.178371.435582-.177794h17.170337c.1635-.000866.320571.063005.436287.17741.115716.114404.180483.269858.1799.431793z"/><path d="M29.048504 30.021738c-.635706-.115378-1.264896.237019-1.527619.85559-.276012.63353-.083576 1.383592.458188 1.78589.094762.065494.1461.181609.132583.299866v1.903585c.004597.261714.139328.501815.355148.6329.21582.131084.481246.134031.69966.007769.225804-.12238.358707-.37595.336329-.641692V32.96206c-.010476-.122136.044313-.240324.14233-.30703.367285-.270672.581318-.716222.570299-1.187182-.00585-.71845-.48451-1.285431-1.166918-1.44611z"/></g></svg>';var hacker='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 53"><g fill="none" fill-rule="evenodd"><path d="M39.4304 29.24865l3.145387-3.052468c2.879573-2.794508 2.960533-7.27394.253546-10.163785L30.536427 2.806102C28.86592 1.022734 26.48352 0 24 0c-2.48352 0-4.86592 1.022734-6.540693 2.810553L5.174827 16.027842c-2.714347 2.897713-2.630614 7.373418.249386 10.168236L8.5696 29.248547C3.330667 31.50881 0 36.52435 0 42.027344v6.210937c0 .857524.716373 1.552735 1.6 1.552735h8v1.65625C9.6 52.304789 10.316373 53 11.2 53h25.6c.883627 0 1.6-.69521 1.6-1.552734v-1.65625h8c.883627 0 1.6-.695211 1.6-1.552735v-6.210937c0-5.49813-3.325973-10.516567-8.5696-12.778694zM7.54688 18.112336l12.28448-13.21729C20.896747 3.757722 22.416107 3.10547 24 3.10547c1.583893 0 3.103253.652252 4.16448 1.785127L40.457387 18.11689c.130986.13985.250986.287359.36064.44077C35.68096 16.52161 29.60704 15.630858 24 15.630858c-5.543253 0-11.644373.876364-16.81728 2.92649.110613-.154755.231787-.30361.36416-.445013zM32 19.379885v.909177c0 4.28089-3.5888 7.763672-8 7.763672s-8-3.482783-8-7.763672v-.909177c2.54432-.420998 5.24448-.643557 8-.643557 2.75552 0 5.45568.222559 8 .643557zm3.2 30.514646H12.8V38.921875c0-.856178.71776-1.552734 1.6-1.552734h19.2c.88224 0 1.6.696556 1.6 1.552734v10.972656zm9.6-3.208984h-6.4v-7.763672c0-2.568533-2.15328-4.658203-4.8-4.658203H14.4c-2.64672 0-4.8 2.08967-4.8 4.658203v7.763672H3.2v-4.658203c0-5.098559 3.570347-9.45491 8.68224-10.59379.567253-.126392 1.018987-.541593 1.17984-1.084429.160747-.542836.00512-1.127492-.4064-1.526855l-4.968747-4.821965c-.519466-.504121-.8928-1.112276-1.099413-1.776018 1.828373-.890338 3.92864-1.626852 6.21248-2.18977v.254545c0 5.993245 5.02432 10.869141 11.2 10.869141 6.17568 0 11.2-4.875896 11.2-10.86914v-.254649c2.283947.562918 4.384107 1.299432 6.21248 2.18977-.206613.663742-.579947 1.271896-1.099413 1.776017l-4.968747 4.821965c-.41152.399363-.567147.984123-.4064 1.526855.160747.542836.612587.958038 1.17984 1.08443C41.229653 32.572434 44.8 36.928785 44.8 42.027344v4.658203z" fill="#000" fill-rule="nonzero"/><path d="M27.2 40.47461h-6.4c-.883627 0-1.6.69521-1.6 1.552734 0 .857523.716373 1.552734 1.6 1.552734h6.4c.883627 0 1.6-.69521 1.6-1.552734 0-.857524-.716373-1.552735-1.6-1.552735z" fill="#000" fill-rule="nonzero"/><path opacity=".332201" d="M-3-2h56v56H-3z"/></g></svg>';var developer='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 52"><g fill="#000" fill-rule="nonzero"><path d="M10.833857 49.001005c-.004246-.02982-.011945-.072011-.020534-.126273l-.15147.024273c.042945.033942.083354.071736.120308.113323.029788.033523.045375.046839.051696.040535v-.051858zm24.106309-.34073v-14.45729c-.002303-.001202-8.011505-.002952-24.027606-.005252-.031367.008979-.057549.0169-.078703.02327v14.43731l24.106309.001961zM10.797687 34.197732h.036698c.001137-.03802-.00345-.03655-.036698 0zm24.187091 0c-.021144-.055814-.041254-.14093-.04127-.243317l-.003342.076731v.166586h.044612zm.02354.050328c.004287.007105.008264.012515.011716.016097a.434906.434906 0 0 0-.00392-.004015l-.007796-.012082zm-.061823-.362189l-.002986.068544a.786803.786803 0 0 1 .002986-.068544zm.74101 14.776108c.008171-.000507.013506-.001063.015862-.001547a.623156.623156 0 0 0-.003385.000705l-.012477.000842zM27.90102 23.526654c2.820981-.024156 4.49238.070529 5.498412.340924.209174.05622 1.886763.467202 2.493626.629262 1.261695.336928 2.376448.692344 3.449556 1.123256 2.73773 1.09935 4.862326 2.562125 6.227622 4.586594 2.035189 3.017789 2.749405 8.324733 2.301322 16.0348l-.090845 1.563135h-9.542707l-.000166 1.24942c.045342.924997-.100746 1.653958-.674636 2.234958-.576813.58396-1.303967.733368-2.141213.689345H10.36842c-.769354.101333-1.513369-.153567-2.046106-.753096-.422345-.475296-.64936-1.081316-.7676-1.82834l-.020534-.129728v-.131362l.000074-1.331197H.149219l-.069854-1.586573c-.365013-8.290424.515837-13.637466 2.916481-16.2145 3.594993-3.85914 8.19233-6.192207 13.067153-6.192207.957978 0 1.788936-.015736 3.674912-.07237-4.827075-1.599371-8.311625-6.172907-8.311625-11.565336C11.426286 5.450324 16.84311 0 23.525102 0c6.681991 0 12.098816 5.450324 12.098816 12.173639 0 5.17061-3.20377 9.58831-7.722898 11.353015zM7.534439 44.484542l.000575-10.32612c.026822-.848576.27536-1.592946.799292-2.169856.488186-.537549 1.159724-.870335 1.992578-1.067006l.185952-.04391h24.80229l.161525.032791c.740962.150425 1.3923.503103 1.911936 1.042157.576855.598411.894955 1.331642.851248 2.13464l-.001386 10.397304h6.414295c.232408-6.170904-.413623-10.33875-1.812915-12.413627-.935319-1.386896-2.54006-2.491754-4.720272-3.36723-.934907-.375416-1.929254-.692443-3.07294-.997858-.562193-.15013-2.243215-.561953-2.498744-.630632-.97701-.262595-3.860904-.287633-9.001752-.13325-.431912.01297-.86578.026524-1.47638.045972-3.629697.115607-4.684918.143511-6.006742.143511-3.88467 0-7.648314 1.909983-10.659692 5.142626-1.47164 1.579769-2.238304 5.69595-2.081867 12.210488H7.53444zm16.113247-23.457347c4.555903 0 8.249193-3.71613 8.249193-8.300209 0-4.584078-3.69329-8.300208-8.249193-8.300208s-8.249193 3.71613-8.249193 8.300208c0 4.584079 3.69329 8.300209 8.249193 8.300209z"/><path d="M24.617164 36.755256c.193164-.576829.823834-.889987 1.40864-.699458.584808.190528.902297.812594.709133 1.389423l-2.946715 8.799523c-.193164.576829-.823834.889987-1.40864.699458-.584808-.190528-.902297-.812594-.709133-1.389423l2.946715-8.799523zm-5.833586 6.809006c.45926.404756.498906 1.100101.08855 1.553096-.410355.452995-1.115317.4921-1.574577.087343l-2.925403-2.578225c-.466504-.41114-.498916-1.12029-.071811-1.571167l2.925402-3.088226c.420473-.443876 1.126144-.467498 1.576159-.052761.450015.414737.473964 1.11078.05349 1.554656l-2.146934 2.26643 2.075124 1.828854zm9.547179-3.962279c-.416744-.447285-.38697-1.143109.066502-1.554167.453471-.411057 1.15892-.38169 1.575663.065596l2.733003 2.933296c.410465.440545.388631 1.12391-.04914 1.538089l-2.733004 2.585712c-.44447.420515-1.150393.406012-1.576724-.032393-.426332-.438405-.411628-1.134698.03284-1.555213l1.945227-1.840392-1.994367-2.140528z"/></g></svg>';var lawyer='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 54"><g fill="#000" fill-rule="nonzero"><path d="M23.681879 22.266165c-4.324255-1.43277-7.445831-5.529896-7.445831-10.360613C16.236048 5.882582 21.08862 1 27.07457 1c5.985951 0 10.838523 4.882582 10.838523 10.905552 0 4.632004-2.870043 8.589527-6.91843 10.170409 2.52713-.02164 4.024424.063182 4.925662.305411.187385.050364 1.690225.418535 2.233873.563713 1.130268.301832 2.128901.620226 3.090227 1.00625 2.45255.984835 4.355834 2.295238 5.578912 4.108825 1.82319 2.703436 2.463008 7.457573 2.0616 14.364509.011044.52289-.089448.870963-.301477 1.04422-.212028.173257-.682759.291953-1.41219.356088h-7.61963v-2.974242h6.449776c.208199-5.528101-.370537-9.261796-1.62407-11.12054-.837889-1.242428-2.27547-2.232197-4.228577-3.016477-.83752-.33631-1.72829-.620313-2.752841-.893914-.503631-.134493-2.009547-.503417-2.238458-.564942-.875238-.235241-3.458727-.25767-8.06407-.11937-.386921.01162-.775595.023761-1.32259.041183-3.251604.103565-4.196906.128563-5.38104.128563-3.480018 0-6.851615 1.711026-9.549308 4.606935-1.318343 1.41521-2.005147 5.102621-1.865005 10.938562H39.55164v2.974242H7.679622c-.471041.068247-.879511-.05045-1.22541-.356088-.345899-.305639-.4818-.833448-.407706-1.583427 0-7.647285.486696-11.698687 2.637273-14.00728 3.220514-3.457145 7.338962-5.547186 11.70599-5.547186.85819 0 1.60259-.014096 3.29211-.064831zm3.502506-2.429303c4.08133 0 7.389902-3.329033 7.389902-7.435603 0-4.10657-3.308572-7.435604-7.389902-7.435604s-7.389901 3.329033-7.389901 7.435604c0 4.10657 3.308571 7.435603 7.389901 7.435603z" stroke="#000" stroke-width=".5"/><path d="M3.80308 50.211072h48.165173v-1.589825H3.80308v1.589825zm-1.708707-4.589825h51.582586c.943693 0 1.708707.671573 1.708707 1.5v4.589825c0 .828427-.765014 1.5-1.708707 1.5H2.094373c-.943693 0-1.708707-.671573-1.708707-1.5v-4.589825c0-.828427.765014-1.5 1.708707-1.5zM18.982146 31.79791c-1.046758.538422-2.361636-.250993-2.03311-1.220623l1.572913-4.642395c.198471-.585781.944629-.930106 1.66659-.769071.72196.161035 1.146331.76645.94786 1.35223l-.642953 1.897653 3.077698-1.583082c.982093-.505161 2.240856.161454 2.066232 1.094233L23.77032 37.9h.563113l1.693779-9.951257c.206123-1.211015 2.328467-1.286582 2.66454-.094872L31.52486 37.9h.449673l-2.850316-9.887816c-.27368-.949401.997551-1.696958 2.024372-1.190447l2.882496 1.42188-1.36305-2.845073c-.27128-.566237.074542-1.203697.772414-1.423806.697872-.22011 1.483524.060482 1.754804.626718l2.811726 5.868868c.469487.979951-.860647 1.88465-1.967887 1.33847l-3.539062-1.74575 2.504 8.686436c.198934.690108-.4466 1.35052-1.320095 1.35052h-3.239624c-.63224 0-1.180544-.354582-1.321566-.854643l-1.422546-5.044312-.842432 4.94944c-.092626.544198-.665898.949515-1.342975.949515h-3.321674c-.82986 0-1.46497-.5995-1.340347-1.265191l1.657065-8.851446-3.52769 1.814546z"/></g></svg>';/* harmony default export */ __webpack_exports__["a"] = ({lemlock:lemlock,lock:lock,hacker:hacker,developer:developer,lawyer:lawyer});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */var navPrev='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 49"><path d="M3.7 24.5L28.5 2.4c.6-.5.6-1.4 0-2-.6-.5-1.6-.5-2.2 0L.5 23.5c-.6.5-.6 1.4 0 2l25.8 23.1c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.6-.5.6-1.4 0-2L3.7 24.5z"/></svg>';var navNext='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 49"><path d="M25.2 24.5L.5 2.4c-.6-.5-.6-1.4 0-2 .6-.5 1.6-.5 2.2 0l25.8 23.1c.6.5.6 1.4 0 2L2.6 48.6c-.3.3-.7.4-1 .4s-.8-.1-1.1-.4c-.6-.5-.6-1.4 0-2l24.7-22.1z"/></svg>';var arrowLeft='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16"><path d="M7 .1c.5-.1 1-.1 1 0 .6.5.6 1.1 0 1l-5 6h18c.7.2 1 .5 1 1 0 .4-.3.8-1 1H3l5 6c.6-.1.6.4 0 1 0 .1-.5.1-1 0L.1 9C0 8.3 0 7.7.1 7L7 .1z"/></svg>';var arrowRight='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16"><path d="M15 .1c-.5-.1-1-.1-1 0-.6.5-.6 1.1 0 1l5 6H1c-.7.1-1 .5-1 .9s.3.8 1 1h18l-5 6c-.6-.1-.6.4 0 1 0 .1.5.1 1 0l7-6.9c.1-.7.1-1.2 0-2l-7-7z"/></svg>';var arrowRightBlue='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16"><path d="M15 .1c-.5-.1-1-.1-1 0-.6.5-.6 1.1 0 1l5 6H1c-.7.1-1 .5-1 .9s.3.8 1 1h18l-5 6c-.6-.1-.6.4 0 1 0 .1.5.1 1 0l7-6.9c.1-.7.1-1.2 0-2l-7-7z" fill="#13A5E1"/></svg>';var icon01='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 98"><path d="M90.4 88.8h-.1l-9.5-16.4c5-8.7 2.4-19.8-5.9-25.4V5.5C74.9 3 72.8.9 70.3.9H4.7C2.2.9.1 3 .1 5.5v78.4c0 2.5 2.1 4.6 4.6 4.6h33.5l-.2.3c-.4.6-.4 1.4 0 2.1.4.7 1.2 1 2 .9l6.1-.8 2.4 5.7c.3.7.9 1.2 1.7 1.2h.1c.7 0 1.4-.4 1.7-1l8.7-15c1.1.2 2.3.3 3.5.3 1.2 0 2.3-.1 3.5-.3l8.8 15c.4.6 1 1 1.7 1h.1c.7 0 1.4-.5 1.7-1.2l2.4-5.7 6.1.8c1.1.2 2.1-.6 2.2-1.7 0-.5-.1-1-.3-1.3zM4.7 84.5c-.4 0-.6-.3-.6-.6V5.5c0-.4.3-.7.6-.7h65.6c.4 0 .7.3.7.7V45c-1.7-.7-3.5-1.1-5.4-1.2V12.1c0-1.1-.9-2-2-2H11.3c-1.1 0-2 .9-2 2v65c0 1.1.9 2 2 2h32.2l-3.1 5.4H4.7zm42.8-12.1l-1.6 2.8H13.3V14.1h48.3v29.8c-9.5 1.3-16.7 9.4-16.7 19 0 3.3.9 6.6 2.6 9.5zm3 19L49.1 88c-.3-.8-1.1-1.2-2-1.2l-3.7.5L50 75.9c1.8 2.1 4.1 3.7 6.6 4.8l-6.1 10.7zm13.6-13.2c-8.4 0-15.3-6.8-15.3-15.3 0-8.4 6.8-15.2 15.3-15.2 8.4 0 15.3 6.8 15.2 15.3.1 8.4-6.7 15.2-15.2 15.2zm17.1 8.7c-.9-.1-1.7.4-2.1 1.2l-1.4 3.4-6.2-10.8c2.6-1.1 5-2.7 6.9-4.8L85 87.3l-3.8-.4zM19 58.2c0-1.1.8-2 1.9-2H31c1.1 0 1.9.9 1.9 2s-.9 1.9-2 1.9h-10c-1 0-1.9-.9-1.9-1.9zM48.3 22c0 1.1-.9 2-2 2H28.6c-1.1 0-2-.9-2-2s.9-2 2-2h17.7c1.1 0 2 .9 2 2zM41 66.8c0 1.1-.8 2-1.9 2H20.9h-.1c-1.1 0-1.9-.9-1.9-2s.9-1.9 2-1.9H39c1.1 0 1.9.8 2 1.9zm32.6-8.3l-4.8-1.7-3.1-3.9c-.7-.8-1.9-1-2.8-.3l-.3.3-3.1 3.9-4.7 1.7c-.6.2-1 .7-1.2 1.2-.2.6-.1 1.2.2 1.7l2.9 4.2.1 5.1c0 .6.3 1.2.8 1.5.5.4 1.1.5 1.7.3l4.9-1.4 4.9 1.4h.5c.4 0 .8-.1 1.1-.4.5-.4.8-.9.8-1.5l.1-5.1 2.9-4.2c.3-.5.4-1.1.3-1.7-.2-.5-.7-.9-1.2-1.1zm-5.5 5.4c-.2.3-.3.7-.4 1V68l-3.2-.9c-.4-.1-.7-.1-1.1 0l-2.8.9v-3c0-.4-.1-.7-.4-1l-1.8-2.6 2.9-1c.4-.1.7-.4.9-.7l2-2.5 2 2.5c.2.3.6.5.9.6l2.9 1-1.9 2.6z" fill="#00b4e7"/></svg>';var icon02='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 93"><path d="M11.2 92.9h-1.1c-5.6-.4-9.2-5.3-9.9-10-.3-1.8-.2-3.6-.2-5.3V40.4v-8.9-17.8c0-3.7.7-6.4 2.2-8.5C5 1.2 10.6.6 12.9.6c2.8-.1 5.6 0 8.3 0H50.8c.7 0 1.7-.1 2.7.6.6.4 1 .9 1.3 1.3.1.1.2.3.4.4L73.3 21c.4.4.6.9.6 1.4v42.4c0 5.5.1 11.3 0 16.9 0 2-.2 4.6-1.4 6.9-1 1.9-2.8 3.3-5.2 3.9-2.3.6-4.5.6-6.6.6H12.2c-.3-.2-.6-.2-1-.2zm5.9-88.4H13c-2.7.1-6 .9-7.5 3-1 1.4-1.4 3.5-1.5 6.3V77.7c-.1 1.6-.1 3.2.1 4.6.5 3 2.8 6.4 6.2 6.6H60.5c2 0 3.9 0 5.6-.5 1.8-.5 2.4-1.3 2.7-1.9.8-1.5.9-3.5.9-5.1.1-5.6.1-11.3 0-16.9V23.4 23L52.4 5.6l-.6-.6c-.2-.2-.3-.4-.5-.5H17.1zm34.4 0zm1.2 19.8c-.7 0-1.4-.1-1.9-.7-.8-.8-.7-2.1-.6-3.5V2.5c0-.8.5-1.5 1.2-1.8.7-.3 1.6-.1 2.2.4l19.8 19.7c.6.6.7 1.4.4 2.2-.3.7-1 1.2-1.8 1.2H53.7c-.4.1-.7.1-1 .1zm1.3-2.6zm-1.4-1.4zm1.5 0H67L54.2 7.4v12.5c0 .1-.1.2-.1.4zm7 29.7c0-1.1-.9-2-2-2H41c-1.1 0-2 .9-2 2s.9 2 2 2h18.1c1.1 0 2-.9 2-2zm0-22.7c0-1.1-.9-2-2-2H41c-1.1 0-2 .9-2 2s.9 2 2 2h18.1c1.1 0 2-.9 2-2zm-2 43.3H41c-1.1 0-2 .9-2 2s.9 2 2 2h18.1c1.1 0 2-.9 2-2s-.9-2-2-2zm-28.4-3v-.1c.1-1 .2-2-.4-2.8-.7-1.1-2-1-2.5-1H16.7c-.7-.1-1.7-.2-2.5.2-1.3.5-1.5 1.5-1.5 2.3v13.5c0 1.1.9 2 2 2H27.1c.3 0 .7.1 1 .1.7 0 1.3-.1 1.9-.6.8-.8.7-1.7.6-2.5v-8l.4-.5c.6-.6.6-1.7-.1-2.3.1-.2 0-.2-.2-.3zm-13.5.1h9.5v2.5l-4.4 4.6-3.2-3.4c-.6-.6-1.6-.7-2.3-.1l-.2.2v-3.8h.6zm-.5 5.7l.1.1 3.9 4.1h-4v-4.2zm10 4.2H24l2.7-2.9v2.9zm4.1-33c.1-.9.1-1.9-.4-2.6-.7-1.1-2-1-2.5-1H16.7c-.7-.1-1.7-.2-2.5.2-1.3.5-1.5 1.5-1.5 2.3V57c0 1.1.9 2 2 2H27.1c.3 0 .7.1 1 .1.7 0 1.3-.1 1.9-.6.8-.8.7-1.7.6-2.5v-8.4l.4-.5c.6-.6.6-1.7-.1-2.3.1-.1 0-.1-.1-.2zm-13.6.4h9.5v2.1l-4.4 4.6-3.2-3.4c-.6-.6-1.6-.7-2.3-.1l-.2.2V45h.6zm-.5 5.4l.1.1 4.2 4.4h-4.3v-4.5zm10 4.6h-3.1l3.1-3.2V55zm4.1-33.4c.1-.8 0-1.6-.4-2.3-.7-1.1-1.9-1-2.5-1H16.7c-.7-.1-1.7-.2-2.5.2-1.3.5-1.5 1.5-1.5 2.3v13.5c0 1.1.9 2 2 2H27.1c.3 0 .7.1 1 .1.7 0 1.3-.1 1.9-.6.8-.8.7-1.7.6-2.5v-8.7l.4-.5c.6-.6.6-1.7-.1-2.3.1 0 0-.1-.1-.2zm-13.6.8h9.5v1.8l-4.4 4.6-3.2-3.4c-.6-.6-1.6-.7-2.3-.1l-.2.2v-3.1h.6zm-.5 5l.1.1 4.4 4.6.2.2h-4.7v-4.9zm10 4.9h-3.4c.1-.1.2-.1.2-.2l3.2-3.3v3.5z" fill="#00b4e7"/></svg>';var icon03='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.3 93.7"><path d="M101.9 29.6l-6.4-2.1 2.9-4.5c.3-.5.4-1.2.2-1.8-.2-.6-.7-1-1.4-1.2L15.9 0c-.5-.1-1 0-1.5.2-.4.4-.7.8-.9 1.3L5.8 34.1c-.2 1 .4 2.1 1.4 2.4l19.8 5c-.4 1.2-.6 2.5-.6 3.9 0 5.5 3.4 10.1 8.3 11.9V71c0 5.2-4.3 9.5-9.5 9.5H3.9V70.3c0-1.1-.9-2-2-2s-2 .9-2 2v21.4c0 1.1.9 2 2 2s2-.9 2-2v-7.4h21.3c7.4 0 13.4-6 13.4-13.4V58.1h.6c6.2 0 11.4-4.5 12.5-10.4l25.1 6.4c.2 0 .3.1.5.1.7 0 1.3-.3 1.7-.9l3.8-5.9 13.5 2.9h.4c.9 0 1.7-.6 1.9-1.5l4.5-16.7c.4-1.1-.2-2.2-1.2-2.5zM39.2 54.2c-4.9 0-8.8-4-8.8-8.8 0-1 .2-2 .5-2.9l17 4.3c-.7 4.1-4.3 7.4-8.7 7.4zm37.3-4.3l-24.6-6.2-4.3-1.1-14.5-3.7-4.3-1.1L10 33l6.8-28.8L93.5 23l-17 26.9zm18.9-4L86.1 44l7.3-13 5.5 1.8-3.5 13.1z"/><path d="M84.8 25.1l-9-1.9c-1.1-.2-2.1.5-2.3 1.5-.2 1.1.5 2.1 1.5 2.3l9 1.9h.4c.9 0 1.7-.6 1.9-1.6.2-.9-.5-1.9-1.5-2.2z"/></svg>';var icon04='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93 93"><path d="M93 46.5c0-9.5-2.8-18.3-7.7-25.6l.3-10.3-4.8 4.5C72.3 5.8 60.1 0 46.5 0 20.8 0 0 20.8 0 46.5S20.8 93 46.5 93c13.1 0 24.9-5.4 33.3-14.1l5.5 3.6 6.3-9.7-8 1.7c5.9-7.8 9.4-17.5 9.4-28zM46.5 89C23.1 89 4 69.9 4 46.5S23.1 4 46.5 4c12.4 0 23.6 5.3 31.3 13.8l-4.2 3.9 7.5.3c4.9 6.9 7.8 15.4 7.8 24.5 0 11.4-4.5 21.7-11.8 29.4l-1.5.3.7.5C68.7 84.3 58.2 89 46.5 89z"/><path d="M38.4 71l4-10.9-14.8 6.8M47.2 33.8L50 22.6 36 31"/></svg>';var icon05='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.9 95"><path d="M36.5 75.8c3 0 4.9-2.2 4.9-5.1 0-3-1.9-5.1-4.9-5.1-2.8 0-4.9 2.1-4.9 5.1 0 2.9 2 5.1 4.9 5.1zM39.3 58.9l1.2-39.5h-8l1.2 39.5M98.1 68.8h-5.2c-.3-3.1-1.6-6-3.5-8.4l3.7-3.7c.7-.7.7-1.8 0-2.5s-1.8-.7-2.5 0L87 57.9c-2.3-1.9-5.2-3.1-8.4-3.5v-5.2c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v5.2c-3.1.3-6 1.6-8.4 3.5L63 54.2c-.7-.7-1.8-.7-2.5 0s-.7 1.8 0 2.5l3.7 3.7c-1.9 2.3-3.1 5.2-3.5 8.4h-5.2c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h5.2c.3 3.1 1.6 6 3.5 8.4l-3.7 3.7c-.7.7-.7 1.8 0 2.5.3.3.8.5 1.3.5s.9-.2 1.3-.5l3.7-3.7c2.3 1.9 5.2 3.1 8.4 3.5V92c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-5.2c3.1-.3 6-1.6 8.4-3.5l3.7 3.7c.3.3.8.5 1.3.5s.9-.2 1.3-.5c.7-.7.7-1.8 0-2.5l-3.7-3.7c1.9-2.3 3.1-5.2 3.5-8.4h5.2c1 0 1.8-.8 1.8-1.8-.4-1-1.2-1.8-2.2-1.8zm-8.8 3.5c-.3 2.2-1.2 4.1-2.4 5.8-.7 1-1.6 1.8-2.5 2.5-1.7 1.3-3.7 2.1-5.8 2.4-.6.1-1.2.1-1.8.1-.6 0-1.2-.1-1.8-.1-2.2-.3-4.1-1.2-5.8-2.4-1-.7-1.8-1.6-2.5-2.5-1.3-1.7-2.1-3.7-2.4-5.8-.1-.6-.1-1.2-.1-1.8 0-.6.1-1.2.1-1.8.3-2.2 1.2-4.1 2.4-5.8.7-1 1.6-1.8 2.5-2.5 1.7-1.3 3.7-2.1 5.8-2.4.6-.1 1.2-.1 1.8-.1.6 0 1.2.1 1.8.1 2.2.3 4.1 1.2 5.8 2.4 1 .7 1.8 1.6 2.5 2.5 1.3 1.7 2.1 3.7 2.4 5.8.1.6.1 1.2.1 1.8.1.7 0 1.3-.1 1.8z"/><path d="M61.5 91H11.3c-4 0-7.3-3.3-7.3-7.3V11.3C4 7.3 7.3 4 11.3 4h50.2c4 0 7.3 3.3 7.3 7.3v42.9c1.3-.6 2.6-1.1 4-1.4V11.3c0-6.2-5-11.3-11.3-11.3H11.3C5.1 0 0 5.1 0 11.3v72.4C0 89.9 5.1 95 11.3 95h50.2c4.7 0 8.7-2.8 10.4-6.9-1.3-.4-2.5-.9-3.7-1.5-1.1 2.6-3.7 4.4-6.7 4.4z"/></svg>';var icon06='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98 98"><path d="M64.430682 15.4306C64.430682 6.922128 57.508567 0 49.000109 0c-8.508458 0-15.430572 6.922127-15.430572 15.4306 0 8.508683 6.922114 15.43081 15.430572 15.43081 8.508458 0 15.430573-6.922127 15.430573-15.43081zM49.113352 4.484109C55.483574 4.484108 60 9.056475 60 15.271761 60 21.487047 55.370222 26 49 26s-11-4.512953-11-10.728239S42.629778 4.484108 49 4.484108L49.113352 4v.484108zm21.979127 53.714696H36.376915c-.863648 0-1.731258-.16695-1.731258 1.886018s.86761 2.165528 1.731258 2.165528h37.756987c.863648 0 1.563825-.699969 1.563825-1.563827 0-14.72104-11.976396-26.697458-26.697618-26.697458-14.721221 0-26.697618 11.976418-26.697618 26.697458 0 .863858.700177 1.563827 1.563825 1.563827h6.2553c.863648 0 1.608556-.714261 1.608556-2.165528s-.744908-1.886018-1.608556-1.886018h-2.576823C28.571987 48.119708 38.108779 38.62691 49.000109 38.62691c12.471399 0 21.48688 9.058048 22.09237 19.571895zM54.66079 20.077045c.566522-.651803 1.724583-2.388512.571028-3.268474-1.153554-.879962-2.669587.228159-3.236108.879962-.755849.869697-1.851548 1.252489-2.995642 1.252489-1.144094 0-2.0945-.852356-2.850558-1.722053-.56673-.651803-1.847964-.566522-2.499766 0-.651802.566731-.56673 2.206273 0 2.858076 1.35031 1.552986 3.300505 2.44395 5.350366 2.44395 2.049862 0 4.31037-.890756 5.66068-2.44395zm-25.384056 58.67982L20.698007 77.3171l-4.02028-7.71384c-.269396-.516897-.803807-.841131-1.3868-.841131-.582995 0-1.117406.324234-1.3868.84113L9.883844 77.3171 1.30512 78.756864c-.574862.09654-1.048388.504595-1.22854 1.059025-.180153.55422-.036907 1.162862.371356 1.578631l6.094121 6.207354-1.28171 8.603763c-.085907.57674.155965 1.153062.627614 1.495644.471233.342792 1.09447.394502 1.616161.134698l7.786597-3.877667 7.786596 3.877667c.220604.109677.459348.16389.69684.16389.32465 0 .647216-.10092.919321-.298796.47165-.342583.713521-.918905.627615-1.495645l-1.28171-8.603763 6.09412-6.207353c.408263-.41577.55151-1.024411.371357-1.578632-.179736-.55422-.653262-.962275-1.228124-1.058816zm-8.014498 7.209662c-.343416.34988-.503135.840714-.430782 1.325917l.95435 6.406064-5.79762-2.887243c-.438913-.218727-.955184-.218727-1.394306 0L8.79605 93.698508l.95435-6.406064c.072353-.485203-.087157-.976245-.430782-1.325917l-4.537594-4.62184 6.387495-1.07216c.483743-.08132.901389-.384702 1.128039-.819655l2.99337-5.743626 2.993368 5.743626c.22665.434953.644296.738335 1.12804.819654l6.387494 1.07216-4.537594 4.621841zm41.723681-7.209663L54.40719 77.3171l-4.020281-7.71384c-.269395-.516897-.803806-.841131-1.3868-.841131s-1.117405.324234-1.3868.84113L43.59303 77.3171l-8.578727 1.439764c-.574862.09654-1.048388.504595-1.22854 1.059025-.180153.55422-.036907 1.162862.371356 1.578631l6.09412 6.207354-1.281501 8.603763c-.085907.57674.155965 1.153062.627615 1.495644.471232.342792 1.094468.394502 1.61616.134698l7.786597-3.877667 7.786597 3.877667c.220603.109677.459347.16389.69684.16389.32465 0 .647215-.10092.91932-.298796.47165-.342583.713522-.918905.627616-1.495645l-1.281503-8.603763 6.094122-6.207353c.408262-.41577.551508-1.024411.371356-1.578632-.180153-.55422-.653679-.962275-1.228541-1.058816zm-8.014498 7.209663c-.343416.34988-.503135.840714-.430782 1.325917l.954142 6.406064-5.79762-2.887243c-.219561-.10926-.458305-.163889-.697049-.163889s-.477696.05463-.697049.16389l-5.79762 2.887242.954142-6.406064c.072353-.485203-.087157-.976245-.430782-1.325917l-4.537594-4.62184 6.387495-1.07216c.483743-.08132.901389-.384702 1.128039-.819655l2.99337-5.743418 2.993368 5.743627c.22665.434952.644296.738335 1.12804.819654l6.387494 1.07216-4.537594 4.621632zm42.952013-6.150638c-.180152-.55443-.65347-.962484-1.22854-1.059025L88.116163 77.3171l-4.02028-7.71384c-.269396-.516897-.803807-.841131-1.3868-.841131-.582994 0-1.117406.324234-1.3868.84113L77.302003 77.3171l-8.578726 1.439764c-.574862.09654-1.048389.504595-1.228541 1.059025-.180153.55422-.036906 1.162862.371356 1.578631l6.094121 6.207354-1.28171 8.603763c-.085907.57674.155965 1.153062.627614 1.495644.471233.342792 1.09447.394502 1.616161.134698l7.786597-3.877667 7.786597 3.877667c.220603.109677.459347.16389.69684.16389.32465 0 .647215-.10092.91932-.298796.47165-.342583.713522-.918905.627616-1.495645l-1.281711-8.603763 6.09412-6.207353c.40868-.415561.551927-1.024203.371774-1.578423zm-9.24283 6.150638c-.343416.34988-.503135.840714-.430782 1.325917l.95435 6.406064-5.797828-2.887243c-.219561-.10926-.458305-.163889-.697049-.163889-.238952 0-.477696.05463-.697049.16389l-5.79762 2.887242.95435-6.406064c.072353-.485203-.087157-.976245-.430781-1.325917l-4.537594-4.62184 6.387494-1.07216c.483743-.08132.901389-.384702 1.12804-.819655l2.993369-5.743626 2.993369 5.743626c.22665.434953.644296.738335 1.128039.819654l6.387494 1.07216-4.537802 4.621841z" fill="#00B4E7" fill-rule="evenodd"/></svg>';var magnifierGradient='<svg viewBox="0 0 390 391" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="106.586865%" y1="-27.103647%" x2="16.505642%" y2="100%" id="b"><stop stop-color="#E6F8FF" offset="0%"/><stop stop-color="#13A5E1" offset="100%"/></linearGradient><path d="M263.265999 1c-49.79698-.401414-95.142662 28.611939-115.646428 73.993608-20.503766 45.381669-12.304988 98.586796 20.909586 135.690603l-24.526316 25.052631-11.473684-11.578947c-2.957892-2.780583-7.568423-2.780583-10.526316 0L9.581789 336.263158c-9.234992 9.241948-11.99643 23.135463-6.997547 35.206497 4.998882 12.071034 16.774483 19.94444 29.839652 19.951398 8.5853.078554 16.832503-3.341945 22.842105-9.473685l111.789474-112c2.780583-2.957892 2.780583-7.568423 0-10.526315l-12.105263-12.105264 25.157895-25.263157c42.180541 37.199196 103.874072 42.030832 151.331458 11.851786 47.457385-30.179047 69.2462-88.098682 53.446983-142.07426C369.087329 37.854582 319.506091.825709 263.265999 1zM44.213368 370.894737c-6.647982 5.575839-16.454788 5.146589-22.590162-.988786-6.135374-6.135374-6.564625-15.94218-.988786-22.590162l106.421053-106.526315 23.68421 23.368421L44.213368 370.894737zm219.052631-133.684211c-44.704104.212962-85.117073-26.574796-102.332999-67.831482-17.215926-41.256687-7.830712-88.824636 23.765072-120.450713 31.595784-31.626077 79.154717-41.056871 120.427882-23.88049 41.273166 17.176381 68.09964 57.56366 67.929519 102.267948-.287543 60.532669-49.257109 109.549186-109.789474 109.894737z" id="a"/><path d="M215.273225 129.210526c-1.88021-.934331-4.057978-1.070087-6.039668-.376496-1.98169.693592-3.599474 2.157791-4.486648 4.060707l-13.263158 27.894737h-2.105263a23.36839 23.36839 0 0 0-4 0l-24-41.368421c6.468419-7.801224 7.023486-18.93165 1.363314-27.337718-5.660172-8.406069-16.182187-12.077813-25.843382-9.018264-9.661195 3.05955-16.151494 12.118827-15.940984 22.250718.001049 4.587156 1.396006 9.065703 4 12.842106l-8.421053 12.315789a23.473692 23.473692 0 0 0-5.684211-.736842c-10.549058-.032705-19.748388 7.162753-22.25743 17.409138-2.509042 10.246385 2.32491 20.878187 11.695564 25.72324 9.370653 4.845054 20.840313 2.642961 27.750405-5.327881 6.910092-7.970842 7.463016-19.636885 1.337777-28.22555l8.210527-12a23.68422 23.68422 0 0 0 6.210526.842106 21.05273 21.05273 0 0 0 4.421053 0l23.894736 41.157894c-3.473414 4.08307-5.376893 9.270983-5.368421 14.631579-.042066 10.357993 6.890872 19.44776 16.891294 22.146155 10.000422 2.698394 20.564781-1.670111 25.738823-10.643352 5.174043-8.97324 3.662479-20.30482-3.682748-27.608066l13.157894-27.789473c1.078984-1.890663 1.305419-4.150253.623053-6.217421-.682366-2.067168-2.209494-3.747912-4.202-4.624685zm-104.526316 30.736842c-4.011331 0-7.263158-3.251826-7.263158-7.263157 0-4.011332 3.251827-7.263158 7.263158-7.263158 4.011332 0 7.263158 3.251826 7.263158 7.263158 0 1.926309-.765223 3.773721-2.127329 5.135828-1.362107 1.362106-3.209519 2.127329-5.135829 2.127329zm33.052632-47.368421c-4.011331 0-7.263158-3.251826-7.263158-7.263158 0-4.011331 3.251827-7.263157 7.263158-7.263157s7.263158 3.251826 7.263158 7.263157c0 1.92631-.765224 3.773722-2.12733 5.135829-1.362106 1.362106-3.209519 2.127329-5.135828 2.127329zm45.894737 77.894737c-4.011332 0-7.263158-3.251826-7.263158-7.263158 0-4.011331 3.251826-7.263158 7.263158-7.263158 4.011331 0 7.263158 3.251827 7.263158 7.263158 0 4.011332-3.251827 7.263158-7.263158 7.263158z" id="c"/><path d="M68.526316 55.736842c-12.615347 0-22.842105 10.226759-22.842105 22.842105 0 12.615347 10.226758 22.842106 22.842105 22.842106 12.615346 0 22.842105-10.22676 22.842105-22.842106S81.141662 55.736842 68.526316 55.736842zm0 30c-4.011332 0-7.263158-3.251826-7.263158-7.263158 0-4.011331 3.251826-7.263158 7.263158-7.263158 4.011331 0 7.263158 3.251827 7.263158 7.263158 0 4.011332-3.251827 7.263158-7.263158 7.263158z" id="d"/></defs><g fill-rule="nonzero" fill="none" opacity=".495754"><g transform="matrix(-1 0 0 1 390.108104 -1)" fill-rule="evenodd"><use fill="#FFF" xlink:href="#a"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#a"/></g><path d="M81.578948 105.263158c1.88021-.934332 4.057978-1.070088 6.039669-.376496 1.98169.693591 3.599474 2.157791 4.486647 4.060706l1.157895 2.421053c.934331 1.88021 1.070087 4.057978.376496 6.039668-.693592 1.981691-2.157791 3.599474-4.060707 4.486648a7.368428 7.368428 0 0 1-3.263158.736842c-3.03134-.007942-5.782751-1.773772-7.052631-4.526316l-1.157895-2.421052c-.944449-1.838591-1.108363-3.980142-.454727-5.94105.653636-1.960908 2.069698-3.5758 3.928411-4.480003z" fill="#F6F7FC"/><g transform="matrix(-1 0 0 1 307.79954 -1)" fill-rule="evenodd"><use fill="#FFF" xlink:href="#c"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#c"/></g><g transform="matrix(-1 0 0 1 137.052632 -1)" fill-rule="evenodd"><use fill="#FFF" xlink:href="#d"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#d"/></g></g></svg>';var magnifier='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 391 391"><path class="a" d="M127.342,0a125.789,125.789,0,0,1,94.737,209.684l24.526,25.053,11.474-11.579a7.683,7.683,0,0,1,10.526,0l112.421,112.1a32.315,32.315,0,0,1-22.842,55.158,31.577,31.577,0,0,1-22.842-9.474l-111.789-112a7.683,7.683,0,0,1,0-10.526l12.1-12.1L210.5,221.053A126.316,126.316,0,1,1,127.342,0ZM346.4,369.9a16.737,16.737,0,0,0,23.579-23.579L263.553,239.789l-23.685,23.369ZM127.342,236.211a110.316,110.316,0,1,0-109.789-109.9A110.316,110.316,0,0,0,127.342,236.211Z"/><path class="a" d="M82.079,105.263a7.79,7.79,0,0,1,10.526,3.684l1.158,2.421A7.789,7.789,0,0,1,90.079,121.9a7.387,7.387,0,0,1-3.263.737,7.789,7.789,0,0,1-7.053-4.527l-1.158-2.421a7.686,7.686,0,0,1,3.474-10.421Z"/><path class="a" d="M93.026,128.211a7.789,7.789,0,0,1,10.527,3.684l13.263,27.894h2.105a23.435,23.435,0,0,1,4,0l24-41.368a22.678,22.678,0,1,1,36.421-1.263l8.421,12.316a23.45,23.45,0,0,1,5.684-.737,22.842,22.842,0,1,1-18.526,9.579l-8.21-12a23.7,23.7,0,0,1-6.211.842,21.075,21.075,0,0,1-4.421,0l-23.9,41.158a22.526,22.526,0,0,1,5.369,14.631,22.842,22.842,0,1,1-38.948-16.1L89.447,139.053a7.684,7.684,0,0,1,3.579-10.842Zm104.527,30.736a7.264,7.264,0,1,0-5.136-2.127,7.263,7.263,0,0,0,5.136,2.127ZM164.5,111.579a7.262,7.262,0,1,0-5.136-2.127,7.263,7.263,0,0,0,5.136,2.127Zm-45.895,77.9a7.264,7.264,0,1,0-7.263-7.263A7.263,7.263,0,0,0,118.605,189.474Z"/><path class="a" d="M69.026,54.737A22.842,22.842,0,1,1,46.184,77.579,22.842,22.842,0,0,1,69.026,54.737Zm0,30a7.263,7.263,0,1,0-7.263-7.263A7.263,7.263,0,0,0,69.026,84.737Z"/></svg>';var web='<svg width="87" height="62" xmlns="http://www.w3.org/2000/svg"><g stroke="#13A5E1" fill="none" fill-rule="evenodd"><g stroke-linecap="round" stroke-linejoin="round"><path d="M14 6.501499C14 7.32867 13.326347 8 12.5 8c-.829341 0-1.5-.671329-1.5-1.498501C11 5.668332 11.670659 5 12.5 5c.826347 0 1.5.668332 1.5 1.501499zM19 6.501499C19 7.32867 18.329341 8 17.5 8S16 7.328671 16 6.501499C16 5.668332 16.670659 5 17.5 5s1.5.668332 1.5 1.501499zM24 6.501499C24 7.32867 23.326347 8 22.5 8c-.829341 0-1.5-.671329-1.5-1.498501C21 5.668332 21.670659 5 22.5 5c.826347 0 1.5.668332 1.5 1.501499z" stroke-width="1.575" fill="#000"/><g stroke-width="2.625"><path d="M79.35008 50.791654V3.986723C79.35008 2.889405 78.465444 2 77.367575 2H9.027358c-1.096428 0-1.983945.889405-1.983945 1.986723v46.80493H79.35008zM84.853251 50.796493v7.056042c0 1.095873-.888957 1.986722-1.985386 1.986722H3.443777c-1.094988 0-1.983946-.890849-1.983946-1.986722v-7.056042h83.39342z"/></g><path d="M7 11V4.412556c0-2.605912 1.256858-2.40917 3.177345-2.40917H76.48c2.16 0 2.52.590226 2.52 2.09858V11H7z" stroke-width="2.625"/></g><path stroke-width="3" d="M15.5 22.5h23v10h-23zM47.385265 23.797775h22.897104M47.385265 31.797775h22.897104M14 39.5h56.470001"/></g></svg>';var server='<svg width="105" height="65" xmlns="http://www.w3.org/2000/svg"><g stroke="#13A5E1" stroke-width="3.456" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M95.318903 62.390566c5.259668-4.299626 7.812154-10.21161 7.657458-17.735955-.154696-7.524345-5.607734-12.553371-16.359116-15.087079.618785-16.661049-6.767955-25.759363-22.16022-27.294944C49.064758.737008 39.628294 5.689255 36.147631 17.12933c-4.872928-2.456929-8.856354-2.802435-11.950276-1.036517-3.093923 1.765918-4.640884 5.105805-4.640884 10.019663C11.357577 27.494498 5.981886 31.103113 3.4294 36.938319c-3.82873 8.752809.928177 18.772472 3.82873 22.11236 1.9337 2.22659 3.674032 3.339887 5.220994 3.339887h82.839779z"/><path d="M45.856354 30.561798c-.077349-6.449438 2.165745-9.674158 6.729281-9.674158 4.563536 0 6.845304 3.22472 6.845304 9.674158M40.63536 32.404494h23.668507v18.311798H40.63536z"/></g></svg>';var important='<svg width="71" height="86" xmlns="http://www.w3.org/2000/svg"><g fill="#13A5E1" fill-rule="evenodd"><rect fill-rule="nonzero" x="5" y="5" width="3" height="3" rx="1.5"/><rect fill-rule="nonzero" x="11" y="5" width="3" height="3" rx="1.5"/><rect fill-rule="nonzero" x="7" y="17" width="23" height="3" rx="1.5"/><rect fill-rule="nonzero" x="7" y="23" width="23" height="3" rx="1.5"/><rect fill-rule="nonzero" x="16" y="5" width="3" height="3" rx="1.5"/><path d="M57.346154 56.4375H71V0H0v56.4375h13.653846V64.5c0 9.582281 8.024366 17.544 21.465212 21.391156L35.5 86l.380942-.108844C49.321788 82.044 57.346154 74.082281 57.346154 64.5v-8.0625zm0-21.498656l-1.365385-.001344c-.120154 0-11.020019-.069875-17.75-3.855219V20.15625h23.211539v26.875h-4.096154V34.938844zM68.26923 2.6875V10.75H2.730769V2.6875h65.538462zM2.730769 53.75V13.4375h65.538462V53.75H57.346154v-4.03125h6.826923v-32.25H35.5v11.713469l-.856096.67725C28.316712 34.870312 15.151674 34.9375 15.01923 34.9375l-1.365385.001344v4.029906H6.826923v2.6875h6.826923v2.6875H6.826923v2.6875h6.826923V53.75H2.73077zM54.615385 64.5c0 8.231813-7.136866 15.16825-19.115385 18.699625C23.52148 79.66825 16.384615 72.731813 16.384615 64.5V37.591406C19.940077 37.446281 29.53327 36.672281 35.5 32.58325c5.96673 4.087688 15.559923 4.861688 19.115385 5.008156V64.5z"/><path d="M26.75 51v2.666667H24V71h22V53.666667h-2.75V51c0-4.412-3.700125-8-8.25-8s-8.25 3.588-8.25 8zm16.5 17.333333h-16.5v-12h16.5v12zM40.5 51v2.666667h-11V51c0-2.941333 2.46675-5.333333 5.5-5.333333s5.5 2.392 5.5 5.333333z" fill-rule="nonzero"/><rect fill-rule="nonzero" x="34" y="59" width="3" height="6" rx="1.5"/></g></svg>';var network='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74"><path d="M69.606962 1H4.393038C2.522111 1 1 2.52211 1 4.39289v10.25172c0 1.87093 1.522111 3.39289 3.393038 3.39289h65.213924C71.477889 18.0375 73 16.51539 73 14.64461V4.39289C73 2.52211 71.477889 1 69.606962 1zm1.095166 13.64461c0 .60373-.491285 1.09502-1.095166 1.09502H4.393038c-.603881 0-1.095166-.49129-1.095166-1.09502V4.39289c0-.60373.491285-1.09502 1.095166-1.09502h65.213924c.603881 0 1.095166.49129 1.095166 1.09502v10.25172zm-1.095166 5.69091H4.393038C2.522111 20.33552 1 21.85763 1 23.72856v10.25158c0 1.87092 1.522111 3.39288 3.393038 3.39288h65.213924C71.477889 37.37302 73 35.85091 73 33.98014V23.72856c0-1.87093-1.522111-3.39304-3.393038-3.39304zm-24.937583 7.36989H9.518826c-.63452 0-1.148937.51427-1.148937 1.14894 0 .63467.514417 1.14894 1.148937 1.14894h35.150553c.634519 0 1.148936-.51427 1.148936-1.14894 0-.63467-.514417-1.14894-1.148936-1.14894zm19.811795-2.29787c-1.900646 0-3.446808 1.54632-3.446808 3.44681 0 1.90049 1.546162 3.44681 3.446808 3.44681 1.900647 0 3.446809-1.54632 3.446809-3.44681 0-1.90049-1.546162-3.44681-3.446809-3.44681zm0 4.59575c-.6336 0-1.148936-.51534-1.148936-1.14894s.515336-1.14894 1.148936-1.14894c.6336 0 1.148937.51534 1.148937 1.14894s-.515337 1.14894-1.148937 1.14894zM54.33714 25.40754c-1.900646 0-3.446808 1.54632-3.446808 3.44681 0 1.90049 1.546162 3.44681 3.446808 3.44681 1.900647 0 3.446809-1.54632 3.446809-3.44681 0-1.90049-1.546162-3.44681-3.446809-3.44681zm0 4.59575c-.6336 0-1.148936-.51534-1.148936-1.14894s.515336-1.14894 1.148936-1.14894c.6336 0 1.148937.51534 1.148937 1.14894s-.515337 1.14894-1.148937 1.14894zm16.364988 3.97685c0 .60372-.491285 1.09501-1.095166 1.09501H4.393038c-.603881 0-1.095166-.49129-1.095166-1.09501V23.72856c0-.60388.491285-1.09516 1.095166-1.09516h65.213924c.603881 0 1.095166.49128 1.095166 1.09516v10.25158zm-1.095166 5.69091H4.393038C2.522111 39.67105 1 41.19316 1 43.06409v10.25157c0 1.87093 1.522111 3.39304 3.393038 3.39304h65.213924C71.477889 56.7087 73 55.18643 73 53.31566V43.06409c0-1.87093-1.522111-3.39304-3.393038-3.39304zm-24.937583 7.36989H9.518826c-.63452 0-1.148937.51426-1.148937 1.14893s.514417 1.14894 1.148937 1.14894h35.150553c.634519 0 1.148936-.51427 1.148936-1.14894 0-.63467-.514417-1.14893-1.148936-1.14893zm19.811795-2.29788c-1.900646 0-3.446808 1.54632-3.446808 3.44681 0 1.9005 1.546162 3.44681 3.446808 3.44681 1.900647 0 3.446809-1.54631 3.446809-3.44681 0-1.90049-1.546162-3.44681-3.446809-3.44681zm0 4.59575c-.6336 0-1.148936-.51534-1.148936-1.14894s.515336-1.14893 1.148936-1.14893c.6336 0 1.148937.51533 1.148937 1.14893s-.515337 1.14894-1.148937 1.14894zM54.33714 44.74306c-1.900646 0-3.446808 1.54632-3.446808 3.44681 0 1.9005 1.546162 3.44681 3.446808 3.44681 1.900647 0 3.446809-1.54631 3.446809-3.44681 0-1.90049-1.546162-3.44681-3.446809-3.44681zm0 4.59575c-.6336 0-1.148936-.51534-1.148936-1.14894s.515336-1.14893 1.148936-1.14893c.6336 0 1.148937.51533 1.148937 1.14893s-.515337 1.14894-1.148937 1.14894zm16.364988 3.97685c0 .60388-.491285 1.09517-1.095166 1.09517H4.393038c-.603881 0-1.095166-.49129-1.095166-1.09517V43.06409c0-.60389.491285-1.09517 1.095166-1.09517h65.213924c.603881 0 1.095166.49128 1.095166 1.09517v10.25157zm1.148936 13.55668C72.485583 66.87234 73 66.35808 73 65.7234c0-.63467-.514417-1.14893-1.148936-1.14893h-26.00349c-.085174-.55042-.559761-.97216-1.133923-.97216h-3.014808v-3.4468c0-.63468-.514417-1.14894-1.148937-1.14894-.634519 0-1.148936.51426-1.148936 1.14894v4.59574c0 .63467.514417 1.14894 1.148936 1.14894h3.014809v4.80194H30.435438v-4.80194h5.518724c.634519 0 1.148936-.51427 1.148936-1.14894 0-.63467-.514417-1.14894-1.148936-1.14894H34.59903v-3.4468c0-.63468-.514417-1.14894-1.148936-1.14894-.63452 0-1.148937.51426-1.148937 1.14894v3.4468h-3.014655c-.574315 0-1.048749.42174-1.133923.97216H2.148936C1.514417 64.57447 1 65.08873 1 65.7234c0 .63468.514417 1.14894 1.148936 1.14894h25.988477v2.29787H2.148936C1.514417 69.17021 1 69.68448 1 70.31915c0 .63467.514417 1.14894 1.148936 1.14894h25.988477v.38297c0 .63468.514417 1.14894 1.148936 1.14894h15.427149c.634519 0 1.148936-.51426 1.148936-1.14894v-.38297h25.98863c.634519 0 1.148936-.51427 1.148936-1.14894 0-.63467-.514417-1.14894-1.148936-1.14894H45.862587v-2.29787h25.988477zM44.669379 8.36989H9.518826c-.63452 0-1.148937.51426-1.148937 1.14894 0 .63467.514417 1.14893 1.148937 1.14893h35.150553c.634519 0 1.148936-.51426 1.148936-1.14893 0-.63468-.514417-1.14894-1.148936-1.14894zm19.811795-2.29787c-1.900646 0-3.446808 1.54631-3.446808 3.44681 0 1.90049 1.546162 3.4468 3.446808 3.4468 1.900647 0 3.446809-1.54631 3.446809-3.4468 0-1.9005-1.546162-3.44681-3.446809-3.44681zm0 4.59574c-.6336 0-1.148936-.51533-1.148936-1.14893s.515336-1.14894 1.148936-1.14894c.6336 0 1.148937.51534 1.148937 1.14894s-.515337 1.14893-1.148937 1.14893zM54.33714 6.07202c-1.900646 0-3.446808 1.54631-3.446808 3.44681 0 1.90049 1.546162 3.4468 3.446808 3.4468 1.900647 0 3.446809-1.54631 3.446809-3.4468 0-1.9005-1.546162-3.44681-3.446809-3.44681zm0 4.59574c-.6336 0-1.148936-.51533-1.148936-1.14893s.515336-1.14894 1.148936-1.14894c.6336 0 1.148937.51534 1.148937 1.14894s-.515337 1.14893-1.148937 1.14893z" fill="#FFF" stroke="#FFF" fill-rule="evenodd"/></svg>';var database='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><path d="M3.672745 37.4182h8.437608l3.029056 6.05844c.210765.42153.641757.68806 1.113242.68806.471485 0 .902477-.26636 1.113243-.68806l3.029221-6.05844h.618025c.687396 0 1.244681-.55712 1.244681-1.24468 0-.68756-.557285-1.24468-1.244681-1.24468h-1.387238c-.471485 0-.902476.26619-1.113242.68806l-2.260009 4.51985-2.259842-4.51985c-.210766-.42153-.641758-.68806-1.113243-.68806H3.672745c-.101068 0-.183383-.08215-.183383-.18322V3.67274c0-.10106.082315-.18338.183383-.18338h25.159812c.101234 0 .183549.08232.183549.18338v13.49334c0 .68756.557285 1.24468 1.244681 1.24468.687396 0 1.244681-.55712 1.244681-1.24468V3.67274C31.505468 2.19904 30.306426 1 28.832557 1H3.672745C2.199043 1 1 2.19904 1 3.67274v31.07272c0 1.47386 1.199043 2.67274 2.672745 2.67274zM16.252817 5.97872c-3.433328 0-6.226391 2.79307-6.226391 6.22639 0 3.43333 2.793229 6.22656 6.226391 6.22656 3.433162 0 6.226392-2.79323 6.226392-6.22656 0-3.43332-2.79323-6.22639-6.226392-6.22639zm0 9.96342c-2.060694 0-3.73703-1.6765-3.73703-3.73719 0-2.06036 1.676336-3.73686 3.73703-3.73686s3.73703 1.6765 3.73703 3.73702c0 2.0607-1.676502 3.73703-3.73703 3.73703zm0 7.46809c1.463579 0 2.889485.40809 4.123213 1.17996.583008.36477 1.350727.18803 1.715336-.39482.364608-.58284.187864-1.35089-.394813-1.71533-1.6302-1.01998-3.512655-1.55934-5.443736-1.55934-5.665289.00017-10.274094 4.60914-10.274094 10.2741 0 .68756.557286 1.24468 1.244681 1.24468H21.01314c.687396 0 1.244681-.55712 1.244681-1.24468 0-.68757-.557285-1.24469-1.244681-1.24469H8.567494c.597612-3.70267 3.816357-6.53988 7.685323-6.53988zM76.327421 1H51.167443c-1.473869 0-2.672911 1.19904-2.672911 2.67274v13.49334c0 .68756.557119 1.24468 1.244681 1.24468.687561 0 1.244681-.55712 1.244681-1.24468V3.67274c0-.10106.082315-.18338.183549-.18338h25.159812c.101068 0 .183217.08232.183217.18338v31.07272c0 .10106-.082149.18321-.183217.18321h-9.206987c-.471485 0-.902477.26636-1.113242.68806l-2.259843 4.51985-2.260009-4.51985c-.210931-.4217-.641757-.68806-1.113242-.68806H58.98686c-.687562 0-1.244681.55712-1.244681 1.24468 0 .68756.557119 1.24468 1.244681 1.24468h.618025l3.029221 6.05845c.210932.42169.641758.68806 1.113243.68806.471485 0 .902477-.26637 1.113242-.68806l3.029222-6.05845h8.437608C77.801123 37.41803 79 36.21899 79 34.74546V3.67274C79 2.19904 77.800957 1 76.327421 1zM63.747349 5.97872c-3.433328 0-6.226558 2.79307-6.226558 6.22639 0 3.43333 2.79323 6.22656 6.226558 6.22656s6.226391-2.79323 6.226391-6.22656c0-3.43332-2.793229-6.22639-6.226391-6.22639zm0 9.96342c-2.060694 0-3.737196-1.6765-3.737196-3.73719 0-2.06053 1.676502-3.73703 3.737196-3.73703 2.060528 0 3.73703 1.6765 3.73703 3.73703-.000166 2.06086-1.676502 3.73719-3.73703 3.73719zm-6.00517 15.25266c0 .68756.557119 1.24468 1.244681 1.24468h13.789736c.687561 0 1.244681-.55712 1.244681-1.24468 0-5.66513-4.608805-10.27393-10.273928-10.27393-1.931247 0-3.813536.53919-5.443736 1.55933-.582677.36445-.759422 1.1325-.394979 1.71534.364775.58268 1.132328.75942 1.715502.39481 1.233894-.77186 2.659468-1.17995 4.123213-1.17995 3.868966 0 7.087545 2.8372 7.685323 6.53988H58.987026c-.687562-.00017-1.244847.55712-1.244847 1.24452zm-32.994996-7.62293v31.07288c0 1.4737 1.199043 2.67258 2.672745 2.67258h8.437608l3.029055 6.05844c.210932.42153.641924.68806 1.113243.68806.471319 0 .902477-.26636 1.113243-.68806l3.029221-6.05844h8.437442c1.473869 0 2.672745-1.19904 2.672745-2.67258V23.57187c0-1.4737-1.199042-2.67258-2.672745-2.67258H27.419928c-1.473702-.00016-2.672745 1.19888-2.672745 2.67258zm28.016106 0v31.07288c0 .10107-.082315.18322-.183383.18322h-9.206655c-.471485 0-.902477.26619-1.113242.68806L40 60.03588l-2.259843-4.51985c-.210766-.42154-.641757-.68806-1.113242-.68806h-9.206821c-.101068 0-.183383-.08215-.183383-.18322V23.57187c0-.10107.082315-.18321.183383-.18321h25.159812c.101068-.00017.183383.08198.183383.18321zM40 38.33063c3.433162 0 6.226391-2.79323 6.226391-6.22655 0-3.43333-2.793063-6.22639-6.226391-6.22639-3.433328 0-6.226391 2.79306-6.226391 6.22639 0 3.43332 2.793063 6.22655 6.226391 6.22655zm0-9.96342c2.060528 0 3.73703 1.6765 3.73703 3.73703 0 2.0607-1.676502 3.7372-3.73703 3.7372-2.060694 0-3.73703-1.6765-3.73703-3.7372 0-2.06053 1.676336-3.73703 3.73703-3.73703zm-9.029413 23.97156h18.05866c.687562 0 1.244681-.55712 1.244681-1.24468 0-5.66512-4.608805-10.27393-10.273928-10.27393-5.665123 0-10.274094 4.60881-10.274094 10.27393 0 .6874.557285 1.24468 1.244681 1.24468zM40 43.30936c3.8688 0 7.087545 2.83721 7.685323 6.53988h-15.37048c.597446-3.70267 3.816191-6.53988 7.685157-6.53988zm37.755319 23.24383H2.244681C1.557285 66.55319 1 67.11031 1 67.79787v9.95745C1 78.44288 1.557285 79 2.244681 79h75.510638C78.442881 79 79 78.44288 79 77.75532v-9.95745c0-.68756-.557119-1.24468-1.244681-1.24468zM3.489362 69.04255h46.053191v7.46809H3.489362v-7.46809zm60.823404 5.06171c.732038 0 1.32766-.59563 1.32766-1.32766 0-.73204-.595622-1.32766-1.32766-1.32766-.732038 0-1.32766.59562-1.32766 1.32766 0 .73203.595622 1.32766 1.32766 1.32766zm-6.804255 0c.732038 0 1.327659-.59563 1.327659-1.32766 0-.73204-.595621-1.32766-1.327659-1.32766-.732039 0-1.32766.59562-1.32766 1.32766 0 .73203.595621 1.32766 1.32766 1.32766zm13.60851 0c.732039 0 1.32766-.59563 1.32766-1.32766 0-.73204-.595621-1.32766-1.32766-1.32766-.732038 0-1.327659.59562-1.327659 1.32766 0 .73203.595621 1.32766 1.327659 1.32766zm5.393617 2.40638H52.031915v-7.46809h24.478723v7.46809z" fill="#FFF" stroke="#FFF" fill-rule="evenodd"/></svg>';var nonTech='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 67"><path d="M71.85106 1H51.55319c-.63452 0-1.14893.51342-1.14893 1.14706 0 .63363.51441 1.14706 1.14893 1.14706h19.14894v6.88235H48.10638V2.14706C48.10638 1.51342 47.59197 1 46.95745 1h-19.9149c-.63452 0-1.14893.51342-1.14893 1.14706v8.02941H3.29787V3.29412h19.14894c.63452 0 1.14893-.51343 1.14893-1.14706C23.59574 1.51342 23.08133 1 22.44681 1H2.14894C1.51442 1 1 1.51342 1 2.14706v62.70588C1 65.48658 1.51442 66 2.14894 66h69.70212C72.48558 66 73 65.48658 73 64.85294V52.61765c0-.63364-.51442-1.14706-1.14894-1.14706-.63452 0-1.14893.51342-1.14893 1.14706v11.08823H3.29787V12.47059h22.59575v35.55882c0 .44093.25322.84286.65121 1.03388.39815.19118.87059.1375 1.21543-.1381L37 41.54532l9.23974 7.37972c.20773.16594.46172.25143.71786.25143.16912 0 .33932-.03716.49757-.11318.39799-.19102.65121-.59295.65121-1.03388V12.47059h22.59575v35.55882c0 .63364.51441 1.14706 1.14893 1.14706S73 48.66305 73 48.02941V2.14706C73 1.51342 72.48558 1 71.85106 1zM45.80851 45.64292l-8.09081-6.46207c-.20987-.16763-.46371-.25144-.7177-.25144s-.50783.08381-.7177.25144l-8.09081 6.46207V3.29412h7.65957v32.19412c0 .63363.51442 1.14705 1.14894 1.14705.63452 0 1.14894-.51342 1.14894-1.14705V3.29412h7.65957v42.3488zM60.66809 6.73529c0-.67462-.54981-1.22353-1.22554-1.22353-.67572 0-1.22553.54891-1.22553 1.22353 0 .67463.54981 1.22353 1.22553 1.22353.67573 0 1.22554-.5489 1.22554-1.22353zm-6.28086 0c0-.67462-.5498-1.22353-1.22553-1.22353s-1.22553.54891-1.22553 1.22353c0 .67463.5498 1.22353 1.22553 1.22353s1.22553-.5489 1.22553-1.22353zm12.56171 0c0-.67462-.54981-1.22353-1.22554-1.22353-.67572 0-1.22553.54891-1.22553 1.22353 0 .67463.54981 1.22353 1.22553 1.22353.67573 0 1.22554-.5489 1.22554-1.22353z" fill="#FFF" stroke="#FFF" fill-rule="evenodd"/></svg>';var presentation='<svg viewBox="0 0 256 232" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="106.586865%" y1="-27.103647%" x2="16.505642%" y2="100%" id="b"><stop stop-color="#E6F8FF" offset="0%"/><stop stop-color="#13A5E1" offset="100%"/></linearGradient><path d="M43.252647 158.533333c-8.53563 0-15.455222 6.924717-15.455222 15.466667s6.919592 15.466667 15.455222 15.466667c8.535629 0 15.455221-6.924717 15.455221-15.466667s-6.919592-15.466667-15.455221-15.466667zm0 23.2c-4.268056 0-7.727611-3.462116-7.727611-7.733333s3.459555-7.733333 7.72761-7.733333c4.268057 0 7.727612 3.462116 7.727612 7.733333s-3.459555 7.733333-7.727611 7.733333z" id="a"/><path d="M43.252647 193.333333c-12.803686 0-23.182833 10.386834-23.182833 23.2v11.6c0 2.135367 1.730019 3.866667 3.863805 3.866667 2.133787 0 3.863806-1.7313 3.863806-3.866667v-11.6c0-8.54195 6.919592-15.466666 15.455222-15.466666 8.535629 0 15.455221 6.924716 15.455221 15.466666v11.6c0 2.135367 1.73002 3.866667 3.863806 3.866667 2.133786 0 3.863805-1.7313 3.863805-3.866667v-11.6c0-12.813166-10.379147-23.2-23.182832-23.2z" id="c"/><path d="M106.172246 158.533333c-8.53563 0-15.455222 6.924717-15.455222 15.466667s6.919593 15.466667 15.455222 15.466667S121.627468 182.54195 121.627468 174s-6.919593-15.466667-15.455222-15.466667zm0 23.2c-4.268056 0-7.72761-3.462116-7.72761-7.733333s3.459554-7.733333 7.72761-7.733333c4.268056 0 7.727611 3.462116 7.727611 7.733333s-3.459555 7.733333-7.727611 7.733333z" id="d"/><path d="M106.172246 193.333333c-12.803685 0-23.182833 10.386834-23.182833 23.2v11.6c0 2.135367 1.73002 3.866667 3.863806 3.866667 2.133786 0 3.863805-1.7313 3.863805-3.866667v-11.6c0-8.54195 6.919593-15.466666 15.455222-15.466666s15.455222 6.924716 15.455222 15.466666v11.6c0 2.135367 1.730019 3.866667 3.863805 3.866667 2.133787 0 3.863806-1.7313 3.863806-3.866667v-11.6c0-12.813166-10.379148-23.2-23.182833-23.2z" id="e"/><path d="M232.817167 158.533333c-8.535629 0-15.455221 6.924717-15.455221 15.466667s6.919592 15.466667 15.455221 15.466667c8.53563 0 15.455222-6.924717 15.455222-15.466667s-6.919592-15.466667-15.455222-15.466667zm0 23.2c-4.268056 0-7.72761-3.462116-7.72761-7.733333s3.459554-7.733333 7.72761-7.733333c4.268056 0 7.727611 3.462116 7.727611 7.733333s-3.459555 7.733333-7.727611 7.733333z" id="f"/><path d="M232.817167 193.333333c-12.798372.012567-23.170275 10.39215-23.182832 23.2v11.6c0 2.135367 1.730019 3.866667 3.863805 3.866667 2.133787 0 3.863806-1.7313 3.863806-3.866667v-11.6c0-8.54195 6.919592-15.466666 15.455221-15.466666 8.53563 0 15.455222 6.924716 15.455222 15.466666v11.6c0 2.135367 1.730019 3.866667 3.863806 3.866667C254.269981 232 256 230.2687 256 228.133333v-11.6c-.012557-12.80785-10.38446-23.187433-23.182833-23.2z" id="g"/><path d="M170.190558 158.533333c-8.535629 0-15.455222 6.924717-15.455222 15.466667s6.919593 15.466667 15.455222 15.466667S185.64578 182.54195 185.64578 174s-6.919593-15.466667-15.455222-15.466667zm0 23.2c-4.268056 0-7.727611-3.462116-7.727611-7.733333s3.459555-7.733333 7.727611-7.733333 7.727611 3.462116 7.727611 7.733333-3.459555 7.733333-7.727611 7.733333z" id="h"/><path d="M170.190558 193.333333c-12.798373.012567-23.170275 10.39215-23.182833 23.2v11.6c0 2.135367 1.730019 3.866667 3.863806 3.866667 2.133786 0 3.863805-1.7313 3.863805-3.866667v-11.6c0-8.54195 6.919593-15.466666 15.455222-15.466666s15.455222 6.924716 15.455222 15.466666v11.6c0 2.135367 1.730019 3.866667 3.863805 3.866667 2.133787 0 3.863806-1.7313 3.863806-3.866667v-11.6c-.012558-12.80785-10.384461-23.187433-23.182833-23.2z" id="i"/><path d="M23.182833 49.881833c-8.53563 0-15.455222 6.924716-15.455222 15.466666s6.919592 15.466667 15.455222 15.466667c8.535629 0 15.455221-6.924717 15.455221-15.466667s-6.919592-15.466667-15.455221-15.466667zm0 23.2c-4.268057 0-7.727611-3.462117-7.727611-7.733334s3.459554-7.733333 7.72761-7.733333c4.268057 0 7.727611 3.462117 7.727611 7.733333 0 4.271217-3.459554 7.733334-7.72761 7.733334z" id="j"/><path d="M23.182833 84.681832C10.379147 84.681832 0 95.068667 0 107.881833v11.6c0 2.135366 1.730019 3.866666 3.863805 3.866666 2.133787 0 3.863806-1.7313 3.863806-3.866666v-11.6c0-8.54195 6.919592-15.466667 15.455222-15.466667 8.535629 0 15.455221 6.924717 15.455221 15.466667v11.6c0 2.135366 1.73002 3.866666 3.863806 3.866666 2.133786 0 3.863805-1.7313 3.863805-3.866666v-11.6c0-12.813167-10.379147-23.2-23.182832-23.2z" id="k"/><path d="M221.225751 0H58.945923c-2.133787 0-3.863806 1.7313-3.863806 3.866667v69.6c0 2.135366 1.73002 3.866666 3.863806 3.866666H221.22575c2.133787 0 3.863806-1.7313 3.863806-3.866666v-69.6C225.089557 1.7313 223.359538 0 221.225751 0zm-3.863805 69.6H62.809728V7.733333h154.552218V69.6zM179 52.7c7.566301 0 13.7-6.133699 13.7-13.7 0-7.566301-6.133699-13.7-13.7-13.7-7.566301 0-13.7 6.133699-13.7 13.7 0 7.566301 6.133699 13.7 13.7 13.7zm0 8.6c-12.31595 0-22.3-9.98405-22.3-22.3s9.98405-22.3 22.3-22.3 22.3 9.98405 22.3 22.3-9.98405 22.3-22.3 22.3z" id="l"/><path d="M88.128755 19.333333h-7.72761c-2.133787 0-3.863806 1.7313-3.863806 3.866667s1.730019 3.866667 3.863805 3.866667h7.727611c2.133787 0 3.863806-1.7313 3.863806-3.866667s-1.73002-3.866667-3.863806-3.866667z" id="m"/><path d="M149.052361 19.79147h-42.50186c-2.133787 0-3.863806 1.7313-3.863806 3.866666s1.730019 3.866667 3.863806 3.866667h42.50186c2.133786 0 3.863805-1.7313 3.863805-3.866667s-1.730019-3.866667-3.863805-3.866667z" id="n"/><path d="M122.903004 34.8h-42.50186c-2.133786 0-3.863805 1.7313-3.863805 3.866667 0 2.135366 1.730019 3.866666 3.863805 3.866666h42.50186c2.133787 0 3.863806-1.7313 3.863806-3.866666 0-2.135367-1.730019-3.866667-3.863806-3.866667z" id="o"/><path d="M99.720172 50.266667H80.401144c-2.133786 0-3.863805 1.7313-3.863805 3.866666C76.53734 56.2687 78.267358 58 80.401144 58h19.319028c2.133786 0 3.863805-1.7313 3.863805-3.866667 0-2.135366-1.730019-3.866666-3.863805-3.866666z" id="p"/><path d="M142.222031 50.266667h-30.910443c-2.133787 0-3.863805 1.7313-3.863805 3.866666 0 2.135367 1.730018 3.866667 3.863805 3.866667h30.910443c2.133787 0 3.863806-1.7313 3.863806-3.866667 0-2.135366-1.730019-3.866666-3.863806-3.866666z" id="q"/></defs><g fill-rule="evenodd" fill="none" opacity=".330729"><g><use fill="#FFF" xlink:href="#a"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#a"/></g><g><use fill="#FFF" xlink:href="#c"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#c"/></g><g><use fill="#FFF" xlink:href="#d"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#d"/></g><g><use fill="#FFF" xlink:href="#e"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#e"/></g><g><use fill="#FFF" xlink:href="#f"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#f"/></g><g><use fill="#FFF" xlink:href="#g"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#g"/></g><g><use fill="#FFF" xlink:href="#h"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#h"/></g><g><use fill="#FFF" xlink:href="#i"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#i"/></g><g><use fill="#FFF" xlink:href="#j"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#j"/></g><g><use fill="#FFF" xlink:href="#k"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#k"/></g><g><use fill="#FFF" xlink:href="#l"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#l"/></g><g><use fill="#FFF" xlink:href="#m"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#m"/></g><g><use fill="#FFF" xlink:href="#n"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#n"/></g><g><use fill="#FFF" xlink:href="#o"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#o"/></g><g><use fill="#FFF" xlink:href="#p"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#p"/></g><g><use fill="#FFF" xlink:href="#q"/><use fill="url(#b)" style="mix-blend-mode:multiply" xlink:href="#q"/></g></g></svg>';var get='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 84"><path d="M60.1 41l-.6-.3c-.2-.1-.3-.2-.5-.3-.1-.1-.3-.1-.4-.1-.1 0-.2 0-.3.1-.1.1-.2.1-.3.2l-.7 1.1c.2.2.4.4.7.6.3.2.5.3.8.5s.6.2.9.3c.3.1.6.2 1 .2l-.2 1.7h.9c.2 0 .3-.1.4-.2.1-.1.2-.3.2-.4l.1-1.2c.7 0 1.2-.2 1.7-.4s.9-.5 1.3-.9.6-.8.8-1.3c.2-.5.3-1 .3-1.5 0-.4 0-.7-.1-1-.1-.3-.2-.5-.4-.7l-.6-.6c-.2-.2-.5-.3-.7-.4-.3-.1-.5-.2-.8-.3-.3-.1-.5-.2-.8-.3l.3-3.3c.2.1.4.1.6.2s.3.1.5.2c.1.1.3.1.4.2s.2.1.3.1c.1 0 .2 0 .3-.1l.3-.3.5-.8c-.3-.3-.7-.6-1.1-.8-.4-.2-1-.4-1.6-.5l.2-1.7h-.9c-.2 0-.3.1-.4.2s-.2.2-.2.4l-.1 1c-.6 0-1.2.2-1.7.4s-.9.5-1.3.8c-.3.3-.6.7-.8 1.1-.2.4-.3.9-.3 1.3s0 .8.1 1.1c.1.3.2.6.4.8s.3.4.6.6c.2.2.4.3.7.4s.5.2.8.3c.3.1.5.2.8.3l-.3 3.6c-.3-.1-.6-.2-.8-.3zm2.5-2.9c.2.1.4.1.5.2.2.1.3.2.4.3s.2.2.3.4c.1.1.1.3.1.5 0 .5-.1.9-.4 1.2-.3.3-.7.5-1.2.6l.3-3.2zm-1.7-2.9c-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.3-.4s-.2-.3-.2-.5 0-.3.1-.5.2-.3.3-.4.3-.2.5-.3.5-.2.7-.2l-.3 2.9c-.1-.1-.3-.2-.4-.3z"/><path d="M100.1 54.3c-1.5-2.1-4.3-2.1-4.6-2.1h-.1l-2.8.2V4.6c0-2.1-1.7-3.8-3.8-3.8h-9.1c-2.1 0-3.8 1.7-3.8 3.8v27.9c-1-3.9-3.4-7.2-6.7-9.3v-11c0-2.1-1.7-3.8-3.8-3.8h-9.1c-2.1 0-3.8 1.7-3.8 3.8v11.3c-4.1 2.8-6.7 7.4-6.7 12.7 0 4.9 2.3 9.2 5.8 12l-5.8-.7v-22c0-2.1-1.7-3.8-3.8-3.8h-9.1c-2.1 0-3.8 1.7-3.8 3.8v21.3l-4.6.7v-1.7c0-2.5-2-4.5-4.5-4.5H5.1c-2.5 0-4.5 2-4.5 4.5V72c0 2.5 2 4.5 4.5 4.5H20c2.5 0 4.5-2 4.5-4.5v-1.1L47.7 82c2.4 1.4 4.8 1.9 6.8 1.9 4.1 0 7-1.8 7.2-1.9l38.2-21.9c.3-.2.6-.5.7-.8.6-2 .5-3.7-.5-5zM78.9 4.6c0-.4.3-.8.8-.8h9.1c.4 0 .8.3.8.8v48l-3.1.3-7.5.6V4.6zm-23.4 7.6c0-.4.3-.8.8-.8h9.1c.4 0 .8.3.8.8v9.6c-.8-.3-1.5-.5-2.3-.6-1-.2-2-.3-2.8-.3-1.5 0-3.4.3-5.5 1v-9.7zm-6.7 24c0-6.8 5.5-12.3 12.3-12.3.7 0 1.3.1 2 .2.9.2 1.9.5 3 .9 4.3 1.9 7.3 6.2 7.3 11.2 0 6.8-5.5 12.3-12.3 12.3s-12.3-5.6-12.3-12.3zm27.1 3.6v11.4c-.1 0-.2-.1-.3-.1l-8.2-1c4.2-1.9 7.4-5.7 8.5-10.3zm-43.8 6.4V25.5c0-.4.3-.8.8-.8H42c.4 0 .8.3.8.8V47l-8.4-1H34l-1 .1-.9.1zM21.4 72c0 .8-.7 1.5-1.5 1.5H5.1c-.8 0-1.5-.7-1.5-1.5V45.7c0-.8.7-1.5 1.5-1.5H20c.8 0 1.5.7 1.5 1.5V72zm76.5-14.2L60.2 79.5c-.1 0-5.4 3.3-11 0 0 0-.1 0-.1-.1L24.4 67.6V50.5l8.4-1.3.6-.1.8-.1 9.9 1.2 30.8 3.9c.2.1.7.4.9 1.1v.2c0 .1 0 .2.1.3 0 .3 0 .6-.1 1v.1c0 .1-2.3 9-36.6 3.9-.8-.1-1.6.4-1.7 1.3-.1.8.4 1.6 1.3 1.7 7.6 1.1 13.7 1.6 18.7 1.6 10.5 0 15.8-2 18.5-4.1 2.2-1.7 2.7-3.3 2.7-3.9.1-.3.1-.5.1-.7l7.8-.7 4.6-.4h.2l4.2-.4c.4 0 1.6.2 2.2.9.2.5.2 1.1.1 1.8z"/></svg>';var download='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 96"><path d="M56.5 59.5H19c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h37.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM56.5 77.5H19c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h37.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"/><path d="M73.8 95.2H2c-.8 0-1.5-.7-1.5-1.5V2C.5 1.2 1.2.5 2 .5h51.5c.4 0 .8.2 1.1.4l20.3 20.5c.3.3.4.7.4 1.1v71.2c0 .8-.6 1.5-1.5 1.5zm-70.3-3h68.8V23.1L52.9 3.5H3.5v88.7z"/><path d="M74.3 24H54c-.8 0-1.5-.7-1.5-1.5V2c0-.6.4-1.2.9-1.4.6-.2 1.2-.1 1.6.3l20.3 20.5c.4.4.6 1.1.3 1.6-.1.6-.7 1-1.3 1zm-18.8-3h15.2L55.5 5.6V21zM28.9 41.3c-6.3 0-11.4-5.1-11.4-11.4 0-6.3 5.1-11.4 11.4-11.4 6.3 0 11.4 5.1 11.4 11.4-.1 6.3-5.2 11.4-11.4 11.4zm0-19.8c-4.6 0-8.4 3.8-8.4 8.4 0 4.6 3.8 8.4 8.4 8.4 4.6 0 8.4-3.8 8.4-8.4-.1-4.6-3.8-8.4-8.4-8.4z"/></svg>';var ask='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109 86"><path d="M51.4 58.9c-.2-.3-.4-.5-.7-.7l-.2-3.6c2.2-2.6 3.6-5.9 3.6-9.5v-2.9c.6-1.2 1.1-2.3 1.5-3.5 2.5-7.2 2.3-13.4-.5-17.5-1.8-2.6-4.5-4.2-7.7-4.5-2.8-4-7.4-6.2-12.6-6-5 .2-9.8 2.4-13.1 6-3.2 3.5-4.8 8-4.5 13.1.2 4.6 1.3 9.1 3.1 12.8 0 .1.1.2.2.3V45c0 3.8 1.5 7.2 3.8 9.8l-.1 3.4c-.2.2-.5.4-.7.7C12.3 60.9 3.1 70.7.4 83.4c-.2.8.3 1.6 1.2 1.8.8.2 1.6-.3 1.8-1.2 2.3-10.7 9.5-19 18.5-21.7-2.4 8 1 20.7 1.1 20.8.3 1.1.6 2 1.7 2.1h.1c.6 0 1.1-.3 1.3-.8 0-.1.1-.2.1-.2 2.4-7.7 10.2-8.8 11.3-9 1 .1 8.9 1.2 11.3 9 0 .1.1.2.1.2.3.5.8.8 1.3.8h.1c1.1-.1 1.3-1 1.6-2.1 0-.2 3.5-12.9 1.1-20.7 8.9 2.7 16.2 11 18.4 21.7.2.7.8 1.2 1.5 1.2h.3c.8-.2 1.3-1 1.2-1.8-2.5-12.8-11.8-22.6-23-24.6zM21.2 35.7c-.5-2-.8-4.1-.9-6.2-.2-4.2 1.1-8 3.8-10.9 2.7-3 6.7-4.8 11-5h.6c4.3 0 7.7 1.8 9.8 5.2.2.3.6.6 1 .7h.4c2.5.1 4.6 1.3 5.9 3.3 2 2.9 2.3 7.4.7 12.8-.1-.5-.3-1-.5-1.5-1.4-3.9-3.9-7-7-8.4 0 0-.1 0-.1-.1h-.1-.1c-.1 0-.1 0-.2-.1H45.2 44.9h-.1-.1s-.1 0-.1.1c-.1 0-.1.1-.2.1 0 0-.1 0-.1.1-.1 0-.1.1-.2.1l-.1.1c-.1.1-.2.3-.3.4 0 .1-.1.1-.1.2l-.3.6c-2.2 3.3-9 3.5-13.5 3.7h-2.2c-.6 0-1.1.1-1.7.2h-.1c-2.5.3-3.9 2.4-4.6 4.6zm2.3 9.3v-3.7c-.1-1.2.1-4.9 1.8-6.6.4-.4.8-.6 1.3-.8.6-.1 1.4-.1 2.2-.2 4.8.1 13.3.1 16.9-4.8 1.3 1 3.2 2.8 4.4 6 .7 1.9 1 4.1 1 6.3V45c0 3.6-1.6 6.8-4.2 8.9l-.1.1c-.2.2-.5.4-.8.6-.2.1-.4.3-.7.4-.1 0-.1.1-.2.1-1.7.9-3.6 1.4-5.6 1.4H35c-3.1 0-6-1.2-8.2-3.4-.1-.1-.1-.1-.2-.1-1.8-2.1-3.1-4.9-3.1-8zm1.6 34.4c-.9-4.5-1.9-11.9-.4-16.3v.1c.1.2.1.4.2.7 0 0 0 .1.1.1.1.2.2.4.2.6 0 .1.1.1.1.2l.3.6v.1c.1.2.3.5.4.7 0 .1.1.1.1.2.1.2.3.4.4.6 0 .1.1.1.1.2.4.5.8 1.1 1.3 1.6l.2.2c.2.2.4.4.6.7l.2.2c.3.3.6.5.9.8l.1.1c.3.2.5.5.8.7.1.1.2.1.3.2.3.2.6.5.9.7.1 0 .1.1.2.1.3.2.7.4 1 .7-2.3.9-5.7 2.7-8 6.2zm2.1-20.2v-.1V57.4c2.3 1.5 5 2.3 7.8 2.3h4.5c2.2 0 4.3-.5 6.2-1.4.1-.1.2-.1.3-.2l.6-.3c.3-.2.7-.4 1-.6l.1 1.8v.2c0 .3 1 7.1-10.3 12.9-11.1-5.8-10.2-12.6-10.2-12.9zm22.7 20.2c-2.3-3.5-5.6-5.3-8.3-6.2 5.5-3.5 7.8-7.3 8.7-10.1 1.5 4.4.5 11.8-.4 16.3zM75.1 12.8c-2.3 0-4.1 1.9-4.1 4.1s1.9 4.1 4.1 4.1c2.3 0 4.1-1.9 4.1-4.1s-1.8-4.1-4.1-4.1zm0 5.2c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1zM85.9 12.8c-2.3 0-4.1 1.9-4.1 4.1s1.9 4.1 4.1 4.1c2.3 0 4.1-1.9 4.1-4.1s-1.9-4.1-4.1-4.1zm0 5.2c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1zM96.6 12.8c-2.3 0-4.1 1.9-4.1 4.1s1.9 4.1 4.1 4.1c2.3 0 4.1-1.9 4.1-4.1s-1.8-4.1-4.1-4.1zm0 5.2c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1z"/><path d="M105.3.7H65.6c-1.8 0-3.2 1.4-3.2 3.2v40.3c0 .6.4 1.2 1 1.4.2.1.3.1.5.1.4 0 .9-.2 1.2-.5l10.2-12.5h30c1.8 0 3.2-1.4 3.2-3.2V4c.1-1.8-1.4-3.3-3.2-3.3zm.3 28.8c0 .1-.1.2-.2.2H74.6c-.4 0-.9.2-1.2.5l-8 9.8V4c0-.1.1-.2.2-.2h39.7c.1 0 .2.1.2.2v25.5z"/></svg>';var act='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88"><path d="M64 39.1c-.4-.3-.8-.3-1.3-.2l-10.1 3.8v-9.2h10.6c.5 0 1-.3 1.2-.7.2-.4.2-1-.1-1.4L58 22.2v-6.6c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v7.1c0 .3.1.5.2.8l5 7.4h-8V24c0-5.2-4.2-9.4-9.4-9.4h-.5c-.3-2.5-1.6-4.8-3.5-6.3l3.4-5c.4-.6.3-1.5-.4-1.9-.6-.4-1.5-.3-1.9.4l-3.4 5.1c-1.2-.5-2.6-.8-4-.8s-2.8.3-4 .8l-3.4-5.1c-.4-.6-1.3-.8-1.9-.4-.6.4-.8 1.3-.4 1.9l3.4 5c-.2.2-.5.4-.7.6-1.6 1.6-2.5 3.5-2.8 5.7h-.5c-5.2 0-9.4 4.2-9.4 9.4v6.9H5l5-7.4c.2-.2.2-.5.2-.8v-7.1c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v6.6l-6.3 9.2c-.3.4-.3 1-.1 1.4.2.4.7.7 1.2.7H13v9.2L2.9 38.9c-.4-.2-.9-.1-1.3.2-.4.3-.6.7-.6 1.1V46c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4v-3.9l9.2 3.5v5.9H2.4c-.4 0-.8.2-1.1.5-.3.3-.4.8-.2 1.2l6.5 25.4v6.9c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-7.1-.3L4.3 54.2h8.8v3.2c0 7.2 3.4 13.6 9.7 18.8 4.7 3.8 9.4 5.5 9.6 5.6.1.1.3.1.5.1s.3 0 .5-.1 4.9-1.8 9.6-5.6c6.4-5.1 9.7-11.6 9.7-18.8v-3.2h8.8l-6.1 23.9V85.5c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-6.9l6.5-25.4c.1-.4 0-.8-.2-1.2-.3-.3-.7-.5-1.1-.5H52.8v-5.9l9.2-3.5V46c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-5.8c-.2-.4-.4-.9-.8-1.1zM15.7 23.9c0-3.7 3-6.7 6.7-6.7H26c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4h-.3c.3-1.4 1-2.7 2-3.7 1.4-1.4 3.2-2.1 5.1-2.1 3.5 0 6.5 2.5 7.1 5.9h-8.4c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h11.7c3.7 0 6.7 3 6.7 6.7v8.3c0 3.7-3 6.7-6.7 6.7h-4.9c-2.2 0-4.2 1-5.5 2.6-1.3-1.6-3.3-2.6-5.5-2.6h-4.9c-3.7 0-6.7-3-6.7-6.7v-8.4zm34.2 33.7c0 6.4-2.9 11.9-8.7 16.6-3.6 2.9-7.2 4.5-8.4 5-1.3-.5-4.9-2.1-8.4-5-5.7-4.6-8.7-10.2-8.7-16.6V38.8c1.7 1.7 4.1 2.8 6.7 2.8h4.9c1.8 0 3.5 1.1 4.1 2.8v30.3c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4V44.4c.7-1.7 2.3-2.8 4.1-2.8h4.9c2.6 0 5-1.1 6.7-2.8v18.8zM87 44c0-.8-.6-1.4-1.4-1.4h-4.8V20.2l2.3-3.2c.2-.2.3-.5.3-.8V2.4c0-.8-.6-1.4-1.4-1.4h-9.8c-.8 0-1.4.6-1.4 1.4v13.8c0 .3.1.6.3.8l2.3 3.2v22.4h-4.8c-.8 0-1.4.6-1.4 1.4 0 .7.5 1.2 1.1 1.4v32.9c0 2.3.9 4.5 2.6 6.2 1.7 1.7 3.9 2.6 6.2 2.6 2.3 0 4.5-.9 6.2-2.6 1.7-1.7 2.6-3.9 2.6-6.2V45.4c.6-.2 1.1-.7 1.1-1.4zM75.9 19l-2.3-3.2v-12h7v12L78.3 19c-.2.2-.3.5-.3.8v22.9h-2V19.8c.1-.3 0-.6-.1-.8zm1.2 29.1c-.8 0-1.4.6-1.4 1.4v28.8c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4V49.5c0-.8-.6-1.4-1.4-1.4zm4.3 34.4c-1.1 1.1-2.6 1.8-4.2 1.8s-3.1-.6-4.2-1.8c-1.1-1.1-1.8-2.6-1.8-4.2V45.4h12v32.9c-.1 1.6-.7 3.1-1.8 4.2z"/></svg>';/* harmony default export */ __webpack_exports__["a"] = ({navPrev:navPrev,navNext:navNext,arrowLeft:arrowLeft,arrowRight:arrowRight,arrowRightBlue:arrowRightBlue,icon01:icon01,icon02:icon02,icon03:icon03,icon04:icon04,icon05:icon05,icon06:icon06,magnifierGradient:magnifierGradient,magnifier:magnifier,web:web,server:server,important:important,network:network,database:database,nonTech:nonTech,presentation:presentation,get:get,download:download,ask:ask,act:act});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */var check='<svg width="22" height="17" xmlns="http://www.w3.org/2000/svg"><g fill="#09F" fill-rule="evenodd"><path d="M2.172 7.757l7.07 7.071-1.414 1.415-7.07-7.071z"/><path d="M7.075 14.01L20.51.575l1.415 1.415L8.49 15.425z"/></g></svg>';var improve11='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M127.187316 34C130.943888 34 134 37.057434 134 40.81563v4.264474C134 46.140271 133.140642 47 132.080934 47s-1.919066-.85973-1.919066-1.919896v-4.264473c0-1.640935-1.334326-2.975839-2.974552-2.975839h-29.26825c-1.059708 0-1.919066-.85973-1.919066-1.919896C96 34.859729 96.859358 34 97.919066 34h29.26825zm-34.773516.586c.3722.372.5862.888.5862 1.414 0 .526-.214 1.042-.5862 1.4138C92.042 37.786 91.526 38 91 38c-.526 0-1.042-.214-1.414-.5862C89.2138 37.042 89 36.526 89 36c0-.526.214-1.0418.586-1.414.372-.3722.888-.586 1.414-.586.526 0 1.042.2138 1.4138.586zM83.044332 34C84.124251 34 85 34.86736 85 35.936937c0 1.069576-.875748 1.936937-1.955669 1.936937H53.222928c-1.67151 0-3.031286 1.346752-3.031286 3.002252V62.93474c3.04263.84741 5.280305 3.618004 5.280305 6.898594C55.471947 73.785073 52.22593 77 48.235974 77 44.246019 77 41 73.785072 41 69.833333c0-3.28059 2.237676-6.051184 5.280305-6.898594V40.876126C46.280305 37.084572 49.394707 34 53.222928 34h29.821403zM52 70.5c0-1.929941-1.570059-3.5-3.5-3.5S45 68.570059 45 70.5s1.570059 3.5 3.5 3.5 3.5-1.570059 3.5-3.5zM132.828866 53C136.783068 53 140 56.209558 140 60.154696c0 3.27511-2.217625 6.041078-5.23299 6.887072v29.369834c0 3.785221-3.086495 6.864641-6.880412 6.864641h-28.2v15.856354h6.570503c1.070243 0 1.938144.865911 1.938144 1.933701S107.327344 123 106.257101 123H74.509522c-1.070244 0-1.938145-.865912-1.938145-1.933702s.867901-1.933701 1.938145-1.933701h6.57089v-15.856354h-28.2c-3.793917 0-6.880412-3.07942-6.880412-6.86464V84.906076c0-1.06779.867901-1.933701 1.938144-1.933701 1.070244 0 1.938145.865911 1.938145 1.933701v1.805498h81.014433V67.041768c-3.015365-.845995-5.23299-3.611961-5.23299-6.887072 0-3.945138 3.216932-7.154696 7.171134-7.154696zM96 119v-16H85v16h11zm-5.004191-26C92.097894 93 93 93.8956 93 95s-.88534 2-1.987426 2h-.016765C89.893723 97 89 96.1044 89 95s.893723-2 1.995809-2zM131 95.94501V90H50v5.94501C50 97.62959 51.347352 99 53.003588 99h74.992823C129.652648 99 131 97.62959 131 95.94501zM133.5 64c1.929941 0 3.5-1.570059 3.5-3.5s-1.570059-3.5-3.5-3.5-3.5 1.570059-3.5 3.5 1.570059 3.5 3.5 3.5zm-21.063651 14.695119c.751535.756142.751535 1.981922 0 2.73787-.375863.377879-.868354.567011-1.360844.567011-.492491 0-.984982-.189132-1.360845-.56701L98.42702 70.079042c-2.530582 1.95482-5.69357 3.120395-9.12349 3.120395-5.382563 0-10.383297-2.925068-13.050714-7.63344-.526363-.929013-.204194-2.111236.719202-2.640497.923395-.52868 2.099099-.205781 2.625077.723426 1.984397 3.502725 5.703577 5.67862 9.706435 5.67862 6.154882 0 11.162352-5.036886 11.162352-11.227924 0-6.191039-5.00747-11.227924-11.162352-11.227924-3.867755 0-7.405836 1.9705-9.463943 5.271123-.56466.905397-1.751912 1.179513-2.653175.610954-.900302-.567978-1.172432-1.762784-.607579-2.668568C79.34575 45.648822 84.102643 43 89.30353 43c8.27746 0 15.011438 6.773536 15.011438 15.099622 0 3.483173-1.181669 6.691842-3.15856 9.249292l11.279941 11.346205zM76.009746 56C77.125753 56.005337 78 56.884013 78 58.000099c0 .012453-.0002.025303-.0004.037756C77.978204 59.14386 77.102956 60 76.001348 60c-.009998 0-.019997 0-.030195-.000198-1.116006-.015814-1.981655-.902594-1.971057-2.018878C74.011094 56.868396 74.888342 56 75.999548 56h.010199z" fill="#000" fill-rule="nonzero"/></svg>';var improve12='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M40.5 47.9c-1.3 0-2.4.6-3 1.7-.7 1.2-.7 2.7 0 3.9.6 1.1 1.7 1.7 3 1.7 2 0 3.5-1.6 3.5-3.6 0-2.1-1.5-3.7-3.5-3.7zm0 4.3c-.2 0-.3-.1-.4-.2-.1-.2-.1-.6 0-.9.1-.1.2-.2.4-.2.3 0 .5.2.5.6 0 .5-.2.7-.5.7zM57 47.9c-2 0-3.5 1.6-3.5 3.6 0 2.1 1.5 3.6 3.5 3.6 1.3 0 2.4-.6 3-1.7.7-1.2.7-2.7 0-3.9-.6-1-1.7-1.6-3-1.6zm.4 4.1c-.1.1-.2.2-.4.2-.3 0-.5-.2-.5-.6 0-.4.2-.6.5-.6.2 0 .3.1.4.2.1.1.1.5 0 .8z"/><path d="M77.5 71.2v-6.1c0-3.8-2.3-6.4-5.5-6.4-.9 0-1.7.2-2.4.5-.1-5.8-3.6-11.3-9.1-14.6l.7-1.1c.1-.1.2-.2.3-.4 1-1.3 2.4-3.1 1.2-4.7-.4-.6-1.1-.9-1.8-.8-1.4.1-2.3 1.5-3.1 3-.1.1-.1.2-.2.3-.2.3-.4.6-.5.9-.2.4-.4.7-.6 1-.5-.2-1.1-.4-1.7-.5-1.6-.4-3.2-.6-4.8-.7-3-.1-6 .3-8.8 1.2 0-.1-.1-.1-.1-.2l-.8-1.2c-.2-.3-.3-.6-.5-.9-.4-.7-.9-1.6-1.5-2.2-1-1-2.1-.9-2.8-.3-.9.7-1.1 2-.6 3.1.3.6.6 1 1 1.5.1.2.3.4.4.6l.9 1.4c-5.6 3.3-9.2 8.9-9.2 14.8v.1c-.8-.5-1.8-.8-2.9-.8-1.6 0-2.8.5-3.8 1.5-2 2-1.9 5.5-1.8 8.1V81.9c0 3.1 1.4 5.4 3.9 6.2.5.2 1.1.3 1.6.3 1 0 2-.3 2.9-.9V91c0 2.5 1.1 4.5 3.1 5.6 1.3.7 2.8.8 4.2.8v7.6c0 .7 0 1.5.2 2.3.6 2.2 2.4 3.8 4.7 4.2 2.3.3 4.4-.7 5.6-2.7 1-1.7.9-3.9.8-5.6v-4.4-.8-.7h4.2v7.7c0 .7 0 1.5.2 2.3.6 2.2 2.4 3.8 4.7 4.2.3 0 .5.1.8.1 2 0 3.8-1 4.8-2.7s.9-3.9.8-5.6v-4.4-.8-.6c1 0 2.1 0 3.2-.3 2.4-.8 4-3.1 4.1-5.8V88c.3.1.5.2.8.3.5.2 1.1.3 1.6.3 1.1 0 2.1-.3 3-1 1.5-1.1 2.5-2.9 2.5-4.9.1-2.5 0-5.1 0-7.5.3-1.5.3-2.8.3-4zM39.9 46.5L41 46c.2 0 .3-.1.5-.1l.2-.1c2.5-.9 5.3-1.3 8.1-1.2 1.4.1 2.9.3 4.2.6.6.2 1.2.3 1.8.6l.2.1c.1.1.3.1.5.1l1.1.5c4.9 2.4 8.3 6.7 8.9 11.3H31.1c.6-4.6 3.9-9 8.8-11.3zM27.6 82.3c0 1-.5 2-1.2 2.5-.4.3-1.1.6-2 .3-1.5-.5-1.8-2.1-1.8-3.3V69.5v-1.4c-.1-2-.1-4.8.9-5.9.2-.2.7-.6 1.6-.6 2.5 0 2.5 3.1 2.5 3.4v17.3zM66.5 91c0 1.4-.8 2.6-2 3-.7.2-1.8.2-2.7.2h-3.1l.5 1.9c.1.3 0 1 0 1.5 0 .4-.1.7-.1 1v4.6c.1 1.4.1 3.1-.4 4s-1.5 1.4-2.6 1.2c-.9-.1-1.9-.7-2.2-1.9-.1-.4-.1-1-.1-1.5v-4.1-1.5c-.1-1.2-.1-2.4.1-3.3l.5-1.9H43.1l.5 1.9c.1.3 0 1 0 1.5 0 .4-.1.7-.1 1.1v4.6c.1 1.4.1 3.1-.4 4s-1.5 1.4-2.6 1.2c-.9-.1-1.9-.7-2.2-1.9-.1-.4-.1-1-.1-1.5V101v-1.5c-.1-1.2-.1-2.4.2-3.3l.5-1.9h-3.1c-1.2 0-2.5.1-3.4-.4-1.3-.7-1.5-2-1.5-3V78.8 61.7h35.6v2.2c-.2 1.5-.2 3-.1 4.4V81.9c0 .5 0 1 .1 1.4V91zm8-8.7c0 1-.5 2-1.2 2.5-.4.3-1.1.6-2 .3-1.1-.3-1.5-1.2-1.7-2.1V64c.1-.8.4-1.4.8-1.9.2-.2.7-.6 1.6-.6 2.5 0 2.5 3.1 2.5 3.4v9.8c0 2.7.1 5.2 0 7.6zM140.8 39.9l-.1-2.3-2.2.6c-9 2.4-13.7 8.4-14 17.8l-.1 2.1 2.1-.2c9.3-.7 14.8-7.6 14.3-18zm-3.7 2.7c-.4 6.1-3.4 10.1-8.7 11.3.7-5.6 3.5-9.3 8.7-11.3z"/><path d="M155.8 92.1c-.2-1.1-1.2-1.6-1.8-1.9l-.1-.1c-1-.6-2-1.3-2.9-2.1-1.8-1.7-3.1-3.9-3.8-6.2-.4-1.2-.5-2.5-.5-3.9 0-4.7 2.5-9.2 6.4-11.7L155 65l-1.6-1.7c-1.7-1.8-4-4-6.8-5.3-2.7-1.3-5.9-1.7-9.2-1.3-1.9.2-3.5.8-5.1 1.4-1.4.5-2.8 1-4.1 1.2-2.4.3-5-.4-7.6-1.1l-.9-.2c-3-.8-6.3-1.5-9.7-.5-2.9.8-5.6 2.7-7.8 5.3-4.8 5.8-5.4 13.1-5.1 18.2.4 6.4 2.2 12.8 5.2 18.7 2.2 4.3 5.9 10.3 11.9 11.9.7.2 1.5.3 2.2.3 2 0 3.9-.7 5.6-1.4.4-.2.9-.3 1.3-.5 2.5-.9 5-.9 7.8-.1.6.2 1.1.4 1.7.6 2.2.7 4.4 1.5 6.9 1.3 2.6-.2 5.1-1.3 7.2-3.4 3.7-3.5 5.8-8.5 7.6-12.8l.8-1.8c.3-.3.6-.9.5-1.7zm-4.6 2.1c-1.8 4.2-3.6 8.6-6.7 11.5-1.1 1-2.8 2.2-4.9 2.3-1.8.1-3.6-.5-5.5-1.1l-1.8-.6c-3.6-1.1-6.9-1-10.2.1-.5.2-.9.4-1.4.5-2 .8-3.7 1.4-5.4 1-4.6-1.2-7.7-6.3-9.6-10-2.8-5.4-4.4-11.4-4.8-17.2-.3-4.4.3-10.7 4.3-15.6 1.7-2 3.7-3.4 5.9-4 .8-.2 1.7-.3 2.5-.3 1.6 0 3.3.3 5.2.9l.8.2c2.8.8 5.9 1.6 9.1 1.2 1.7-.2 3.3-.8 4.9-1.4 1.5-.5 2.9-1 4.3-1.2 2.6-.3 5.1 0 7.2 1 1.6.7 3 1.8 4.2 3-3.9 3.3-6.3 8.3-6.3 13.5 0 1.7.2 3.3.7 4.9.9 3 2.5 5.7 4.8 7.9 1 .9 2 1.7 3.2 2.4l-.5 1z"/></svg>';var improve13='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M118.9 41H55.1c-2.4 0-4.3 2-4.3 4.4v12.7c0 2.4 1.9 4.4 4.3 4.4H119c2.4 0 4.3-2 4.3-4.4V45.4c-.1-2.4-2-4.4-4.4-4.4zm-64.6 4.4c0-.5.3-.8.8-.8H119c.4 0 .8.4.8.8v12.7c0 .5-.3.8-.8.8H55.1c-.4 0-.8-.4-.8-.8V45.4zM118.9 88.7H55.1c-2.4 0-4.3 2-4.3 4.4v12.7c0 2.4 1.9 4.4 4.3 4.4H119c2.4 0 4.3-2 4.3-4.4V93.1c-.1-2.5-2-4.4-4.4-4.4zm-64.6 4.4c0-.5.3-.8.8-.8H119c.4 0 .8.4.8.8v12.7c0 .5-.3.8-.8.8H55.1c-.4 0-.8-.4-.8-.8V93.1zM118.9 64.9H55.1c-2.4 0-4.3 2-4.3 4.4V82c0 2.4 1.9 4.4 4.3 4.4H119c2.4 0 4.3-2 4.3-4.4V69.2c-.1-2.4-2-4.3-4.4-4.3zm-64.6 4.3c0-.5.3-.8.8-.8H119c.4 0 .8.4.8.8v12.7c0 .5-.3.8-.8.8H55.1c-.4 0-.8-.4-.8-.8V69.2z"/><path d="M96 101.4h18c1 0 1.9-.8 1.9-1.9s-.8-1.9-1.9-1.9H96c-1 0-1.9.8-1.9 1.9s.9 1.9 1.9 1.9zM96 78.4h18c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9H96c-1 0-1.9.8-1.9 1.9 0 1 .9 1.9 1.9 1.9zM96 54.4h18c1 0 1.9-.8 1.9-1.9s-.8-1.9-1.9-1.9H96c-1 0-1.9.8-1.9 1.9s.9 1.9 1.9 1.9z"/></svg>';var improve14='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M103.9 49.7c-5.6-5-12.8-7.3-20.3-6.5C71.8 44.5 62.2 54 60.7 65.7c-1.1 8.2 1.7 16.2 7.5 22 2.3 2.3 3.6 5.1 3.8 8.2-1.7.8-2.8 2.5-2.8 4.5 0 1.4.6 2.7 1.5 3.6-.9.9-1.5 2.2-1.5 3.6s.6 2.7 1.5 3.6c-.9.9-1.5 2.2-1.5 3.6 0 2.8 2.3 5.1 5.1 5.1h24.6c2.8 0 5.1-2.3 5.1-5.1 0-1.4-.6-2.7-1.5-3.6.9-.9 1.5-2.2 1.5-3.6s-.6-2.7-1.5-3.6c.9-.9 1.5-2.2 1.5-3.6 0-2-1.2-3.7-2.8-4.5.2-3 1.5-5.9 3.7-8 5-5 7.8-11.6 7.8-18.6-.2-7.5-3.3-14.6-8.8-19.6zm-5.1 67.4H74.2c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h24.6c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2zm0-7.3H74.2c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h24.6c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2zm0-7.2H74.2c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h24.6c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2zm3.9-16.8c-2.6 2.5-4.2 6-4.6 9.6H74.9c-.3-3.6-2-7-4.7-9.7-5.2-5.1-7.6-12.3-6.6-19.6 1.3-10.4 9.9-18.8 20.3-20 6.7-.7 13.1 1.3 18.1 5.8 4.9 4.4 7.7 10.7 7.7 17.3-.1 6.3-2.5 12.2-7 16.6zm19.9-16.4c-.5-15.9-11.4-29.3-26-33.6h21.7v2.9h8.7V30h-8.7v2.9H54.7V30H46v8.7h8.7v-2.9h21.7c-14.7 4.3-25.5 17.6-26 33.6-2.5.6-4.4 2.9-4.4 5.6 0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-2.7-1.8-4.9-4.3-5.6.7-17.8 15.3-32.2 33.2-32.2s32.6 14.3 33.2 32.2c-2.5.7-4.3 2.9-4.3 5.6 0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-2.7-1.9-5-4.4-5.6zm-1.4-36.5h2.9v2.9h-2.9v-2.9zm-69.4 2.9h-2.9v-2.9h2.9v2.9zM54.7 75c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9c1.6 0 2.9 1.3 2.9 2.9zm66.5 2.9c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9zm-26-13.1c2.4 0 4.3-2 4.3-4.4 0-2.4-1.9-4.4-4.3-4.4s-4.3 2-4.3 4.4v1.5h-8.7v-1.5c0-2.4-1.9-4.4-4.3-4.4s-4.3 2-4.3 4.4c0 2.4 1.9 4.4 4.3 4.4h1.4v8.7h-1.4c-2.4 0-4.3 2-4.3 4.4s1.9 4.4 4.3 4.4 4.3-2 4.3-4.4v-1.5h8.7v1.5c0 2.4 1.9 4.4 4.3 4.4s4.3-2 4.3-4.4-1.9-4.4-4.3-4.4h-1.4v-8.7h1.4zm-1.5-4.3c0-.8.6-1.5 1.4-1.5.8 0 1.4.7 1.4 1.5s-.6 1.5-1.4 1.5h-1.4v-1.5zM79.3 77.9c0 .8-.6 1.5-1.4 1.5-.8 0-1.4-.7-1.4-1.5s.6-1.5 1.4-1.5h1.4v1.5zm0-16h-1.4c-.8 0-1.4-.7-1.4-1.5s.6-1.5 1.4-1.5c.8 0 1.4.7 1.4 1.5v1.5zm11.5 11.6h-8.7v-8.7h8.7v8.7zm4.4 3c.8 0 1.4.7 1.4 1.5s-.6 1.5-1.4 1.5c-.8 0-1.4-.7-1.4-1.5v-1.5h1.4z"/></svg>';var improve15='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M121.6 96.7c3 0 5.4 2.4 5.4 5.4 0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-.9.2-1.8.6-2.5l-4.7-4.7c-.3-.3-.5-.7-.5-1.1v-8.9H102v16.8l4.2 4.2c.8-.4 1.6-.6 2.5-.6 3 0 5.4 2.4 5.4 5.4 0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-.9.2-1.8.6-2.5l-4.7-4.7c-.3-.3-.5-.7-.5-1.1V84.9H88.1V97c2.2.7 3.8 2.7 3.8 5.1 0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-2.4 1.6-4.5 3.8-5.1V84.9H74.2v17.4c0 .4-.2.8-.5 1.1l-4.7 4.7c.4.8.6 1.6.6 2.5 0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-3 2.4-5.4 5.4-5.4.9 0 1.8.2 2.5.6l4.2-4.2V84.9h-9.7v8.9c0 .4-.2.8-.5 1.1L56 99.6c.4.8.6 1.6.6 2.5 0 3-2.4 5.4-5.4 5.4S46 105 46 102.1c0-3 2.4-5.4 5.4-5.4.9 0 1.8.2 2.5.6l4.2-4.2v-8.6C51.2 83.1 46 76.9 46 69.6c0-8.3 6.6-15 14.8-15.2 1.4-5.2 4.4-10 8.6-13.5C74 37.1 79.9 35 85.9 35c5.4 0 10.6 1.6 15 4.8 4 2.8 7 6.6 8.9 11.1 6.3 0 11.4 5.1 11.4 11.4 0 .4 0 .8-.1 1.2 3.7 2 5.9 5.8 5.9 10 0 6.3-5.1 11.4-11.4 11.4h-.7v8.2l4.2 4.2c.8-.4 1.6-.6 2.5-.6zm-70.2 7.6c1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2c0 1.2 1 2.2 2.2 2.2zm12.9 8.5c1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2-.1 1.2.9 2.2 2.2 2.2zm44.4-4.4c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2 0-1.2-.9-2.2-2.2-2.2zm-20-6.3c0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2c1.2 0 2.2-1 2.2-2.2zm13.9-49.3c.3.8-.1 1.7-.9 2.1-.2.1-.4.1-.6.1-.6 0-1.2-.4-1.5-1-2.2-5.5-7.1-9.1-13-9.6-.9-.1-1.5-.8-1.4-1.7.1-.9.8-1.5 1.7-1.4 3.4.3 6.6 1.5 9.4 3.5 2.8 2 5 4.8 6.3 8zm-22-9.5c.3.8-.1 1.7-.9 2-.2.1-.4.1-.6.1-.6 0-1.2-.4-1.5-1-.3-.8.1-1.7.9-2.1h.1c.8-.2 1.7.2 2 1zm7 17.2c.3.3.5.7.5 1.1s-.2.8-.5 1.1c-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.5-.3-.3-.5-.7-.5-1.1s.2-.8.5-1.1c.3-.3.7-.5 1.1-.5.4 0 .8.2 1.1.5zm25.7 13.4c.9 0 1.6.7 1.6 1.6v6.2h.7c4.5 0 8.2-3.7 8.2-8.2 0-3.4-2-6.3-5.1-7.6-.7-.3-1.1-1.1-.9-1.8.1-.6.2-1.2.2-1.8 0-4.5-3.7-8.2-8.2-8.2h-.9c-.7.1-1.4-.3-1.7-1-3.3-8.9-11.8-14.9-21.3-14.9-10.2 0-19.1 6.8-21.9 16.4 2.7.5 5.3 1.7 7.4 3.6.7.6.7 1.6.1 2.2-.3.4-.7.5-1.2.5-.4 0-.7-.1-1.1-.4-2-1.8-4.6-2.9-7.3-3h-.7c-6.7 0-12.1 5.4-12.1 12.1 0 5.6 3.8 10.3 8.9 11.7v-5.8c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6v6.2H71V71.5c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6v10.2h10.7V67.6c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6v14.1h10.8V71.5c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6v10.2h9.7v-6.2c-.1-.9.6-1.6 1.5-1.6zm8.3 30.4c1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2z"/></svg>';var improve16='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M77 108.3c-3-.2-5.6 2.3-5.6 5.3 0 2.8 2.1 5.1 4.9 5.3 2.9.1 5.5-2 5.6-4.9.3-2.9-2-5.5-4.9-5.7zM97.6 48.9c-2.1-7.5-9.3-11.9-16.7-12.6-7.9-.7-15.4 2.3-21 7.8.4.7.8 1.3 1.2 2 .6 1 1.4 1.3 2.3.5 1.4-1 2.6-2.2 4.1-3.1 3-1.8 6.4-2.8 10-2.9 7.6-.1 15.2 4.4 15.5 12.6.1 3.7-.9 7.1-3.1 10.1-2.3 3.2-5.6 5.4-8.7 7.8-2.7 2.1-6.2 4.6-6.6 8.3-.1 1.3 0 2.7.1 4.1.1 1.9.1 3.9.2 5.8 0 .3-.1.7.1.9.2.1.9 0 1.2 0h1.5c.6 0 .8.2.9-.3.2-.6.1-1.5.2-2.1.1-2 .3-3.9.4-5.9 0-.5.1-1 .1-1.5.3-1.8 1.4-3.1 2.6-4.2 2.8-2.6 6.1-4.5 9-7.1 5.7-5.2 8.7-12.7 6.7-20.2z"/></svg>';var improve21='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M119.7 61.4c4.6 0 8.3 3.7 8.3 8.3v23.7c0 5.2-1.3 10.3-3.7 14.9L118 120c-.3.6-1 1-1.6 1-.3 0-.6-.1-.8-.2-.9-.5-1.2-1.6-.8-2.4l6.3-11.7c2.2-4.1 3.3-8.6 3.3-13.2V69.7c0-2.6-2.1-4.7-4.7-4.7s-4.7 2.1-4.7 4.7v15.1c0 .6-.3 1.1-.8 1.5l-1.7 1.1c-6.5 4.5-10.4 11.9-10.4 19.7v12.1c0 1-.8 1.8-1.8 1.8h-35c-5 0-9.1-4-9.1-9v-6.9l-6.7-2c-2.7-.8-4.5-3.3-4.5-6.1 0-1.9.8-3.6 2.2-4.8-1.4-1.2-2.2-2.9-2.2-4.8s.8-3.6 2.2-4.8c-1.4-1.2-2.2-2.9-2.2-4.8s.8-3.6 2.2-4.8c-1.4-1.2-2.2-2.9-2.2-4.8 0-2 1-3.9 2.6-5.1 1.7-1.2 3.7-1.6 5.7-1l2.9.9V38c0-5 4.1-9 9.1-9h42c5 0 9.1 4 9.1 9v24.1c1-.4 2.1-.7 3.3-.7zm-69.9 4.5c-.7.5-1.1 1.3-1.1 2.2 0 1.2.8 2.3 2 2.7l5.7 1.7 2.7.8c.9.3 1.8.1 2.5-.4s1.1-1.3 1.1-2.2c0-1.2-.8-2.3-2-2.7l-8.4-2.6c-.3-.1-.6-.1-.8-.1-.7.1-1.2.3-1.7.6zm0 9.6c-.7.5-1.1 1.3-1.1 2.2 0 1.2.8 2.3 2 2.7l5.7 1.7 2.6.9c.9.3 1.8.1 2.5-.4s1.1-1.3 1.1-2.2c0-1.2-.8-2.3-2-2.7l-2.6-.9-5.7-1.7c-.3-.1-.6-.1-.9-.1-.6 0-1.1.2-1.6.5zm12.9 14.4c0-1.2-.8-2.3-2-2.7l-2.7-.8-5.7-1.7c-.3-.1-.6-.1-.8-.1-.6 0-1.2.2-1.7.5-.7.5-1.1 1.3-1.1 2.2 0 1.2.8 2.3 2 2.7l5.7 1.7 2.7.8c.9.3 1.8.1 2.5-.4.6-.5 1.1-1.3 1.1-2.2zM59 102.2c.9.3 1.8.1 2.5-.4s1.1-1.3 1.1-2.2c0-1.2-.8-2.3-2-2.7L58 96l-5.7-1.7c-.3-.1-.6-.1-.8-.1-.6 0-1.2.2-1.7.5-.7.5-1.1 1.3-1.1 2.2 0 1.2.8 2.3 2 2.7l8.3 2.6zm39.5 15.2v-6.1H59.9v.7c0 3 2.4 5.4 5.4 5.4h33.2zM66 39.2c.3.3.5.8.5 1.3s-.2.9-.5 1.3c-.3.3-.8.5-1.3.5s-.9-.2-1.3-.5c-.3-.3-.5-.8-.5-1.3s.2-.9.5-1.3.8-.5 1.3-.5 1 .2 1.3.5zm21.6 62.5c.3.3.5.8.5 1.3s-.2.9-.5 1.3c-.3.3-.8.5-1.3.5s-.9-.2-1.3-.5c-.3-.3-.5-.8-.5-1.3s.2-.9.5-1.3c.3-.3.8-.5 1.3-.5s1 .2 1.3.5zm19-43c2.4 2.3 2.4 6.1 0 8.5-.7.7-1.5 1.2-2.4 1.5v5.8c0 .7-.4 1.3-1 1.6l-15.1 7.7v12.1c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8v-5.2L72.4 78.6c-.3-.3-.5-.8-.5-1.3v-4.4c-2.4-.8-4.2-3-4.2-5.7 0-3.3 2.7-6 6.1-6 3.3 0 6.1 2.7 6.1 6 0 2.7-1.8 5-4.3 5.7v3.6l9.1 8.9V60.6c-2.9-.8-5.1-3.4-5.1-6.6 0-3.8 3.1-6.8 6.9-6.8 3.8 0 6.9 3.1 6.9 6.8 0 3.1-2.2 5.8-5.1 6.6v19l12.4-6.3v-4.6c-.9-.3-1.8-.8-2.5-1.5-2.4-2.3-2.4-6.1 0-8.5 2.2-2.4 6.1-2.4 8.4 0zM73.7 69.6c1.3 0 2.4-1.1 2.4-2.4 0-1.3-1.1-2.4-2.4-2.4-1.3 0-2.4 1.1-2.4 2.4-.1 1.3 1 2.4 2.4 2.4zm12.6-12.3c1.8 0 3.3-1.5 3.3-3.2s-1.5-3.2-3.3-3.2-3.3 1.5-3.3 3.2 1.5 3.2 3.3 3.2zm17.8 7.3c.9-.9.9-2.5 0-3.4-.9-.9-2.5-.9-3.4 0-.9.9-.9 2.5 0 3.4.9 1 2.4 1 3.4 0zm7.2 5.1c0-1.7.5-3.4 1.5-4.7V42.3H71.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h41.6V38c0-3-2.4-5.4-5.4-5.4h-42c-3 0-5.4 2.4-5.4 5.4v26.1l1.9.6c2.7.8 4.5 3.3 4.5 6.1 0 1.9-.8 3.6-2.2 4.8 1.4 1.2 2.2 2.9 2.2 4.8s-.8 3.6-2.2 4.8c1.4 1.2 2.2 2.9 2.2 4.8s-.8 3.6-2.2 4.8c1.4 1.2 2.2 2.9 2.2 4.8 0 2-1 3.9-2.6 5.1-1.1.8-2.5 1.3-3.8 1.3v1.8h38.6v-.6c0-9.1 4.5-17.5 12-22.7l.9-.6V69.7z"/></svg>';var improve22='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M84 74l9.6-25.9h-3.9L80 74zM95.6 70.1l17.3-7.6v-2.2l-17.3-8.6v3.4l13 6.1-13 5.4zM78 51.7l-17.3 8.6v2.2L78 70.1v-3.5l-13-5.4 13-6.1zM94.9 40.8h28.5c1.6 0 2.9 1.3 2.9 3v4.3c0 1.1.8 1.9 1.9 1.9 1 0 1.9-.9 1.9-1.9v-4.3c0-3.8-3-6.8-6.6-6.8H94.9c-1 0-1.9.9-1.9 1.9 0 1.1.8 1.9 1.9 1.9zM87 98c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/><path d="M128.1 55c-3.8 0-6.9 3.2-6.9 7.1 0 3.2 2.1 6 5.1 6.8v19.4H47.8v-1.8c0-1.1-.8-1.9-1.9-1.9s-1.9.8-1.9 1.9v11.3c0 3.7 3 6.8 6.7 6.8H78v15.6h-6.4c-1 0-1.9.9-1.9 1.9s.8 1.9 1.9 1.9h30.7c1 0 1.9-.9 1.9-1.9s-.8-1.9-1.9-1.9H96v-15.6h27.3c3.7 0 6.7-3 6.7-6.8v-29c2.9-.8 5.1-3.6 5.1-6.8-.1-3.8-3.2-7-7-7zM93 121H82v-16h11v16zm33-23.1c0 1.7-1.3 3.1-2.9 3.1H50.9c-1.6 0-2.9-1.4-2.9-3.1V92h78v5.9zm2-32.9c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zM87 41c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4s-.2-1-.6-1.4c-.4-.4-.9-.6-1.4-.6s-1 .2-1.4.6-.6.9-.6 1.4.2 1 .6 1.4c.4.4.9.6 1.4.6zM52.8 72c0-3.2-2.1-5.9-5-6.7V43.7c0-1.6 1.3-2.9 2.9-2.9h28.5c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9H50.7C47 37 44 40 44 43.7v21.5c-2.9.8-5 3.5-5 6.7 0 3.9 3.1 7 6.9 7s6.9-3 6.9-6.9zM43 72c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3z"/></svg>';var improve23='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M39.8 54.7c-.3.5-.7 1-1.1 1.6-.4.6-.8 1.2-1.3 1.8-.2.4-.5.7-.7 1.1-.4.5-.7 1-.9 1.4-.3.4-.5.8-.8 1.1l-1.2 1.8h4l5.1-7.5 5 7.6H52l-7-10.3 7.2-10.5h-4l-5.1 7.6-4.9-7.6H34L41 53l-.5.8c-.3.3-.5.6-.7.9zM66.1 69.7H21.8c-1.8 0-3.3 1.6-3.3 3.4v8.8c0 1.9 1.4 3.4 3.3 3.4h44.3c1.9 0 3.3-1.5 3.3-3.4v-8.8c0-1.9-1.4-3.4-3.3-3.4zm.2 12.2c0 .2-.1.3-.2.3H21.8c-.1 0-.2-.1-.2-.3v-8.8c0-.1.1-.2.2-.2h.5v-.1h43.8c.1 0 .2.1.2.3v8.8zM66.1 102.8H21.8c-1.8 0-3.3 1.6-3.3 3.4v8.7c0 1.9 1.4 3.4 3.3 3.4h44.3c1.8 0 3.3-1.5 3.3-3.3v-8.8c0-2-1.4-3.4-3.3-3.4zm.2 12.2c0 .2-.1.3-.2.3H21.8c-.1 0-.2-.1-.2-.3v-8.8c0-.2.1-.3.2-.3h44.3c.1 0 .2.1.2.3v8.8zM66.1 86.3H21.8c-1.8 0-3.3 1.6-3.3 3.4v8.7c0 1.9 1.4 3.4 3.3 3.4h44.3c1.8 0 3.3-1.5 3.3-3.3v-8.8c0-1.9-1.4-3.4-3.3-3.4zm.2 12.2c0 .2-.1.3-.2.3H21.8c-.1 0-.2-.1-.2-.3v-8.8c0-.2.1-.3.2-.3h44.3c.1 0 .2.1.2.3v8.8zM109.9 73.1v8.8c0 1.8 1.3 3.1 3 3.1h44.3c1.7 0 3.1-1.4 3.1-3.1v-8.8c0-1.8-1.3-3.1-3.1-3.1h-44.3c-1.6-.1-3 1.4-3 3.1zm3.3-.6h44c.3 0 .5.3.5.5v8.8c0 .3-.2.5-.5.5h-44.3c-.3 0-.5-.3-.5-.5V73c0-.3.2-.4.5-.4h.2v-.1zM157.2 102.8h-44.3c-1.8 0-3.3 1.6-3.3 3.4v8.7c0 1.9 1.4 3.4 3.3 3.4h44.3c1.8 0 3.3-1.5 3.3-3.3v-8.8c0-2-1.4-3.4-3.3-3.4zm.2 12.2c0 .2-.1.3-.2.3h-44.3c-.1 0-.2-.1-.2-.3v-8.8c0-.2.1-.3.2-.3h44.3c.1 0 .2.1.2.3v8.8zM157.2 86.3h-44.3c-1.8 0-3.3 1.6-3.3 3.4v8.7c0 1.9 1.4 3.4 3.3 3.4h44.3c1.8 0 3.3-1.5 3.3-3.3v-8.8c0-1.9-1.4-3.4-3.3-3.4zm.2 12.2c0 .2-.1.3-.2.3h-44.3c-.1 0-.2-.1-.2-.3v-8.8c0-.2.1-.3.2-.3h44.3c.1 0 .2.1.2.3v8.8zM114.1 64.1c.3.4.6.8 1 1.2.3.4.7.6 1.2.6.3 0 .6-.1.9-.3.7-.5.8-1.4.3-2.1-.3-.4-.7-.9-1-1.3-.5-.7-1.5-.8-2.1-.3s-.8 1.5-.3 2.2zM59.8 63.5c.3.2.6.3.9.3.5 0 .9-.2 1.2-.6.7-1 1.4-1.9 2.2-2.8.5-.6.4-1.6-.2-2.1-.6-.5-1.6-.4-2.1.2-.8.9-1.6 1.9-2.3 3-.5.6-.3 1.5.3 2zM88.1 45.4h-1c-1 0-1.9.1-2.8.2-.8.1-1.4.8-1.3 1.6.1.8.7 1.3 1.5 1.3h.2c.8-.1 1.7-.1 2.6-.2h.9c.9 0 1.5-.6 1.5-1.5-.1-.7-.7-1.4-1.6-1.4zM108.9 54c-1-.8-2-1.6-2.9-2.4-.7-.5-1.6-.3-2.1.3-.5.7-.3 1.6.3 2.1.9.7 1.8 1.4 2.7 2.2.3.2.6.4 1 .4s.8-.2 1.1-.5c.5-.6.5-1.5-.1-2.1zM102.7 49.6c-1.1-.7-2.3-1.2-3.4-1.7-.8-.3-1.6 0-2 .8-.3.8 0 1.6.8 2 1 .5 2.1 1 3.1 1.6.2.1.5.2.8.2.5 0 1-.3 1.3-.7.4-.9.1-1.8-.6-2.2zM113 61.8c.3 0 .7-.1 1-.4.6-.5.7-1.5.1-2.1-.8-1-1.7-1.9-2.5-2.7-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1.8.8 1.6 1.7 2.4 2.6.3.3.7.5 1.1.5zM95.7 46.5c-1.2-.4-2.5-.6-3.8-.8-.8-.1-1.6.4-1.7 1.3-.1.8.4 1.6 1.3 1.7 1.1.2 2.3.4 3.4.7.1 0 .3.1.4.1.6 0 1.2-.4 1.4-1.1.3-.8-.2-1.6-1-1.9zM73.4 48.8c-1.1.6-2.2 1.2-3.3 2-.7.5-.9 1.4-.4 2.1.3.4.8.7 1.2.7.3 0 .6-.1.8-.3 1-.7 2-1.2 3-1.8.7-.4 1-1.3.6-2s-1.2-1-1.9-.7zM80.6 46.2c-1.2.3-2.5.7-3.7 1.1-.8.3-1.2 1.1-.9 1.9.2.6.8 1 1.4 1 .2 0 .3 0 .5-.1 1.1-.4 2.2-.7 3.3-1 .8-.2 1.3-1 1.1-1.8-.1-.8-.9-1.3-1.7-1.1zM67.1 53.1c-.9.8-1.9 1.7-2.8 2.6-.6.6-.6 1.5 0 2.1.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.8-.8 1.7-1.7 2.6-2.4.6-.5.7-1.5.2-2.1-.6-.7-1.6-.7-2.2-.2zM130.9 64.6c.3.3.8.4 1.2.4h.2c.5-.1 1-.3 1.3-.7l14.9-19c.7-.8.6-1.9-.3-2.6-.8-.7-1.9-.6-2.6.3l-13.9 17.4-7.4-6.3c-.7-.6-2-.4-2.6.3-.5.7-.6 1.9.3 2.6l8.9 7.6z"/></svg>';var improve31='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M97.6 61.2c.4.4.6.9.6 1.4s-.2 1-.6 1.4c-.4.4-.9.6-1.4.6s-1-.2-1.4-.6c-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4c.4-.4.9-.6 1.4-.6s1 .3 1.4.6zm-1.4-17.7c4.2 0 7.6 3.4 7.6 7.6s-3.4 7.6-7.6 7.6-7.6-3.4-7.6-7.6 3.4-7.6 7.6-7.6zm0 11.2c2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6-3.6 1.6-3.6 3.6c0 1.9 1.6 3.6 3.6 3.6zm28.2 6.3c2.6 2.6 2.6 6.8 0 9.4-1.3 1.3-3 2-4.7 2s-3.4-.7-4.7-2c-.2-.2-.3-.4-.5-.5l-8.7 4.4v22.6c0 1.1-.9 2-2 2s-2-.9-2-2V73c0-.8.4-1.4 1.1-1.8l10.2-5.1c-.1-1.8.5-3.7 1.9-5.1 2.6-2.6 6.8-2.6 9.4 0zm-2.8 6.6c1-1 1-2.7 0-3.8-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-1.1 1-1.1 2.7 0 3.8 1 1 2.7 1 3.8 0zm15.2-25.1c.7.3 1.2 1 1.2 1.8v30c-.2 9.2-.8 17.6-6.1 25.9-5.9 9.2-17 17.4-34.9 25.6-.3.1-.6.2-.8.2s-.6-.1-.8-.2c-15.5-7.2-26.1-14.4-32.4-22.2-.7-.9-.6-2.1.3-2.8s2.1-.6 2.8.3c4.4 5.5 11.2 10.7 20.6 15.9v-13.3l-5.1-3.3c-1.2 1-2.7 1.5-4.2 1.5-1.7 0-3.4-.7-4.7-2-2.6-2.6-2.6-6.8 0-9.4s6.8-2.6 9.4 0c1.8 1.8 2.3 4.3 1.7 6.5l6 3.9c.6.4.9 1 .9 1.7v16.5l3.6 1.8V69.5c0-1.1.9-2 2-2s2 .9 2 2v51.4c15.5-7.5 25.2-14.7 30.4-22.8 4.8-7.4 5.3-14.8 5.5-23.8V45.6l-38-17.4-37.9 17.4v4.9c1-.2 1.9-.3 2.9-.3 8.6 0 15.8 6.5 17 14.8.3 0 .7-.1 1-.1 5.4 0 9.8 4.4 9.8 9.8s-4.4 9.8-9.8 9.8H45.8c-.4 0-.8 0-1.1-.1v14.8c1 .3 1.9.9 2.7 1.7 2.6 2.6 2.6 6.8 0 9.4-1.3 1.3-3 2-4.7 2s-3.4-.7-4.7-2c-2.6-2.6-2.6-6.8 0-9.4.8-.8 1.7-1.3 2.7-1.6V83c-2.8-1.7-4.6-4.8-4.6-8.3 0-4.9 3.6-8.9 8.2-9.6.5-3.8 2.3-7.3 5-10 1.5-1.5 3.2-2.6 5.1-3.4v-7.4c0-.8.5-1.5 1.2-1.8l39.8-18.3c.5-.2 1.1-.2 1.7 0l39.7 18.3zm-92.3 65c1-1 1-2.7 0-3.8-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-1 1-1 2.7 0 3.8 1.1 1 2.8 1 3.8 0zm16.7-53.3c-7.4-.1-12.3 6.5-13 11.1 1.7.4 3.2 1.3 4.4 2.5.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6-1-1-2.3-1.6-3.6-1.7h-.1H45.8c-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8h33.5c3.2 0 5.8-2.6 5.8-5.8s-2.6-5.8-5.8-5.8c-.7 0-1.5.1-2.1.4h-.1c-.1 0 0 0 0 0-.7.3-1.3.7-1.9 1.3-.6.6-1.1 1.4-1.4 2.2s-1.1 1.3-1.9 1.3c-.2 0-.4 0-.7-.1-1-.4-1.6-1.5-1.2-2.5.5-1.4 1.3-2.6 2.3-3.7.6-.6 1.3-1.1 2-1.5-.5-6.8-6.2-12.1-13.1-12.1zm18 42.9c1-1 1-2.7 0-3.8-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-1 1-1 2.7 0 3.8 1.1 1.1 2.8 1.1 3.8 0zm-21.5-8.4c.4.4.6.9.6 1.4 0 .5-.2 1-.6 1.4-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4 0-.5.2-1.1.6-1.4.4-.4.9-.6 1.4-.6.5 0 1 .2 1.4.6zm3.3 25.8c2.6 2.6 2.6 6.8 0 9.4-1.3 1.3-3 2-4.7 2s-3.4-.7-4.7-2c-2.6-2.6-2.6-6.8 0-9.4.8-.8 1.7-1.3 2.7-1.6V98c0-1.1.9-2 2-2s2 .9 2 2v14.9c1 .3 1.9.8 2.7 1.6zm-2.8 6.6c1-1.1 1-2.7 0-3.8-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-1 1-1 2.7 0 3.8 1.1 1 2.8 1 3.8 0z"/></svg>';var improve32pl='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M89.5,66a1.38,1.38,0,0,0-.6-1.1,2.65,2.65,0,0,0-2.8,0,1.31,1.31,0,0,0,0,2.2,2.65,2.65,0,0,0,2.8,0A1.38,1.38,0,0,0,89.5,66Z"/><path d="M127.8,93a1.52,1.52,0,0,0,1.7-1.4,1.58,1.58,0,0,0-1.7-1.4H110.9V79.7a16.2,16.2,0,0,0,2.2.1,17.83,17.83,0,0,0,11.6-4.1,13.48,13.48,0,0,0,4.2-13.9,1.38,1.38,0,0,0-1.2-1.1c-5.9-1.3-11.9.1-15.9,3.6A13.4,13.4,0,0,0,107.6,78V89.9H88.7v-11c4.7-2.8,7.5-7.2,7.5-11.9,0-5-3.1-9.6-8.3-12.4a1.72,1.72,0,0,0-1.7,0C81,57.4,77.9,62.1,77.9,67c0,4.7,2.8,9.1,7.5,11.9v11h-19v-12a13.4,13.4,0,0,0-4.2-13.7c-4-3.5-9.9-4.8-15.9-3.6a1.51,1.51,0,0,0-1.2,1.1,13.48,13.48,0,0,0,4.2,13.9,17.31,17.31,0,0,0,11.6,4.1,17,17,0,0,0,2.2-.1V90.1H46.2a1.52,1.52,0,0,0-1.7,1.4,1.58,1.58,0,0,0,1.7,1.4H63.1v2.5l-9.3,8.1a6.39,6.39,0,0,0-6.5.9,4.33,4.33,0,0,0,0,6.8,6.13,6.13,0,0,0,7.8,0,4.25,4.25,0,0,0,1-5.6l7-6.1v14.8a5.1,5.1,0,0,0-2.3,1.2,4.33,4.33,0,0,0,0,6.8,6.13,6.13,0,0,0,7.8,0,4.33,4.33,0,0,0,0-6.8,5.67,5.67,0,0,0-2.3-1.2V93h19v4.7l-10.5,7a1.08,1.08,0,0,0-.7,1.1v7.7a1.73,1.73,0,0,0,3.4,0v-7l7.8-5.2v16.4a5.71,5.71,0,0,0-4.7,5.3c0,3,2.8,5.5,6.3,5.5s6.3-2.5,6.3-5.5a5.61,5.61,0,0,0-4.6-5.3V97.8l8.9,7.9v3.5a1.58,1.58,0,0,0,1.7,1.4,1.52,1.52,0,0,0,1.7-1.4v-4.1a1.39,1.39,0,0,0-.5-1L88.7,93.6v-.7h19v21.3a5.1,5.1,0,0,0-2.3,1.2,4.41,4.41,0,0,0,0,6.8,6.13,6.13,0,0,0,7.8,0,4.33,4.33,0,0,0,0-6.8,5.67,5.67,0,0,0-2.3-1.2V99.5l7,6.1a4.25,4.25,0,0,0,1,5.6,6.13,6.13,0,0,0,7.8,0,4.41,4.41,0,0,0,0-6.8,6.17,6.17,0,0,0-6.5-.9l-9.3-8.1V93Zm-74,15.9a3,3,0,0,1-3.6,0,1.68,1.68,0,0,1,0-2.8,3,3,0,0,1,1.8-.6,2.79,2.79,0,0,1,1.8.6A1.68,1.68,0,0,1,53.8,108.9Zm1.4-37.7,6,5.4A13.85,13.85,0,0,1,52,73.5a10.33,10.33,0,0,1-3.3-9.8c4.3-.6,8.5.4,11.3,2.9a10.26,10.26,0,0,1,3.5,8l-6.1-5.3a1.8,1.8,0,0,0-2.2,0A1.23,1.23,0,0,0,55.2,71.2Zm11.6,45.9a1.68,1.68,0,0,1,0,2.8,3,3,0,0,1-3.6,0,1.68,1.68,0,0,1,0-2.8,3,3,0,0,1,3.6,0Zm23.7,6.4a3,3,0,1,1-3-3A2.95,2.95,0,0,1,90.5,123.5Zm-3-54.7a1.58,1.58,0,0,0-1.7,1.4v4.3a10.14,10.14,0,0,1-4.3-7.9c0-3.5,2.2-6.9,6-9.1,3.8,2.2,6,5.6,6,9.1a10.29,10.29,0,0,1-4.3,7.9V70.2A1.58,1.58,0,0,0,87.5,68.8Zm33.7,37.3a2.52,2.52,0,0,1,1.7-.6,2.79,2.79,0,0,1,1.8.6,2.1,2.1,0,0,1,.7,1.4,1.75,1.75,0,0,1-.7,1.4,2.85,2.85,0,0,1-3.5,0A1.68,1.68,0,0,1,121.2,106.1Zm-10.4,13.8a3,3,0,0,1-3.6,0,2.1,2.1,0,0,1-.7-1.4,1.75,1.75,0,0,1,.7-1.4,3,3,0,0,1,1.8-.6,2.79,2.79,0,0,1,1.8.6A1.68,1.68,0,0,1,110.8,119.9Zm-.3-45.3a10.73,10.73,0,0,1,3.4-8.1,14.15,14.15,0,0,1,11.3-2.9,10.1,10.1,0,0,1-3.3,9.8,13.34,13.34,0,0,1-9.2,3.1l6.1-5.3a1.23,1.23,0,0,0,0-1.9,1.8,1.8,0,0,0-2.2,0Z"/><path d="M77.9,117.9a3.26,3.26,0,0,0-1.4-.4,2.3,2.3,0,0,0-1.4.4,1.31,1.31,0,0,0,0,2.2,3.26,3.26,0,0,0,1.4.4,2.3,2.3,0,0,0,1.4-.4,1.31,1.31,0,0,0,0-2.2Zm23-3a3.26,3.26,0,0,0-1.4-.4,2.3,2.3,0,0,0-1.4.4,1.31,1.31,0,0,0,0,2.2,3.26,3.26,0,0,0,1.4.4,2.3,2.3,0,0,0,1.4-.4,1.31,1.31,0,0,0,0-2.2Z"/><path d="M51.62,42.5a.66.66,0,0,1-.48-.2.64.64,0,0,1-.19-.47V23.6a.7.7,0,0,1,.18-.5.63.63,0,0,1,.49-.2h7.25a8.23,8.23,0,0,1,5.39,1.6A5.51,5.51,0,0,1,66.21,29a5.81,5.81,0,0,1-1,3.43,5.44,5.44,0,0,1-2.75,2l4.06,7.14a.71.71,0,0,1,.09.31.52.52,0,0,1-.19.42.58.58,0,0,1-.4.17H63.46a1.06,1.06,0,0,1-.7-.21,1.93,1.93,0,0,1-.45-.55l-3.58-6.63H54.89v6.72a.64.64,0,0,1-.19.47.69.69,0,0,1-.51.2Zm7.17-10.58a3.68,3.68,0,0,0,2.52-.75A2.72,2.72,0,0,0,62.15,29a2.81,2.81,0,0,0-.84-2.19A3.59,3.59,0,0,0,58.79,26h-3.9v5.88ZM77.38,42.78a8.56,8.56,0,0,1-6-1.93,7.74,7.74,0,0,1-2.24-5.74c0-.54,0-1.34,0-2.38s0-1.87,0-2.41a7.66,7.66,0,0,1,2.3-5.71,8.44,8.44,0,0,1,5.91-2,8.42,8.42,0,0,1,5.89,2,7.59,7.59,0,0,1,2.31,5.71c0,1.08.06,1.89.06,2.41s0,1.3-.06,2.38a7.63,7.63,0,0,1-2.25,5.74A8.56,8.56,0,0,1,77.38,42.78Zm0-3.25a4,4,0,0,0,3-1.12A5,5,0,0,0,81.52,35c0-1.12.06-1.88.06-2.27s0-1.19-.06-2.27A5,5,0,0,0,80.32,27a4.43,4.43,0,0,0-5.91,0,4.88,4.88,0,0,0-1.18,3.43c0,.54,0,1.3,0,2.27s0,1.71,0,2.27A4.93,4.93,0,0,0,74.4,38.4,4,4,0,0,0,77.38,39.53ZM90,42.5a.66.66,0,0,1-.48-.2.64.64,0,0,1-.19-.47V23.6a.7.7,0,0,1,.18-.5.63.63,0,0,1,.49-.2h6.83q8.27,0,8.43,7.62c0,1.08.06,1.81.06,2.18s0,1.07-.06,2.16c-.07,2.61-.78,4.54-2.11,5.78s-3.4,1.86-6.18,1.86Zm6.83-3.25a4.61,4.61,0,0,0,3.36-1,4.89,4.89,0,0,0,1.09-3.45q.06-1.68.06-2.1t-.06-2.07a4.72,4.72,0,0,0-1.14-3.37,4.76,4.76,0,0,0-3.45-1.08H93.23v13.1Zm19.74,3.53a8.53,8.53,0,0,1-6-1.93,7.67,7.67,0,0,1-2.24-5.74c0-.54,0-1.34,0-2.38s0-1.87,0-2.41a7.66,7.66,0,0,1,2.29-5.71,9.76,9.76,0,0,1,11.81,0,7.67,7.67,0,0,1,2.31,5.71c0,1.08,0,1.89,0,2.41s0,1.3,0,2.38a7.68,7.68,0,0,1-2.26,5.74A8.56,8.56,0,0,1,116.52,42.78Zm0-3.25a4,4,0,0,0,3-1.12A5,5,0,0,0,120.67,35c0-1.12,0-1.88,0-2.27s0-1.19,0-2.27A5,5,0,0,0,119.46,27a4,4,0,0,0-2.94-1.13,4,4,0,0,0-3,1.13,4.93,4.93,0,0,0-1.17,3.43c0,.54,0,1.3,0,2.27s0,1.71,0,2.27a4.93,4.93,0,0,0,1.16,3.43A4,4,0,0,0,116.52,39.53Z"/></svg>';var improve32en='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M89 69.5c0-.4-.2-.8-.6-1.1-.4-.2-.9-.4-1.4-.4s-1 .2-1.4.4c-.4.3-.6.7-.6 1.1s.2.8.6 1.1c.4.2.9.4 1.4.4s1-.2 1.4-.4c.4-.3.6-.7.6-1.1z"/><path d="M127.3 96.5c1 0 1.7-.6 1.7-1.4 0-.8-.8-1.4-1.7-1.4h-16.9V83.2c.7.1 1.5.1 2.2.1 4.4 0 8.6-1.5 11.6-4.1 4-3.5 5.6-8.7 4.2-13.9-.1-.6-.6-1-1.2-1.1-5.9-1.3-11.9.1-15.9 3.6s-5.5 8.6-4.2 13.7v11.9H88.2v-11c4.7-2.8 7.5-7.2 7.5-11.9 0-5-3.1-9.6-8.3-12.4-.5-.3-1.2-.3-1.7 0-5.2 2.8-8.3 7.5-8.3 12.4 0 4.7 2.8 9.1 7.5 11.9v11h-19v-12c1.3-5.1-.2-10.2-4.2-13.7s-9.9-4.8-15.9-3.6c-.6.1-1.1.6-1.2 1.1-1.4 5.2.2 10.4 4.2 13.9 3 2.7 7.2 4.1 11.6 4.1.7 0 1.4 0 2.2-.1v10.5H45.7c-1 0-1.7.6-1.7 1.4s.8 1.4 1.7 1.4h16.9v2.5l-9.3 8.1c-2.1-.9-4.7-.6-6.5.9-2.2 1.9-2.2 4.9 0 6.8 1.1.9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4c1.8-1.5 2.1-3.8 1-5.6l7-6.1v14.8c-.9.2-1.6.6-2.3 1.2-2.2 1.9-2.2 4.9 0 6.8 1.1.9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4c2.2-1.9 2.2-4.9 0-6.8-.7-.6-1.5-1-2.3-1.2V96.5h19v4.7l-10.5 7c-.5.2-.7.6-.7 1.1v7.7c0 .8.7 1.4 1.7 1.4s1.7-.6 1.7-1.4v-7l7.8-5.2v16.4c-2.7.6-4.7 2.8-4.7 5.3 0 3 2.8 5.5 6.3 5.5s6.3-2.5 6.3-5.5c0-2.5-1.9-4.7-4.6-5.3v-19.9l8.9 7.9v3.5c0 .8.8 1.4 1.7 1.4 1 0 1.7-.6 1.7-1.4v-4.1c0-.4-.2-.7-.5-1L88.2 97.1v-.7h19v21.3c-.9.2-1.6.6-2.3 1.2-1 .9-1.6 2.1-1.6 3.4s.6 2.5 1.6 3.4c1.1.9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4c2.2-1.9 2.2-4.9 0-6.8-.7-.6-1.5-1-2.3-1.2V103l7 6.1c-1.1 1.8-.8 4.1 1 5.6 1.1.9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4c1-.9 1.6-2.1 1.6-3.4s-.6-2.5-1.6-3.4c-1.8-1.6-4.4-1.8-6.5-.9l-9.3-8.1v-2.4h16.9zm-74 15.9c-1 .8-2.6.8-3.6 0s-1-2 0-2.8c.5-.4 1.2-.6 1.8-.6.7 0 1.3.2 1.8.6 1 .8 1 2 0 2.8zm1.4-37.7l6 5.4c-3.5 0-6.8-1-9.2-3.1-2.8-2.5-4-6.1-3.3-9.8 4.3-.6 8.5.4 11.3 2.9 2.3 2.1 3.6 4.9 3.5 8l-6.1-5.3c-.6-.5-1.6-.5-2.2 0-.6.5-.6 1.4 0 1.9zm11.6 45.9c1 .8 1 2 0 2.8-1 .8-2.6.8-3.6 0s-1-2 0-2.8c.5-.4 1.1-.6 1.8-.6s1.3.2 1.8.6zM90 127c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3zm-3-54.7c-.9 0-1.7.6-1.7 1.4V78c-2.7-2.1-4.3-4.9-4.3-7.9 0-3.5 2.2-6.9 6-9.1 3.8 2.2 6 5.6 6 9.1 0 2.9-1.6 5.8-4.3 7.9v-4.3c0-.8-.8-1.4-1.7-1.4zm33.7 37.3c.5-.4 1-.6 1.7-.6s1.3.2 1.8.6c.4.4.7.9.7 1.4s-.2 1-.7 1.4c-.9.8-2.5.8-3.5 0s-1-2 0-2.8zm-10.4 13.8c-1 .8-2.6.8-3.6 0-.4-.4-.7-.9-.7-1.4s.2-1 .7-1.4c.5-.4 1.2-.6 1.8-.6.7 0 1.3.2 1.8.6 1 .8 1 2 0 2.8zm-.3-45.3c-.1-3.1 1.2-6 3.4-8.1 2.9-2.5 7-3.5 11.3-2.9.8 3.7-.5 7.3-3.3 9.8-2.4 2.1-5.7 3.2-9.2 3.1l6.1-5.3c.6-.5.6-1.4 0-1.9s-1.6-.5-2.2 0l-6.1 5.3z"/><path d="M77.4 121.4c-.4-.2-.9-.4-1.4-.4s-1 .1-1.4.4c-.4.3-.6.7-.6 1.1s.2.8.6 1.1c.4.2.9.4 1.4.4s1-.1 1.4-.4c.4-.3.6-.7.6-1.1s-.2-.8-.6-1.1zM100.4 118.4c-.4-.2-.9-.4-1.4-.4s-1 .1-1.4.4c-.4.3-.6.7-.6 1.1s.2.8.6 1.1c.4.2.9.4 1.4.4s1-.1 1.4-.4c.4-.3.6-.7.6-1.1s-.2-.8-.6-1.1zM111.5 38.2h3.1l4.7 7.8h3.6l-5.5-8.6c2.5-1 3.8-2.8 3.8-5.2 0-1.9-.6-3.4-1.8-4.3-1.2-.9-3.1-1.4-5.6-1.4h-5.5V46h3.2v-7.8zm-.1-9h2.1c1.5 0 2.6.2 3.3.7s1.1 1.3 1.1 2.4c0 1.1-.4 2-1 2.5s-1.7.8-3.2.8H111.4v-6.4zM94.7 38.7h2c2.5 0 4.4-.5 5.7-1.6 1.3-1.1 2-2.7 2-4.7 0-1.9-.6-3.4-1.8-4.4-1.2-1-3.1-1.5-5.5-1.5h-5.6V46h3.2v-7.3zm-.1-9.6h2.2c1.4 0 2.5.2 3.2.8.7.5 1 1.4 1 2.5 0 1.2-.3 2.1-1.1 2.7-.8.6-2 .9-3.6.9h-1.7v-6.9zM84.6 43.5c1.8-1.7 2.7-4.2 2.7-7.4 0-3.1-1-5.4-2.7-7.1-1.7-1.7-4.1-2.5-7.2-2.5h-6v19.6h5.5c3.3 0 5.9-.9 7.7-2.6zm-10-14.3h2.8c4.3 0 6.5 2.3 6.5 7s-2.3 7.1-7 7.2h-2.3V29.2zM59.9 46.2c1.3 0 2.4 0 3.5-.2 1.1-.1 2.2-.4 3.4-.8v-9.8h-7.2v2.8h4v5c-1.2.3-2.3.4-3.3.4-2 0-3.6-.7-4.7-1.9s-1.6-3-1.6-5.4c0-2.3.6-4.1 1.8-5.4 1.2-1.3 2.8-2 4.9-2 1.5 0 3.1.4 4.7 1.1l1.3-2.7c-1.8-.8-3.8-1.2-5.8-1.2-3.2 0-5.7.9-7.5 2.7-1.8 1.8-2.7 4.3-2.7 7.4 0 3.2.8 5.7 2.4 7.4 1.6 1.7 3.8 2.6 6.8 2.6z"/></svg>';var improve32de='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M89,66a1.38,1.38,0,0,0-.6-1.1,2.65,2.65,0,0,0-2.8,0,1.31,1.31,0,0,0,0,2.2,2.65,2.65,0,0,0,2.8,0A1.38,1.38,0,0,0,89,66Z"/><path d="M127.3,93a1.52,1.52,0,0,0,1.7-1.4,1.58,1.58,0,0,0-1.7-1.4H110.4V79.7a16.2,16.2,0,0,0,2.2.1,17.83,17.83,0,0,0,11.6-4.1,13.48,13.48,0,0,0,4.2-13.9,1.38,1.38,0,0,0-1.2-1.1c-5.9-1.3-11.9.1-15.9,3.6A13.4,13.4,0,0,0,107.1,78V89.9H88.2v-11c4.7-2.8,7.5-7.2,7.5-11.9,0-5-3.1-9.6-8.3-12.4a1.72,1.72,0,0,0-1.7,0c-5.2,2.8-8.3,7.5-8.3,12.4,0,4.7,2.8,9.1,7.5,11.9v11h-19v-12a13.4,13.4,0,0,0-4.2-13.7c-4-3.5-9.9-4.8-15.9-3.6a1.51,1.51,0,0,0-1.2,1.1,13.48,13.48,0,0,0,4.2,13.9,17.31,17.31,0,0,0,11.6,4.1,17,17,0,0,0,2.2-.1V90.1H45.7A1.52,1.52,0,0,0,44,91.5a1.58,1.58,0,0,0,1.7,1.4H62.6v2.5l-9.3,8.1a6.39,6.39,0,0,0-6.5.9,4.33,4.33,0,0,0,0,6.8,6.13,6.13,0,0,0,7.8,0,4.25,4.25,0,0,0,1-5.6l7-6.1v14.8a5.1,5.1,0,0,0-2.3,1.2,4.33,4.33,0,0,0,0,6.8,6.13,6.13,0,0,0,7.8,0,4.33,4.33,0,0,0,0-6.8,5.67,5.67,0,0,0-2.3-1.2V93h19v4.7l-10.5,7a1.08,1.08,0,0,0-.7,1.1v7.7a1.73,1.73,0,0,0,3.4,0v-7l7.8-5.2v16.4a5.71,5.71,0,0,0-4.7,5.3c0,3,2.8,5.5,6.3,5.5s6.3-2.5,6.3-5.5a5.61,5.61,0,0,0-4.6-5.3V97.8l8.9,7.9v3.5a1.58,1.58,0,0,0,1.7,1.4,1.52,1.52,0,0,0,1.7-1.4v-4.1a1.39,1.39,0,0,0-.5-1L88.2,93.6v-.7h19v21.3a5.1,5.1,0,0,0-2.3,1.2,4.41,4.41,0,0,0,0,6.8,6.13,6.13,0,0,0,7.8,0,4.33,4.33,0,0,0,0-6.8,5.67,5.67,0,0,0-2.3-1.2V99.5l7,6.1a4.25,4.25,0,0,0,1,5.6,6.13,6.13,0,0,0,7.8,0,4.41,4.41,0,0,0,0-6.8,6.17,6.17,0,0,0-6.5-.9l-9.3-8.1V93Zm-74,15.9a3,3,0,0,1-3.6,0,1.68,1.68,0,0,1,0-2.8,3,3,0,0,1,1.8-.6,2.79,2.79,0,0,1,1.8.6A1.68,1.68,0,0,1,53.3,108.9Zm1.4-37.7,6,5.4a13.85,13.85,0,0,1-9.2-3.1,10.33,10.33,0,0,1-3.3-9.8c4.3-.6,8.5.4,11.3,2.9a10.26,10.26,0,0,1,3.5,8l-6.1-5.3a1.8,1.8,0,0,0-2.2,0A1.23,1.23,0,0,0,54.7,71.2Zm11.6,45.9a1.68,1.68,0,0,1,0,2.8,3,3,0,0,1-3.6,0,1.68,1.68,0,0,1,0-2.8,3,3,0,0,1,3.6,0ZM90,123.5a3,3,0,1,1-3-3A2.95,2.95,0,0,1,90,123.5ZM87,68.8a1.58,1.58,0,0,0-1.7,1.4v4.3A10.14,10.14,0,0,1,81,66.6c0-3.5,2.2-6.9,6-9.1,3.8,2.2,6,5.6,6,9.1a10.29,10.29,0,0,1-4.3,7.9V70.2A1.58,1.58,0,0,0,87,68.8Zm33.7,37.3a2.52,2.52,0,0,1,1.7-.6,2.79,2.79,0,0,1,1.8.6,2.1,2.1,0,0,1,.7,1.4,1.75,1.75,0,0,1-.7,1.4,2.85,2.85,0,0,1-3.5,0A1.68,1.68,0,0,1,120.7,106.1Zm-10.4,13.8a3,3,0,0,1-3.6,0,2.1,2.1,0,0,1-.7-1.4,1.75,1.75,0,0,1,.7-1.4,3,3,0,0,1,1.8-.6,2.79,2.79,0,0,1,1.8.6A1.68,1.68,0,0,1,110.3,119.9ZM110,74.6a10.73,10.73,0,0,1,3.4-8.1,14.15,14.15,0,0,1,11.3-2.9,10.1,10.1,0,0,1-3.3,9.8,13.34,13.34,0,0,1-9.2,3.1l6.1-5.3a1.23,1.23,0,0,0,0-1.9,1.8,1.8,0,0,0-2.2,0Z"/><path d="M77.4,117.9a3.26,3.26,0,0,0-1.4-.4,2.3,2.3,0,0,0-1.4.4,1.31,1.31,0,0,0,0,2.2,3.26,3.26,0,0,0,1.4.4,2.3,2.3,0,0,0,1.4-.4,1.31,1.31,0,0,0,0-2.2Zm23-3a3.26,3.26,0,0,0-1.4-.4,2.3,2.3,0,0,0-1.4.4,1.31,1.31,0,0,0,0,2.2,3.26,3.26,0,0,0,1.4.4,2.3,2.3,0,0,0,1.4-.4,1.31,1.31,0,0,0,0-2.2Z"/><path d="M41,42.5a.66.66,0,0,1-.48-.2.64.64,0,0,1-.19-.47V23.6a.7.7,0,0,1,.18-.5.63.63,0,0,1,.49-.2h6.83q8.26,0,8.43,7.62c0,1.08,0,1.81,0,2.18s0,1.07,0,2.16c-.08,2.61-.78,4.54-2.12,5.78S50.77,42.5,48,42.5Zm6.83-3.25a4.61,4.61,0,0,0,3.36-1,4.94,4.94,0,0,0,1.09-3.45q.06-1.68.06-2.1T52.3,30.6a4.72,4.72,0,0,0-1.15-3.37,4.71,4.71,0,0,0-3.44-1.08H44.29v13.1Zm19,3.53A10.93,10.93,0,0,1,62.55,42a6.44,6.44,0,0,1-2.72-2,4.79,4.79,0,0,1-1-2.69.6.6,0,0,1,.17-.41.54.54,0,0,1,.42-.18H62a.85.85,0,0,1,.5.14,1.39,1.39,0,0,1,.37.39,2.83,2.83,0,0,0,1.27,1.6,5,5,0,0,0,2.73.64,5.41,5.41,0,0,0,3-.66,2,2,0,0,0,1-1.8,1.71,1.71,0,0,0-.5-1.26,4.2,4.2,0,0,0-1.53-.88,30.92,30.92,0,0,0-3-.91,12,12,0,0,1-4.84-2.08,4.52,4.52,0,0,1-1.54-3.69,5,5,0,0,1,.89-2.9,6,6,0,0,1,2.57-2,9.51,9.51,0,0,1,3.87-.73,9.24,9.24,0,0,1,4,.81,6.66,6.66,0,0,1,2.58,2,4.49,4.49,0,0,1,.94,2.42.6.6,0,0,1-.17.41.54.54,0,0,1-.42.18H71a.84.84,0,0,1-.84-.5,2.19,2.19,0,0,0-1.09-1.5,4.35,4.35,0,0,0-2.36-.6,4.27,4.27,0,0,0-2.42.59,1.91,1.91,0,0,0-.88,1.7,1.8,1.8,0,0,0,.45,1.26,3.67,3.67,0,0,0,1.4.89,26.53,26.53,0,0,0,2.77.85,18.92,18.92,0,0,1,4,1.26,5.14,5.14,0,0,1,2.17,1.76,4.84,4.84,0,0,1,.7,2.72,5.14,5.14,0,0,1-1,3.15,6.18,6.18,0,0,1-2.8,2A11.5,11.5,0,0,1,66.86,42.78Zm18.82,0a8.48,8.48,0,0,1-6-2,7.59,7.59,0,0,1-2.28-5.54q0-.81,0-2.61c0-1.19,0-2.06,0-2.6a7.3,7.3,0,0,1,2.3-5.45,8.62,8.62,0,0,1,6-2,10.28,10.28,0,0,1,4.44.88,7.18,7.18,0,0,1,2.81,2.19,4.75,4.75,0,0,1,1,2.56.57.57,0,0,1-.17.42.61.61,0,0,1-.45.17H90.38a.66.66,0,0,1-.42-.12.87.87,0,0,1-.25-.36,3.88,3.88,0,0,0-1.37-1.76,4.35,4.35,0,0,0-2.66-.73,4.28,4.28,0,0,0-3.07,1.05,4.48,4.48,0,0,0-1.16,3.26q0,.81,0,2.46c0,1.09,0,1.91,0,2.47a4.59,4.59,0,0,0,1.18,3.34,4.24,4.24,0,0,0,3.08,1.08,4.64,4.64,0,0,0,3.19-1.06,4.05,4.05,0,0,0,1.2-3.19v-.87H86.69a.68.68,0,0,1-.68-.67V32.2a.68.68,0,0,1,.68-.68h6.72a.69.69,0,0,1,.5.2.66.66,0,0,1,.2.48v3a7.72,7.72,0,0,1-1,4.05,6.82,6.82,0,0,1-2.94,2.65A10.16,10.16,0,0,1,85.68,42.78Zm17.69-.28a1,1,0,0,1-1.09-.78l-6-18a.81.81,0,0,1,0-.25.58.58,0,0,1,.59-.59h2.49a.88.88,0,0,1,.59.2,1.09,1.09,0,0,1,.31.42l4.67,14.33,4.71-14.33a.84.84,0,0,1,.28-.42.86.86,0,0,1,.59-.2H113a.58.58,0,0,1,.4.17.54.54,0,0,1,.18.42l0,.25-6,18a1.07,1.07,0,0,1-1.09.78Zm20.75.28a8.53,8.53,0,0,1-6-1.93,7.67,7.67,0,0,1-2.24-5.74c0-.54,0-1.34,0-2.38s0-1.87,0-2.41a7.66,7.66,0,0,1,2.29-5.71,9.76,9.76,0,0,1,11.81,0,7.67,7.67,0,0,1,2.31,5.71c0,1.08,0,1.89,0,2.41s0,1.3,0,2.38a7.68,7.68,0,0,1-2.26,5.74A8.56,8.56,0,0,1,124.12,42.78Zm0-3.25a4,4,0,0,0,3-1.12A5,5,0,0,0,128.27,35c0-1.12,0-1.88,0-2.27s0-1.19,0-2.27A5,5,0,0,0,127.06,27a4,4,0,0,0-2.94-1.13,4,4,0,0,0-3,1.13A4.93,4.93,0,0,0,120,30.43c0,.54,0,1.3,0,2.27s0,1.71,0,2.27a4.93,4.93,0,0,0,1.16,3.43A4,4,0,0,0,124.12,39.53Z"/></svg>';var improve33='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M131.7 72.6c-.5-.7-1.4-1.8-2.6-3.3-2-2.4-5.4-6.1-9.7-9.7-6.8-5.9-17.1-12.8-28.8-14l8.7-8.7h10c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8H98.6c-.5 0-.9.2-1.3.5L85.8 45.4c-12.7.5-23.9 7.9-31.2 14.1-4.3 3.7-7.6 7.3-9.7 9.7-1.3 1.5-2.1 2.6-2.7 3.3-1 1.5-1.2 1.9-1.2 2.5 0 .6.2 1 1.3 2.4.5.7 1.4 1.8 2.6 3.3 2 2.4 5.4 6.1 9.7 9.7 6.8 5.9 17.1 12.8 28.7 14l-8.7 8.7H52.9c-.8-2.5-3.1-4.3-5.8-4.3-3.4 0-6.1 2.7-6.1 6.1s2.7 6.1 6.1 6.1c2.7 0 5.1-1.8 5.8-4.3h22.5c.5 0 .9-.2 1.3-.5l11.5-11.5c12.7-.5 23.9-7.9 31.2-14.1 4.3-3.7 7.6-7.3 9.7-9.7 1.3-1.5 2.1-2.6 2.7-3.3 1.1-1.4 1.3-1.8 1.3-2.4-.1-.8-.3-1.2-1.4-2.6zm-84.6 44.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zm69.3-29.1C109.5 94.1 98.8 101 87 101c-11.8 0-22.5-7-29.4-12.8C51.1 82.7 46.5 77.1 45 75c1.5-2.1 6-7.8 12.7-13.3C64.5 55.9 75.2 49 87 49s22.5 7 29.4 12.8c6.5 5.5 11 11.1 12.6 13.3-1.5 2-6 7.7-12.6 13.2zM104 58c-9.4-9.4-24.6-9.4-33.9 0-3.7 3.7-6.1 8.4-6.8 13.6-.7 5 .2 10.3 2.6 14.7.5.9 1.6 1.2 2.4.7.9-.5 1.2-1.6.7-2.4-4.2-7.9-2.8-17.8 3.5-24.1 8-8 20.9-8 28.8 0 8 8 8 20.9 0 28.8-6.3 6.3-16.2 7.8-24.1 3.5-.9-.5-2-.1-2.4.7-.5.9-.1 2 .7 2.4C79.1 98 83.1 99 87 99c1.1 0 2.2-.1 3.3-.2 5.2-.7 9.9-3.1 13.6-6.8 9.4-9.4 9.4-24.6.1-34zM72.6 89.4c-.7-.7-1.8-.7-2.5 0s-.7 1.8 0 2.5c.4.4.8.5 1.3.5s.9-.2 1.3-.5c.6-.6.6-1.8-.1-2.5zm24.5-16.2c-1 0-1.8.8-1.8 1.8 0 4.6-3.7 8.3-8.3 8.3-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8c-6.5 0-11.9 5.3-11.9 11.9 0 6.5 5.3 11.9 11.9 11.9 6.5 0 11.9-5.3 11.9-11.9 0-1-.8-1.8-1.8-1.8zm20.1-39.4c.3.3.5.8.5 1.3s-.2.9-.5 1.3c-.3.3-.8.5-1.3.5s-.9-.2-1.3-.5c-.3-.3-.5-.8-.5-1.3s.2-.9.5-1.3c.3-.3.8-.5 1.3-.5s1 .2 1.3.5zm9.7-4.8c3.4 0 6.1 2.7 6.1 6.1s-2.7 6.1-6.1 6.1c-3.4 0-6.1-2.7-6.1-6.1s2.7-6.1 6.1-6.1zm0 8.6c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5zm-71 4.6c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H42.8c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h13.1zm0-8.6c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H42.8c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h13.1zm18.1 0c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H63.3c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8H74zm57.2 70.6c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8h-12.9c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h12.9zm-36.8 8.6c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8h-5.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h5.2zm16.5 0c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8h-9c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h9zm20.3 0c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8h-12.9c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h12.9zm-69.5-11.6c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H42.8c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h18.9zM52.5 94c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8h-9.7c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h9.7z"/></svg>';var improve43='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M124.198022 60.146492c.995133 0 1.801798.804461 1.801978 1.796516v7.258656c-.003063.990617-.809187 1.791664-1.801798 1.791664h-.005405c-.995133-.002875-1.799456-.809851-1.796573-1.802086v-5.45118h-4.234585c-.849367 0-1.583239-.591351-1.761617-1.419351-.788467-3.659516-2.223058-7.112031-4.264135-10.261594-.4609-.711383-.36126-1.647015.239279-2.245914l2.980353-2.972031-7.272416-7.247336-2.977651 2.969516c-.600539.598718-1.538735.698265-2.252067.238445-3.15783-2.03514-6.619804-3.465813-10.289706-4.252125-.830268-.17789-1.42324-.909938-1.42324-1.756805V32.59375H80.8592v4.199117c0 .846867-.592972 1.578914-1.42324 1.756805-3.669722.786312-7.131696 2.216984-10.289707 4.252125-.713151.45982-1.651528.360094-2.252067-.238445l-2.97765-2.969516-7.272417 7.247336 2.980174 2.97221c.600539.5989.700178 1.534532.239278 2.245915-2.041076 3.149562-3.475668 6.602078-4.264134 10.261594-.178378.828-.91243 1.419351-1.761618 1.419351h-4.228639l-.005586 5.41057v.046c0 .992235-.806664 1.796875-1.801797 1.796875S46 70.189047 46 69.196812v-.007187V69.106969v-.001797l.007568-7.163961c.00108-.991516.807385-1.794899 1.801797-1.794899H52.4135c.803782-3.091703 2.029004-6.040195 3.655307-8.796601l-3.24756-3.238508c-.338017-.337094-.527747-.794219-.527747-1.27093.00018-.47653.19027-.933656.528287-1.27057l9.8216-9.787578c.703782-.70132 1.84414-.70096 2.547742.00036l3.243957 3.235273c2.763777-1.62186 5.720167-2.843735 8.8207-3.64532v-4.575563c0-.992234.806665-1.796875 1.801798-1.796875h13.884654c.995132 0 1.801797.80464 1.801797 1.796875v4.575742c3.100534.801586 6.056924 2.023461 8.820701 3.64532l3.243957-3.235273c.703602-.70132 1.84414-.70168 2.547742-.00036l9.821599 9.787579c.338198.336914.528287.794039.528287 1.27057 0 .476711-.189909.933836-.527746 1.27093l-3.24756 3.238508c1.626302 2.756406 2.851525 5.704898 3.655307 8.796601h4.611701zM86.113423 42.23686c.99279.008985 1.795672.817399 1.789366 1.807836-.005946.988461-.807566 1.785914-1.797654 1.785914-.015856.00018-.031892-.00018-.048108-.000718-.976755-.021383-1.767203-.817938-1.766843-1.796875.00018-1.00122.82216-1.81179 1.82324-1.796157zm26.912372 26.839024c.001081.038094.001081.075828.001081.114101 0 .04007-.00018.08032-.001622.12147-.056576 12.707679-8.975655 23.366741-20.899232 26.13285v19.446321c0 3.368781-2.748102 6.109375-6.126112 6.109375s-6.126112-2.740594-6.126112-6.109375v-19.4465c-11.921235-2.76557-20.839233-13.421219-20.899233-26.125664-.001621-.043305-.001621-.085711-.001621-.128836 0-.035758 0-.071516.00108-.107992.04847-12.06404 8.202865-22.700281 19.864821-25.888477.959097-.262164 1.950987.300797 2.214049 1.257992.263243.957016-.30144 1.945657-1.261258 2.208-8.166468 2.232618-14.347355 8.680883-16.441585 16.591266 1.01225-1.05818 2.23549-2.249508 3.63747-3.454492 4.268999-3.669219 10.892587-8.023586 18.439597-8.235977.19027-.00611.38108-.010242.572972-.010242.192792 0 .384684.004313.576215.010422 7.535839.214906 14.163572 4.58904 18.438517 8.274969 1.4027 1.209476 2.631345 2.40871 3.649001 3.474258-2.073329-7.90104-8.226648-14.3635-16.360684-16.624149-.958556-.266297-1.519096-1.257273-1.25189-2.21321.267207-.955759 1.259998-1.514227 2.219275-1.24847 11.59565 3.222516 19.70428 13.843305 19.755271 25.85236zM85.99991 55.143633c-7.766109 0-14.084653 6.300922-14.084653 14.046172S78.23362 83.235977 85.99991 83.235977c7.766289 0 14.084653-6.300922 14.084653-14.046172S93.766199 55.143633 85.99991 55.143633zm-16.212036 6.995773c-3.356569 2.808516-5.746473 5.645242-6.813858 7.036203 1.099277 1.417735 3.504316 4.246016 6.789174 7.008532-.932971-2.145649-1.451348-4.510696-1.451348-6.994336 0-2.505383.527566-4.889836 1.476032-7.050399zm18.734553 52.751219v-18.86611c-.83081.077087-1.671888.118415-2.522517.118415-.850629 0-1.691708-.041328-2.522517-.118414v18.866109c0 1.387187 1.13153 2.515625 2.522517 2.515625 1.390988 0 2.522517-1.128438 2.522517-2.515625zM85.99991 92.54918c10.861417 0 20.018694-7.410672 22.657426-17.427711-1.013691 1.060156-2.239454 2.25436-3.644856 3.462218-4.269 3.66922-10.892588 8.023586-18.439598 8.235977-.19027.00611-.38108.010242-.572972.010242-.192792 0-.384684-.004312-.576215-.010422-7.535659-.214906-14.163572-4.589039-18.438337-8.274789-1.407744-1.213789-2.639814-2.417156-3.659631-3.485398C65.942838 85.10796 75.11615 92.54918 85.99991 92.54918zm16.212396-16.308797c3.356569-2.808695 5.746473-5.645422 6.813858-7.036383-1.099276-1.417555-3.504316-4.245836-6.789174-7.008352.932971 2.145649 1.451349 4.510516 1.451349 6.994157 0 2.505382-.527567 4.890015-1.476033 7.050578zm-10.400157-1.895344c.57063.813086.372432 1.933438-.442521 2.502688-1.579276 1.102921-3.436029 1.685828-5.369538 1.685828-5.166295 0-9.369348-4.19157-9.369348-9.34375s4.203053-9.34375 9.369348-9.34375c.995133 0 1.801798.80464 1.801798 1.796875 0 .992234-.806665 1.796875-1.801798 1.796875-3.179272 0-5.765753 2.579414-5.765753 5.75s2.586481 5.75 5.765753 5.75c1.190088 0 2.332067-.358297 3.302515-1.035899.815314-.56925 1.938734-.371594 2.509544.441133zm1.755311-6.95211c.995133 0 1.801798.804641 1.801798 1.796696l-.00036.091281c-.010991.985586-.815494 1.77693-1.801257 1.77693-.006847 0-.013694 0-.02054-.00018-.994954-.010781-1.79261-.824406-1.781618-1.81664l.00018-.051211c0-.992235.806664-1.796875 1.801797-1.796875zm4.92107 37.765282c.282162.951625-.262161 1.951406-1.216213 2.233156l-.096937.028211c-.167567.048336-.336576.071516-.502701.071516-.78144 0-1.501078-.511032-1.729726-1.296985-.277297-.953062.272792-1.949789 1.228465-2.226328l.077838-.02264c.954052-.281211 1.956752.261265 2.239274 1.21307zm7.408993-3.480906c.479098.869867.16036 1.962367-.71171 2.440156l-.157117.085531c-.272612.146985-.566485.216883-.856034.216883-.640179 0-1.259997-.340867-1.586123-.941922-.473692-.872922-.148108-1.963265.727026-2.435664l.137116-.07457c.872251-.477789 1.967564-.160102 2.446842.709586zm6.494039-4.975188c.653152.748578.574233 1.883485-.176396 2.534852l-.132612.11446c-.34036.292891-.759278.436282-1.176034.436282-.505944 0-1.008826-.211313-1.365222-.623336-.649908-.751633-.565944-1.88636.187567-2.534313l.120361-.103859c.750809-.651547 1.888824-.573023 2.542336.175914zm11.332047-21.305906c.97261.208797 1.591528 1.164734 1.382339 2.134687l-.036937.168907c-.184504.83968-.930268 1.412523-1.758194 1.412523-.127748 0-.257477-.013476-.387387-.041867-.97207-.21239-1.587383-1.170484-1.374231-2.139899l.033874-.155609c.209369-.970312 1.167385-1.587 2.140536-1.378742zm-6.038906 15.075422c.795494.595844.956214 1.722305.359099 2.515805l-.103243.136921c-.354234.467907-.893692.714438-1.439457.714438-.378197 0-.759277-.118414-1.084321-.362969-.794233-.598-.95207-1.72482-.352432-2.516883l.097657-.129554c.597477-.7935 1.727024-.953602 2.522697-.357758zm3.833145-7.215172c.906124.409687 1.308105 1.474336.897475 2.378164l-.074774.162797c-.304144.657297-.955854 1.044164-1.636933 1.044164-.252793 0-.509549-.053188-.754053-.165852-.903601-.415976-1.297835-1.48368-.880719-2.384632l.064144-.139618c.41063-.904007 1.478375-1.304351 2.38486-.895023zm-68.527954 1.160422c.42108.899156.031712 1.968476-.869728 2.388586-.246666.11482-.506305.169265-.76162.169265-.678016 0-1.327384-.383453-1.63351-1.036617l-.075134-.162078c-.416216-.901492-.021081-1.968656.88288-2.383734.903602-.415617 1.97387-.021203 2.390266.880468l.066846.14411zm-2.52576-7.426485c.216396.968696-.395675 1.928766-1.366844 2.14475-.131891.02929-.263783.043305-.393512.043305-.825584 0-1.569907-.56943-1.756933-1.406594l-.038559-.175375c-.21063-.969953.407207-1.92643 1.379637-2.136484.97207-.209875 1.931707.405914 2.142337 1.375867l.033874.154531zm6.599805 14.136196c.605044.78811.454954 1.916008-.335134 2.519219-.326666.249585-.71189.370515-1.094052.370515-.5418 0-1.077115-.242578-1.431889-.704555l-.108468-.142132c-.600539-.791524-.444323-1.918344.349189-2.517243.793511-.598898 1.923599-.443109 2.524138.348235l.096216.12596zM68.997786 101.2085c.879818.463773 1.216213 1.550703.75135 2.428297-.323063.6095-.948286.957734-1.594771.957734-.283784 0-.57171-.067023-.840179-.208437l-.158558-.084274c-.876935-.469164-1.206484-1.558429-.736034-2.432789.470269-.874539 1.562699-1.203187 2.439454-.734203l.138738.073672zm-6.512778-4.396234c.759638.640945.854593 1.774773.211891 2.532695-.356215.42011-.864682.636273-1.376393.636273-.41117 0-.824503-.139437-1.16288-.42496l-.136396-.115899c-.755855-.645258-.844143-1.779445-.197117-2.533594.647026-.754148 1.78432-.842375 2.540535-.196578l.12036.102063zm13.755645 7.272132c.958556.267375 1.518014 1.258711 1.249907 2.214289-.222522.79386-.946304 1.313516-1.73423 1.313516-.16054 0-.323784-.021562-.486126-.066844l-.096576-.026953c-.956755-.272586-1.510807-1.267156-1.237475-2.221297.273333-.95414 1.270628-1.507039 2.227383-1.234093l.077117.021382z" fill="#000" fill-rule="nonzero"/></svg>';var decrease11='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M66.1 93.3V81.2c-.5-3.7-3.7-6.5-7.5-6.5s-7 2.8-7.5 6.5v12.1c.5 3.7 3.7 6.5 7.5 6.5 3.8.1 7-2.7 7.5-6.5zm-11.2 0V81.2c.3-1.8 1.9-3.1 3.7-3.1 1.8 0 3.4 1.3 3.7 3.1v12.1c-.3 1.8-1.9 3.1-3.7 3.1-1.8 0-3.4-1.3-3.7-3.1z"/><path d="M62 111.6h-1.6v-3.2c7.5-.9 13.2-7.3 13.2-14.9 0-1-.8-1.9-1.9-1.9-1 0-1.9.8-1.9 1.9 0 6.2-5.1 11.3-11.3 11.3-6.2 0-11.3-5.1-11.3-11.3 0-1-.8-1.9-1.9-1.9-1 0-1.9.8-1.9 1.9 0 7.6 5.7 14 13.2 14.9v3.2h-1.5c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9H62c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9zM73.3 67.1h16.3c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9H73.3c-1 0-1.9.8-1.9 1.9 0 1 .9 1.9 1.9 1.9zM99.7 94.3h-6.6c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9h6.6c1 0 1.9-.8 1.9-1.9 0-1.1-.9-1.9-1.9-1.9zM73.3 77.4h26.4c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9H73.3c-1 0-1.9.8-1.9 1.9 0 1.1.9 1.9 1.9 1.9zM73.3 87.7h26.4c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9H73.3c-1 0-1.9.8-1.9 1.9 0 1 .9 1.9 1.9 1.9z"/><path d="M129.6 95.7c-.4-.4-.9-.5-1.4-.5h-12.1V42.5c0-4.9-4-8.8-8.9-8.9H58.6c-4.9 0-8.8 4-8.9 8.9v9.8c0 1 .8 1.9 1.9 1.9h5.1v15.1c0 1 .8 1.9 1.9 1.9 1 0 1.9-.8 1.9-1.9V54.1h39.9c1 0 1.9-.8 1.9-1.9v-9.8c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v64c0 1.8.6 3.6 1.6 5.1H68.6c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9h52.7c4.9 0 8.8-4 8.9-8.9V97c0-.4-.2-.9-.6-1.3zM98.5 42.5v7.9h-45v-7.9c0-2.8 2.3-5.1 5.1-5.1H100c-1 1.5-1.5 3.3-1.5 5.1zm27.9 64c0 1.4-.5 2.7-1.5 3.6-1 1-2.3 1.5-3.6 1.5v.1c-2.8 0-5.1-2.3-5.1-5.1V99h10.2v7.5z"/></svg>';var decrease12='<svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><style>.st0{fill:#231f20}</style><path class="st0" d="M131.2 111.4l-6.9-5.9c-.8-.7-1.9-.6-2.6.2-.7.8-.6 1.9.2 2.6l3.2 2.7H113v-.4c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v.4h-9.1v-.4c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v.4h-9.1v-.4c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v.4h-9.1v-.4c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v.4h-9.1v-.4c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v.4h-5.5V64l7-11 11.4 28.7v2.5c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8V82v-.2L85 66l11.6 34.7v2.6c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2l9.1-9.1v1.9c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2c0-.2 0-.3-.1-.5l10 7.4c.8.6 2 .4 2.6-.4.6-.8.4-2-.4-2.6L112.2 86c-.7-.5-1.7-.5-2.4.2L99.1 96.9 87.2 61.3c-.2-.7-.8-1.1-1.5-1.2-.7-.1-1.4.2-1.8.8L73.1 77.4l-11.5-29c-.3-.6-.8-1.1-1.5-1.1-.7-.1-1.3.3-1.7.8l-5.8 9.1V40.8l2.7 3.2c.4.4.9.6 1.4.6.4 0 .9-.1 1.2-.4.8-.7.8-1.8.2-2.6l-5.9-6.9c-.1-.1-.1-.2-.2-.2-.2-.1-.3-.2-.5-.3-.7-.3-1.5-.1-2 .5l-5.9 6.9c-.7.8-.6 1.9.2 2.6.8.7 1.9.6 2.6-.2l2.7-3.2V111h-5c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h5v4.5c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-4.5h72.6l-3.2 2.7c-.8.7-.8 1.8-.2 2.6.4.4.9.6 1.4.6.4 0 .9-.1 1.2-.4l6.9-5.9c.2-.2.4-.4.5-.7.1-.8-.1-1.6-.7-2.1z"/><path class="st0" d="M111.1 99.3c-1 0-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2c.1-1-.8-1.8-1.8-1.8zM85.5 99.3c-1 0-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2c0-1-.8-1.8-1.8-1.8zM87.3 82.1c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2zM87.3 91.6c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2zM74.5 91.6c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2zM72.7 99.3c-1 0-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2c0-1-.8-1.8-1.8-1.8zM59.9 99.3c-1 0-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2c0-1-.8-1.8-1.8-1.8zM58.1 74.8c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2zM61.7 91.6c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2zM59.9 67.1c1 0 1.8-.8 1.8-1.8v-2.2c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8zM61.7 82.1c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v2.2c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-2.2z"/></svg>';var decrease13='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M50.4 87.3h22.9V91H50.4zM50.4 94.2h22.9v3.7H50.4zM50.4 80.5h22.9v3.7H50.4zM84.7 63.5l5.9-5.9 5.9 5.9 2.6-2.7-5.8-5.9 5.8-5.9-2.6-2.6-5.9 5.9-5.9-5.9-2.6 2.6 5.9 5.9-5.9 5.9zM50.4 101h12v3.7h-12zM50.4 73.6h22.9v3.7H50.4zM70.4 50.3l-2.8-2.5-9.7 10.9-1.7-2.5-3.1 2.1 4.4 6.5zM79.1 73.6H102v3.7H79.1zM79.1 66.8H102v3.7H79.1z"/><path d="M118.1 32.5H55.7c-6.7 0-12.2 5.5-12.2 12.2v73.8h65.4V62.8l2.4-1.6 5.3 2.7 5.5-2.7 7.4 3.7V44.7c0-6.5-5-11.8-11.4-12.2zm-12.9 12.2v70.1h-58V44.7c0-4.6 3.8-8.4 8.4-8.4h52.9c-2.1 2.2-3.3 5.2-3.3 8.4zm3.7 0c0-4.6 3.8-8.4 8.4-8.4s8.4 3.8 8.4 8.4v14.1l-3.6-1.8-5.5 2.7-5.6-2.8-2.1 1.4V44.7z"/><path d="M50.4 66.8h22.9v3.7H50.4zM79.1 87.3h17.5V91H79.1zM79.1 80.5H102v3.7H79.1z"/></svg>';var decrease21='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M82.1 30.8l-1.5 4.8c-.2.6 0 1.2.5 1.5s1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.5-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1-.6 0-1.1.4-1.3 1l-1.5 4.8H79c-.6 0-1.1.4-1.3.9s0 1.2.5 1.5l3.9 2.9zm2.6-2.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H90l-1.5 1.1c-.5.3-.6.9-.5 1.5l.5 1.7-1.3-1c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5L83 28.1h1.7zM94 118.4h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1-.6 0-1.1.4-1.3 1l-1.5 4.8H79c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5.5.3 1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.6-.7-1-1.3-1zm-5.9 5.3l.5 1.7-1.3-1c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H90l-1.5 1.1c-.4.3-.6.9-.4 1.5zM105.1 39.8l-1.5 4.8c-.2.6 0 1.2.5 1.5.5.3 1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.5-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H102c-.6 0-1.1.4-1.3.9s0 1.2.5 1.5l3.9 2.9zm2.6-2.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1h1.7l-1.5 1.1c-.5.3-.6.9-.5 1.5l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.9zM125.1 54.8l-1.5 4.8c-.2.6 0 1.2.5 1.5.2.2.5.2.8.2.3 0 .6-.1.8-.3l3.8-2.9 3.8 2.9c.5.4 1.1.4 1.6 0s.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.5-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1-.6 0-1.1.4-1.3 1l-1.5 4.8H122c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3.1zm2.6-2.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1h1.7l-1.5 1.1c-.5.3-.6.9-.5 1.5l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.9zM137 94.4h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H122c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5.5.3 1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.6-.7-1-1.3-1zm-5.9 5.3l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1h1.7l-1.5 1.1c-.3.3-.5.9-.3 1.5zM40.1 54.8l-1.5 4.8c-.2.6 0 1.2.5 1.5.5.3 1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5s-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H37c-.6 0-1.1.4-1.3.9s0 1.2.5 1.5l3.9 2.9zm2.6-2.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H48l-1.5 1.1c-.4.3-.6.9-.5 1.5l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5L41 52.1h1.7zM142.3 72.3c-.2-.5-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H126c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5.2.2.5.2.8.2.3 0 .6-.1.8-.3l3.8-2.9 3.8 2.9c.5.4 1.1.4 1.6 0 .5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.2.7-.9.5-1.4zm-7.2 4.4l.5 1.7-1.3-1c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1h1.7l-1.5 1.1c-.3.3-.5.9-.3 1.5zM36.7 83.1l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5s-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1-.6 0-1.1.4-1.3 1l-1.5 4.8H33c-.6 0-1.1.4-1.3.9s0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5.5.2 1.1.2 1.6-.1zm2-9c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H44l-1.5 1.1c-.4.3-.6.9-.5 1.5l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5L37 74.1h1.7zM48.9 99.8l3.9-3c.5-.4.6-1 .5-1.5-.2-.5-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H37c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5.5.3 1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.9zm-2.8-.1l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5L41 97.1h1.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H48l-1.5 1.1c-.4.3-.6.9-.4 1.5zM123 114.4h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H108c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5s1.1.3 1.6 0l3.8-2.9 3.8 2.9c.2.2.5.3.8.3.3 0 .5-.1.8-.2.5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.7-.7-1-1.3-1zm-5.9 5.3l.5 1.7-1.3-1c-.5-.4-1.2-.4-1.6 0l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1h1.7l-1.5 1.1c-.3.3-.5.9-.3 1.5zM59.1 39.8l-1.5 4.8c-.2.6 0 1.2.5 1.5.2.2.5.2.8.2.3 0 .6-.1.8-.3l3.8-2.9 3.8 2.9c.5.4 1.1.4 1.6 0 .5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5s-.7-.9-1.3-.9h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1-.6 0-1.1.4-1.3 1l-1.5 4.8H56c-.6 0-1.1.4-1.3.9s0 1.2.5 1.5l3.9 3.1zm2.6-2.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H67l-1.5 1.1c-.4.3-.6.9-.5 1.5l.5 1.7-1.3-1c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5L60 37.1h1.7zM67 114.4h-4.7l-1.5-4.8c-.2-.6-.7-1-1.3-1s-1.1.4-1.3 1l-1.5 4.8H52c-.6 0-1.1.4-1.3.9-.2.5 0 1.2.5 1.5l3.9 3-1.5 4.8c-.2.6 0 1.2.5 1.5.2.2.5.2.8.2.3 0 .6-.1.8-.3l3.8-2.9 3.8 2.9c.5.4 1.1.4 1.6 0 .5-.3.7-.9.5-1.5l-1.5-4.8 3.9-3c.5-.4.6-1 .5-1.5-.2-.4-.7-.8-1.3-.8zm-5.9 5.3l.5 1.7-1.3-1c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-1.3 1 .5-1.7c.2-.5 0-1.1-.5-1.5l-1.5-1.1h1.7c.6 0 1.1-.4 1.3-1l.5-1.6.5 1.6c.2.6.7 1 1.3 1H63l-1.5 1.1c-.4.3-.6.9-.4 1.5zM100.5 68.9v-3.8c0-7.8-6.1-14.2-13.5-14.2-7.5 0-13.5 6.4-13.5 14.2v3.8c-3 .1-5.5 2.7-5.5 5.8v15.4c0 3.2 2.5 5.8 5.6 5.8h26.7c3.1 0 5.6-2.6 5.6-5.8V74.8c.1-3.2-2.3-5.8-5.4-5.9zm1.5 21.3c0 1-.7 1.8-1.6 1.8H73.6c-.9 0-1.6-.8-1.6-1.8V74.8c0-1 .7-1.8 1.6-1.8h3.8v-7.8c0-5.6 4.3-10.2 9.5-10.2s9.5 4.6 9.5 10.2V73h3.8c.9 0 1.6.8 1.6 1.8v15.4z"/><path d="M87 57.4c-4.1 0-7.5 3.5-7.5 7.8V73h14.9v-7.8c.1-4.3-3.3-7.8-7.4-7.8zm3.5 11.5h-6.9v-3.8c0-2.1 1.6-3.8 3.5-3.8s3.5 1.7 3.5 3.8v3.8z"/></svg>';var decrease22='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M66 86.8c.5.9.2 2-.6 2.5-.3.2-.6.3-.9.3-.6 0-1.2-.3-1.5-.9-.5-.9-.2-2 .6-2.5.8-.6 1.9-.3 2.4.6zm27.7-14.1c1 0 1.8.8 1.8 1.8 0 5-4 9-9 9s-9-4-9-9 4-9 9-9c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8c-3 0-5.4 2.4-5.4 5.4 0 3 2.4 5.4 5.4 5.4 3 0 5.4-2.4 5.4-5.4 0-1 .8-1.8 1.8-1.8zm1.7-14.2c5.8 3.2 9.5 9.4 9.5 16 0 10.1-8.2 18.3-18.3 18.3-10.1 0-18.3-8.2-18.3-18.3 0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8c0 8.1 6.6 14.7 14.7 14.7s14.7-6.6 14.7-14.7c0-5.4-2.9-10.3-7.6-12.9-.9-.5-1.2-1.6-.7-2.4.4-.9 1.5-1.2 2.4-.7zm-8.8-2.3c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8-1.8-.8-1.8-1.8.7-1.8 1.8-1.8zm38.6 11.5c3.8 0 6.8 3.1 6.8 6.8 0 3.8-3.1 6.8-6.8 6.8-3.1 0-5.8-2.1-6.6-5h-4.7c-.5 7.1-3.7 13.8-9 18.8-2.3 2.1-3.7 5-4.2 8 1.7.3 3 1.7 3 3.5v3.7c0 .6-.2 1.2-.5 1.7.3.5.5 1.1.5 1.7v3.7c0 1.9-1.6 3.5-3.5 3.5H72.8c-1.9 0-3.5-1.6-3.5-3.5v-3.7c0-.6.2-1.2.5-1.7-.3-.5-.5-1.1-.5-1.7v-3.7c0-1.8 1.3-3.2 3-3.5-.4-3-1.8-5.9-4.1-8-.3-.3-.6-.5-.9-.8-.7-.7-.7-1.8 0-2.5s1.8-.7 2.5 0c.2.2.5.5.8.7 3 2.8 4.9 6.6 5.3 10.6h21.2c.4-4 2.3-7.8 5.3-10.6 5-4.7 7.9-11.2 7.9-18 0-13.2-10.7-24-23.9-24s-23.9 10.8-23.9 24c0 2.4.4 4.8 1.1 7.1.3.9-.2 2-1.2 2.3-.9.3-2-.2-2.3-1.2-.7-2.1-1-4.2-1.2-6.4h-4.7c-.8 2.9-3.4 5-6.6 5-3.8 0-6.8-3.1-6.8-6.8 0-3.8 3.1-6.8 6.8-6.8 3.1 0 5.8 2.1 6.6 5h4.7c.4-6.2 2.9-11.9 6.7-16.4L62.3 53c-1 .6-2.2.9-3.4.9-1.7 0-3.5-.7-4.8-2-1.3-1.3-2-3-2-4.8 0-1.8.7-3.5 2-4.8 2.7-2.7 7-2.7 9.7 0 2.2 2.2 2.6 5.6 1.1 8.2l3.3 3.3c4.4-3.9 10.1-6.4 16.4-6.8v-4c0-.2 0-.4.1-.6-2.9-.8-5.1-3.4-5.1-6.6 0-3.8 3.1-6.8 6.8-6.8 3.8 0 6.8 3.1 6.8 6.8 0 3.2-2.2 5.9-5.1 6.6.1.2.1.4.1.6v4c6.3.4 11.9 2.9 16.4 6.8l3.3-3.3c-1.5-2.6-1.1-6 1.1-8.2 2.7-2.7 7-2.7 9.7 0 1.3 1.3 2 3 2 4.8 0 1.8-.7 3.5-2 4.8-1.3 1.3-3.1 2-4.8 2-1.2 0-2.3-.3-3.4-.9l-3.3 3.3c3.9 4.4 6.3 10.1 6.7 16.4h4.7c.8-2.9 3.4-5 6.6-5zm-13.6-22.8c-1.3 1.3-1.3 3.3 0 4.6 1.3 1.3 3.3 1.3 4.6 0 1.3-1.3 1.3-3.3 0-4.6-.6-.6-1.5-.9-2.3-.9-.9-.1-1.7.2-2.3.9zm-50.2 4.5c1.3-1.3 1.3-3.3 0-4.6-.6-.6-1.5-.9-2.3-.9-.8 0-1.7.3-2.3.9-1.3 1.3-1.3 3.3 0 4.6 1.3 1.3 3.4 1.3 4.6 0zM47.8 77.7c1.8 0 3.2-1.5 3.2-3.2 0-1.8-1.5-3.2-3.2-3.2s-3.2 1.5-3.2 3.2c0 1.8 1.4 3.2 3.2 3.2zm35.5-41.9c0 1.8 1.5 3.2 3.2 3.2s3.2-1.5 3.2-3.2-1.5-3.2-3.2-3.2-3.2 1.4-3.2 3.2zm16.9 74.4v-3.6H72.8v3.6h13.6c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H72.8v3.6h27.3v-3.6h-6.5c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h6.6zm25-32.5c1.8 0 3.2-1.5 3.2-3.2 0-1.8-1.5-3.2-3.2-3.2s-3.2 1.5-3.2 3.2c-.1 1.8 1.4 3.2 3.2 3.2z"/></svg>';var decrease23='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M79.3 80.5h-.2l-9.8-1.2-3.4.4c-.5.1-1-.1-1.4-.4-.4-.3-.6-.8-.6-1.3V55.5c0-2.2 1.8-4 4-4H77c2.2 0 4 1.8 4 4v23.3c0 .5-.2 1-.6 1.3-.3.2-.7.4-1.1.4zm-10.1-4.7h.2l8.1 1V55.5c0-.3-.2-.5-.5-.5h-9.1c-.3 0-.5.2-.5.5V76l1.7-.2h.1zM102.7 55.7c-.2 0-.5 0-.7-.1-2.4-1-4.4-1.5-6-1.5-1.6 0-3.7.5-6.4 1.5-.5.2-1.1.1-1.6-.2-.5-.3-.8-.9-.8-1.4V42.2c0-2.2 1.8-4 4-4h9.1c2.2 0 4 1.8 4 4V54c0 .6-.3 1.1-.8 1.5-.2.1-.5.2-.8.2zm-11.4-14c-.3 0-.5.2-.5.5v9.3c2-.6 3.8-.9 5.3-.9 1.4 0 3.1.3 4.9.9v-9.3c0-.3-.2-.5-.5-.5h-9.2zM112.4 86.9c-.4 0-.9-.2-1.2-.5-.4-.3-.6-.8-.6-1.3V34.6c0-2.2 1.8-4 4-4h9.1c2.2 0 4 1.8 4 4v49.5c0 .9-.7 1.7-1.6 1.7l-13.7 1.1c.1 0 0 0 0 0zm2.3-52.8c-.3 0-.5.2-.5.5v48.6l10.2-.8V34.6c0-.3-.2-.5-.5-.5h-9.2zM97.3 71.3c.5-.1 1-.3 1.2-.6.3-.3.4-.7.4-1.2 0-.2 0-.4-.1-.5s-.2-.3-.3-.4c-.1-.1-.3-.2-.4-.3s-.3-.2-.5-.2l-.3 3.2zm-.6-8.8c-.3 0-.5.1-.7.2-.2.1-.4.2-.5.3s-.2.3-.3.4c-.1.2-.2.4-.2.6 0 .2 0 .4.1.5.1.2.2.3.3.4.1.1.3.2.4.3.2.1.3.2.5.3l.4-3zm1.1 3.4c.3.1.5.2.8.3.3.1.5.2.8.3s.5.3.7.4c.2.2.4.3.6.6.2.2.3.5.4.7.1.3.1.6.1 1 0 .5-.1 1-.3 1.5s-.4.9-.8 1.3-.8.7-1.3.9c-.5.2-1.1.4-1.7.4l-.1 1.1c0 .1-.1.3-.2.4-.1.1-.3.2-.4.2h-.9l.2-1.8c-.3 0-.6-.1-1-.2l-.9-.3c-.3-.1-.6-.3-.8-.5-.3-.2-.5-.4-.7-.6l.7-1.1c.1-.1.1-.2.3-.2.1-.1.2-.1.3-.1.1 0 .3 0 .4.1.1.1.3.2.5.3l.6.3c.2.1.5.2.8.3l.3-3.6c-.3-.1-.5-.2-.8-.3-.3-.1-.5-.2-.8-.3s-.5-.3-.7-.4l-.6-.6c-.2-.2-.3-.5-.4-.8-.1-.3-.1-.7-.1-1.1 0-.4.1-.9.3-1.3.2-.4.4-.8.8-1.1.3-.3.8-.6 1.3-.8s1.1-.3 1.7-.4l.1-1c0-.1.1-.3.2-.4.1-.1.3-.2.4-.2h.9l-.2 1.7c.6.1 1.1.3 1.6.5s.8.5 1.1.8l-.6.9-.3.3c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1 0-.2-.1-.4-.2s-.3-.1-.5-.2-.4-.1-.6-.2l-.2 3.4z"/><path d="M96.1 81.7c-8.6 0-15.5-7-15.5-15.5 0-8.6 7-15.5 15.5-15.5s15.5 7 15.5 15.5-7 15.5-15.5 15.5zm0-27.6c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12z"/><path d="M110.4 82.6l-41.2-5.1-1.1.2 36.5 4.6s2.7 1 1.9 4.4c0 0-.9 7.7-24 6.6 28.7 2.7 29.7-6.3 29.7-6.3.9-3.4-1.8-4.4-1.8-4.4z" fill="#fff"/><path d="M89.5 114.2c-2.1 0-4.5-.5-7-1.9l-25.3-12.2c-.6-.3-1-.9-1-1.6V79.2c0-.9.6-1.6 1.5-1.7l11.2-1.7h.5l41.2 5.1c.1 0 .3 0 .4.1.2.1 1.7.7 2.6 2.4l16.8-1.4h.2c.3 0 3.2.1 4.8 2.2.7.9 1.3 2.6.5 5.2-.1.4-.4.8-.8 1l-38.3 21.9c-.1.1-3.1 1.9-7.3 1.9zM59.7 97.4l24.4 11.7s.1 0 .1.1c5.5 3.2 10.7.1 10.8 0l37.6-21.6c.1-.5.1-1.1-.2-1.5-.4-.6-1.6-.8-1.9-.8l-18.1 1.5c-.5 0-.9-.1-1.3-.4s-.6-.7-.6-1.2v-.1c-.2-.5-.5-.8-.7-.9l-40.7-5.1-9.5 1.4v16.9z"/><path d="M92.4 95.5c-5 0-11.1-.5-18.7-1.6-1-.1-1.6-1-1.5-2s1-1.6 2-1.5c33.9 5 36.3-3.7 36.3-3.7v-.1c.4-1.5-.3-2.1-.7-2.3l-40.7-5.1-11 1.7c-1 .2-1.8-.5-2-1.5-.1-1 .5-1.8 1.5-2l11.2-1.7h.5l41.2 5.1c.1 0 .3 0 .4.1 1.4.5 3.9 2.5 3 6.4-.1.6-.6 2.3-2.8 4-2.7 2.2-8.1 4.2-18.7 4.2z"/><path d="M55 106.7H40.1c-2.6 0-4.7-2.1-4.7-4.7V75.7c0-2.6 2.1-4.7 4.7-4.7H55c2.6 0 4.7 2.1 4.7 4.7V102c0 2.6-2.1 4.7-4.7 4.7zM40.1 74.5c-.7 0-1.2.6-1.2 1.2V102c0 .7.6 1.2 1.2 1.2H55c.7 0 1.2-.6 1.2-1.2V75.7c0-.7-.6-1.2-1.2-1.2H40.1z"/></svg>';var decrease33='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M124.2 43.6c-.7-1.2-1.9-2-3.3-2.3l-3.7-.8v-.6c0-2.9-2.4-5.2-5.2-5.2H92.4l-19.1-4.4c-1.4-.3-2.8-.1-4 .7s-2 1.9-2.3 3.3l-.1.5H63c-2.9 0-5.2 2.4-5.2 5.2v33.9L50.1 107c-.3 1.4-.1 2.8.7 4s1.9 2 3.3 2.3l3.7.9v.5c0 2.9 2.4 5.2 5.2 5.2h19.8l.2.1 18.8 4.3c1.4.3 2.8.1 4-.7 1.2-.7 2-1.9 2.3-3.3l.1-.5h3.8c2.9 0 5.2-2.4 5.2-5.2v-34l7.6-33.1c.4-1.3.2-2.7-.6-3.9zm-66.4 66.9l-2.9-.7c-.5-.1-.9-.4-1.1-.8-.3-.4-.3-.9-.2-1.3l4.2-18.2v21zm14.7-76.8l4.4 1h-6.4c.3-.8 1.1-1.2 2-1zm30 87.1l-4.3-1h6.3c-.3.8-1.1 1.2-2 1zm11.3-6.2c0 1-.8 1.8-1.8 1.8H63c-1 0-1.8-.8-1.8-1.8V39.9c0-1 .8-1.8 1.8-1.8h49c1 0 1.8.8 1.8 1.8v74.7zm7.7-67.8l-4.2 18.3V44l2.9.7c.5.1.9.4 1.1.8.2.4.3.8.2 1.3z"/><path d="M105 106.7H71.8V92.5c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v16c0 1 .8 1.8 1.8 1.8h35c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8zM75.8 61.9c4.2 0 7.6-3.4 7.6-7.6 0-1.4-.4-2.8-1.2-4l3.2-3.2c.7-.7.7-1.8 0-2.5s-1.8-.7-2.5 0l-7.1 7.1-4-4c-.7-.7-1.8-.7-2.5 0s-.7 1.8 0 2.5c-.7 1.2-1.1 2.6-1.1 4 0 4.3 3.4 7.7 7.6 7.7zm-3.8-9l2.6 2.6c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l2.6-2.6c.2.4.2.9.2 1.4-.1 2.2-1.9 3.8-4.1 3.8-2.2 0-3.9-1.7-4.1-3.8.1-.5.2-.9.4-1.4zM75.8 81.1c3.1 0 5.8-1.8 7-4.7 1.2-2.8.5-6.1-1.6-8.3-2.2-2.2-5.4-2.8-8.3-1.7-2.8 1.2-4.7 3.9-4.7 7 .1 4.3 3.4 7.6 7.6 7.7zm0-11.7c1.7 0 3.2 1 3.8 2.5.6 1.5.3 3.3-.9 4.5-1.2 1.2-2.9 1.5-4.5.9-1.5-.6-2.5-2.1-2.5-3.8.1-2.3 1.9-4.1 4.1-4.1z"/><path d="M105 84.9h-6.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h2.6L91 98.2l-6.9-7c-.7-.7-1.8-.7-2.5 0l-6.3 6.3c-.5.4-.7 1.1-.6 1.7.2.6.7 1.1 1.3 1.3.6.2 1.3-.1 1.7-.6l5-5 6.9 6.9c.3.3.8.5 1.2.5s.9-.2 1.2-.5l11-10.9v2.6c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-6.9c.2-.9-.6-1.7-1.6-1.7zM89.8 71.7h7.5c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8h-7.5c-1 0-1.8.8-1.8 1.8.1 1 .9 1.8 1.8 1.8zM89.8 78.7h14.4c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8H89.8c-1 0-1.8.8-1.8 1.8s.9 1.8 1.8 1.8zM89.8 52.6h7.5c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8h-7.5c-1 0-1.8.8-1.8 1.8s.9 1.8 1.8 1.8zM89.8 59.6h14.4c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8H89.8c-1 0-1.8.8-1.8 1.8s.9 1.8 1.8 1.8z"/></svg>';var common1='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M95.9 69c-.5 0-.9.2-1.3.5-.3.3-.5.8-.5 1.3s.2.9.5 1.3c.3.3.8.5 1.3.5s.9-.2 1.3-.5c.3-.3.5-.8.5-1.3s-.2-.9-.5-1.3-.8-.5-1.3-.5z"/><path d="M128 72.7c0-1-.8-1.8-1.8-1.8h-4.8c-.8-3.2-2.1-6.3-3.8-9.2l3.4-3.4c.7-.7.7-1.8 0-2.5l-10.2-10.1c-.7-.7-1.9-.7-2.6 0l-1 1c-.1-7.2-4-13.9-10.3-17.5-.6-.3-1.3-.3-1.8 0-.6.3-.9.9-.9 1.6v14.1l-7.6 4.4-7.6-4.4V30.8c0-.6-.3-1.2-.9-1.6-.6-.3-1.3-.3-1.8 0-6.4 3.6-10.3 10.3-10.5 17.5l-1-1c-.7-.7-1.9-.7-2.6 0L52.1 55.8c-.7.7-.7 1.8 0 2.5l3.4 3.4c-1.7 2.9-3 5.9-3.8 9.2h-4.8c-1 0-1.8.8-1.8 1.8L45 87c0 .5.2.9.5 1.3.3.3.8.5 1.3.5h4.8c.8 3.2 2.1 6.3 3.8 9.2l-3.4 3.4c-.7.7-.7 1.8 0 2.5L62.3 114c.7.7 1.9.7 2.6 0l3.4-3.4c2.9 1.7 6 3 9.2 3.8v4.8c0 .5.2.9.5 1.3.3.3.8.5 1.3.5h14.4c1 0 1.8-.8 1.8-1.8v-4.8c3.3-.8 6.3-2.1 9.2-3.8l3.4 3.4c.3.3.8.5 1.3.5s.9-.2 1.3-.5l10.2-10.1c.7-.7.7-1.8 0-2.5l-3.4-3.4c1.7-2.9 3-5.9 3.8-9.2h4.8c.5 0 .9-.2 1.3-.5.3-.3.5-.8.5-1.3l.1-14.3zM75.3 34.3V46c0 .6.3 1.2.9 1.6l9.4 5.4c.6.3 1.3.3 1.8 0l9.4-5.4c.6-.3.9-.9.9-1.6V34.3c3.6 3.2 5.8 7.8 5.8 12.7 0 9.3-7.6 16.9-17 16.9s-17-7.6-17-16.9c0-4.9 2.1-9.5 5.8-12.7zm44.6 50.9c-.9 0-1.6.6-1.8 1.4-.8 3.8-2.3 7.4-4.4 10.6-.5.7-.4 1.6.2 2.2l3.1 3.1-7.6 7.6-3.2-3.1c-.6-.6-1.5-.7-2.3-.2-3.3 2.1-6.9 3.6-10.7 4.4-.8.2-1.4.9-1.4 1.8v4.4H81V113c0-.8-.6-1.6-1.4-1.8-3.8-.8-7.4-2.3-10.7-4.4-.7-.5-1.7-.4-2.3.2l-3.2 3.1-7.6-7.6 3.2-3.1c.6-.6.7-1.5.2-2.2-2.1-3.3-3.6-6.8-4.4-10.6-.2-.8-.9-1.4-1.8-1.4h-4.5V74.5H53c.9 0 1.6-.6 1.8-1.4.8-3.8 2.3-7.4 4.4-10.6.5-.7.4-1.6-.2-2.2l-3.2-3.1 7.6-7.6 3.1 3c1.4 4.8 4.5 9 8.7 11.6v34.6l-.1-.1c-.9-.5-2-.2-2.5.6-.5.9-.2 2 .6 2.5 4.1 2.4 8.7 3.6 13.2 3.6 6.6 0 13.2-2.6 18.2-7.5 4.4-4.4 7.1-10.2 7.5-16.3.4-6.1-1.4-12.1-5.1-17-.6-.8-1.7-1-2.5-.4s-1 1.7-.4 2.5c6.5 8.7 5.6 21-2.1 28.6-1.3 1.3-2.8 2.5-4.4 3.4V78.2c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v22.3c-2.4.9-5 1.3-7.6 1.3-2.6 0-5.1-.4-7.6-1.3V66c2.4.9 4.9 1.4 7.6 1.4 9.4 0 17.4-6.3 19.9-14.9l3.1-3.1L117 57l-3.1 3.1c-.6.6-.7 1.5-.2 2.2 2.1 3.3 3.6 6.8 4.4 10.6.2.8.9 1.4 1.8 1.4h4.4V85h-4.4z"/><path d="M69.2 93.7c-.7-.7-1.9-.7-2.6 0-.7.7-.7 1.8 0 2.5.4.4.8.5 1.3.5s.9-.2 1.3-.5c.7-.7.7-1.8 0-2.5zM66.1 88.3c-3-7.1-2-15.3 2.7-21.5.6-.8.4-1.9-.4-2.5-.8-.6-1.9-.4-2.5.4-5.4 7.2-6.6 16.8-3.1 25 .3.7 1 1.1 1.7 1.1.2 0 .5 0 .7-.1.8-.5 1.3-1.5.9-2.4z"/></svg>';var common2='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173 150"><path d="M87 51.6c-3 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4-2.4-5.4-5.4-5.4zm40.6 22.7c3 0 5.4 2.4 5.4 5.4 0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4c0-.8.2-1.6.5-2.3l-4.5-4.5h-8.1c-3.8 5.6-9.7 9.7-16.4 11.4v30.1c0 3.7-3 6.7-6.7 6.7s-6.7-3-6.7-6.7V84.2c-6.8-1.7-12.6-5.8-16.4-11.4h-8.1l-4.5 4.5c.3.7.5 1.5.5 2.3 0 3-2.4 5.4-5.4 5.4S41 82.6 41 79.6c0-3 2.4-5.4 5.4-5.4.8 0 1.6.2 2.3.5l5-5c.3-.3.8-.5 1.3-.5h6.8c-1.6-3.2-2.5-6.7-2.8-10.4h-7.6c-.7 2.1-2.7 3.6-5.1 3.6-3 0-5.4-2.4-5.4-5.4s2.4-5.4 5.4-5.4c2.3 0 4.3 1.5 5.1 3.6H59c.2-3.7 1.2-7.3 2.8-10.5H55c-.5 0-.9-.2-1.3-.5l-5-5c-.7.3-1.5.5-2.3.5-3 0-5.4-2.4-5.4-5.4s2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4c0 .8-.2 1.6-.5 2.3l4.5 4.5h8.1C68.9 33.8 77.4 29 87 29s18.1 4.8 23.1 12.2h8.1l4.5-4.5c-.3-.7-.5-1.5-.5-2.3 0-3 2.4-5.4 5.4-5.4s5.4 2.4 5.4 5.4c0 3-2.4 5.4-5.4 5.4-.8 0-1.6-.2-2.3-.5l-5 5c-.3.3-.8.5-1.3.5h-6.8c1.6 3.2 2.5 6.7 2.8 10.5h7.6c.7-2.1 2.7-3.6 5.1-3.6 3 0 5.4 2.4 5.4 5.4s-2.4 5.4-5.4 5.4c-2.3 0-4.3-1.5-5.1-3.6H115c-.2 3.7-1.2 7.2-2.8 10.4h6.8c.5 0 .9.2 1.3.5l5 5c.7-.3 1.5-.5 2.3-.5zm0-19.1c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8zm0-22.6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8zm-81.2 3.6c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8zm0 22.6c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8zm0 22.6c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8zm43.7 32.9V84.9c-1 .1-2.1.1-3.1.1s-2.1-.1-3.1-.2v29.4c0 1.7 1.4 3.1 3.1 3.1s3.1-1.3 3.1-3zm9.6-55.1c.6.6.8 1.5.4 2.2L97.4 66c-.4.7-1.3 1.1-2.1.8l-2.1-.7c-.4.3-.8.5-1.3.7l-.5 2.2c-.2.8-.9 1.4-1.8 1.4h-5.3c-.8 0-1.6-.6-1.8-1.4l-.5-2.2c-.4-.2-.9-.5-1.3-.7l-2.1.7c-.8.3-1.7-.1-2.1-.8l-2.7-4.6c-.4-.7-.3-1.7.4-2.2l1.7-1.5V57v-.7l-1.7-1.5c-.6-.6-.8-1.5-.4-2.2l2.7-4.6c.4-.7 1.3-1.1 2.1-.8l2.1.7c.4-.3.8-.5 1.3-.7l.5-2.2c.2-.8.9-1.4 1.8-1.4h5.3c.8 0 1.6.6 1.8 1.4l.5 2.2c.4.2.9.5 1.3.7l2.1-.7c.8-.3 1.7.1 2.1.8l2.7 4.6c.4.7.3 1.7-.4 2.2L98 56.3v1.4l1.7 1.5zM87 58.8c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zm7.4-2.9c-.1-.6.1-1.2.6-1.6l1.3-1.1L95 51l-1.6.5c-.6.2-1.2.1-1.7-.3-.6-.5-1.3-.9-2-1.2-.6-.2-1-.7-1.1-1.3l-.4-1.7h-2.4l-.4 1.7c-.1.6-.5 1.1-1.1 1.3-.7.3-1.4.7-2 1.2-.5.4-1.1.5-1.7.3L79 51l-1.2 2.1 1.3 1.1c.5.4.7 1 .6 1.6-.1.4-.1.8-.1 1.2 0 .4 0 .8.1 1.2.1.6-.1 1.2-.6 1.6l-1.3 1.1L79 63l1.6-.5c.6-.2 1.2-.1 1.7.3.6.5 1.3.9 2 1.2.6.2 1 .7 1.1 1.3l.4 1.7h2.4l.4-1.7c.1-.6.5-1.1 1.1-1.3.7-.3 1.4-.7 2-1.2.5-.4 1.1-.5 1.7-.3l1.6.5 1.2-2.1-1.2-1.1c-.5-.4-.7-1-.6-1.6.1-.4.1-.8.1-1.2s-.1-.8-.1-1.1zM87 81.4c13.5 0 24.4-11 24.4-24.4s-11-24.4-24.4-24.4-24.4 11-24.4 24.4S73.5 81.4 87 81.4zm40.6 0c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8zM74.4 69.6c.7.7.7 1.8 0 2.5-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5c-.7-.7-.7-1.8 0-2.5.8-.7 1.9-.7 2.6 0zM87 35.7c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8c-4.8 0-9.2 1.8-12.6 5.2-5.2 5.2-6.7 12.9-3.8 19.6.4.9 0 2-.9 2.4-.2.1-.5.1-.7.1-.7 0-1.4-.4-1.7-1.1-1.7-3.9-2.2-8.2-1.4-12.3.8-4.3 2.8-8.2 5.9-11.3 4.1-4 9.5-6.2 15.2-6.2zm15.1 6.2c.7.7.7 1.8 0 2.5-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5l1.3-1.3-1.3 1.3c-.7-.7-.7-1.8 0-2.5.8-.7 1.9-.7 2.6 0zm4.8 7.4c3.1 7.9 1.2 16.9-4.8 22.8-4 4-9.4 6.3-15.1 6.3-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8c4.7 0 9.2-1.9 12.6-5.2 5-5 6.6-12.4 4-19-.4-.9.1-2 1-2.3.9-.4 2 .1 2.3 1z"/></svg>';var buttonPower='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 111"><path d="M77.5 42.3c4 6.2 5.8 13.6 5 21-.8 7.5-4.1 14.5-9.4 19.8-4.1 4.1-9.3 7.1-15 8.5-1 .2-1.9-.3-2.2-1.3-.2-1 .3-1.9 1.3-2.2 5-1.3 9.6-3.9 13.3-7.6 9.6-9.6 11.3-24.9 3.9-36.3-.6-.9-1.6-1.5-2.7-1.6-1.1-.1-2.1.3-2.9 1-1.2 1.2-1.4 3.1-.5 4.5 5.6 8.7 4.3 20.3-3.2 27.6-4.1 4-9.5 6.2-15.3 6.2s-11.2-2.2-15.3-6.2c-7.4-7.2-8.8-18.8-3.2-27.6.9-1.5.8-3.3-.5-4.5-.8-.8-1.8-1.1-2.9-1-1.1.1-2.1.7-2.7 1.6-7.4 11.4-5.7 26.7 3.9 36.3 3.7 3.7 8.3 6.3 13.4 7.6 1 .2 1.5 1.2 1.3 2.2-.2.8-.9 1.4-1.7 1.4-.1 0-.3 0-.4-.1-5.7-1.4-10.9-4.4-15.1-8.6-5.3-5.3-8.7-12.4-9.4-19.8-.7-7.4 1-14.8 5-21 1.2-1.8 3.1-3 5.3-3.3 2.2-.2 4.3.5 5.8 2.1 2.4 2.4 2.8 6.1.9 9-4.7 7.3-3.6 17 2.7 23 7 6.9 18.5 6.9 25.5 0 6.2-6.1 7.3-15.7 2.7-23-1.9-2.9-1.5-6.6.9-9 1.5-1.5 3.7-2.3 5.8-2.1 2.6.4 4.5 1.5 5.7 3.4zM50.1 89.1c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H50c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.9-1.8zm17.1-71.8c.9.4 1.4 1.4 1 2.3-.4.9-1.4 1.4-2.3 1-5-2-10.4-3.1-15.9-3.1-23.4 0-42.4 19-42.4 42.4 0 8.9 2.7 17.3 7.8 24.4 1-.5 2.2-.8 3.4-.8 2 0 3.9.8 5.4 2.2s2.2 3.3 2.2 5.4-.8 3.9-2.2 5.4c-1.4 1.4-3.3 2.2-5.4 2.2s-3.9-.8-5.4-2.2-2.2-3.3-2.2-5.4c0-1.6.5-3.2 1.5-4.5C7 78.9 4 69.7 4 60c0-12.3 4.8-23.8 13.5-32.5S37.7 14 50 14c6 0 11.7 1.1 17.2 3.3zM15.9 88.4c-.8.8-1.2 1.8-1.2 2.8s.4 2.1 1.2 2.8c.8.8 1.8 1.2 2.8 1.2s2.1-.4 2.8-1.2c.8-.8 1.2-1.8 1.2-2.8s-.4-2.1-1.2-2.8c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .5-2.8 1.2zm71.5-55.2C93 41.1 96 50.3 96 60c0 12.3-4.8 23.8-13.5 32.5S62.3 106 50 106c-5.9 0-11.7-1.1-17.1-3.3-.9-.4-1.4-1.4-1-2.3.4-.9 1.4-1.4 2.3-1 5 2 10.3 3 15.8 3 23.4 0 42.4-19 42.4-42.4 0-8.9-2.7-17.3-7.8-24.4-1.1.5-2.2.8-3.4.8-1.9 0-3.9-.7-5.4-2.2-1.4-1.4-2.2-3.3-2.2-5.4s.8-3.9 2.2-5.4c3-3 7.8-3 10.8 0 2.7 2.6 3 6.9.8 9.8zm-3.3-1.6c1.6-1.6 1.6-4.1 0-5.7-.8-.8-1.8-1.2-2.8-1.2-1 0-2.1.4-2.8 1.2-.8.8-1.2 1.8-1.2 2.8 0 1.1.4 2.1 1.2 2.8 1.5 1.7 4 1.7 5.6.1zm-28.7 6.7c-1 0-1.8-.8-1.8-1.8v-3.6c0-2-1.6-3.6-3.6-3.6s-3.6 1.6-3.6 3.6v21.7c0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6v-3.3c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v3.3c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2V32.9c0-4 3.2-7.2 7.2-7.2s7.2 3.2 7.2 7.2v3.6c0 1-.8 1.8-1.8 1.8zm1.3 4.2c.3.3.5.8.5 1.3s-.2.9-.5 1.3c-.3.3-.8.5-1.3.5s-.9-.2-1.3-.5c-.3-.3-.5-.8-.5-1.3s.2-.9.5-1.3c.3-.3.8-.5 1.3-.5s.9.2 1.3.5z"/><path d="M100.6 110.4c-.5 0-1-.2-1.3-.6L.7 3.2C0 2.5 0 1.4.8.7 1.5 0 2.6 0 3.3.8L102 107.4c.7.7.6 1.9-.1 2.5-.4.4-.8.5-1.3.5z" fill="#f92251"/></svg>';var analysis='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 59"><path d="M58.193359 27.97763c-.334295-.44552-.900095-1.17303-1.69625-2.10773-1.314363-1.54306-3.4568-3.88012-6.198687-6.25094-4.361852-3.77145-10.94208-8.19918-18.438537-8.99733l5.55084-5.55109H43.8544c.63644 0 1.152344-.51593 1.152344-1.1524 0-.63646-.515904-1.15239-1.152344-1.15239h-6.920976c-.305602 0-.598758.12146-.814822.33754l-7.405883 7.40587c-8.155828.29236-15.34991 5.0529-20.006647 9.06647-2.76067 2.37946-4.896078 4.71122-6.201222 6.24829-.81102.9551-1.372096 1.68457-1.700168 2.12836-.674237.91235-.801686 1.15815-.801686 1.54778 0 .40887.14243.63739.806641 1.52243.33441.44574.900211 1.17337 1.696365 2.10796 1.314363 1.54317 3.456801 3.88023 6.198687 6.25094 4.361276 3.77098 10.940352 8.19814 18.435657 8.99698l-5.55084 5.5512H7.662395c-.493319-1.59975-1.985258-2.76563-3.744541-2.76563C1.757439 51.16417 0 52.92169 0 55.08209 0 57.24248 1.757439 59 3.917738 59c1.759399 0 3.251453-1.16588 3.744541-2.76563h14.404412c.305602 0 .598758-.12147.814823-.33754l7.405306-7.40564c8.157326-.29121 15.352676-5.05233 20.009989-9.06647 2.760785-2.37947 4.896078-4.71134 6.201222-6.24829.81102-.95511 1.372211-1.68457 1.700168-2.12847C58.872666 30.13572 59 29.8898 59 29.50006c0-.40887-.14243-.63739-.806641-1.52243zM3.917738 56.69555c-.889609 0-1.613166-.7237-1.613166-1.61323 0-.88965.723672-1.61324 1.613166-1.61324.88961 0 1.613166.7237 1.613166 1.61324.000116.88953-.723556 1.61323-1.613166 1.61323zm44.430918-18.63826c-4.411402 3.71497-11.262201 8.14363-18.847158 8.14363-7.587031 0-14.456037-4.46692-18.882305-8.21405-4.15708-3.51953-7.075966-7.13759-8.081847-8.49972.973384-1.33989 3.874179-4.97051 8.117109-8.54363 4.411518-3.71509 11.262316-8.14375 18.847158-8.14375 7.587032 0 14.456037 4.4668 18.882305 8.21416 4.157195 3.51942 7.076197 7.13748 8.081963 8.49973-.9735 1.33966-3.874065 4.97028-8.117225 8.54363zm-7.963617-19.44103c-5.998986-5.99903-15.759799-5.99903-21.758785.00011-2.387426 2.38754-3.894692 5.41281-4.358856 8.74841-.448953 3.22602.150497 6.57373 1.687608 9.4266.301799.56018 1.000695.7698 1.560965.46799.560269-.30193.769765-1.00097.467851-1.56104-2.717226-5.04311-1.782791-11.39719 2.272076-15.45224 5.100274-5.10062 13.399108-5.10062 18.499497-.00011 5.100388 5.10061 5.100388 13.39982 0 18.50044-4.055098 4.05516-10.409237 4.98964-15.451778 2.27195-.560039-.30159-1.259051-.09243-1.560965.46787-.301914.56029-.092418 1.25922.467852 1.56115 2.234971 1.20425 4.773699 1.833 7.319687 1.833.703737 0 1.408164-.04806 2.106715-.1452 3.33569-.46419 6.360707-1.97152 8.748133-4.35905 5.998871-5.99938 5.998871-15.76074 0-21.75988zm-20.12868 20.12878c-.449875-.4499-1.179539-.4499-1.629529 0l-.009219.00921c-.44999.45002-.44999 1.17971 0 1.62972.225053.22495.519938.33754.814823.33754.294884 0 .589884-.11259.814822-.33754l.009219-.00922c.449875-.44989.449875-1.17959-.000116-1.62971zm15.697918-10.39715c-.636439 0-1.152343.51593-1.152343 1.1524 0 2.92282-2.377862 5.30079-5.300551 5.30079-2.92269 0-5.300551-2.37797-5.300551-5.30079s2.377861-5.30079 5.300551-5.30079c.636439 0 1.152344-.51593 1.152344-1.1524 0-.63646-.515905-1.15239-1.152344-1.15239-4.193494 0-7.605123 3.41178-7.605123 7.60546 0 4.19369 3.411629 7.60547 7.605123 7.60547 4.193494 0 7.605123-3.41178 7.605123-7.60547 0-.63635-.515904-1.15228-1.152229-1.15228zM48.867902 3.10363c.214336.21435.337637.51167.337637.81475s-.123301.60039-.337637.81474c-.214336.21434-.51164.33765-.814707.33765-.303066 0-.600371-.12331-.814707-.33765-.214336-.21435-.337636-.51166-.337636-.81474s.1233-.6004.337636-.81475c.214336-.2155.511641-.33765.814707-.33765.303067 0 .600371.12215.814707.33765zM55.082262 0C57.242561 0 59 1.75763 59 3.91803s-1.757439 3.91791-3.917738 3.9178c-2.160184 0-3.917739-1.75752-3.917739-3.91792C51.164523 1.75752 52.921963 0 55.082262 0zm0 5.53127c.889494 0 1.613166-.72371 1.613166-1.61324s-.723557-1.61324-1.613166-1.61324c-.889379 0-1.613166.72371-1.613166 1.61324s.723556 1.61324 1.613166 1.61324zM9.566873 8.46942c.636439 0 1.152229.51592 1.152344 1.15239 0 .63647-.515905 1.1524-1.152344 1.1524H1.155225c-.63644 0-1.152344-.51593-1.152344-1.1524 0-.63647.515904-1.15239 1.152344-1.15239h8.411648zm0-5.53127c.636439 0 1.152229.51593 1.152344 1.15239 0 .63647-.515905 1.1524-1.152344 1.1524H1.155225c-.63644 0-1.152344-.51593-1.152344-1.1524 0-.63646.515904-1.15239 1.152344-1.15239h8.411648zm11.569647 0c.636439 0 1.152343.51593 1.152343 1.15239 0 .63647-.515904 1.1524-1.152343 1.1524h-6.845268c-.636439 0-1.152344-.51593-1.152344-1.1524 0-.63646.515905-1.15239 1.152344-1.15239h6.845268zm36.711136 45.28833c.63644 0 1.152344.51605 1.152344 1.1524 0 .63635-.515904 1.1524-1.152344 1.1524h-8.258041c-.636439 0-1.152344-.51605-1.152344-1.1524 0-.63635.515905-1.1524 1.152344-1.1524h8.258041zm-23.621894 5.53127c.636439 0 1.152459.51605 1.152459 1.1524 0 .63635-.515905 1.15239-1.152344 1.15239h-3.332693c-.63644 0-1.152344-.51604-1.152344-1.15239s.515904-1.1524 1.152344-1.1524h3.332578zm10.601101 0c.63644 0 1.152344.51605 1.152344 1.1524 0 .63635-.515904 1.15239-1.152344 1.15239h-5.761488c-.636439 0-1.152344-.51604-1.152344-1.15239s.515905-1.1524 1.152344-1.1524h5.761488zm13.020793 0c.63644 0 1.152344.51605 1.152344 1.1524 0 .63635-.515904 1.15239-1.152344 1.15239h-8.258041c-.636439 0-1.152344-.51604-1.152344-1.15239s.515905-1.1524 1.152344-1.1524h8.258041zM13.26048 46.32411c.63644 0 1.152459.51604 1.152459 1.1524 0 .63635-.515904 1.15239-1.152343 1.15239H1.152344C.515904 48.6289 0 48.11286 0 47.47651c0-.63636.515904-1.1524 1.152344-1.1524H13.26048zm-5.882945-4.60935c.63644 0 1.152344.51604 1.152344 1.15239 0 .63636-.515904 1.1524-1.152344 1.1524H1.152344C.515904 44.01955 0 43.50351 0 42.86715c0-.63635.515904-1.15239 1.152344-1.15239h6.225191z" fill="#000" fill-rule="nonzero"/></svg>';var click='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 65"><path d="M64.710938 0C65.422758 0 66 .57955 66 1.29464v51.78045c0 .71483-.577242 1.29451-1.289062 1.29451h-9.201715l2.251734 4.00768c.349852.62266.13084 1.41218-.489199 1.76351-.200063.1134-.417656.16738-.632285.16738-.450012 0-.886875-.23702-1.123805-.65864l-6.033973-10.7394-5.998136 3.47771 3.466804 5.82918c.365063.61386.165516 1.40869-.445629 1.77516-.207023.12428-.434929.18344-.659742.18344-.438926 0-.866637-.22512-1.107949-.63095l-3.486398-5.86219-7.606114 4.40988c-.199418.11573-.42191.17346-.644531.17346-.222621 0-.445113-.05773-.644531-.17346-.398836-.2312-.644531-.65865-.644531-1.12105v-2.60184H1.289062C.577242 54.36947 0 53.78979 0 53.07496V1.29451C0 .57968.577242 0 1.289062 0h63.421876zM34.289062 54.72909l21.82009-12.65113-21.82009-12.65113v25.30226zm-1.1773-39.19431c.711949.00829 1.28223.5947 1.273851 1.30953-.008121.70978-.583687 1.27937-1.288676 1.27937-.005156 0-.010183 0-.015339-.00013L33 18.12316c-.71182 0-1.289062-.57968-1.289062-1.29451 0-.71483.577242-1.29451 1.289062-1.29451.037254 0 .074508.00012.111762.00064zm30.310113 36.24567V2.58902H2.578125v49.19143h29.132941V38.7631c-2.234332-.24919-4.279043-1.13787-5.94825-2.47963l-4.633921 4.65351c.498093.82214.785167 1.78681.785167 2.81763 0 2.99796-2.428722 5.43695-5.414062 5.43695-2.98534 0-5.414062-2.43899-5.414062-5.43695 0-2.99796 2.428722-5.43695 5.414062-5.43695 1.02648 0 1.986961.28829 2.805773.78849l4.633922-4.65351c-1.589285-1.99393-2.541257-4.52121-2.541257-7.2679 0-2.69142.921035-5.242 2.536488-7.27257l-4.629153-4.64872c-.818683.5002-1.779293.78849-2.805773.78849-2.98534 0-5.414062-2.43899-5.414062-5.43695 0-2.99796 2.428722-5.43694 5.414062-5.43694 2.98534 0 5.414062 2.43898 5.414062 5.43694 0 1.03082-.287074 1.99536-.785296 2.81764l4.629797 4.64936c.535863-.42978 1.113105-.81645 1.729535-1.15121.625968-.34045 1.4083-.10589 1.747066.52286.338637.62887.105574 1.41438-.520652 1.75445-2.922434 1.5872-4.73795 4.64367-4.73795 7.97665 0 4.55694 3.367547 8.3373 7.734376 8.96759v-8.96759c0-.4624.245695-.88985.644531-1.12105.398836-.23133.890226-.23133 1.289062 0l7.735406 4.48483c.422813-1.06395.643501-2.20766.643501-3.36378 0-3.28612-1.778004-6.32188-4.640368-7.9228-.621843-.34797-.845367-1.13632-.498867-1.76092.346629-.62461 1.131797-.84869 1.753512-.50098.568992.31832 1.104469.68104 1.603594 1.08195l4.629796-4.64936c-.498093-.82215-.785167-1.78682-.785167-2.81764 0-2.99796 2.428722-5.43694 5.414062-5.43694 2.98534 0 5.414062 2.43898 5.414062 5.43694S52.48534 16.05194 49.5 16.05194c-1.02648 0-1.986961-.28829-2.805773-.78849l-4.631731 4.65131c1.615711 2.03329 2.539066 4.5862 2.539066 7.26998 0 1.61102-.333867 3.20378-.970921 4.66878l15.701296 9.10339c.398836.2312.644532.65865.644532 1.12105 0 .4624-.245696.88985-.644532 1.12105l-7.617457 4.41648 2.340165 4.16496h9.36723zM46.664062 10.61499c0 1.57037 1.272176 2.84793 2.835938 2.84793s2.835938-1.27756 2.835938-2.84793c0-1.57037-1.272176-2.84792-2.835938-2.84792s-2.835938 1.27755-2.835938 2.84792zm-27.328124 0c0-1.57037-1.272176-2.84792-2.835938-2.84792s-2.835938 1.27755-2.835938 2.84792c0 1.57037 1.272176 2.84793 2.835938 2.84793s2.835938-1.27756 2.835938-2.84793zm0 33.13949c0-1.57037-1.272176-2.84792-2.835938-2.84792s-2.835938 1.27755-2.835938 2.84792c0 1.57037 1.272176 2.84793 2.835938 2.84793s2.835938-1.27756 2.835938-2.84793zm30.120234 19.03579c.239766.24078.377695.57476.377695.91522s-.138058.67444-.377695.91509c-.239766.24091-.571055.37942-.911367.37942-.339024 0-.671602-.13864-.911367-.37942-.239766-.24065-.377696-.57463-.377696-.91509s.138059-.67444.377696-.91522c.239765-.24091.572343-.37929.911367-.37929.340183 0 .671601.13838.911367.37929z" fill="#000" fill-rule="nonzero"/></svg>';var cpu='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 66"><path d="M37.55775 27.07031h-9.260815c-.710381 0-1.286224.57724-1.286224 1.28907v9.28124c0 .71183.575843 1.28907 1.286224 1.28907h9.260815c.710382 0 1.286225-.57724 1.286225-1.28907v-9.28124c0-.71183-.575843-1.28907-1.286225-1.28907zm15.889244 7.21875h-7.914653v5.41406h9.007558c.710382 0 1.286224.57725 1.286224 1.28907v16.43709c1.783479.55301 3.082951 2.22106 3.082951 4.18791 0 2.41673-1.961749 4.38281-4.373162 4.38281-2.411414 0-4.373163-1.96608-4.373163-4.38281 0-1.96969 1.303331-3.63967 3.090926-4.19023V42.28125h-7.721334v2.0625c0 .71182-.575842 1.28906-1.286224 1.28906h-10.03255v7.93199c1.785537.55172 3.086939 2.2208 3.086939 4.18907 0 2.41673-1.96175 4.38281-4.373163 4.38281-2.411414 0-4.373163-1.96608-4.373163-4.38281 0-1.96827 1.301402-3.63722 3.086939-4.18907v-7.93199h-5.402143v9.02731c0 .71182-.575842 1.28906-1.286224 1.28906h-8.49191c-.710382 0-1.286225-.57724-1.286225-1.28906 0-.71182.575843-1.28907 1.286225-1.28907h7.205686v-7.73824h-2.057959c-.710382 0-1.286225-.57724-1.286225-1.28906V34.28906h-7.914652c-.550504 1.78961-2.215908 3.09375-4.179844 3.09375-2.411413 0-4.373162-1.96608-4.373162-4.38281 0-2.41673 1.961749-4.38281 4.373162-4.38281 1.963808 0 3.629211 1.30414 4.179844 3.09375h7.914652v-5.41406l-4.630407-4.17987c-.710382 0-1.780556-2.28997-1.780556-3.00179l-3.882819-10.5445c-1.783478-.55301-3.082951-2.22106-3.082951-4.18791C6.945611 1.96608 8.907361 0 11.318774 0c2.411413 0 4.373163 1.96608 4.373163 4.38281 0 1.96969-1.303331 3.63967-3.090926 4.19023l3.859831 11.79415 3.861502 3.35156v-2.0625c0-.71182.575843-1.28906 1.286225-1.28906h10.03255V12.4352c-1.785537-.55172-3.086939-2.2208-3.086939-4.18907 0-2.41673 1.961749-4.38281 4.373163-4.38281 2.411413 0 4.373163 1.96608 4.373163 4.38281 0 1.96827-1.301402 3.63722-3.086939 4.18907v7.93199h5.402142v-9.02731c0-.71182.575843-1.28906 1.286225-1.28906h8.49191c.710382 0 1.286224.57724 1.286224 1.28906 0 .71182-.575842 1.28907-1.286224 1.28907h-7.205686v7.73824h2.057959c.710382 0 1.286224.57724 1.286224 1.28906v10.05469h7.914653c.550504-1.78961 2.215907-3.09375 4.179843-3.09375C60.038122 28.61719 62 30.58327 62 33c0 2.41673-1.961749 4.38281-4.373163 4.38281-1.963807 0-3.62921-1.30414-4.179843-3.09375zm4.179843-3.09375c-.992965 0-1.800714.80953-1.800714 1.80469 0 .99516.807749 1.80469 1.800714 1.80469.992837 0 1.800714-.80953 1.800714-1.80469 0-.99516-.807749-1.80469-1.800714-1.80469zM11.318774 6.1875c.992965 0 1.800714-.80953 1.800714-1.80469 0-.99515-.807749-1.80469-1.800714-1.80469-.992965 0-1.800714.80954-1.800714 1.80469 0 .99516.807749 1.80469 1.800714 1.80469zM8.227848 34.80469c.992966 0 1.800714-.80953 1.800714-1.80469 0-.99516-.807748-1.80469-1.800714-1.80469-.992965 0-1.800714.80953-1.800714 1.80469 0 .99516.807749 1.80469 1.800714 1.80469zM31.126629 8.24613c0 .99516.807749 1.80469 1.800714 1.80469.992965 0 1.800714-.80953 1.800714-1.80469 0-.99515-.807749-1.80468-1.800714-1.80468-.992965 0-1.800714.80953-1.800714 1.80468zm3.601428 49.50774c0-.99516-.807749-1.80469-1.800714-1.80469-.992965 0-1.800714.80953-1.800714 1.80469 0 .99515.807749 1.80468 1.800714 1.80468.992965 0 1.800714-.80953 1.800714-1.80468zm1.543469-21.40231H29.58316v-6.70312h6.688366v6.70312zm6.688367 6.70313V22.94531h-20.0651v20.10938h20.0651zM54.535912 59.8125c-.992966 0-1.800714.80953-1.800714 1.80469 0 .99515.807748 1.80469 1.800714 1.80469.992965 0 1.800714-.80954 1.800714-1.80469 0-.99516-.807749-1.80469-1.800714-1.80469zM4.373163 50.27344c2.411413 0 4.373162 1.96608 4.373162 4.38281 0 2.41673-1.961749 4.38281-4.373162 4.38281C1.961749 59.03906 0 57.07298 0 54.65625c0-2.41673 1.961749-4.38281 4.373163-4.38281zm0 6.1875c.992965 0 1.800714-.80953 1.800714-1.80469 0-.99516-.807749-1.80469-1.800714-1.80469-.992965 0-1.800714.80953-1.800714 1.80469 0 .99516.807749 1.80469 1.800714 1.80469zm8.433773-2.71219c.239237.23964.376863.57221.376863.91137 0 .33902-.137626.6716-.376863.91124-.239238.23989-.571084.37782-.909361.37782-.338277 0-.670123-.13806-.909361-.37782-.239237-.23964-.376863-.57222-.376863-.91124 0-.33916.137626-.67173.376863-.91137.239238-.23989.571084-.3777.909361-.3777.338277 0 .670123.13793.909361.3777z" fill="#000" fill-rule="nonzero"/></svg>';var monitor='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 60"><path d="M57.943359 0c2.52334 0 4.576172 2.08624 4.576172 4.65066v2.90986c0 .72341-.577242 1.31005-1.289062 1.31005-.711821 0-1.289063-.58664-1.289063-1.31005V4.65066c0-1.1197-.896285-2.03057-1.998047-2.03057H38.28348c-.71182 0-1.289062-.58664-1.289062-1.31005C36.994418.58664 37.57166 0 38.28348 0h19.659879zM33.911238.38384c.239895.24367.377824.58166.377824.9262 0 .34455-.137929.68254-.377824.92607-.239636.2438-.572215.38398-.911238.38398-.339023 0-.671602-.14018-.911367-.38398-.239895-.24353-.377695-.58152-.377695-.92607 0-.34454.137929-.6824.377695-.9262C32.328398.14004 32.660977 0 33 0c.339023 0 .671602.14004.911238.38384zM27.713168 0c.71182 0 1.289062.58664 1.289062 1.31004 0 .72341-.577242 1.31005-1.289062 1.31005H8.056641c-1.101762 0-1.998047.91087-1.998047 2.03057v14.9193c2.005523.57314 3.480468 2.44703 3.480468 4.66585 0 2.67275-2.139585 4.84716-4.769531 4.84716C2.139586 29.08297 0 26.90856 0 24.23581c0-2.21882 1.474945-4.09271 3.480469-4.66585V4.65066C3.480469 2.08624 5.533301 0 8.056641 0h19.656527zM6.960938 24.23581c0-1.22804-.98304-2.22708-2.191407-2.22708s-2.191406.99904-2.191406 2.22708c0 1.22803.983039 2.22707 2.191406 2.22707 1.208367 0 2.191407-.99904 2.191407-2.22707zm54.269531-11.65939C63.860414 12.57642 66 14.75083 66 17.42358c0 2.21882-1.474945 4.09271-3.480469 4.66585V41.9869c0 2.56441-2.052832 4.65065-4.576172 4.65065H39.1875v10.74236h4.370051c.71182 0 1.289062.58664 1.289062 1.31005 0 .7234-.577242 1.31004-1.289062 1.31004h-21.11536c-.71182 0-1.289062-.58664-1.289062-1.31004 0-.72341.577242-1.31005 1.289062-1.31005H26.8125V46.63755H8.056641c-2.52334 0-4.576172-2.08624-4.576172-4.65065v-7.79476c0-.72341.577242-1.31004 1.289062-1.31004.711821 0 1.289063.58663 1.289063 1.31004v1.22319h53.882812v-13.3259c-2.005523-.57314-3.480468-2.44703-3.480468-4.66585 0-2.67275 2.139585-4.84716 4.769531-4.84716zM36.609375 57.37991V46.63755h-7.21875v10.74236h7.21875zM33.108797 39.5362c.71182 0 1.294476.58664 1.294476 1.31004 0 .72341-.571828 1.31005-1.283648 1.31005h-.010828c-.71182 0-1.289063-.58664-1.289063-1.31005 0-.7234.577243-1.31004 1.289063-1.31004zm26.832609 2.4507v-3.95149H6.058594v3.95149c0 1.11969.896285 2.03057 1.998047 2.03057h49.886718c1.101762 0 1.998047-.91088 1.998047-2.03057zm1.289063-22.33624c1.208367 0 2.191406-.99904 2.191406-2.22708 0-1.22803-.983039-2.22707-2.191406-2.22707-1.208367 0-2.191407.99904-2.191407 2.22707 0 1.22804.98304 2.22708 2.191407 2.22708zm-13.396711 10.6251c.503379.51171.503379 1.34123 0 1.8528-.251754.25572-.581625.38371-.911496.38371s-.659742-.12799-.911496-.38371l-7.560481-7.68354c-1.694988 1.32288-3.813562 2.11166-6.11093 2.11166-3.60525 0-6.95475-1.97947-8.74139-5.16576-.352559-.62869-.13677-1.42874.481723-1.7869.618492-.35778 1.40598-.13926 1.758281.48956 1.329152 2.37039 3.820265 3.84288 6.501386 3.84288 4.122551 0 7.476563-3.4086 7.476563-7.59825s-3.354012-7.59825-7.476563-7.59825c-2.590628 0-4.960441 1.33349-6.338964 3.56711-.378211.61271-1.173434.79821-1.777102.41345-.603023-.38436-.785297-1.19292-.406957-1.80589 1.853285-3.00223 5.039461-4.79476 8.523023-4.79476 5.544258 0 10.054688 4.58384 10.054688 10.21834 0 2.35716-.791484 4.52856-2.115609 6.25926l7.555324 7.67829zm-24.25268-15.42327c.719426.00354 1.283004.58585 1.283004 1.3255 0 .00825-.000129.01677-.000258.02502-.013793.73297-.578015 1.30035-1.28816 1.30035-.006445 0-.012891 0-.019465-.00013-.719426-.01048-1.277461-.59816-1.270629-1.33795.00709-.73729.572602-1.31279 1.288934-1.31279h.006574z" fill="#000" fill-rule="nonzero"/></svg>';var plug='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66"><path d="M14.439092 51.88799c-1.031638-1.03966-2.403202-1.61217-3.861907-1.61217-.861739 0-1.692412.20136-2.441229.57914C.777591 40.3487.752068 25.95155 8.198217 15.41983c.413017-.58433.277923-1.39548-.301898-1.81184-.579821-.41636-1.384713-.28021-1.797858.30412C1.991116 19.72151-.115988 26.58174.004926 33.75102c.115113 6.82269 2.24078 13.29475 6.157086 18.78899-1.556158 2.15129-1.371951 5.19142.553266 7.13187 1.064767 1.07291 2.463273 1.60944 3.861907 1.60944 1.398635 0 2.79714-.53653 3.861907-1.60944 2.129405-2.1461 2.129405-5.63779 0-7.78389zm-1.823123 5.94658c-1.124451 1.13294-2.953504 1.13294-4.077696 0-1.124322-1.13306-1.124322-2.9766 0-4.10953.544629-.54887 1.268696-.85117 2.038783-.85117s1.494283.3023 2.038784.85117c1.124451 1.13306 1.124451 2.9766.000129 4.10953zm39.972976.51652c.416883.58148.287203 1.39354-.289911 1.81379-3.999192 2.9123-8.494546 4.84158-13.361021 5.73431-.368156.06755-.73786.10081-1.105114.10081-1.42158 0-2.805519-.4982-3.916048-1.43199-1.391416-1.17009-2.189475-2.88878-2.189475-4.71556v-9.52206h-.145278c-1.492607 0-2.707035-1.22375-2.707035-2.72809v-2.19338c-4.366446-1.67973-7.476571-5.94412-7.476571-10.92742v-6.15054c-2.077456-.57186-3.60938-2.48944-3.60938-4.76181 0-2.50179 1.856639-4.57331 4.253912-4.8925v-8.09839c0-2.14896 1.734822-3.89727 3.867192-3.89727s3.867192 1.74831 3.867192 3.89727v8.05435h6.445321v-8.05435c0-2.14896 1.734822-3.89727 3.867192-3.89727s3.867192 1.74831 3.867192 3.89727v8.09839c2.397273.31919 4.253912 2.39084 4.253912 4.8925 0 2.27237-1.531924 4.18995-3.609379 4.76181v6.15054c0 4.9833-3.110125 9.24769-7.476572 10.92742v2.19325c0 1.50434-1.214428 2.72809-2.707035 2.72809h-.112535v9.52206c0 1.05395.460325 2.04568 1.263154 2.72068.80863.67995 1.868498.96068 2.907742.76997 4.485169-.82271 8.627835-2.60051 12.313011-5.28404.577372-.42026 1.383037-.28931 1.799534.29216zM38.800986 10.57826v8.05435h2.578128v-8.05435c0-.71632-.578274-1.29909-1.289064-1.29909s-1.289064.58277-1.289064 1.29909zm-14.179705 0v8.05435h2.578128v-8.05435c0-.71632-.578274-1.29909-1.289064-1.29909s-1.289064.58277-1.289064 1.29909zm-4.253912 12.99089c0 1.28935 1.04092 2.33836 2.320316 2.33836H43.31271c1.279396 0 2.320316-1.04901 2.320316-2.33836 0-1.28935-1.04092-2.33836-2.320316-2.33836H22.687685c-1.279396 0-2.320316 1.04901-2.320316 2.33836zm3.60938 10.91235c0 5.01422 4.047919 9.09362 9.023449 9.09362 4.975529 0 9.023448-4.0794 9.023448-9.09362v-5.97581H23.976749v5.97581zm9.072304 13.25071h1.369115c.071156 0 .128906-.05833.128906-.12991v-1.53319c-.506215.06834-1.022485.10419-1.546876.10419-.524392 0-1.040662-.03585-1.546877-.10419v1.53319c0 .07158.05775.12991.129164.12991h1.401857c.010828-.00026.021527-.00169.032356-.00169.010828 0 .021527.00143.032355.00169zm23.253685 7.09783c.520395.48963.548626 1.31156.062778 1.83613-.009411.01001-.019336.0204-.029262.03053-.250981.25566-.583173.38492-.916138.38492-.315047 0-.630739-.11562-.879271-.34932-.520395-.48963-.548625-1.31156-.062777-1.83613.00941-.01001.019336-.0204.029262-.03053.488555-.49768 1.284552-.51626 1.795408-.0356zm9.609844-24.07589c.568606 7.87053-1.650646 15.69443-6.24848 22.03061-.252528.34802-.644403.53236-1.041564.53236-.264129 0-.530579-.08145-.760032-.25059-.574665-.42364-.699833-1.23635-.279598-1.81548 8.901632-12.26652 7.610119-28.98255-3.07068-39.74693C44.176899 1.08776 27.355128-.33487 15.383203 8.19456c-.581239.41428-1.385873.27489-1.796698-.31087-.410953-.58576-.272894-1.39652.308473-1.81067C20.155705 1.61246 27.872172-.50791 35.625505.10305c7.848983.61824 15.203867 4.01484 20.709718 9.5639 5.601628 5.64545 9.003081 13.13444 9.577359 21.0872zM11.332061 9.81712c.505571.50509.509309 1.32767.008121 1.83717l-.021011.02157c-.252141.25618-.583946.38453-.915623.38453-.328066 0-.656133-.12536-.907501-.37635-.505571-.50508-.509309-1.32767-.008121-1.83717l.021012-.02156c.501188-.50977 1.317423-.51315 1.823123-.00819zM35.90665 34.00045c.231001.39934.234094.89221.007993 1.29441l-2.668492 4.74817c-.237188.42194-.673536.65903-1.123033.65916-.215402 0-.433383-.05444-.634219-.16901-.619267-.35349-.837118-1.14619-.486235-1.77053l1.578588-2.80889h-1.374143c-.494356 0-.945141-.28489-1.160415-.73334-.215274-.44845-.157137-.98146.14966-1.3721l3.350536-4.2653c.441891-.56237 1.252712-.6576 1.810877-.21214.558165.4452.652524 1.26233.210633 1.82483l-1.696666 2.15987h.921165c.458649 0 .882751.24553 1.113751.64487z" fill="#000" fill-rule="nonzero"/></svg>';/* harmony default export */ __webpack_exports__["a"] = ({check:check,improve11:improve11,improve12:improve12,improve13:improve13,improve14:improve14,improve15:improve15,improve16:improve16,improve21:improve21,improve22:improve22,improve23:improve23,improve31:improve31,improve32pl:improve32pl,improve32en:improve32en,improve32de:improve32de,improve33:improve33,improve43:improve43,decrease11:decrease11,decrease12:decrease12,decrease13:decrease13,decrease21:decrease21,decrease22:decrease22,decrease23:decrease23,decrease33:decrease33,common1:common1,common2:common2,buttonPower:buttonPower,analysis:analysis,click:click,cpu:cpu,monitor:monitor,plug:plug});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderPlaceholder__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HeaderMenu__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HeaderLanguage__ = __webpack_require__(260);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const SAGITON_URL = 'https://www.sagiton.pl';
var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={menuOpen:false,small:false};_this.scroll=_this.scroll.bind(_this);_this.resize=_this.resize.bind(_this);_this.updateBodyClass=_this.updateBodyClass.bind(_this);_this.menuTriggerClick=_this.menuTriggerClick.bind(_this);_this.closeMenu=_this.closeMenu.bind(_this);_this.previousWindowWidth=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();return _this;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.scroll);window.addEventListener('resize',this.resize);this.updateBodyClass();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateBodyClass();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.scroll);window.removeEventListener('resize',this.resize);}},{key:'scroll',value:function scroll(){var scrollTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var windowHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();var small=scrollTop>windowHeight/2;this.setState({small:small});}},{key:'resize',value:function resize(){// this prevent an ios bug when resize event is triggered randomly on scroll
if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width()!==this.previousWindowWidth){this.previousWindowWidth=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();this.updateBodyClass();this.setState({menuOpen:false});this.scroll();}}},{key:'updateBodyClass',value:function updateBodyClass(){if((this.props.breakpoint==='phone'||this.props.breakpoint==='tablet')&&this.state.menuOpen){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').addClass('mobile-menu-open');}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').removeClass('mobile-menu-open');}}},{key:'menuTriggerClick',value:function menuTriggerClick(){this.setState({menuOpen:!this.state.menuOpen});}},{key:'closeMenu',value:function closeMenu(){this.setState({menuOpen:false});}},{key:'render',value:function render(){var _state=this.state,menuOpen=_state.menuOpen,small=_state.small;var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language,page=_props.page,subpage=_props.subpage,noTransition=_props.noTransition;// const menuHeight = $('.header-menu-main').outerHeight(true) + $('.header-language').outerHeight(true) + $('.header-contact').outerHeight(true);
var containerClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-header',{'container-header--small':small});var triggerClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('header-menu-trigger',{active:menuOpen});var headerMenuContainerClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('header-menu-container',{open:menuOpen});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HeaderPlaceholder__["a" /* default */],{key:'header-placeholder'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:containerClassName,id:'header-menu-container',key:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-header',{'no-transition':noTransition}),id:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-cover',id:'header-cover'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-logo-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('header-logo',{'no-transition':noTransition}),id:'header-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,t('header.logo')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:triggerClassName,id:triggerClassName,onClick:this.menuTriggerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line line-1',id:'line-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line line-2a',id:'line-2a'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line line-2b',id:'line-2b'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line line-3',id:'line-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:page,subpage:subpage,query:{video:''},className:'header-video-mobile'},t('header.menu.video')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:headerMenuContainerClassName,id:headerMenuContainerClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-menu-mobile',id:'header-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'header-menu',id:'header-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HeaderMenu__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,closeMenu:this.closeMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:page,subpage:subpage,query:{video:''},className:'header-button'},t('header.menu.video'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__HeaderLanguage__["a" /* default */],{openPage:openPage,language:language,page:page,subpage:subpage,closeMenu:this.closeMenu}))))))];}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Header.defaultProps={subpage:null};Header.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,noTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HeaderPlaceholder=function HeaderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container-header-placeholder",id:"container-header-placeholder"});};/* harmony default export */ __webpack_exports__["a"] = (HeaderPlaceholder);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Link__ = __webpack_require__(8);
// import { LANG_PL, LANG_EN } from '../../config/languages';
var HeaderMenu=function HeaderMenu(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,closeMenu=_ref.closeMenu;return(// TODO
// 04.12.2023 the scanner link was hidden for testing it *
// const blogLanguage = (language === LANG_PL || language === LANG_EN) ? `${ language }/` : '';
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'header-menu-main',id:'header-menu-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({active:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]}),id:'menu-item-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */],callback:closeMenu,id:'menu-link-threats',className:'link'},t('header.menu.threats'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({active:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]}),id:'menu-item-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */],callback:closeMenu,id:'menu-link-offer',className:'link'},t('header.menu.offer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({active:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */]}),id:'menu-item-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */],callback:closeMenu,id:'menu-link-estimation',className:'link'},t('header.menu.estimation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({active:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */]}),id:'menu-item-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */],callback:closeMenu,id:'menu-link-about',className:'link'},t('header.menu.about'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({active:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["c" /* PAGE_CONTACT */]}),id:'menu-item-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["c" /* PAGE_CONTACT */],callback:closeMenu,id:'menu-link-contact',className:'link'},t('header.menu.contact')))));};HeaderMenu.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,closeMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HeaderMenu);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_languages__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Link__ = __webpack_require__(8);
var HeaderLanguage=function HeaderLanguage(_ref){var openPage=_ref.openPage,language=_ref.language,page=_ref.page,subpage=_ref.subpage,closeMenu=_ref.closeMenu;if(__WEBPACK_IMPORTED_MODULE_3__config_languages__["a" /* AVAILABLE_LANGUAGES */].length<=1){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'header-language'},__WEBPACK_IMPORTED_MODULE_3__config_languages__["a" /* AVAILABLE_LANGUAGES */].map(function(lang){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({active:lang===language}),key:lang,id:lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:lang,page:page,subpage:subpage,callback:closeMenu,scroll:false,className:'link'},lang.toUpperCase()));}));};HeaderLanguage.defaultProps={subpage:null};HeaderLanguage.propTypes={openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,closeMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HeaderLanguage);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var nextPage=function nextPage(page){switch(page){case __WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */];case __WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */];case __WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */];case __WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["c" /* PAGE_CONTACT */];default:return null;}};var prevPage=function prevPage(page){switch(page){case __WEBPACK_IMPORTED_MODULE_3__config_pages__["c" /* PAGE_CONTACT */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */];case __WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */];case __WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */];case __WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]:return __WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */];default:return null;}};var Switch=function(_Component){_inherits(Switch,_Component);function Switch(props){_classCallCheck(this,Switch);var _this=_possibleConstructorReturn(this,(Switch.__proto__||Object.getPrototypeOf(Switch)).call(this,props));_this.state={localNoTransition:true};return _this;}_createClass(Switch,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.setState({localNoTransition:false});},100);}},{key:'render',value:function render(){var localNoTransition=this.state.localNoTransition;var _props=this.props,type=_props.type,t=_props.t,openPage=_props.openPage,language=_props.language,page=_props.page,noTransition=_props.noTransition;var newPage=type==='prev'?prevPage(page):nextPage(page);var className=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-switch','container-switch-'+type,'has-transition',{show:newPage!==null,'no-transition':noTransition||(page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["k" /* PAGE_WEBINAR */]||page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["d" /* PAGE_EBOOK */])&&localNoTransition});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:newPage,className:className,id:className},newPage&&t('header.menu.'+newPage));}}]);return Switch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Switch.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev','next']).isRequired,t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,noTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BackToTop=function(_Component){_inherits(BackToTop,_Component);_createClass(BackToTop,null,[{key:'backtoTopClick',value:function backtoTopClick(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').animate({scrollTop:0},1000);}}]);function BackToTop(props){_classCallCheck(this,BackToTop);var _this=_possibleConstructorReturn(this,(BackToTop.__proto__||Object.getPrototypeOf(BackToTop)).call(this,props));_this.state={show:false};_this.scroll=_this.scroll.bind(_this);_this.updateTimer=null;return _this;}_createClass(BackToTop,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){var _this2=this;this.updateTimer=setTimeout(function(){_this2.scroll();},1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);clearTimeout(this.updateTimer);}},{key:'scroll',value:function scroll(){if(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.container-back-to-top').length>0){var winTop=__WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).height();var docHeight=__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).height();var scrollMoreThanOneWindow=winTop>winHeight;var scrollMoreThan90Percent=winTop+winHeight>=docHeight*0.9;var noScrollBar=winHeight===docHeight;this.setState({show:(scrollMoreThanOneWindow||scrollMoreThan90Percent)&&!noScrollBar});}}},{key:'render',value:function render(){var className=__WEBPACK_IMPORTED_MODULE_1_classnames___default()('container-back-to-top',{show:this.state.show});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,id:className,onClick:BackToTop.backtoTopClick});}}]);return BackToTop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BackToTop);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var prevOpen=function prevOpen(current,prev){var open=false;if(current!==prev){switch(current){case __WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]:{if(prev===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]){open=true;}else{open=false;}break;}case __WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["c" /* PAGE_CONTACT */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["i" /* PAGE_PRIVACY */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["g" /* PAGE_LEGAL */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["d" /* PAGE_EBOOK */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["k" /* PAGE_WEBINAR */]:{if(__WEBPACK_IMPORTED_MODULE_3__config_pages__["a" /* AVAILABLE_PAGES */].indexOf(current)>__WEBPACK_IMPORTED_MODULE_3__config_pages__["a" /* AVAILABLE_PAGES */].indexOf(prev)){open=true;}break;}default:{open=false;break;}}}return open;};var nextOpen=function nextOpen(current,next){var open=false;if(current!==next){switch(current){case __WEBPACK_IMPORTED_MODULE_3__config_pages__["f" /* PAGE_HOME */]:{if(next===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]||next===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]){open=false;}else{open=true;}break;}case __WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]:{if(next===__WEBPACK_IMPORTED_MODULE_3__config_pages__["f" /* PAGE_HOME */]){open=false;}else{open=true;}break;}case __WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]:{if(next===__WEBPACK_IMPORTED_MODULE_3__config_pages__["f" /* PAGE_HOME */]||next===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]){open=false;}else{open=true;}break;}case __WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["b" /* PAGE_ABOUT */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["c" /* PAGE_CONTACT */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["i" /* PAGE_PRIVACY */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["g" /* PAGE_LEGAL */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["d" /* PAGE_EBOOK */]:case __WEBPACK_IMPORTED_MODULE_3__config_pages__["k" /* PAGE_WEBINAR */]:{if(__WEBPACK_IMPORTED_MODULE_3__config_pages__["a" /* AVAILABLE_PAGES */].indexOf(current)<__WEBPACK_IMPORTED_MODULE_3__config_pages__["a" /* AVAILABLE_PAGES */].indexOf(next)){open=true;}break;}default:{open=false;break;}}}return open;};var Cover=function(_Component){_inherits(Cover,_Component);function Cover(props){_classCallCheck(this,Cover);var _this=_possibleConstructorReturn(this,(Cover.__proto__||Object.getPrototypeOf(Cover)).call(this,props));_this.state={open:false};return _this;}_createClass(Cover,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;var _props=this.props,type=_props.type,current=_props.page;var next=nextProps.page,firstLoad=nextProps.firstLoad;if(!firstLoad){var open=type==='prev'?prevOpen(current,next):nextOpen(current,next);this.setState({open:open});if(open===true){this.setState({open:open});setTimeout(function(){return _this2.setState({open:false});},1600);}}}},{key:'render',value:function render(){var open=this.state.open;var type=this.props.type;var coverClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-cover',{open:open,prev:type==='prev',next:type==='next'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:coverClassName,id:coverClassName});}}]);return Cover;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Cover.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev','next']).isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,firstLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Cover);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_copy_to_clipboard__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoModal=function(_Component){_inherits(VideoModal,_Component);function VideoModal(props){_classCallCheck(this,VideoModal);var _this=_possibleConstructorReturn(this,(VideoModal.__proto__||Object.getPrototypeOf(VideoModal)).call(this,props));_this.state={copied:false,isOpen:false};_this.copyClick=_this.copyClick.bind(_this);_this.shareUrl=_this.shareUrl.bind(_this);_this.encodedShareUrl=_this.encodedShareUrl.bind(_this);_this.utmContent='videopopup';return _this;}_createClass(VideoModal,[{key:'componentWillMount',value:function componentWillMount(){if(typeof this.props.query.video!=='undefined'){this.setState({isOpen:true});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(typeof nextProps.query.video!=='undefined'){this.setState({isOpen:true});}else{this.setState({isOpen:false});}}},{key:'shareUrl',value:function shareUrl(utmSource){var _props=this.props,page=_props.page,subpage=_props.subpage,language=_props.language;var slashedPage=page?'/'+page:__WEBPACK_IMPORTED_MODULE_4__config_pages__["f" /* PAGE_HOME */];var slashedSubpage=subpage?'/'+subpage:'';var domain='https://www.'+"lemlock.com"+'/';var path=''+""+language+slashedPage+slashedSubpage;var utm='?utm_medium=social&utm_campaign=share_from_www&utm_content='+this.utmContent+'&utm_source='+utmSource;return''+domain+path+utm+'&video';}},{key:'encodedShareUrl',value:function encodedShareUrl(utmSource){return encodeURIComponent(this.shareUrl(utmSource));}},{key:'copyClick',value:function copyClick(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3_copy_to_clipboard___default()(this.shareUrl('share'));this.setState({copied:true});setTimeout(function(){return _this2.setState({copied:false});},3000);}},{key:'render',value:function render(){var _state=this.state,copied=_state.copied,isOpen=_state.isOpen;var _props2=this.props,t=_props2.t,breakpoint=_props2.breakpoint,openPage=_props2.openPage,language=_props2.language,page=_props2.page,subpage=_props2.subpage;var isAndroid=/Android/i.test(navigator.userAgent);var smsSeparator=isAndroid?'?':'&';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-container',{open:isOpen})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:page,subpage:subpage,className:'modal-close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line line-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line line-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-video'},isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'title',src:'https://www.youtube.com/embed/'+t('modals.video.video_id')+'?rel=0&amp;controls=1&amp;showinfo=0',frameBorder:'0',allow:'encrypted-media',allowFullScreen:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-share-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.shareUrl('share'),readOnly:true,onClick:this.copyClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.copyClick},copied?t('modals.video.copied'):t('modals.video.copy'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-share-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button facebook',href:'https://www.facebook.com/sharer/sharer.php?u='+this.encodedShareUrl('facebook'),target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.facebook}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button twitter',href:'https://twitter.com/intent/tweet?url='+this.encodedShareUrl('twitter'),target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.twitter}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button googleplus',href:'https://plus.google.com/share?url='+this.encodedShareUrl('google-plus'),target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.googleplus}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button linkedin',href:'https://www.linkedin.com/shareArticle?mini=true&url='+this.encodedShareUrl('linkedin'),target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.linkedin}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button xing',href:'https://www.xing.com/spi/shares/new?url='+this.encodedShareUrl('xing'),target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.xing}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button email',href:'mailto: ?body='+this.encodedShareUrl('mail_client')+'&subject='+t('modals.video.subject'),dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.email}}),breakpoint==='phone'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button sms',href:'sms:'+smsSeparator+'body='+this.encodedShareUrl('sms'),dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.sms}}),breakpoint==='phone'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'share-button whatsapp',href:'https://api.whatsapp.com/send?text='+this.encodedShareUrl('whatsapp'),target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.whatsapp}})))));}}]);return VideoModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoModal.defaultProps={subpage:null,query:{}};VideoModal.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,query:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};/* harmony default export */ __webpack_exports__["a"] = (VideoModal);

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(266);

var defaultMessage = 'Copy to clipboard: #{key}, Enter';

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug, message, reselectPrevious, range, selection, mark, success = false;
  if (!options) { options = {}; }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement('span');
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = 'unset';
    // prevents scrolling to the end of the page
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = 'pre';
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = 'text';
    mark.style.MozUserSelect = 'text';
    mark.style.msUserSelect = 'text';
    mark.style.userSelect = 'text';

    document.body.appendChild(mark);

    range.selectNode(mark);
    selection.addRange(range);

    var successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('copy command was unsuccessful');
    }
    success = true;
  } catch (err) {
    debug && console.error('unable to copy using execCommand: ', err);
    debug && console.warn('trying IE specific stuff');
    try {
      window.clipboardData.setData('text', text);
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using clipboardData: ', err);
      debug && console.error('falling back to prompt');
      message = format('message' in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == 'function') {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 266 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_Home__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_FooterSmall__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Offer__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__ = __webpack_require__(10);
var MainContent=function MainContent(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,subpage=_ref.subpage,preloaderDone=_ref.preloaderDone,pageTransitionState=_ref.pageTransitionState,breakpoint=_ref.breakpoint,noTransition=_ref.noTransition,consents=_ref.consents,claim=_ref.claim,companyInfo=_ref.companyInfo;var mainClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-main-content',{home:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["f" /* PAGE_HOME */],open:page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["f" /* PAGE_HOME */]||page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]||page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:mainClassName,id:mainClassName},!subpage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__home_Home__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,breakpoint:breakpoint,noTransition:noTransition,preloaderDone:preloaderDone}),page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["f" /* PAGE_HOME */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_FooterSmall__["a" /* default */],{t:t,openPage:openPage,language:language,type:'home',claim:claim}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Offer__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,subpage:subpage,pageTransitionState:pageTransitionState,breakpoint:breakpoint,consents:consents,claim:claim,companyInfo:companyInfo}));};MainContent.defaultProps={subpage:null,companyInfo:null};MainContent.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,preloaderDone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,pageTransitionState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,noTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired,claim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (MainContent);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomeBox__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HomeLink__ = __webpack_require__(270);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.state={mouse:false,mouseElem:null,mousePercent:0.0};_this.mouseMove=_this.mouseMove.bind(_this);_this.mouseOut=_this.mouseOut.bind(_this);_this.boxClick=_this.boxClick.bind(_this);_this.scrollToContent=_this.scrollToContent.bind(_this);return _this;}_createClass(Home,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-home').on('mousemove',this.mouseMove);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.page!==nextProps.page&&nextProps.page!==__WEBPACK_IMPORTED_MODULE_4__config_pages__["f" /* PAGE_HOME */]){this.reset();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-home').off('mousemove');}},{key:'mouseMove',value:function mouseMove(e){if(this.props.page!==__WEBPACK_IMPORTED_MODULE_4__config_pages__["f" /* PAGE_HOME */]){this.reset();return;}if(this.props.breakpoint==='phone'||this.props.breakpoint==='tablet'){this.reset();return;}var cursorX=e.pageX;var windowWidth=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();var percent=2*(cursorX/windowWidth)-1.0;this.setState({mouse:true,mouseElem:percent<=0?__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]:__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */],mousePercent:Math.abs(percent)});}},{key:'mouseOut',value:function mouseOut(){this.reset();}},{key:'boxClick',value:function boxClick(type){this.props.openPage(type);}},{key:'reset',value:function reset(){this.setState({mouse:false,mouseElem:null,mousePercent:0.0});}},{key:'scrollToContent',value:function scrollToContent(){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-security-page').length>0){var breakpoint=this.props.breakpoint;var headerPlaceholderHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-header-placeholder').outerHeight(true);var headerHeight=breakpoint==='widescreen'||breakpoint==='desktop'?50:40;var contentTop=600;if(breakpoint==='laptop'){contentTop=428;}else if(breakpoint==='tablet'){contentTop=300;}else if(breakpoint==='phone'){contentTop=100;}var posTop=contentTop+headerPlaceholderHeight-headerHeight;__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').animate({scrollTop:posTop},1000);}}},{key:'render',value:function render(){var _state=this.state,mouse=_state.mouse,mouseElem=_state.mouseElem,mousePercent=_state.mousePercent;var _props=this.props,t=_props.t,page=_props.page,noTransition=_props.noTransition,preloaderDone=_props.preloaderDone;var elemClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-home',{open:page!==__WEBPACK_IMPORTED_MODULE_4__config_pages__["f" /* PAGE_HOME */],'no-transition':noTransition});var ctaLeft=[{type:__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */],text:t('home.'+__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]+'.excerpt.button')}];var ctaRight=[{type:__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */],text:t('home.'+__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]+'.excerpt.button')},{type:__WEBPACK_IMPORTED_MODULE_4__config_pages__["e" /* PAGE_ESTIMATION */],text:t('home.'+__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]+'.excerpt.button_pricing')}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:elemClassName,id:elemClassName,onMouseOut:this.mouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HomeBox__["a" /* default */],{ctas:ctaLeft,t:t,page:page,type:__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */],mouse:mouse,mouseActive:mouseElem===__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */],mousePercent:mousePercent,boxClick:this.boxClick,scrollToContent:this.scrollToContent,noTransition:noTransition}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HomeBox__["a" /* default */],{ctas:ctaRight,t:t,page:page,type:__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */],mouse:mouse,mouseActive:mouseElem===__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */],mousePercent:mousePercent,boxClick:this.boxClick,scrollToContent:this.scrollToContent,noTransition:noTransition}),page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["f" /* PAGE_HOME */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HomeLink__["a" /* default */],{t:t,preloaderDone:preloaderDone}));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Home.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,noTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,preloaderDone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
/* eslint-disable max-len */// import List from '../../helpers/List';
var HomeBox=function HomeBox(_ref){var t=_ref.t,page=_ref.page,type=_ref.type,mouse=_ref.mouse,mouseActive=_ref.mouseActive,mousePercent=_ref.mousePercent,boxClick=_ref.boxClick,scrollToContent=_ref.scrollToContent,noTransition=_ref.noTransition,ctas=_ref.ctas;var boxClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('home-box','home-box-'+type,{'mouse-move':mouse,'mouse-active':mouseActive,open:(page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]||page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */])&&type===page,closed:(page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]||page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */])&&type!==page,'no-transition':noTransition});var buttonClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('button',{'button-white':type===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]&&type===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]&&"en"==='de','button-gray':type===__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]&&("en"==='en'||"en"==='pl')});var percent=mouseActive?mousePercent:-1.0*mousePercent;var boxStyle=mouse?{width:50+percent*6+'%',top:20-percent*20,bottom:20-percent*20}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:boxClassName,id:'button-button',style:boxStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-box-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-box-excerpt has-transition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('home.'+type+'.excerpt.title')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-box-excerpt-button-box'},ctas.map(function(cta,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return boxClick(cta.type);},className:buttonClassName,id:'home-box-button-'+cta.type},cta.text));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-box-content has-transition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('home.'+type+'.content.title')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:t('home.'+type+'.content.description')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:buttonClassName,id:'content-'+type,onClick:scrollToContent},t('home.'+type+'.content.button'),' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-box-scroll has-transition',onClick:scrollToContent}));};HomeBox.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */],__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */]]).isRequired,ctas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */],__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */],__WEBPACK_IMPORTED_MODULE_3__config_pages__["e" /* PAGE_ESTIMATION */]])})).isRequired,mouse:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,mouseActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,mousePercent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,boxClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,scrollToContent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,noTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HomeBox);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_icons__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeLink=function(_Component){_inherits(HomeLink,_Component);function HomeLink(props){_classCallCheck(this,HomeLink);var _this=_possibleConstructorReturn(this,(HomeLink.__proto__||Object.getPrototypeOf(HomeLink)).call(this,props));_this.state={popup:false};_this.timer=null;return _this;}_createClass(HomeLink,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.preloaderDone){this.timer=setTimeout(function(){_this2.setState({popup:true});},5000);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(!prevProps.preloaderDone&&this.props.preloaderDone){this.timer=setTimeout(function(){_this3.setState({popup:true});},5000);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timer);}},{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:t('home.popup.link'),className:'home-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'home-link-icon',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_3__data_icons__["a" /* default */].social.popup}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('home-link-text',{popup:this.state.popup})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home.popup.text'))));}}]);return HomeLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HomeLink.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,preloaderDone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HomeLink);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Form__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threats_ThreatsVideo__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threats_ThreatsOne__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threats_ThreatsTwo__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threats_ThreatsThree__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__threats_ThreatsFour__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__threats_ThreatsFive__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__offer_OfferList__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__offer_details_OfferDetails__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__security_SecurityOne__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__security_SecurityTwo__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__security_SecurityThree__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__offer_ClientsSlider__ = __webpack_require__(407);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* eslint-disable max-len */var Offer=function Offer(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,breakpoint=_ref.breakpoint,pageTransitionState=_ref.pageTransitionState,consents=_ref.consents,subpage=_ref.subpage,claim=_ref.claim,companyInfo=_ref.companyInfo;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),offer=_useState2[0],setOffer=_useState2[1];var currentOffer=offer?offer.items.find(function(item){return item.translations.slug===subpage;}):null;Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchOffer=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_18__helpers_fetchCmsContent__["g" /* getCmsOffer */])(language);case 2:response=_context.sent;setOffer(response);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function fetchOffer(){return _ref2.apply(this,arguments);};}();fetchOffer();},[language]);var threatsClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('container-threats-security-page',{open:page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]});var securityClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('container-threats-security-page',{open:page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-threats-security',id:'container-threats-security'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:threatsClassName,id:threatsClassName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__threats_ThreatsVideo__["a" /* default */],{t:t,page:page,videoId:t('threats.video.link')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__threats_ThreatsOne__["a" /* default */],{t:t,language:language,page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Form__["a" /* default */],{type:'minimize',typeButton:'consultation',t:t,language:language,formName:'threats-blue-1',breakpoint:breakpoint,linkColor:'blue-bg',consents:consents}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__threats_ThreatsTwo__["a" /* default */],{t:t,page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Form__["a" /* default */],{type:'estimate',typeButton:'consultation',t:t,language:language,formName:'threats-blue-2',breakpoint:breakpoint,linkColor:'blue-bg',consents:consents}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__threats_ThreatsThree__["a" /* default */],{t:t,page:page,openPage:openPage,language:language}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__threats_ThreatsFour__["a" /* default */],{t:t,page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Form__["a" /* default */],{type:'audit',typeButton:'consultation',t:t,language:language,formName:'threats-blue-5',breakpoint:breakpoint,linkColor:'blue-bg',consents:consents}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__threats_ThreatsFive__["a" /* default */],{t:t,page:page,openPage:openPage,language:language}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Form__["a" /* default */],{type:'bottom',typeButton:'consultation',t:t,language:language,formName:'threats-bottom',breakpoint:breakpoint,consents:consents}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:securityClassName,id:securityClassName},currentOffer?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__offer_details_OfferDetails__["a" /* default */],{t:t,openPage:openPage,language:language,item:currentOffer,companyInfo:companyInfo,claim:claim}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__offer_ClientsSlider__["a" /* default */],{language:language,t:t}),offer&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__offer_OfferList__["a" /* default */],{t:t,openPage:openPage,language:language,page:page,pageTransitionState:pageTransitionState,offer:offer}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__security_SecurityOne__["a" /* default */],{t:t,openPage:openPage,language:language,page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__security_SecurityTwo__["a" /* default */],{t:t,page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__security_SecurityThree__["a" /* default */],{t:t,openPage:openPage,language:language,page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Form__["a" /* default */],{type:'bottom',typeButton:'offer',t:t,language:language,formName:'security-bottom',breakpoint:breakpoint,consents:consents}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo}))));};Offer.defaultProps={subpage:null,companyInfo:null};Offer.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,pageTransitionState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired,subpage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,claim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_18__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (Offer);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var ConsentPopup=function ConsentPopup(_ref){var t=_ref.t,content=_ref.content,open=_ref.open,handleClose=_ref.handleClose;var rootElement=document.getElementById('root');return rootElement?Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('rodo-popup-container',{open:open})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rodo-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rodo-content',dangerouslySetInnerHTML:{__html:content}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-button form-button-gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:handleClose},t('consent.common.button'))))),rootElement):null;};ConsentPopup.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,content:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,open:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConsentPopup);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recaptcha__ = __webpack_require__(81);
/* unused harmony reexport ReCAPTCHA */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__["a" /* default */]);


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(276);


var callbackName = "onloadcallback";
var globalName = "grecaptcha";
function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  if (dynamicOptions.enterprise) {
    return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
  }
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_async_script__["a" /* default */])(getURL, {
  callbackName: callbackName,
  globalName: globalName,
  attributes: getOptions().nonce ? {
    nonce: getOptions().nonce
  } : {}
})(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */]));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAsyncScript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(AsyncScriptLoader, _extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardedComponent, WrappedComponent);
  };
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(278);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(279);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-white.cce3a4b7.svg";

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./contact-1-avatar-128.jpg": 283
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var youtubeInit=function youtubeInit(){if(typeof window.YT==='undefined'){var tag=document.createElement('script');tag.src='https://www.youtube.com/iframe_api';document.body.appendChild(tag);}};var Video=function Video(_ref){var playing=_ref.playing,file=_ref.file;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{src:__webpack_require__(285)("./"+file),className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-threats-video-overlay-item',{hide:playing}),muted:true,playsInline:true,autoPlay:true,loop:true,width:'100%'});};Video.propTypes={playing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};var ThreatsVideo=function(_Component){_inherits(ThreatsVideo,_Component);function ThreatsVideo(props){_classCallCheck(this,ThreatsVideo);var _this=_possibleConstructorReturn(this,(ThreatsVideo.__proto__||Object.getPrototypeOf(ThreatsVideo)).call(this,props));_this.state={playing:false};_this.playVideo=_this.playVideo.bind(_this);_this.stopVideo=_this.stopVideo.bind(_this);_this.videoPlaying=_this.videoPlaying.bind(_this);_this.videoStopped=_this.videoStopped.bind(_this);_this.player=null;window.onYouTubePlayerAPIReady=function(){_this.player=new window.YT.Player('ytplayer',{videoId:_this.props.videoId,playerVars:{controls:1,disablekb:1,fs:0,modestbranding:1,playsinline:1,rel:0,showinfo:0}});_this.player.addEventListener('onStateChange',function(e){if(e.data===0||e.data===2){_this.videoStopped();}else if((e.data===1||e.data===3)&&_this.props.page===__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]){_this.videoPlaying();}});};return _this;}_createClass(ThreatsVideo,[{key:'componentDidMount',value:function componentDidMount(){youtubeInit();if(typeof window.YT!=='undefined'){window.onYouTubePlayerAPIReady();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.page!==prevProps.page){this.stopVideo();this.videoStopped();}if(this.props.videoId!==prevProps.videoId&&this.player){this.player.loadVideoById(this.props.videoId);this.player.mute();if(this.props.page!==__WEBPACK_IMPORTED_MODULE_3__config_pages__["j" /* PAGE_THREATS */]){this.stopVideo();}}}},{key:'playVideo',value:function playVideo(){if(this.player){this.player.playVideo();}}},{key:'stopVideo',value:function stopVideo(){if(this.player){this.player.stopVideo();}}},{key:'videoPlaying',value:function videoPlaying(){this.setState({playing:true});}},{key:'videoStopped',value:function videoStopped(){this.setState({playing:false});}},{key:'render',value:function render(){var playing=this.state.playing;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-video',id:'page-threats-video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ytplayer',className:'page-threats-video-yt'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-threats-video-overlay',{hide:playing})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Video,{playing:playing,file:t('threats.video.file')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-video-overlay-cover'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-threats-video-content',{hide:playing})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'page-threats-video-button',onClick:this.playVideo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'page-threats-video-text'},t('threats.video.text'))));}}]);return ThreatsVideo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThreatsVideo.propTypes={page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,videoId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ThreatsVideo);

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./threats-de.mp4": 286,
	"./threats-en.mp4": 287,
	"./threats-pl.mp4": 288
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 285;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/threats-de.515d989f.mp4";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/threats-en.4f6089bb.mp4";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/threats-pl.092200a1.mp4";

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Text__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setCharAt=function setCharAt(str,index,chr){if(index>str.length-1){return str;}return str.substr(0,index)+chr+str.substr(index+1);};var shuffleString=function shuffleString(string){var a=string.split('');var n=a.length;for(var i=n-1;i>0;i-=1){var j=Math.floor(Math.random()*(i+1));var tmp=a[i];a[i]=a[j];a[j]=tmp;}return a.join('');};var ThreatsOne=function(_Component){_inherits(ThreatsOne,_Component);function ThreatsOne(props){_classCallCheck(this,ThreatsOne);var _this=_possibleConstructorReturn(this,(ThreatsOne.__proto__||Object.getPrototypeOf(ThreatsOne)).call(this,props));_this.state={show:false,parallaxBottom:0,tags:__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(props.t('threats.one.image.tags'))};_this.scroll=_this.scroll.bind(_this);_this.glitch=_this.glitch.bind(_this);_this.glitchTag=_this.glitchTag.bind(_this);_this.glitchReset=_this.glitchReset.bind(_this);_this.glitchTagActive=false;_this.glitchTimeout=null;_this.componentIsMounted=false;return _this;}_createClass(ThreatsOne,[{key:'componentDidMount',value:function componentDidMount(){this.componentIsMounted=true;window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);this.glitch();}},{key:'componentDidUpdate',value:function componentDidUpdate(nextProps){if(this.props.language!==nextProps.language){this.glitchReset();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.componentIsMounted=false;window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'glitchReset',value:function glitchReset(){var _this2=this;clearTimeout(this.glitchTimeout);this.glitchTagActive=false;this.setState({tags:__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(this.props.t('threats.one.image.tags'))});setTimeout(function(){_this2.glitch();},1000);}},{key:'glitchTag',value:function glitchTag(tagIndex,index,symbols,i){var _this3=this;setTimeout(function(){if(!_this3.glitchTagActive){return;}var tags=_this3.state.tags;tags[tagIndex]=setCharAt(tags[tagIndex],index,symbols.charAt(i));if(_this3.componentIsMounted){_this3.setState({tags:tags});}var j=i+1;if(j<symbols.length){_this3.glitchTag(tagIndex,index,symbols,j);}},75);}},{key:'glitch',value:function glitch(){var tags=this.props.t('threats.one.image.tags');this.glitchTagActive=true;var symbols='!@#$%^&*()';var tagsCount=tags.length;var tagIndex=Math.floor(Math.random()*tagsCount);var random=Math.floor(Math.random()*5);var indexes=[];var textIndex=void 0;for(var x=0;x<random;x+=1){do{textIndex=Math.floor(Math.random()*tags[tagIndex].length);}while(indexes.indexOf(textIndex)!==-1);indexes.push(textIndex);var localSymbols=shuffleString(symbols)+tags[tagIndex].charAt(textIndex);this.glitchTag(tagIndex,textIndex,localSymbols,0);}clearTimeout(this.glitchTimeout);this.glitchTimeout=setTimeout(this.glitch,300);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_5__config_pages__["j" /* PAGE_THREATS */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-1').length>0){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-1').offset().top;var elemHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-1').outerHeight(true);var bgHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-1-bg').outerHeight(true);var diff=bgHeight-elemHeight;if(diff>0){var parallaxStart=elemTop-winHeight>0?elemTop-winHeight:0;var parallaxEnd=elemTop+elemHeight;var parallaxDiff=parallaxEnd-parallaxStart;if(winTop>parallaxStart&&winTop<parallaxEnd){var percent=(winTop-parallaxStart)/parallaxDiff;var parallaxBottom=-1*diff*percent;this.setState({parallaxBottom:parallaxBottom});}else{this.setState({parallaxBottom:0});}}if(this.state.show===false){if(elemTop<winTop+winHeight/2){this.setState({show:true});}}}}},{key:'render',value:function render(){var _state=this.state,parallaxBottom=_state.parallaxBottom,tags=_state.tags;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-threats-1',id:'container-threats-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-1-bg',id:'threats-1-bg',style:{bottom:parallaxBottom}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(142),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-1',id:'page-threats-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('threats.one.section.title')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-1-content',id:'threats-1-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',id:'image-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icon',id:'icon-1',src:__webpack_require__(354),alt:'Lemlock threats'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-top',id:'text-top-1'},t('threats.one.image.title')),tags.map(function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tag','tag-'+(index+1)),'data-text':tag,key:index},tag);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16',id:'section-text-16-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_Text__["a" /* default */],{data:t('threats.one.paragraphs')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16 threats-1-note',id:'threats-1-note'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('threats.one.note'))))));}}]);return ThreatsOne;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThreatsOne.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ThreatsOne);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(291);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(46),
    arrayEach = __webpack_require__(320),
    assignValue = __webpack_require__(88),
    baseAssign = __webpack_require__(322),
    baseAssignIn = __webpack_require__(329),
    cloneBuffer = __webpack_require__(332),
    copyArray = __webpack_require__(333),
    copySymbols = __webpack_require__(334),
    copySymbolsIn = __webpack_require__(336),
    getAllKeys = __webpack_require__(101),
    getAllKeysIn = __webpack_require__(337),
    getTag = __webpack_require__(36),
    initCloneArray = __webpack_require__(342),
    initCloneByTag = __webpack_require__(343),
    initCloneObject = __webpack_require__(348),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(50),
    isMap = __webpack_require__(350),
    isObject = __webpack_require__(20),
    isSet = __webpack_require__(352),
    keys = __webpack_require__(35);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(31);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(31);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(31);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(31);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(30);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(30),
    Map = __webpack_require__(48),
    MapCache = __webpack_require__(49);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(85),
    isMasked = __webpack_require__(305),
    isObject = __webpack_require__(20),
    toSource = __webpack_require__(87);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(306);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(13);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(309),
    ListCache = __webpack_require__(30),
    Map = __webpack_require__(48);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(310),
    hashDelete = __webpack_require__(311),
    hashGet = __webpack_require__(312),
    hashHas = __webpack_require__(313),
    hashSet = __webpack_require__(314);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(32);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(32);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(32);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(32);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(33);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(33);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(33);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(33);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(34),
    keys = __webpack_require__(35);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isLength = __webpack_require__(52),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(55),
    nativeKeys = __webpack_require__(328);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(94);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(34),
    keysIn = __webpack_require__(96);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20),
    isPrototype = __webpack_require__(55),
    nativeKeysIn = __webpack_require__(331);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(13);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module)))

/***/ }),
/* 333 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(34),
    getSymbols = __webpack_require__(56);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(34),
    getSymbolsIn = __webpack_require__(98);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(102),
    getSymbolsIn = __webpack_require__(98),
    keysIn = __webpack_require__(96);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(57),
    cloneDataView = __webpack_require__(344),
    cloneRegExp = __webpack_require__(345),
    cloneSymbol = __webpack_require__(346),
    cloneTypedArray = __webpack_require__(347);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(57);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(57);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(349),
    getPrototype = __webpack_require__(100),
    isPrototype = __webpack_require__(55);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(351),
    baseUnary = __webpack_require__(53),
    nodeUtil = __webpack_require__(54);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(353),
    baseUnary = __webpack_require__(53),
    nodeUtil = __webpack_require__(54);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/image-2.f8845dc2.svg";

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThreatsTwo=function(_Component){_inherits(ThreatsTwo,_Component);function ThreatsTwo(props){_classCallCheck(this,ThreatsTwo);var _this=_possibleConstructorReturn(this,(ThreatsTwo.__proto__||Object.getPrototypeOf(ThreatsTwo)).call(this,props));_this.state={show:false};_this.scroll=_this.scroll.bind(_this);return _this;}_createClass(ThreatsTwo,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-2').length>0&&this.state.show===false){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-2').offset().top;if(elemTop<winTop+winHeight/2){this.setState({show:true});}}}},{key:'render',value:function render(){var show=this.state.show;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-threats-2',id:'container-threats-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-2',id:'page-threats-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('threats.two.section.title')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-boxes threats-2-boxes',id:'threats-2-boxes'},t('threats.two.boxes').map(function(text,index){var boxClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('section-box','threats-2-box',{show:show});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:boxClassName,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(356)("./icon-"+(index+1)+'.svg'),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:text}})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text threats-2-text',id:'threats-2-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:t('threats.two.text')}})))));}}]);return ThreatsTwo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThreatsTwo.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ThreatsTwo);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-1.svg": 357,
	"./icon-2.svg": 358,
	"./icon-3.svg": 359,
	"./icon-4.svg": 360,
	"./icon-5.svg": 361
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-1.212b0397.svg";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-2.ca6101b8.svg";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-3.5c625049.svg";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-4.62185dda.svg";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-5.9632e71d.svg";

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable max-len */var ThreatsThree=function(_Component){_inherits(ThreatsThree,_Component);_createClass(ThreatsThree,null,[{key:'buttonClick',value:function buttonClick(e){var $text=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(e.target).closest('.threats-3-box').find('.section-text-16');var $target=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(e.target);var $button=$target.hasClass('button')?$target:$target.closest('.button');if($button.hasClass('expanded')){$button.removeClass('expanded');$text.removeClass('expanded').removeAttr('style');}else{$button.addClass('expanded');var height=$text.find('p').outerHeight(true);$text.addClass('expanded').height(height);}}},{key:'boxesClose',value:function boxesClose(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-3-box .section-text-16').removeClass('expanded').removeAttr('style');__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-3-box .button').removeClass('expanded');}},{key:'pieAnimate',value:function pieAnimate(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-3-chart .pie').addClass('show');var x=0;var interval=setInterval(function(){x+=1;if(x>=75){clearInterval(interval);}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-3-chart .counter').text(x+'%');},1400/75);}}]);function ThreatsThree(props){_classCallCheck(this,ThreatsThree);var _this=_possibleConstructorReturn(this,(ThreatsThree.__proto__||Object.getPrototypeOf(ThreatsThree)).call(this,props));_this.state={showPie:false,showBoxes:false};_this.scroll=_this.scroll.bind(_this);_this.resize=_this.resize.bind(_this);_this.windowWidth=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();return _this;}_createClass(ThreatsThree,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.resize);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.resize);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-3').length>0){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();if(this.state.showPie===false){var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-3-chart').offset().top;if(elemTop<winTop+winHeight/2){this.setState({showPie:true});ThreatsThree.pieAnimate();}}if(this.state.showBoxes===false){var _elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-3-boxes').offset().top;if(_elemTop<winTop+winHeight/2){this.setState({showBoxes:true});}}}}},{key:'resize',value:function resize(){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width()!==this.windowWidth){this.windowWidth=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();ThreatsThree.boxesClose();this.scroll();}}},{key:'render',value:function render(){var showBoxes=this.state.showBoxes;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-threats-3',id:'container-threats-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-3',id:'page-threats-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('threats.three.section.title')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-3-chart',id:'threats-3-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pie',id:'pie-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 32 32'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'circle',r:'16',cx:'16',cy:'16'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'circle-inside',r:'9',cx:'16',cy:'16'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'counter',id:'counter-3'},'0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text',id:'section-text-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('threats.three.text')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-boxes threats-3-boxes',id:'threats-3-boxes'},t('threats.three.boxes').map(function(box,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('section-box','section-box-mobile-white','threats-3-box',{show:showBoxes}),key:index,id:'threats-3-box-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inside'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,box.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(363)("./icon-"+(index+1)+'.svg'),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'section-text-16-1-'+index},box.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'button button-blue',onClick:ThreatsThree.buttonClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'more',id:'button-more-1-'+index},t('threats.three.buttons.more')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'less',id:'button-less-1-'+index},t('threats.three.buttons.less'))))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-3-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'threats-3-text'},t('form.title.breach')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-security-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:t('form.link.breach'),className:'threats-3-button',id:'threats-3-button'},t('form.button.breach'))))));}}]);return ThreatsThree;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThreatsThree.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ThreatsThree);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-1.svg": 364,
	"./icon-2.svg": 365,
	"./icon-3.svg": 366
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-1.1a6221f6.svg";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-2.0e8bff9f.svg";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-3.bff96b41.svg";

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Text__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable max-len */var ThreatsFour=function(_Component){_inherits(ThreatsFour,_Component);function ThreatsFour(props){_classCallCheck(this,ThreatsFour);var _this=_possibleConstructorReturn(this,(ThreatsFour.__proto__||Object.getPrototypeOf(ThreatsFour)).call(this,props));_this.state={show:false};_this.scroll=_this.scroll.bind(_this);return _this;}_createClass(ThreatsFour,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-4').length>0){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();if(this.state.show===false){var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.threats-4-boxes-title').offset().top;if(elemTop<winTop+winHeight/2){this.setState({show:true});}}}}},{key:'render',value:function render(){var show=this.state.show;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-threats-4',id:'container-threats-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-4',id:'page-threats-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('threats.four.section.title')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc',id:'desc-4',dangerouslySetInnerHTML:{__html:t('threats.four.section.desc')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-4-content',id:'threats-4-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',id:'image-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(368)("./"+t('threats.four.icon')+'.svg'),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_Text__["a" /* default */],{className:'section-text-16',id:'section-text-16-4',data:t('threats.four.text')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-4-boxes-title',id:'threats-4-boxes-title',dangerouslySetInnerHTML:{__html:t('threats.four.boxes.title')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-boxes',id:'threats-4-boxes'},t('threats.four.boxes.list').map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('section-box','section-box-animation','threats-4-box',{show:show}),key:index,id:'threats-4-box-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',id:'image-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(372)("./icon-"+(index+1)+'.svg'),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16',id:'section-text-16-4-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,text)));})))));}}]);return ThreatsFour;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThreatsFour.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ThreatsFour);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dsgvo.svg": 369,
	"./gdpr.svg": 370,
	"./icon-1.svg": 105,
	"./icon-2.svg": 106,
	"./icon-3.svg": 107,
	"./rodo.svg": 371
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dsgvo.f6bb9136.svg";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr.14f051ed.svg";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rodo.902a02b0.svg";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-1.svg": 105,
	"./icon-2.svg": 106,
	"./icon-3.svg": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThreatsFive=function(_Component){_inherits(ThreatsFive,_Component);function ThreatsFive(props){_classCallCheck(this,ThreatsFive);var _this=_possibleConstructorReturn(this,(ThreatsFive.__proto__||Object.getPrototypeOf(ThreatsFive)).call(this,props));_this.state={show:false};_this.scroll=_this.scroll.bind(_this);return _this;}_createClass(ThreatsFive,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["j" /* PAGE_THREATS */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-5').length>0){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();if(this.state.show===false){var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-threats-5').offset().top;if(elemTop<winTop+winHeight/2){this.setState({show:true});}}}}},{key:'render',value:function render(){var show=this.state.show;var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-threats-5',id:'container-threats-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-threats-5',id:'page-threats-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('threats.five.section.title')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc',id:'desc',dangerouslySetInnerHTML:{__html:t('threats.five.section.desc')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-5-text section-text',id:'threats-5-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('threats.five.text'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-boxes',id:'section-boxes-5'},t('threats.five.boxes').map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('section-box','threats-5-box',{show:show}),key:index,id:'threats-5-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',id:'image-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(374)("./icon-"+(index+1)+'.svg'),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text',id:'section-text-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,text)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-security-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_Link__["a" /* default */],{id:'threats-5-button',openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]},t('threats.five.button'))))));}}]);return ThreatsFive;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ThreatsFive.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ThreatsFive);

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-1.svg": 375,
	"./icon-2.svg": 376,
	"./icon-3.svg": 377
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-1.7ff91440.svg";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-2.4b77226a.svg";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-3.98e23c53.svg";

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfferBox__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OfferTitle__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Link__ = __webpack_require__(8);
/* eslint-disable import/extensions *//* eslint-disable import/no-unresolved */var OfferList=function OfferList(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,subpage=_ref.subpage,pageTransitionState=_ref.pageTransitionState,offer=_ref.offer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-offer-content',id:'container-offer-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-offer-content',id:'page-offer-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OfferTitle__["a" /* default */],{t:t,title:offer.header.translations.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'offer-subtitle',id:'offer-subtitle'},offer.header.translations.subtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-boxes',id:'offer-boxes'},offer.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OfferBox__["a" /* default */],{key:item.translations.slug,t:t,openPage:openPage,language:language,page:page,pageTransitionState:pageTransitionState,offer:item,active:subpage===item.translations.slug,index:index,totalItems:offer.items.length});})),page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-security-buttons-wrapper'},offer.ctas.map(function(cta,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-security-button',id:'security-'+index+'-button-1',key:'security-'+index+'-button-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:cta.translations.path.slice(1),id:'security-'+index+'-button-2'},cta.translations.text));})))));};OfferList.defaultProps={subpage:null};OfferList.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pageTransitionState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,offer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferList);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Link__ = __webpack_require__(8);
/* eslint-disable max-len */var API_URL="https://directus.sagiton.pl";var OfferBox=function OfferBox(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,offer=_ref.offer,index=_ref.index,totalItems=_ref.totalItems;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */],subpage:offer.translations.slug,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('offer-box',{'container-2':totalItems===2},{'container-3':totalItems>=3&&totalItems%3===0},{'container-4':totalItems>=3&&totalItems%3===1},{'container-5':totalItems>=3&&totalItems%3===2}),id:'offer-box-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-icon',id:'offer-box-icon-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'offer-box-icon-src',src:API_URL+'/assets/'+offer.icon,alt:offer.translations.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-header',id:'offer-box-header-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-title',id:'offer-box-title-'+index},offer.translations.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-subtitle',id:'offer-box-subtitle-'+index},offer.translations.short_description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-more',id:'offer-box-more-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-more-text',id:'offer-box-more-text-'+index},t('offer.general.read_more')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-box-more-icon',id:'offer-box-more-icon-'+index,dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_4__data_icons__["a" /* default */].offer.arrowRight}})));};OfferBox.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,offer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,totalItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferBox);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var OfferTitle=function OfferTitle(_ref){var title=_ref.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-title',id:'offer-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:title}})));};OfferTitle.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferTitle);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfferDetailsHeader__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OfferDetailsTexts__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OfferDetailsIcons__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OfferDetailsCta__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__ = __webpack_require__(10);
/* eslint-disable max-len */var OfferDetails=function OfferDetails(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,item=_ref.item,claim=_ref.claim,companyInfo=_ref.companyInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-content',key:item.translations.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OfferDetailsHeader__["a" /* default */],{t:t,openPage:openPage,language:language,item:item}),item.translations.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OfferDetailsTexts__["a" /* default */],{item:item}),item.use_cases.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OfferDetailsIcons__["a" /* default */],{item:item}),item.ctas.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OfferDetailsCta__["a" /* default */],{openPage:openPage,language:language,item:item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo}));};OfferDetails.defaultProps={companyInfo:null};OfferDetails.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,claim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (OfferDetails);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Link__ = __webpack_require__(8);
var API_URL="https://directus.sagiton.pl";var OfferDetailsHeader=function OfferDetailsHeader(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,item=_ref.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_3__config_pages__["h" /* PAGE_OFFER */],className:'offer-details-back',id:'offer-details-back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-back-icon',id:'offer-details-back-icon',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_2__data_icons__["a" /* default */].offer.arrowLeft}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-back-label',id:'offer-details-back-label'},t('offer.general.back'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-header-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'offer-details-icon-src',src:API_URL+'/assets/'+item.icon,alt:item.translations.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'offer-details-header-title'},item.translations.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'offer-details-header-subtitle'},item.translations.short_description));};OfferDetailsHeader.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferDetailsHeader);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_icons__ = __webpack_require__(12);
/* eslint-disable max-len */var OfferDetailsTexts=function OfferDetailsTexts(_ref){var item=_ref.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-offer-details-texts')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-texts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-text',dangerouslySetInnerHTML:{__html:item.translations.description}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-texts-icon',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_3__data_icons__["a" /* default */].offer.magnifier}}))));};OfferDetailsTexts.propTypes={item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferDetailsTexts);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var API_URL="https://directus.sagiton.pl";var OfferDetailsIcons=function OfferDetailsIcons(_ref){var item=_ref.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'offer-details-icons-title',dangerouslySetInnerHTML:{__html:item.translations.use_case_description}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-icons-container'},item.use_cases.map(function(elem,number){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-icons-content',key:'offer-details-icons-content-'+number},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-icons-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:API_URL+'/assets/'+elem.icon,alt:elem.translations.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'offer-details-icons-icon-title'},elem.translations.name));})));};OfferDetailsIcons.propTypes={item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferDetailsIcons);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Link__ = __webpack_require__(8);
/* eslint-disable max-len */var API_URL="https://directus.sagiton.pl";var PRICING_PATH='estimation';var OfferDetailsCta=function OfferDetailsCta(_ref){var openPage=_ref.openPage,language=_ref.language,item=_ref.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-cta-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-cta-content'},item.ctas.map(function(elem,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Link__["a" /* default */],{key:index,openPage:openPage,language:language,page:elem.type==='file'?API_URL+'/assets/'+elem.file:elem.translations.path,query:elem.translations.path===PRICING_PATH&&elem.query?{pricing:elem.query}:{},className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('offer-details-cta',{'container-2':item.ctas.length===2},{'container-3':item.ctas.length>=3&&item.ctas.length%3===0},{'container-4':item.ctas.length>=3&&item.ctas.length%3===1},{'container-5':item.ctas.length>=3&&item.ctas.length%3===2})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer-details-cta-item',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'offer-details-cta-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'offer-details-cta-icon-src',src:API_URL+'/assets/'+elem.icon,alt:elem.translations.text})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'offer-details-cta-text'},elem.translations.text)));}))));};OfferDetailsCta.propTypes={openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (OfferDetailsCta);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecurityOne=function(_Component){_inherits(SecurityOne,_Component);function SecurityOne(props){_classCallCheck(this,SecurityOne);var _this=_possibleConstructorReturn(this,(SecurityOne.__proto__||Object.getPrototypeOf(SecurityOne)).call(this,props));_this.state={show:false,standby:false};_this.scroll=_this.scroll.bind(_this);return _this;}_createClass(SecurityOne,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){var _this2=this;if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-security-1').length>0&&this.state.show===false){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-security-1').offset().top;if(elemTop<winTop+winHeight/2){this.setState({show:true},function(){setTimeout(function(){_this2.setState({standby:true});},2000);});}}}},{key:'render',value:function render(){var _state=this.state,show=_state.show,standby=_state.standby;var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-security-1',id:'container-security-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-security-1',id:'page-security-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('offer.one.section.title')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'security-1-box',id:'security-1-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'security-1-logo',id:'security-1-logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'security-1-icons',id:'security-1-icons'},t('offer.one.icons').map(function(icon,index){var iconClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('security-1-icon','text-on-'+icon.align,{show:show,standby:standby});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:iconClassName,id:'security-1-box-'+index,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(387)("./icon-"+(index+1)+'.svg'),alt:'Lemlock security',id:'security-1-image-'+index})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text',id:'security-1-text-1-'+index,dangerouslySetInnerHTML:{__html:icon.title_2_lines}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup',id:'security-1-popup-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',id:'security-1-title-'+index},icon.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc',id:'security-1-box-desc-'+index},icon.desc)));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-security-button',id:'security-1-button-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_4__config_pages__["b" /* PAGE_ABOUT */],id:'security-1-button-2'},t('offer.one.button'))))));}}]);return SecurityOne;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SecurityOne.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SecurityOne);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-1.svg": 388,
	"./icon-2.svg": 389,
	"./icon-3.svg": 390,
	"./icon-4.svg": 391,
	"./icon-5.svg": 392,
	"./icon-6.svg": 393
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 387;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-1.6a79b36b.svg";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-2.61382994.svg";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-3.1bd44f04.svg";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-4.f1bdc781.svg";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-5.60299908.svg";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-6.fd07d8df.svg";

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecurityTwo=function(_Component){_inherits(SecurityTwo,_Component);function SecurityTwo(props){_classCallCheck(this,SecurityTwo);var _this=_possibleConstructorReturn(this,(SecurityTwo.__proto__||Object.getPrototypeOf(SecurityTwo)).call(this,props));_this.state={show:false};_this.scroll=_this.scroll.bind(_this);return _this;}_createClass(SecurityTwo,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-security-2').length>0&&this.state.show===false){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-security-2').offset().top;if(elemTop<winTop+winHeight/2){this.setState({show:true});}}}},{key:'render',value:function render(){var show=this.state.show;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-security-2',id:'container-security-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-security-2',id:'page-security-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('offer.two.section.title')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('security-2-list',{show:show}),id:'security-2-list'},t('offer.two.icons').map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('security-2-elem',{show:show}),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',id:'image-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(395)("./icon-"+(index+1)+'.svg'),alt:'Lemlock security'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name',id:'name-2'},text));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text security-2-text',id:'security-2-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:t('offer.two.bonus')}})))));}}]);return SecurityTwo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SecurityTwo.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SecurityTwo);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-1.svg": 396,
	"./icon-2.svg": 397,
	"./icon-3.svg": 398,
	"./icon-4.svg": 399,
	"./icon-5.svg": 400,
	"./icon-6.svg": 401
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-1.fbde03f0.svg";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-2.5b93b2ee.svg";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-3.50c2d0a9.svg";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-4.3b25201b.svg";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-5.7a526a8d.svg";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-6.5f3bf686.svg";

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecurityThree=function(_Component){_inherits(SecurityThree,_Component);function SecurityThree(props){_classCallCheck(this,SecurityThree);var _this=_possibleConstructorReturn(this,(SecurityThree.__proto__||Object.getPrototypeOf(SecurityThree)).call(this,props));_this.state={show:false};_this.scroll=_this.scroll.bind(_this);return _this;}_createClass(SecurityThree,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.scroll);window.addEventListener('scroll',this.scroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.scroll);window.removeEventListener('scroll',this.scroll);}},{key:'scroll',value:function scroll(){if(this.props.page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["h" /* PAGE_OFFER */]&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-security-3').length>0&&this.state.show===false){var winTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();var winHeight=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();var elemTop=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.container-security-3').offset().top;if(elemTop<winTop+winHeight/2){this.setState({show:true});}}}},{key:'render',value:function render(){var show=this.state.show;var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-security-3',id:'container-security-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'security-3-bg',id:'security-3-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(108),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-security-3',id:'page-security-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'threats-security-button',id:'security-3-button-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:__WEBPACK_IMPORTED_MODULE_4__config_pages__["e" /* PAGE_ESTIMATION */],id:'security-3-button-2'},t('offer.three.button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title',id:'section-title-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('offer.three.section.title')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc',id:'desc',dangerouslySetInnerHTML:{__html:t('offer.three.section.desc')}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-boxes security-3-boxes',id:'security-3-boxes'},t('offer.three.boxes').map(function(box,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('section-box','section-box-mobile-white','security-3-box',{show:show}),key:index,id:'security-3-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inside',id:'inside-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image',id:'image-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(403)("./cert-"+(index+1)+'.svg'),alt:'Lemlock security'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',id:'title-3'},box.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16 text-top',id:'section-text-3-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:box.textTop}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-text-16 text-bottom',id:'section-text-3-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,box.textBottom))));})))));}}]);return SecurityThree;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SecurityThree.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SecurityThree);

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cert-1.svg": 404,
	"./cert-2.svg": 405,
	"./cert-3.svg": 406
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cert-1.09483f38.svg";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cert-2.56c69f26.svg";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cert-3.ec8c853a.svg";

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ClientsSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconsSlider__ = __webpack_require__(408);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var API_URL="https://directus.sagiton.pl";function ClientsSlider(_ref){var _this=this;var t=_ref.t;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),clients=_useState2[0],setClients=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchClients=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var clientsList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_fetchCmsContent__["d" /* getCMSClientList */])();case 2:clientsList=_context.sent;setClients(clientsList);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function fetchClients(){return _ref2.apply(this,arguments);};}();fetchClients();},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clients-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clients-title',id:'section-title-legal-notice'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{dangerouslySetInnerHTML:{__html:t('offer.clients.title')}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IconsSlider__["a" /* default */],{className:'clients-slider',loader:true,items:clients.map(function(client){return{imgUrl:API_URL+'/assets/'+client.logo.id,title:client.name,id:client.id,url:client.url};})})));}ClientsSlider.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconsSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_react__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_swiper_bundle_min_css__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_swiper_bundle_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_swiper_bundle_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_swiper_min_css__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_swiper_swiper_min_css__);
__WEBPACK_IMPORTED_MODULE_1_swiper__["c" /* default */].use([__WEBPACK_IMPORTED_MODULE_1_swiper__["b" /* Navigation */],__WEBPACK_IMPORTED_MODULE_1_swiper__["a" /* Autoplay */]]);function IconsSlider(_ref){var items=_ref.items,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('slider-swiper-container',className)},items.length>3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_swiper_react__["a" /* Swiper */],{modules:[__WEBPACK_IMPORTED_MODULE_1_swiper__["b" /* Navigation */],__WEBPACK_IMPORTED_MODULE_1_swiper__["a" /* Autoplay */]],navigation:true,className:'slider-slider',slidesPerView:1,loop:true,spaceBetween:0,scrollbar:false,autoplay:{delay:7000,disableOnInteraction:true},breakpoints:{1281:{slidesPerView:items.length>1?4:1},767:{slidesPerView:3},479:{slidesPerView:2},320:{slidesPerView:1}}},items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_swiper_react__["b" /* SwiperSlide */],{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'scroll-'+item.id,style:{width:'100%',margin:0,padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-image'},item.url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+item.url,rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.imgUrl,alt:item.title})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.imgUrl,alt:item.title})))));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'60px',marginBottom:'60px',display:'flex',alignItems:'center'},className:'no-swiper-'+items.length},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon-item',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.imgUrl,alt:item.title})));})));}IconsSlider.defaultProps={items:[],className:''};IconsSlider.propTypes={items:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,imgUrl:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,url:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})),className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_get_support__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_get_device__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_get_browser__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_resize_resize__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_observer_observer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modular__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events_emitter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__update_index__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translate_index__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transition_index__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__slide_index__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loop_index__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__grab_cursor_index__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__manipulation_index__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_index__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__breakpoints_index__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__classes_index__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_index__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__check_overflow_index__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__defaults__ = __webpack_require__(475);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint no-param-reassign: "off" */























var prototypes = {
  modular: __WEBPACK_IMPORTED_MODULE_8__modular__["a" /* default */],
  eventsEmitter: __WEBPACK_IMPORTED_MODULE_9__events_emitter__["a" /* default */],
  update: __WEBPACK_IMPORTED_MODULE_10__update_index__["a" /* default */],
  translate: __WEBPACK_IMPORTED_MODULE_11__translate_index__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_12__transition_index__["a" /* default */],
  slide: __WEBPACK_IMPORTED_MODULE_13__slide_index__["a" /* default */],
  loop: __WEBPACK_IMPORTED_MODULE_14__loop_index__["a" /* default */],
  grabCursor: __WEBPACK_IMPORTED_MODULE_15__grab_cursor_index__["a" /* default */],
  manipulation: __WEBPACK_IMPORTED_MODULE_16__manipulation_index__["a" /* default */],
  events: __WEBPACK_IMPORTED_MODULE_17__events_index__["a" /* default */],
  breakpoints: __WEBPACK_IMPORTED_MODULE_18__breakpoints_index__["a" /* default */],
  checkOverflow: __WEBPACK_IMPORTED_MODULE_21__check_overflow_index__["a" /* default */],
  classes: __WEBPACK_IMPORTED_MODULE_19__classes_index__["a" /* default */],
  images: __WEBPACK_IMPORTED_MODULE_20__images_index__["a" /* default */]
};
var extendedDefaults = {};

var Swiper = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(params.el).length > 1) {
      var swipers = [];
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(params.el).each(function (containerEl) {
        var newParams = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = Object(__WEBPACK_IMPORTED_MODULE_3__utils_get_support__["a" /* getSupport */])();
    swiper.device = Object(__WEBPACK_IMPORTED_MODULE_4__utils_get_device__["a" /* getDevice */])({
      userAgent: params.userAgent
    });
    swiper.browser = Object(__WEBPACK_IMPORTED_MODULE_5__utils_get_browser__["a" /* getBrowser */])();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])({}, __WEBPACK_IMPORTED_MODULE_22__defaults__["a" /* default */]);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])({}, swiper.params);
    swiper.passedParams = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = __WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */]; // Extend Swiper

    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
      var wrapper = document.createElement('div');
      $wrapperEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["d" /* deleteProps */])(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_22__defaults__["a" /* default */];
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([__WEBPACK_IMPORTED_MODULE_6__modules_resize_resize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_observer_observer__["a" /* default */]]);
/* harmony default export */ __webpack_exports__["a"] = (Swiper);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $; });
/* unused harmony export add */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addClass; });
/* unused harmony export animate */
/* unused harmony export animationEnd */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return append; });
/* unused harmony export appendTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return attr; });
/* unused harmony export blur */
/* unused harmony export change */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return children; });
/* unused harmony export click */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return css; });
/* unused harmony export data */
/* unused harmony export dataset */
/* unused harmony export detach */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return each; });
/* unused harmony export empty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return eq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return find; });
/* unused harmony export focus */
/* unused harmony export focusin */
/* unused harmony export focusout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasClass; });
/* unused harmony export height */
/* unused harmony export hide */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return html; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return index; });
/* unused harmony export insertAfter */
/* unused harmony export insertBefore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return is; });
/* unused harmony export keydown */
/* unused harmony export keypress */
/* unused harmony export keyup */
/* unused harmony export mousedown */
/* unused harmony export mouseenter */
/* unused harmony export mouseleave */
/* unused harmony export mousemove */
/* unused harmony export mouseout */
/* unused harmony export mouseover */
/* unused harmony export mouseup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return nextAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return offset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return on; });
/* unused harmony export once */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return outerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return outerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return parent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return parents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return prepend; });
/* unused harmony export prependTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return prevAll; });
/* unused harmony export prop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return removeAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return removeClass; });
/* unused harmony export removeData */
/* unused harmony export resize */
/* unused harmony export scroll */
/* unused harmony export scrollLeft */
/* unused harmony export scrollTo */
/* unused harmony export scrollTop */
/* unused harmony export show */
/* unused harmony export siblings */
/* unused harmony export stop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return styles; });
/* unused harmony export submit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return toggleClass; });
/* unused harmony export touchend */
/* unused harmony export touchmove */
/* unused harmony export touchstart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return transform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return transitionEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return trigger; });
/* unused harmony export val */
/* unused harmony export value */
/* unused harmony export width */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
    return group.toUpperCase();
  });
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  var el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    var dataKey = el.getAttribute("data-" + key);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      var _attr = el.attributes[i];

      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }

  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    var el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      var values = [];

      for (var i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (var _i = 0; _i < this.length; _i += 1) {
    var _el = this[_i];

    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < _el.options.length; j += 1) {
        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
      }
    } else {
      _el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once() {
  var dom = this;

  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var eventName = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventName = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  function onceHandler() {
    for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      eventArgs[_key8] = arguments[_key8];
    }

    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  $(parent).append(this);
  return this;
}

function prepend(newChild) {
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  var before = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  var after = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add() {
  var dom = this;
  var i;
  var j;

  for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    els[_key10] = arguments[_key10];
  }

  for (i = 0; i < els.length; i += 1) {
    var toAdd = $(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

function scrollTo() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var left = args[0],
      top = args[1],
      duration = args[2],
      easing = args[3],
      callback = args[4];

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    left = args[0];
    top = args[1];
    duration = args[2];
    callback = args[3];
    easing = args[4];
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    var el = this;
    var currentTop;
    var currentLeft;
    var maxTop;
    var maxLeft;
    var newTop;
    var newLeft;
    var scrollTop; // eslint-disable-line

    var scrollLeft; // eslint-disable-line

    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time) {
      if (time === void 0) {
        time = new Date().getTime();
      }

      if (startTime === null) {
        startTime = time;
      }

      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var top = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    top = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }

  var dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var left = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    left = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }

  var dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var els = this;
  var a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],
    easingProgress: function easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },
    stop: function stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(function (el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done: function done(complete) {
      a.animating = false;
      a.elements.each(function (el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate: function animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      var elements = []; // Define & Cache Initials & Units

      a.elements.each(function (el, index) {
        var initialFullValue;
        var initialValue;
        var unit;
        var finalValue;
        var finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(function (prop) {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue: initialFullValue,
            initialValue: initialValue,
            unit: unit,
            finalValue: finalValue,
            finalFullValue: finalFullValue,
            currentValue: initialValue
          };
        });
      });
      var startTime = null;
      var time;
      var elementsDone = 0;
      var propsDone = 0;
      var done;
      var began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress;
        var easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(function (element) {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(function (prop) {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var _el$prop = el[prop],
                initialValue = _el$prop.initialValue,
                finalValue = _el$prop.finalValue,
                unit = _el$prop.unit;
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }
  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance;

  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;

  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'undefined') {
      for (var i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            $(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on.apply(this, [name].concat(args));
  }

  return eventHandler;
}

var click = shortcut('click');
var blur = shortcut('blur');
var focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var scroll = shortcut('scroll');

/* unused harmony default export */ var _unused_webpack_default_export = ($);



/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_support__ = __webpack_require__(109);


var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = Object(__WEBPACK_IMPORTED_MODULE_1__get_support__["a" /* getSupport */])();
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}



/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);

var browser;

function calcBrowser() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}



/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);



var supportsResizeObserver = function supportsResizeObserver() {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  return typeof window.ResizeObserver !== 'undefined';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resize',
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      observer: _extends({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-underscore-dangle */
/* harmony default export */ __webpack_exports__["a"] = ({
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__updateSize__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__updateSlides__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__updateAutoHeight__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__updateSlidesOffset__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__updateSlidesProgress__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__updateProgress__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__updateSlidesClasses__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__updateActiveIndex__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__updateClickedSlide__ = __webpack_require__(426);









/* harmony default export */ __webpack_exports__["a"] = ({
  updateSize: __WEBPACK_IMPORTED_MODULE_0__updateSize__["a" /* default */],
  updateSlides: __WEBPACK_IMPORTED_MODULE_1__updateSlides__["a" /* default */],
  updateAutoHeight: __WEBPACK_IMPORTED_MODULE_2__updateAutoHeight__["a" /* default */],
  updateSlidesOffset: __WEBPACK_IMPORTED_MODULE_3__updateSlidesOffset__["a" /* default */],
  updateSlidesProgress: __WEBPACK_IMPORTED_MODULE_4__updateSlidesProgress__["a" /* default */],
  updateProgress: __WEBPACK_IMPORTED_MODULE_5__updateProgress__["a" /* default */],
  updateSlidesClasses: __WEBPACK_IMPORTED_MODULE_6__updateSlidesClasses__["a" /* default */],
  updateActiveIndex: __WEBPACK_IMPORTED_MODULE_7__updateActiveIndex__["a" /* default */],
  updateClickedSlide: __WEBPACK_IMPORTED_MODULE_8__updateClickedSlide__["a" /* default */]
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateSlides;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateAutoHeight;
function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateSlidesOffset;
function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateSlidesProgress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(swiper.visibleSlides);
}

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateProgress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateSlidesClasses;
function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateActiveIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateClickedSlide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTranslate__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setTranslate__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__minTranslate__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__maxTranslate__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translateTo__ = __webpack_require__(432);





/* harmony default export */ __webpack_exports__["a"] = ({
  getTranslate: __WEBPACK_IMPORTED_MODULE_0__getTranslate__["a" /* default */],
  setTranslate: __WEBPACK_IMPORTED_MODULE_1__setTranslate__["a" /* default */],
  minTranslate: __WEBPACK_IMPORTED_MODULE_2__minTranslate__["a" /* default */],
  maxTranslate: __WEBPACK_IMPORTED_MODULE_3__maxTranslate__["a" /* default */],
  translateTo: __WEBPACK_IMPORTED_MODULE_4__translateTo__["a" /* default */]
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSwiperTranslate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* getTranslate */])($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setTranslate;
function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minTranslate;
function minTranslate() {
  return -this.snapGrid[0];
}

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maxTranslate;
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = translateTo;
function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setTransition__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitionStart__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transitionEnd__ = __webpack_require__(436);



/* harmony default export */ __webpack_exports__["a"] = ({
  setTransition: __WEBPACK_IMPORTED_MODULE_0__setTransition__["a" /* default */],
  transitionStart: __WEBPACK_IMPORTED_MODULE_1__transitionStart__["a" /* default */],
  transitionEnd: __WEBPACK_IMPORTED_MODULE_2__transitionEnd__["a" /* default */]
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setTransition;
function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transitionStart;
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transitionEnd;
function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slideTo__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slideToLoop__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slideNext__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slidePrev__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slideReset__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slideToClosest__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slideToClickedSlide__ = __webpack_require__(444);







/* harmony default export */ __webpack_exports__["a"] = ({
  slideTo: __WEBPACK_IMPORTED_MODULE_0__slideTo__["a" /* default */],
  slideToLoop: __WEBPACK_IMPORTED_MODULE_1__slideToLoop__["a" /* default */],
  slideNext: __WEBPACK_IMPORTED_MODULE_2__slideNext__["a" /* default */],
  slidePrev: __WEBPACK_IMPORTED_MODULE_3__slidePrev__["a" /* default */],
  slideReset: __WEBPACK_IMPORTED_MODULE_4__slideReset__["a" /* default */],
  slideToClosest: __WEBPACK_IMPORTED_MODULE_5__slideToClosest__["a" /* default */],
  slideToClickedSlide: __WEBPACK_IMPORTED_MODULE_6__slideToClickedSlide__["a" /* default */]
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slideTo;
function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slideToLoop;
function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slideNext;
/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slidePrev;
/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slideReset;
/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slideToClosest;
/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slideToClickedSlide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);


function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["h" /* nextTick */])(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["h" /* nextTick */])(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loopCreate__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loopFix__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loopDestroy__ = __webpack_require__(448);



/* harmony default export */ __webpack_exports__["a"] = ({
  loopCreate: __WEBPACK_IMPORTED_MODULE_0__loopCreate__["a" /* default */],
  loopFix: __WEBPACK_IMPORTED_MODULE_1__loopFix__["a" /* default */],
  loopDestroy: __WEBPACK_IMPORTED_MODULE_2__loopDestroy__["a" /* default */]
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);


function loopCreate() {
  var swiper = this;
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append(Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend(Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopFix;
function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopDestroy;
function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setGrabCursor__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unsetGrabCursor__ = __webpack_require__(451);


/* harmony default export */ __webpack_exports__["a"] = ({
  setGrabCursor: __WEBPACK_IMPORTED_MODULE_0__setGrabCursor__["a" /* default */],
  unsetGrabCursor: __WEBPACK_IMPORTED_MODULE_1__unsetGrabCursor__["a" /* default */]
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setGrabCursor;
function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unsetGrabCursor;
function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appendSlide__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prependSlide__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addSlide__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__removeSlide__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__removeAllSlides__ = __webpack_require__(457);





/* harmony default export */ __webpack_exports__["a"] = ({
  appendSlide: __WEBPACK_IMPORTED_MODULE_0__appendSlide__["a" /* default */],
  prependSlide: __WEBPACK_IMPORTED_MODULE_1__prependSlide__["a" /* default */],
  addSlide: __WEBPACK_IMPORTED_MODULE_2__addSlide__["a" /* default */],
  removeSlide: __WEBPACK_IMPORTED_MODULE_3__removeSlide__["a" /* default */],
  removeAllSlides: __WEBPACK_IMPORTED_MODULE_4__removeAllSlides__["a" /* default */]
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = appendSlide;
function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prependSlide;
function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSlide;
function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeSlide;
function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeAllSlides;
function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__onTouchStart__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__onTouchMove__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__onTouchEnd__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__onResize__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onClick__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__onScroll__ = __webpack_require__(464);







var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = __WEBPACK_IMPORTED_MODULE_1__onTouchStart__["a" /* default */].bind(swiper);
  swiper.onTouchMove = __WEBPACK_IMPORTED_MODULE_2__onTouchMove__["a" /* default */].bind(swiper);
  swiper.onTouchEnd = __WEBPACK_IMPORTED_MODULE_3__onTouchEnd__["a" /* default */].bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = __WEBPACK_IMPORTED_MODULE_6__onScroll__["a" /* default */].bind(swiper);
  }

  swiper.onClick = __WEBPACK_IMPORTED_MODULE_5__onClick__["a" /* default */].bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', __WEBPACK_IMPORTED_MODULE_4__onResize__["a" /* default */], true);
  } else {
    swiper.on('observerUpdate', __WEBPACK_IMPORTED_MODULE_4__onResize__["a" /* default */], true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', __WEBPACK_IMPORTED_MODULE_4__onResize__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  attachEvents: attachEvents,
  detachEvents: detachEvents
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onTouchStart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])() || el === Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onTouchMove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);



function onTouchMove(event) {
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onTouchEnd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["i" /* now */])();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["i" /* now */])();
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["h" /* nextTick */])(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["i" /* now */])() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onResize;
function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onClick;
function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onScroll;
function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setBreakpoint__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getBreakpoint__ = __webpack_require__(467);


/* harmony default export */ __webpack_exports__["a"] = ({
  setBreakpoint: __WEBPACK_IMPORTED_MODULE_0__setBreakpoint__["a" /* default */],
  getBreakpoint: __WEBPACK_IMPORTED_MODULE_1__getBreakpoint__["a" /* default */]
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setBreakpoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBreakpoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addClasses__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__removeClasses__ = __webpack_require__(470);


/* harmony default export */ __webpack_exports__["a"] = ({
  addClasses: __WEBPACK_IMPORTED_MODULE_0__addClasses__["a" /* default */],
  removeClasses: __WEBPACK_IMPORTED_MODULE_1__removeClasses__["a" /* default */]
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClasses;
function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClasses;
function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loadImage__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preloadImages__ = __webpack_require__(473);


/* harmony default export */ __webpack_exports__["a"] = ({
  loadImage: __WEBPACK_IMPORTED_MODULE_0__loadImage__["a" /* default */],
  preloadImages: __WEBPACK_IMPORTED_MODULE_1__preloadImages__["a" /* default */]
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = preloadImages;
function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  checkOverflow: checkOverflow
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Virtual = {
  update: function update(force) {
    var swiper = this;
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;
    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;
    var offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    var slidesAfter;
    var slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, offset + "px");
      }

      swiper.updateProgress();
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];

          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      }

      return;
    }

    var prependIndexes = [];
    var appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
        }
      }
    }

    for (var _i = 0; _i < slides.length; _i += 1) {
      if (_i >= from && _i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i);
        } else {
          if (_i > previousTo) appendIndexes.push(_i);
          if (_i < previousFrom) prependIndexes.push(_i);
        }
      }
    }

    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) {
      return b - a;
    }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
    onRendered();
  },
  renderSlide: function renderSlide(slide, index) {
    var swiper = this;
    var params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    var $slideEl = params.renderSlide ? Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(params.renderSlide.call(swiper, slide, index)) : Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  },
  appendSlide: function appendSlide(slides) {
    var swiper = this;

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slides) {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        var $cachedEl = cache[cachedIndex];
        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    swiper.virtual.update(true);
    swiper.slideTo(newActiveIndex, 0);
  },
  removeSlide: function removeSlide(slidesIndexes) {
    var swiper = this;
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    swiper.virtual.update(true);
    swiper.slideTo(activeIndex, 0);
  },
  removeAllSlides: function removeAllSlides() {
    var swiper = this;
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    swiper.virtual.update(true);
    swiper.slideTo(0, 0);
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      virtual: _extends({}, Virtual, {
        slides: swiper.params.virtual.slides,
        cache: {}
      })
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
      var overwriteParams = {
        watchSlidesProgress: true
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.params, overwriteParams);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.originalParams, overwriteParams);

      if (!swiper.params.initialSlide) {
        swiper.virtual.update();
      }
    },
    setTranslate: function setTranslate(swiper) {
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable consistent-return */



var Keyboard = {
  handle: function handle(event) {
    var swiper = this;
    if (!swiper.enabled) return;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    var kc = e.keyCode || e.charCode;
    var pageUpDown = swiper.params.keyboard.pageUpDown;
    var isPageUp = pageUpDown && kc === 33;
    var isPageDown = pageUpDown && kc === 34;
    var isArrowLeft = kc === 37;
    var isArrowRight = kc === 39;
    var isArrowUp = kc === 38;
    var isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      var inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
        return undefined;
      }

      var $el = swiper.$el;
      var swiperWidth = $el[0].clientWidth;
      var swiperHeight = $el[0].clientHeight;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable: function enable() {
    var swiper = this;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    if (swiper.keyboard.enabled) return;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(document).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable: function disable() {
    var swiper = this;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    if (!swiper.keyboard.enabled) return;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(document).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      keyboard: _extends({
        enabled: false
      }, Keyboard)
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy: function destroy(swiper) {
      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
/* eslint-disable consistent-return */




function isEventSupported() {
  var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
  var eventName = 'onwheel';
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

var Mousewheel = {
  lastScrollTime: Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])(),
  lastEventBeforeSnap: undefined,
  recentWheelEvents: [],
  event: function event() {
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    if (window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
    return isEventSupported() ? 'wheel' : 'mousewheel';
  },
  normalize: function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;
    var sX = 0;
    var sY = 0; // spinX, spinY

    var pX = 0;
    var pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  },
  handleMouseLeave: function handleMouseLeave() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  },
  handle: function handle(event) {
    var e = event;
    var disableParentSwiper = true;
    var swiper = this;
    if (!swiper.enabled) return;
    var params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;
    var data = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    var positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode) {
      // Register the new event in a variable which stores the relevant data
      var newEvent = {
        time: Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      var recentWheelEvents = swiper.mousewheel.recentWheelEvents;

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          swiper.mousewheel.animateSlider(newEvent);
        }
      } else {
        swiper.mousewheel.animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (swiper.mousewheel.releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      var _newEvent = {
        time: Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
      var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        swiper.mousewheel.lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        var position = swiper.getTranslate() + delta * params.sensitivity;
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = undefined;
          var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;

          if (_recentWheelEvents.length >= 15) {
            _recentWheelEvents.shift(); // only store the last N events

          }

          var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;

          var firstEvent = _recentWheelEvents[0];

          _recentWheelEvents.push(_newEvent);

          if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            _recentWheelEvents.splice(0);
          } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            var snapToThreshold = delta > 0 ? 0.8 : 0.2;
            swiper.mousewheel.lastEventBeforeSnap = _newEvent;

            _recentWheelEvents.splice(0);

            swiper.mousewheel.timeout = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["h" /* nextTick */])(function () {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!swiper.mousewheel.timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            swiper.mousewheel.timeout = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["h" /* nextTick */])(function () {
              var snapToThreshold = 0.5;
              swiper.mousewheel.lastEventBeforeSnap = _newEvent;

              _recentWheelEvents.splice(0);

              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  },
  animateSlider: function animateSlider(newEvent) {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

    if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (this.params.mousewheel.thresholdTime && Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])() - swiper.mousewheel.lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        swiper.emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      swiper.emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  },
  releaseScroll: function releaseScroll(newEvent) {
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  },
  enable: function enable() {
    var swiper = this;
    var event = Mousewheel.event();

    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
      return true;
    }

    if (!event) return false;
    if (swiper.mousewheel.enabled) return false;
    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(swiper.params.mousewheel.eventsTarget);
    }

    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable: function disable() {
    var swiper = this;
    var event = Mousewheel.event();

    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
      return true;
    }

    if (!event) return false;
    if (!swiper.mousewheel.enabled) return false;
    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(swiper.params.mousewheel.eventsTarget);
    }

    target.off(event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      mousewheel: {
        enabled: false,
        lastScrollTime: Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["i" /* now */])(),
        lastEventBeforeSnap: undefined,
        recentWheelEvents: [],
        enable: Mousewheel.enable,
        disable: Mousewheel.disable,
        handle: Mousewheel.handle,
        handleMouseEnter: Mousewheel.handleMouseEnter,
        handleMouseLeave: Mousewheel.handleMouseLeave,
        animateSlider: Mousewheel.animateSlider,
        releaseScroll: Mousewheel.releaseScroll
      }
    });
  },
  on: {
    init: function init(swiper) {
      if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
        swiper.mousewheel.disable();
      }

      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
    },
    destroy: function destroy(swiper) {
      if (swiper.params.cssMode) {
        swiper.mousewheel.enable();
      }

      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["c" /* createElementIfNotDefined */])(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      navigation: _extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(targetEl).is($prevEl) && !Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["c" /* createElementIfNotDefined */])(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(params.bulletClass));
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      pagination: _extends({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    var params = swiper.params.scrollbar;
    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
      $dragEl[0].style.width = newSize + "px";
    } else {
      $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
      $dragEl[0].style.height = newSize + "px";
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize;

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + "px";
    } else {
      $dragEl[0].style.height = dragSize + "px";
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;

    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;
    var positionRatio;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);
    clearTimeout(swiper.scrollbar.dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["h" /* nextTick */])(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    swiper.emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;
    swiper.params.scrollbar = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["c" /* createElementIfNotDefined */])($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
      el: 'swiper-scrollbar'
    });
    var params = swiper.params.scrollbar;
    if (!params.el) return;
    var $el = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

    if ($dragEl.length === 0) {
      $dragEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
      $el.append($dragEl);
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* extend */])(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      scrollbar: _extends({
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }, Scrollbar)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update(swiper) {
      swiper.scrollbar.updateSize();
    },
    resize: function resize(swiper) {
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate(swiper) {
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate(swiper) {
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      swiper.scrollbar.setTransition(duration);
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.scrollbar.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
      }
    },
    destroy: function destroy(swiper) {
      swiper.scrollbar.destroy();
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Parallax = {
  setTransform: function setTransform(el, progress) {
    var swiper = this;
    var rtl = swiper.rtl;
    var $el = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(el);
    var rtlFactor = rtl ? -1 : 1;
    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = parseInt(x, 10) * progress * rtlFactor + "%";
    } else {
      x = x * progress * rtlFactor + "px";
    }

    if (y.indexOf('%') >= 0) {
      y = parseInt(y, 10) * progress + "%";
    } else {
      y = y * progress + "px";
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform("translate3d(" + x + ", " + y + ", 0px)");
    } else {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
    }
  },
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides,
        progress = swiper.progress,
        snapGrid = swiper.snapGrid;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
      swiper.parallax.setTransform(el, progress);
    });
    slides.each(function (slideEl, slideIndex) {
      var slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
        swiper.parallax.setTransform(el, slideProgress);
      });
    });
  },
  setTransition: function setTransition(duration) {
    if (duration === void 0) {
      duration = this.params.speed;
    }

    var swiper = this;
    var $el = swiper.$el;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (parallaxEl) {
      var $parallaxEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(parallaxEl);
      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'parallax',
  params: {
    parallax: {
      enabled: false
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      parallax: _extends({}, Parallax)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (!swiper.params.parallax.enabled) return;
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    init: function init(swiper) {
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTranslate: function setTranslate(swiper) {
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTransition(duration);
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return distance;
  },
  // Events
  onGestureStart: function onGestureStart(e) {
    var swiper = this;
    var support = swiper.support;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(e.target).closest("." + swiper.params.slideClass);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    swiper.zoom.isScaling = true;
  },
  onGestureChange: function onGestureChange(e) {
    var swiper = this;
    var support = swiper.support;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') zoom.onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
    }

    gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
  },
  onGestureEnd: function onGestureEnd(e) {
    var swiper = this;
    var device = swiper.device;
    var support = swiper.support;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  },
  onTouchStart: function onTouchStart(e) {
    var swiper = this;
    var device = swiper.device;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove: function onTouchMove(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["f" /* getTranslate */])(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["f" /* getTranslate */])(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
  },
  onTouchEnd: function onTouchEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
  },
  onTransitionEnd: function onTransitionEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  },
  // Toggle Zoom
  toggle: function toggle(e) {
    var swiper = this;
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom.in(e);
    }
  },
  in: function _in(e) {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(e.target).closest("." + swiper.params.slideClass);
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
    gesture.$slideEl.addClass("" + params.zoomedSlideClass);
    var touchX;
    var touchY;
    var offsetX;
    var offsetY;
    var diffX;
    var diffY;
    var translateX;
    var translateY;
    var imageWidth;
    var imageHeight;
    var scaledWidth;
    var scaledHeight;
    var translateMinX;
    var translateMinY;
    var translateMaxX;
    var translateMaxY;
    var slideWidth;
    var slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
    gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
  },
  out: function out() {
    var swiper = this;
    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
    gesture.$slideEl = undefined;
  },
  toggleGestures: function toggleGestures(method) {
    var swiper = this;
    var zoom = swiper.zoom;
    var selector = zoom.slideSelector,
        passive = zoom.passiveListener;
    swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
    swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
    swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
  },
  enableGestures: function enableGestures() {
    if (this.zoom.gesturesEnabled) return;
    this.zoom.gesturesEnabled = true;
    this.zoom.toggleGestures('on');
  },
  disableGestures: function disableGestures() {
    if (!this.zoom.gesturesEnabled) return;
    this.zoom.gesturesEnabled = false;
    this.zoom.toggleGestures('off');
  },
  // Attach/Detach Events
  enable: function enable() {
    var swiper = this;
    var support = swiper.support;
    var zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    var activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    var slideSelector = "." + swiper.params.slideClass;
    swiper.zoom.passiveListener = passiveListener;
    swiper.zoom.slideSelector = slideSelector; // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
  },
  disable: function disable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (!zoom.enabled) return;
    var support = swiper.support;
    swiper.zoom.enabled = false;
    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    var activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    var slideSelector = "." + swiper.params.slideClass; // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      zoom: _extends({
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {}
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined
        }
      }, Zoom)
    });
    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
      get: function get() {
        return scale;
      },
      set: function set(value) {
        if (scale !== value) {
          var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
          var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
          swiper.emit('zoomChange', value, imageEl, slideEl);
        }

        scale = value;
      }
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy: function destroy(swiper) {
      swiper.zoom.disable();
    },
    touchStart: function touchStart(swiper, e) {
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchStart(e);
    },
    touchEnd: function touchEnd(swiper, e) {
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap: function doubleTap(swiper, e) {
      if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd: function transitionEnd(swiper) {
      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    },
    slideChange: function slideChange(swiper) {
      if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
        swiper.zoom.onTransitionEnd();
      }
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Lazy = {
  loadInSlide: function loadInSlide(index, loadInDuplicate) {
    if (loadInDuplicate === void 0) {
      loadInDuplicate = true;
    }

    var swiper = this;
    var params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
    var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(function (imageEl) {
      var $imageEl = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(imageEl);
      $imageEl.addClass(params.loadingClass);
      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');
      var $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', "url(\"" + background + "\")");
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(function (sourceEl) {
              var $source = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find("." + params.preloaderClass).remove();

        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }

        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load: function load() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        swiperParams = swiper.params,
        slides = swiper.slides,
        activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;
    var slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(slideEl).attr('data-swiper-slide-index');
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;

    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (slideEl) {
        var index = isVirtual ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(slideEl).attr('data-swiper-slide-index') : Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(slideEl).index();
        swiper.lazy.loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) swiper.lazy.loadInSlide(i);
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1) {
          if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
        } // Prev Slides


        for (var _i2 = minIndex; _i2 < activeIndex; _i2 += 1) {
          if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
        }
      } else {
        var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
        var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
      }
    }
  },
  checkInViewOnLoad: function checkInViewOnLoad() {
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var $scrollElement = swiper.params.lazy.scrollingElement ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(swiper.params.lazy.scrollingElement) : Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(window);
    var isWindow = $scrollElement[0] === window;
    var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    var swiperOffset = swiper.$el.offset();
    var rtl = swiper.rtlTranslate;
    var inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (var i = 0; i < swiperCoord.length; i += 1) {
      var point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    var passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      swiper.lazy.load();
      $scrollElement.off('scroll', swiper.lazy.checkInViewOnLoad, passiveListener);
    } else if (!swiper.lazy.scrollHandlerAttached) {
      swiper.lazy.scrollHandlerAttached = true;
      $scrollElement.on('scroll', swiper.lazy.checkInViewOnLoad, passiveListener);
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'lazy',
  params: {
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      lazy: _extends({
        initialImageLoaded: false
      }, Lazy)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function init(swiper) {
      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        if (swiper.params.lazy.checkInView) {
          swiper.lazy.checkInViewOnLoad();
        } else {
          swiper.lazy.load();
        }
      }
    },
    scroll: function scroll(swiper) {
      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    'scrollbarDragMove resize _freeModeNoMomentumRelease': function lazyLoad(swiper) {
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart: function transitionStart(swiper) {
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd: function transitionEnd(swiper) {
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    },
    slideChange: function slideChange(swiper) {
      var _swiper$params = swiper.params,
          lazy = _swiper$params.lazy,
          cssMode = _swiper$params.cssMode,
          watchSlidesVisibility = _swiper$params.watchSlidesVisibility,
          watchSlidesProgress = _swiper$params.watchSlidesProgress,
          touchReleaseOnEdges = _swiper$params.touchReleaseOnEdges,
          resistanceRatio = _swiper$params.resistanceRatio;

      if (lazy.enabled && (cssMode || (watchSlidesVisibility || watchSlidesProgress) && (touchReleaseOnEdges || resistanceRatio === 0))) {
        swiper.lazy.load();
      }
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex;
      var minIndex;
      var guess;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    var i1;
    var i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;

    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(_setTranslate, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier;
    var controlledTranslate;
    var Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var Swiper = swiper.constructor;
    var controlled = swiper.controller.control;
    var i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["h" /* nextTick */])(function () {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      controller: _extends({
        control: swiper.params.controller.control
      }, Controller)
    });
  },
  on: {
    update: function update(swiper) {
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize(swiper) {
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate(swiper) {
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(swiper, translate, byController) {
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(swiper, duration, byController) {
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var A11y = {
  getRandomNumber: function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }

    var randomChar = function randomChar() {
      return Math.round(16 * Math.random()).toString(16);
    };

    return 'x'.repeat(size).replace(/x/g, randomChar);
  },
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  makeElNotFocusable: function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElRoleDescription: function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
    return $el;
  },
  addElControls: function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  addElId: function addElId($el, id) {
    $el.attr('id', id);
    return $el;
  },
  addElLive: function addElLive($el, live) {
    $el.attr('aria-live', live);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    var swiper = this;
    var params = swiper.params.a11y;
    var $targetEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;
    if (swiper.params.loop || !swiper.navigation) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
        swiper.a11y.makeElNotFocusable($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
        swiper.a11y.makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
        swiper.a11y.makeElNotFocusable($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
        swiper.a11y.makeElFocusable($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;

    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletEl) {
        var $bulletEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      });
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.a11y;
    swiper.$el.append(swiper.a11y.liveRegion); // Container

    var $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      swiper.a11y.addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    var $wrapperEl = swiper.$wrapperEl;
    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
    var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    swiper.a11y.addElId($wrapperEl, wrapperId);
    swiper.a11y.addElLive($wrapperEl, live); // Slide

    if (params.itemRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription(Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(swiper.slides), params.itemRoleDescriptionMessage);
    }

    swiper.a11y.addElRole(Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(swiper.slides), params.slideRole);
    var slidesLength = swiper.params.loop ? swiper.slides.filter(function (el) {
      return !el.classList.contains(swiper.params.slideDuplicateClass);
    }).length : swiper.slides.length;
    swiper.slides.each(function (slideEl, index) {
      var $slideEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])(slideEl);
      var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
      var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
      swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
    }); // Navigation

    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      swiper.a11y.makeElFocusable($nextEl);

      if ($nextEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($nextEl, 'button');
        $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      swiper.a11y.addElControls($nextEl, wrapperId);
    }

    if ($prevEl && $prevEl.length) {
      swiper.a11y.makeElFocusable($prevEl);

      if ($prevEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($prevEl, 'button');
        $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      swiper.a11y.addElControls($prevEl, wrapperId);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* classesToSelector */])(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      a11y: _extends({}, A11y, {
        liveRegion: Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
      })
    });
  },
  on: {
    afterInit: function afterInit(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var History = {
  init: function init() {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    var history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues(swiper.params.url);
    if (!history.paths.key && !history.paths.value) return;
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState: function setHistoryPopState() {
    var swiper = this;
    swiper.history.paths = History.getPathValues(swiper.params.url);
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues: function getPathValues(urlOverride) {
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    var pathArray = location.pathname.slice(1).split('/').filter(function (part) {
      return part !== '';
    });
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return {
      key: key,
      value: value
    };
  },
  setHistory: function setHistory(key, index) {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
    var location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    var slide = swiper.slides.eq(index);
    var value = History.slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      var root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = root + "/" + key + "/" + value;
    } else if (!location.pathname.includes(key)) {
      value = key + "/" + value;
    }

    var currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value: value
      }, null, value);
    } else {
      window.history.pushState({
        value: value
      }, null, value);
    }
  },
  slugify: function slugify(text) {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  },
  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
    var swiper = this;

    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var slide = swiper.slides.eq(i);
        var slideHistory = History.slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          var index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'history',
  params: {
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      history: _extends({}, History)
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy: function destroy(swiper) {
      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(swiper) {
      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    },
    slideChange: function slideChange(swiper) {
      if (swiper.history.initialized && swiper.params.cssMode) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var HashNavigation = {
  onHashChange: function onHashChange() {
    var swiper = this;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    swiper.emit('hashChange');
    var newHash = document.location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  },
  setHash: function setHash() {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
      swiper.emit('hashSet');
    } else {
      var slide = swiper.slides.eq(swiper.activeIndex);
      var hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      swiper.emit('hashSet');
    }
  },
  init: function init() {
    var swiper = this;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    swiper.hashNavigation.initialized = true;
    var hash = document.location.hash.replace('#', '');

    if (hash) {
      var speed = 0;

      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var slide = swiper.slides.eq(i);
        var slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          var index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(window).on('hashchange', swiper.hashNavigation.onHashChange);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var window = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* getWindow */])();

    if (swiper.params.hashNavigation.watchState) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(window).off('hashchange', swiper.hashNavigation.onHashChange);
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      hashNavigation: _extends({
        initialized: false
      }, HashNavigation)
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy: function destroy(swiper) {
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(swiper) {
      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    },
    slideChange: function slideChange(swiper) {
      if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
        swiper.hashNavigation.setHash();
      }
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint no-underscore-dangle: "off" */


var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["h" /* nextTick */])(function () {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
        swiper.autoplay.run();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
      });
    }
  },
  onVisibilityChange: function onVisibilityChange() {
    var swiper = this;
    var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      swiper.autoplay.run();
      swiper.autoplay.paused = false;
    }
  },
  onTransitionEnd: function onTransitionEnd(e) {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.run();
    }
  },
  onMouseEnter: function onMouseEnter() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
  },
  onMouseLeave: function onMouseLeave() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    swiper.autoplay.run();
  },
  attachMouseEvents: function attachMouseEvents() {
    var swiper = this;

    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
    }
  },
  detachMouseEvents: function detachMouseEvents() {
    var swiper = this;
    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      autoplay: _extends({}, Autoplay, {
        running: false,
        paused: false
      })
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        swiper.autoplay.attachMouseEvents();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove(swiper) {
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd(swiper) {
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy(swiper) {
      swiper.autoplay.detachMouseEvents();

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      var document = Object(__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* getDocument */])();
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset = $slideEl[0].swiperSlideOffset;
      var tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      fadeEffect: _extends({}, Fade)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "fade");
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper.params, overwriteParams);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Cube = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides,
        swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        rtl = swiper.rtlTranslate,
        swiperSize = swiper.size,
        browser = swiper.browser;
    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: swiperWidth + "px"
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      var slideAngle = slideIndex * 90;
      var round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if (shadowBefore.length === 0) {
          shadowBefore = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
          $slideEl.append(shadowBefore);
        }

        if (shadowAfter.length === 0) {
          shadowAfter = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
          $slideEl.append(shadowAfter);
        }

        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
      '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
      '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
      'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var offset = params.shadowOffset;
        $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
      }
    }

    var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      cubeEffect: _extends({}, Cube)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'cube') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "cube");
      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.params, overwriteParams);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTransition(duration);
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Flip = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      var offset = $slideEl[0].swiperSlideOffset;
      var rotate = -180 * progress;
      var rotateY = rotate;
      var rotateX = 0;
      var tx = -offset;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if (shadowBefore.length === 0) {
          shadowBefore = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
          $slideEl.append(shadowBefore);
        }

        if (shadowAfter.length === 0) {
          shadowAfter = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
          $slideEl.append(shadowAfter);
        }

        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }

      $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        activeIndex = swiper.activeIndex,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false; // eslint-disable-next-line

      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;

        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      flipEffect: _extends({}, Flip)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'flip') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "flip");
      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.params, overwriteParams);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* extend */])(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTransition(duration);
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(3);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Coverflow = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        slides = swiper.slides,
        slidesSizesGrid = swiper.slidesSizesGrid;
    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform = swiper.translate;
    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth; // Each slide offset from center

    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      var translateZ = -translate * Math.abs(offsetMultiplier);
      var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
          $slideEl.append($shadowBeforeEl);
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* default */])("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
          $slideEl.append($shadowAfterEl);
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      coverflowEffect: _extends({}, Coverflow)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'coverflow') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
      swiper.classNames.push(swiper.params.containerModifierClass + "3d");
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTransition(duration);
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Thumbs = {
  init: function init() {
    var swiper = this;
    var thumbsParams = swiper.params.thumbs;
    if (swiper.thumbs.initialized) return false;
    swiper.thumbs.initialized = true;
    var SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["g" /* isObject */])(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass(Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* extend */])({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false
      }));
      swiper.thumbs.swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    return true;
  },
  onThumbClick: function onThumbClick() {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* default */])(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  },
  update: function update(initial) {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex;
      var direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    } // Activate thumbs


    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
      }
    } else {
      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
      }
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs'
    }
  },
  create: function create() {
    var swiper = this;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* bindModuleMethods */])(swiper, {
      thumbs: _extends({
        swiper: null,
        initialized: false
      }, Thumbs)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      var thumbs = swiper.params.thumbs;
      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange: function slideChange(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update: function update(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize: function resize(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate: function observerUpdate(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition: function setTransition(swiper, duration) {
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy: function beforeDestroy(swiper) {
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;

      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__esm_react_swiper__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__esm_react_swiper_slide__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__esm_react_swiper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__esm_react_swiper_slide__["a"]; });
/**
 * Swiper React 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */






/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Swiper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_params__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_swiper__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loop__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_changed_params__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_children__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__update_swiper__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__virtual__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__use_isomorphic_layout_effect__ = __webpack_require__(111);
var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var Swiper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var eventsAssigned = false;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var swiperElRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var swiperRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var oldPassedParamsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var oldSlides = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var nextElRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var prevElRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var paginationElRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var scrollbarElRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  var _getParams = Object(__WEBPACK_IMPORTED_MODULE_1__get_params__["a" /* getParams */])(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = Object(__WEBPACK_IMPORTED_MODULE_6__get_children__["a" /* getChildren */])(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = Object(__WEBPACK_IMPORTED_MODULE_2__init_swiper__["a" /* initSwiper */])(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = Object(__WEBPACK_IMPORTED_MODULE_4__loop__["a" /* calcLoopedSlides */])(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* extend */])(swiperRef.current.params.virtual, extendWith);
      Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* extend */])(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  Object(__WEBPACK_IMPORTED_MODULE_9__use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    Object(__WEBPACK_IMPORTED_MODULE_2__init_swiper__["b" /* mountSwiper */])({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  Object(__WEBPACK_IMPORTED_MODULE_9__use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    attachEvents();
    var changedParams = Object(__WEBPACK_IMPORTED_MODULE_5__get_changed_params__["a" /* getChangedParams */])(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      Object(__WEBPACK_IMPORTED_MODULE_7__update_swiper__["a" /* updateSwiper */])({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  Object(__WEBPACK_IMPORTED_MODULE_9__use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_8__virtual__["b" /* updateOnVirtualData */])(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__virtual__["a" /* renderVirtual */])(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_4__loop__["b" /* renderLoop */])(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    ref: swiperElRef,
    className: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* uniqueClasses */])("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* needsNavigation */])(swiperParams) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* needsScrollbar */])(swiperParams) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* needsPagination */])(swiperParams) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper.displayName = 'Swiper';


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__params_list__ = __webpack_require__(110);
// eslint-disable-next-line




function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* extend */])(params, __WEBPACK_IMPORTED_MODULE_0__core__["c" /* default */].defaults);
  Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* extend */])(params, __WEBPACK_IMPORTED_MODULE_0__core__["c" /* default */].extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = __WEBPACK_IMPORTED_MODULE_2__params_list__["a" /* paramsList */].map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isObject */])(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* extend */])(params[key], obj[key]);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* extend */])(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}



/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initSwiper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mountSwiper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(24);
// eslint-disable-next-line



function initSwiper(swiperParams) {
  return new __WEBPACK_IMPORTED_MODULE_0__core__["c" /* default */](swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* needsNavigation */])(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* needsPagination */])(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* needsScrollbar */])(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}



/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcLoopedSlides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderLoop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(37);
 // eslint-disable-next-line



function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = __WEBPACK_IMPORTED_MODULE_1__core__["c" /* default */].prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}



/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChangedParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__params_list__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(24);



function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = __WEBPACK_IMPORTED_MODULE_0__params_list__["a" /* paramsList */].filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isObject */])(swiperParams[key]) && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isObject */])(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}



/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function processChildren(c) {
  var slides = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}



/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateSwiper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);


function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isObject */])(currentParams[key]) && Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isObject */])(passedParams[key])) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* extend */])(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}



/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderVirtual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateOnVirtualData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}



/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SwiperSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__use_isomorphic_layout_effect__ = __webpack_require__(111);
var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SwiperSlide = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var slideElRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  Object(__WEBPACK_IMPORTED_MODULE_2__use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    ref: slideElRef,
    className: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* uniqueClasses */])("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';


/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contact_ContactForm__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_FooterSmall__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contact_ContactMap__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__contact_NurturingForm__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_directusLink__ = __webpack_require__(18);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var Contact=function Contact(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,consents=_ref.consents,claim=_ref.claim,companyInfo=_ref.companyInfo;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),topics=_useState2[0],setTopics=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var responseTopics;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_8__helpers_fetchCmsContent__["i" /* getCmsTopicList */])(language);case 2:responseTopics=_context.sent;setTopics(responseTopics);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function fetchContent(){return _ref2.apply(this,arguments);};}();fetchContent();},[language]);var contactDetails=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){if(!companyInfo){return{street:'',zip_code:'',town:'',vatIdName:'',vatIdNumber:'',shortName:'',fullName:''};}var companyRegistrationNumber=companyInfo.company_registration_number.map(function(_ref3){var translations=_ref3.translations,el=_objectWithoutProperties(_ref3,['translations']);return Object.assign({},el,__WEBPACK_IMPORTED_MODULE_10__helpers_directusLink__["a" /* default */].getTranslationByLang(translations));}).find(function(el){return el.company_registration_number_id===1;});return{street:companyInfo.street,zip_code:companyInfo.zip_code,town:companyInfo.town,vatIdName:companyRegistrationNumber?companyRegistrationNumber.name:'',vatIdNumber:companyRegistrationNumber?companyRegistrationNumber.number:'',shortName:companyInfo.short_name,fullName:companyInfo.full_name};},[language,companyInfo]);var contactClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('container-contact',{open:page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["c" /* PAGE_CONTACT */]});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:contactClassName,id:contactClassName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section-title',id:'section-title-contact'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{dangerouslySetInnerHTML:{__html:t('contact.title')}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contact',id:'page-contact'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contact-form',id:'page-contact-form'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-title',id:'contact-title'},t('contact.form.title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__contact_ContactForm__["a" /* default */],{t:t,language:language,consents:consents,topics:topics})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-contact-content',id:'page-contact-content-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-list',id:'contact-list-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-nurturing-form',id:'nurturing-form'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-title',id:'contact-title-01'},t('contact.people.title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__contact_NurturingForm__["a" /* default */],{t:t,language:language,consents:consents,topics:topics})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-list',id:'contact-list-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-title',id:'contact-title-02'},t('contact.headquarter.title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-elem',id:'contact-elem-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-avatar',id:'contact-avatar-01'}, false?React.createElement('img',{src:require('../../assets/images/footer/headquarter-avatar-128-de.jpg'),srcSet:require('../../assets/images/footer/headquarter-avatar-128-de.jpg')+' 1x,\n                                                    '+require('../../assets/images/footer/headquarter-avatar-256-de.jpg')+' 2x',alt:contactDetails.fullName}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__webpack_require__(45),srcSet:__webpack_require__(45)+' 1x,\n                                                    '+__webpack_require__(513)+' 2x',alt:contactDetails.fullName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-details',id:'contact-details'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-name',id:'contact-name-03'},t('contact.headquarter.address.company')),companyInfo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-text',id:'contact-text-03'},'ul. ',contactDetails.street,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),contactDetails.zip_code,' ',contactDetails.town,' ',t('contact.headquarter.address.country'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'tel:'+companyInfo.phone},' ',companyInfo.phone,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),contactDetails.vatIdName,': ',contactDetails.vatIdNumber,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),t('contact.headquarter.address.note').length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://sagiton.pl',target:'_blank',rel:'noopener noreferrer',className:'note',id:'note-01',dangerouslySetInnerHTML:{__html:t('contact.headquarter.address.note')}}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__contact_ContactMap__["a" /* default */],{t:t,language:language}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_FooterSmall__["a" /* default */],{t:t,language:language,openPage:openPage,claim:claim}));};Contact.defaultProps={companyInfo:null};Contact.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired,claim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_8__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Recaptcha__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Consent__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactDropdown__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_clarity__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_sentry__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable camelcase *//* eslint-disable max-len */var ContactForm=function(_Component){_inherits(ContactForm,_Component);function ContactForm(props){_classCallCheck(this,ContactForm);var _this=_possibleConstructorReturn(this,(ContactForm.__proto__||Object.getPrototypeOf(ContactForm)).call(this,props));_this.state={formType:'LemlockContactForm',name:'',surname:'',email:'',phone:'',message:'',selected_topic:-1,agreement_data:false,agreement_marketing:false,agreement_rodo:false,sending:false,error:{selected_topic:false,name:false,surname:false,email:false,phone:false,// message: false,
agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:null,errorType:null};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleRecaptchaError=_this.handleRecaptchaError.bind(_this);_this.handleServerError=_this.handleServerError.bind(_this);_this.handleTopicChange=_this.handleTopicChange.bind(_this);_this.reCaptchaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();return _this;}_createClass(ContactForm,[{key:'handleRecaptchaError',value:function handleRecaptchaError(){this.setState({responseType:'error',errorType:'recaptcha_error'});}},{key:'handleServerError',value:function handleServerError(){this.setState({responseType:'error',errorType:'server_error'});}},{key:'handleTopicChange',value:function handleTopicChange(value){this.setState({selected_topic:value});}},{key:'handleChange',value:function handleChange(e){switch(e.target.type){case'checkbox':{this.setState(_defineProperty({},e.target.name,e.target.checked));break;}case'textarea':{this.setState(_defineProperty({},e.target.name,e.target.value.substring(0,10000)));break;}default:{this.setState(_defineProperty({},e.target.name,e.target.value));break;}}}},{key:'handleSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _this2=this;var params,language,_state,name,surname,email,phone,message,agreement_data,agreement_marketing,agreement_rodo,errorAll,error,emailRegExp,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();params={};if(window.location.search!==''){params=JSON.parse('{"'+decodeURI(window.location.search.substring(1)).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');}language=this.props.language;_state=this.state,name=_state.name,surname=_state.surname,email=_state.email,phone=_state.phone,message=_state.message,agreement_data=_state.agreement_data,agreement_marketing=_state.agreement_marketing,agreement_rodo=_state.agreement_rodo;errorAll=false;error={selected_topic:false,name:false,surname:false,email:false,phone:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false};error.selected_topic=this.state.selected_topic===-1;errorAll=errorAll||error.selected_topic;error.name=name==='';errorAll=errorAll||error.name;error.surname=surname==='';errorAll=errorAll||error.surname;emailRegExp=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;// eslint-disable-line max-len
error.email=!emailRegExp.test(email);errorAll=errorAll||error.email;error.agreement_data=!agreement_data;errorAll=errorAll||error.agreement_data;error.agreement_rodo=!agreement_rodo;errorAll=errorAll||error.agreement_rodo;this.setState({error:error});token='';if(!(errorAll===false&&this.state.sending===false)){_context.next=26;break;}_context.next=25;return this.reCaptchaRef.current.executeAsync();case 25:token=_context.sent;case 26:if(errorAll===false&&this.state.sending===false&&token!==''){this.setState({sending:true},function(){__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:Object.assign({type:_this2.state.formType,clarity_project_id:__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].getProjectId(),session_id:sessionStorage.getItem('session_id'),form_name:'Formularz kontaktowy',selected_topic:_this2.state.selected_topic>=0?_this2.props.topics[_this2.state.selected_topic].key:'_default',name:name.substring(0,50),surname:surname.substring(0,50),email:email.substring(0,100),phone:phone.substring(0,20),message:message.substring(0,10000),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,recaptcha:token,referrer:document.referrer},params),headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].setCorrelationId(response);__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].setCustomAttributes(window.location.pathname);if(response.data&&response.data.success){_this2.setState({selected_topic:-1,name:'',surname:'',email:'',phone:'',message:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,error:{selected_topic:false,name:false,surname:false,email:false,phone:false,message:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:'success',errorType:null});}else{_this2.setState({error:{selected_topic:!!response.selected_topic,name:!!response.data.error_name,surname:!!response.data.error_surname,email:!!response.data.error_email,phone:!!response.data.error_phone,message:!!response.data.error_message,agreement_data:!!response.data.error_agreement_data,agreement_marketing:!!response.data.error_agreement_marketing,agreement_rodo:!!response.data.error_agreement_rodo},responseType:'error',errorType:'general_error'});}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_9__lib_sentry__["a" /* default */].captureException(err);var response=err.response;if(response.data.error==='RECAPTCHA_LOW_SCORE'||'RECAPTCHA_VALIDATION_ERROR'){_this2.handleRecaptchaError();}else{_this2.handleServerError();}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{form_info:JSON.stringify(Object.assign({type:_this2.state.formType,form_name:'Formularz kontaktowy',selected_topic:_this2.state.selected_topic>=0?_this2.props.topics[_this2.state.selected_topic].key:'_default',name:name.substring(0,50),surname:surname.substring(0,50),email:email.substring(0,100),phone:phone.substring(0,20),message:message.substring(0,10000),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,recaptcha:token,referrer:document.referrer,session_id:sessionStorage.getItem('session_id')},params))},headers:{'X-Requested-With':'XMLHttpRequest'}});}).finally(function(){if(_this2.reCaptchaRef.current)_this2.reCaptchaRef.current.reset();_this2.setState({sending:false});});});}else{this.setState({responseType:'error',errorType:'general_error'});}case 27:case'end':return _context.stop();}}},_callee,this);}));function handleSubmit(_x){return _ref.apply(this,arguments);}return handleSubmit;}()},{key:'render',value:function render(){var _this3=this;var _state2=this.state,responseType=_state2.responseType,errorType=_state2.errorType,error=_state2.error;var _props=this.props,t=_props.t,consents=_props.consents;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{method:'post',action:'',acceptCharset:'utf-8',className:'contact-page-form',onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContactDropdown__["a" /* default */],{error:this.state.error.selected_topic,topic:this.state.selected_topic,setSelectedTopic:function setSelectedTopic(value){return _this3.handleTopicChange(value);},topics:this.props.topics,t:t}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'name',id:'contact-form-input-field-01',value:this.state.name,placeholder:t('contact.form.placeholder.name')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.name}),onChange:this.handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'surname',id:'contact-form-input-field-02',value:this.state.surname,placeholder:t('contact.form.placeholder.surname')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.surname}),onChange:this.handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',name:'email',id:'contact-form-input-field-03',value:this.state.email,placeholder:t('contact.form.placeholder.email')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.email}),onChange:this.handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-04'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'phone',id:'contact-form-input-field-04',value:this.state.phone,placeholder:t('contact.form.placeholder.phone'),className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.phone}),onChange:this.handleChange,maxLength:20})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-textarea',id:'contact-form-textarea'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{name:'message',id:'contact-form-textarea-field',value:this.state.message,placeholder:''+t('contact.form.placeholder.message'),onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'contact-form-checkbox-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_data',id:'contact-form-checkbox-agree-data',checked:this.state.agreement_data,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contact-form-checkbox-agree-data',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_data})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Consent__["a" /* default */],{t:t,required:true,content:consents.contact.text,title:consents.contact.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'contact-form-checkbox-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_marketing',id:'contact-form-checkbox-agree-marketing',checked:this.state.agreement_marketing,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contact-form-checkbox-agree-marketing',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_marketing})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Consent__["a" /* default */],{t:t,content:consents.marketing.text,title:consents.marketing.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'contact-form-checkbox-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_rodo',id:'contact-form-checkbox-agree-rodo',checked:this.state.agreement_rodo,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contact-form-checkbox-agree-rodo',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_rodo})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Consent__["a" /* default */],{t:t,required:true,content:consents.rodo.text,title:consents.rodo.label}))),errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-gray',id:'contact-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'contact-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('contact.form.label.refresh'))):responseType!=='success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-gray',id:'contact-form-button-submit-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:this.state.sending,type:'submit',id:'contact-form-button-submit'},t('contact.form.label.button'))),responseType&&(responseType==='success'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message',responseType),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message',responseType)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+responseType))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error'),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+errorType)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Recaptcha__["a" /* default */],{ref:this.reCaptchaRef,language:this.props.language}));}}]);return ContactForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ContactForm.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired,topics:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactForm);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_maps__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_map_options__ = __webpack_require__(511);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactMap=function(_Component){_inherits(ContactMap,_Component);function ContactMap(props){_classCallCheck(this,ContactMap);var _this=_possibleConstructorReturn(this,(ContactMap.__proto__||Object.getPrototypeOf(ContactMap)).call(this,props));_this.map=null;_this.marker=null;_this.initMap=_this.initMap.bind(_this);return _this;}_createClass(ContactMap,[{key:'componentDidMount',value:function componentDidMount(){var language=this.props.language;__WEBPACK_IMPORTED_MODULE_2_google_maps___default.a.KEY='AIzaSyDmzZYzSO4gaZ2Wo5Jr4ZTIVd3TVD-Fh_k';__WEBPACK_IMPORTED_MODULE_2_google_maps___default.a.LIBRARIES=['places'];__WEBPACK_IMPORTED_MODULE_2_google_maps___default.a.LANGUAGE=[language];__WEBPACK_IMPORTED_MODULE_2_google_maps___default.a.load(this.initMap);}},{key:'initMap',value:function initMap(){var _this2=this;var t=this.props.t;var map=new window.google.maps.Map(document.getElementById('contact-map'),{zoom:12,options:__WEBPACK_IMPORTED_MODULE_3__data_map_options__["a" /* default */]});var request={placeId:t('contact.map.placeId'),fields:['name','formatted_address','place_id','geometry','adr_address','url']};var service=new window.google.maps.places.PlacesService(map);var infowindow=new window.google.maps.InfoWindow();service.getDetails(request,function(place,status){if(status===window.google.maps.places.PlacesServiceStatus.OK){var marker=new window.google.maps.Marker({map:map,position:place.geometry.location});map.setCenter(marker.getPosition());var content='\n                <div style="border-radius: 2px;">\n                <div  jstcache="0">\n                    <div jstcache="117" style="display:flex; justify-content: space-between" class="place-card place-card-large">  \n                        <div class="place-desc-large"> \n                            <div jstcache="36" class="place-name" jsan="7.place-name"><strong>'+place.name+'</strong></div> \n                            <div jstcache="37" class="address" jsan="7.address">'+place.formatted_address+'</div> \n                            </br>\n                            <div jsaction="placeCard.directions" > \n                            <a target="_blank"jstcache="52" style="color: #007acc" href='+t('contact.map.infowindow.navigate_url')+' class="navigate-link"> \n                                <div class="icon navigate-icon"></div> \n                                <div jstcache="53" class="navigate-text">'+t('contact.map.infowindow.navigate_text')+'</div> \n                            </a> \n                        </div> \n                        </div> \n                        \n                        <div jstcache="38" class="navigate" style="display:flex; flex-direction: column; align-items: flex-end; justify-content: flex-end;"> \n                            </br>\n                            <div class="review-box"> \n                            <a \n                            target="_blank" jstcache="44" style="color: #007acc"\n                            href='+t('contact.map.infowindow.review_url')+' \n                            jsaction="mouseup:placeCard.reviews" \n                            jsan="7.review-box-link,8.href,0.target,22.jsaction"\n                            >\n                                '+t('contact.map.infowindow.review_text')+'\n                            </a>\n                            </div> \n                            </br>\n                            <div class="large-map-box"> \n                            <a \n                                target="_blank" jstcache="44" style="color: #007acc" \n                                href='+place.url+' jsaction="mouseup:placeCard.reviews" jsan="7.review-box-link,8.href,0.target,22.jsaction"\n                            >\n                                '+t('contact.map.infowindow.large_map_text')+'\n                            </a>\n                            </div> \n                        </div> \n                    </div>  </div></div></div>';window.google.maps.event.addListener(marker,'click',function(){infowindow.setContent(content);infowindow.open(map,_this2);});infowindow.setContent(content);infowindow.open(map,marker);}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-map-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'contact-map',className:'contact-map'}));}}]);return ContactMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContactMap.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactMap);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {

	if (root === null) {
		throw new Error('Google-maps package can be used only in browser');
	}

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.GoogleMapsLoader = factory();
	}

})(typeof window !== 'undefined' ? window : null, function() {


	'use strict';


	var googleVersion = '3.31';

	var script = null;

	var google = null;

	var loading = false;

	var callbacks = [];

	var onLoadEvents = [];

	var originalCreateLoaderMethod = null;


	var GoogleMapsLoader = {};


	GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';

	GoogleMapsLoader.KEY = null;

	GoogleMapsLoader.LIBRARIES = [];

	GoogleMapsLoader.CLIENT = null;

	GoogleMapsLoader.CHANNEL = null;

	GoogleMapsLoader.LANGUAGE = null;

	GoogleMapsLoader.REGION = null;

	GoogleMapsLoader.VERSION = googleVersion;

	GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';


	GoogleMapsLoader._googleMockApiObject = {};


	GoogleMapsLoader.load = function(fn) {
		if (google === null) {
			if (loading === true) {
				if (fn) {
					callbacks.push(fn);
				}
			} else {
				loading = true;

				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
					ready(fn);
				};

				GoogleMapsLoader.createLoader();
			}
		} else if (fn) {
			fn(google);
		}
	};


	GoogleMapsLoader.createLoader = function() {
		script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = GoogleMapsLoader.createUrl();

		document.body.appendChild(script);
	};


	GoogleMapsLoader.isLoaded = function() {
		return google !== null;
	};


	GoogleMapsLoader.createUrl = function() {
		var url = GoogleMapsLoader.URL;

		url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;

		if (GoogleMapsLoader.KEY) {
			url += '&key=' + GoogleMapsLoader.KEY;
		}

		if (GoogleMapsLoader.LIBRARIES.length > 0) {
			url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
		}

		if (GoogleMapsLoader.CLIENT) {
			url += '&client=' + GoogleMapsLoader.CLIENT;
		}

		if (GoogleMapsLoader.CHANNEL) {
			url += '&channel=' + GoogleMapsLoader.CHANNEL;
		}

		if (GoogleMapsLoader.LANGUAGE) {
			url += '&language=' + GoogleMapsLoader.LANGUAGE;
		}

		if (GoogleMapsLoader.REGION) {
			url += '&region=' + GoogleMapsLoader.REGION;
		}

		if (GoogleMapsLoader.VERSION) {
			url += '&v=' + GoogleMapsLoader.VERSION;
		}

		return url;
	};


	GoogleMapsLoader.release = function(fn) {
		var release = function() {
			GoogleMapsLoader.KEY = null;
			GoogleMapsLoader.LIBRARIES = [];
			GoogleMapsLoader.CLIENT = null;
			GoogleMapsLoader.CHANNEL = null;
			GoogleMapsLoader.LANGUAGE = null;
			GoogleMapsLoader.REGION = null;
			GoogleMapsLoader.VERSION = googleVersion;

			google = null;
			loading = false;
			callbacks = [];
			onLoadEvents = [];

			if (typeof window.google !== 'undefined') {
				delete window.google;
			}

			if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
				delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
			}

			if (originalCreateLoaderMethod !== null) {
				GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
				originalCreateLoaderMethod = null;
			}

			if (script !== null) {
				script.parentElement.removeChild(script);
				script = null;
			}

			if (fn) {
				fn();
			}
		};

		if (loading) {
			GoogleMapsLoader.load(function() {
				release();
			});
		} else {
			release();
		}
	};


	GoogleMapsLoader.onLoad = function(fn) {
		onLoadEvents.push(fn);
	};


	GoogleMapsLoader.makeMock = function() {
		originalCreateLoaderMethod = GoogleMapsLoader.createLoader;

		GoogleMapsLoader.createLoader = function() {
			window.google = GoogleMapsLoader._googleMockApiObject;
			window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
		};
	};


	var ready = function(fn) {
		var i;

		loading = false;

		if (google === null) {
			google = window.google;
		}

		for (i = 0; i < onLoadEvents.length; i++) {
			onLoadEvents[i](google);
		}

		if (fn) {
			fn(google);
		}

		for (i = 0; i < callbacks.length; i++) {
			callbacks[i](google);
		}

		callbacks = [];
	};


	return GoogleMapsLoader;

});


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mapStyle=[{featureType:'administrative',elementType:'labels.text.fill',stylers:[{color:'#444444'}]},{featureType:'landscape.man_made',elementType:'geometry',stylers:[{saturation:'-100'}]},{featureType:'landscape.natural',elementType:'all',stylers:[{color:'#f2f2f2'}]},{featureType:'poi',elementType:'all',stylers:[{visibility:'off'}]},{featureType:'poi.park',elementType:'all',stylers:[{visibility:'on'}]},{featureType:'poi.park',elementType:'labels',stylers:[{visibility:'off'}]},{featureType:'road',elementType:'all',stylers:[{saturation:-100},{lightness:45}]},{featureType:'road.highway',elementType:'all',stylers:[{visibility:'simplified'}]},{featureType:'road.arterial',elementType:'labels.icon',stylers:[{visibility:'off'}]},{featureType:'transit',elementType:'all',stylers:[{visibility:'off'}]},{featureType:'water',elementType:'all',stylers:[{color:'#46bcec'},{visibility:'on'}]}];var mapOptions={styles:mapStyle,streetViewControl:true,scaleControl:true,mapTypeControl:false,panControl:true,zoomControl:true,rotateControl:false,fullscreenControl:false};/* harmony default export */ __webpack_exports__["a"] = (mapOptions);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Consent__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactDropdown__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_clarity__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Recaptcha__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_sentry__ = __webpack_require__(17);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var reCaptchaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();var NurturingForm=function NurturingForm(_ref){var t=_ref.t,language=_ref.language,consents=_ref.consents,topics=_ref.topics;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({agreement_rodo:false,agreement_data:false,agreement_marketing:false,selected_topic:-1,responseType:'',errorType:null}),_useState2=_slicedToArray(_useState,2),state=_useState2[0],setState=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),sending=_useState4[0],setSending=_useState4[1];var formType='LemlockNurturingForm';var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({agreement_rodo:false,agreement_data:false,selected_topic:false}),_useState6=_slicedToArray(_useState5,2),error=_useState6[0],setError=_useState6[1];var correlationId=void 0;var sessionId=sessionStorage.getItem('session_id');var handleRecaptchaError=function handleRecaptchaError(){setState(Object.assign({},state,{responseType:'error',errorType:'recaptcha_error'}));};var handleServerError=function handleServerError(){setState(Object.assign({},state,{responseType:'error',errorType:'server_error'}));};var submitNurturingForm=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var params,errorAny,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();params={};if(window.location.search!==''){params=JSON.parse('{"'+decodeURI(window.location.search.substring(1)).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');}error.agreement_data=!state.agreement_data;error.agreement_rodo=!state.agreement_rodo;error.selected_topic=state.selected_topic===-1;errorAny=Object.keys(error).reduce(function(acc,key){return error[key]||acc;},false);token='';if(!(!errorAny&&!sending)){_context.next=12;break;}_context.next=11;return reCaptchaRef.current.executeAsync();case 11:token=_context.sent;case 12:if(!errorAny&&!sending&&token!==''){setSending(true);__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{type:formType,agreement_data:state.agreement_data,agreement_marketing:state.agreement_marketing,agreement_rodo:state.agreement_rodo,language:language,recaptcha:token,referrer:document.referrer,visit_data:JSON.stringify(params),session_id:sessionId,clarity_project_id:__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].getProjectId()},headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].setCorrelationId(response);__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].setCustomAttributes(window.location.pathname);if(response.data&&response.data.success){setState(Object.assign({},state,{agreement_data:false,agreement_marketing:false,agreement_rodo:false,responseType:'success',errorType:null}));}else{setError({agreement_data:!!response.data.error_agreement_data,agreement_marketing:!!response.data.error_agreement_marketing,agreement_rodo:!!response.data.error_agreement_rodo});setState(Object.assign({},state,{responseType:'error',errorType:'general_error'}));}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_10__lib_sentry__["a" /* default */].ex(err);var response=err.response;if(response.data.error==='RECAPTCHA_LOW_SCORE'||'RECAPTCHA_VALIDATION_ERROR'){handleRecaptchaError();}else{handleServerError();}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{form_info:JSON.stringify({type:formType,agreement_data:state.agreement_data,agreement_marketing:state.agreement_marketing,agreement_rodo:state.agreement_rodo,language:language,recaptcha:token,referrer:document.referrer,visit_data:JSON.stringify(params),session_id:sessionId})},headers:{'X-Requested-With':'XMLHttpRequest'}});}).finally(function(){if(reCaptchaRef.current)reCaptchaRef.current.reset();setSending(false);});}else{setState(Object.assign({},state,{responseType:'error',errorType:'general_error'}));}case 13:case'end':return _context.stop();}}},_callee,_this);}));return function submitNurturingForm(_x){return _ref2.apply(this,arguments);};}();return state.responseType!=='success'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContactDropdown__["a" /* default */],{error:error.selected_topic,topic:state.selected_topic,setSelectedTopic:function setSelectedTopic(value){return setState(Object.assign({},state,{selected_topic:value}));},topics:topics,t:t}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'nurturing-form-checkbox-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_data',id:'nurturing-form-checkbox-agree-data',checked:state.agreement_data,onChange:function onChange(){return setState(Object.assign({},state,{agreement_data:!state.agreement_data}));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'nurturing-form-checkbox-agree-data',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_data})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Consent__["a" /* default */],{t:t,required:true,content:consents.contact.text,title:consents.contact.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'nurturing-form-checkbox-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_marketing',id:'nurturing-form-checkbox-agree-marketing',checked:state.marketing_data,onChange:function onChange(){return setState(Object.assign({},state,{agreement_marketing:!state.agreement_marketing}));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'nurturing-form-checkbox-agree-marketing',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_marketing})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Consent__["a" /* default */],{t:t,content:consents.marketing.text,title:consents.marketing.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'nurturing-form-checkbox-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_rodo',id:'nurturing-form-checkbox-agree-rodo',checked:state.agreement_rodo,onChange:function onChange(){return setState(Object.assign({},state,{agreement_rodo:!state.agreement_rodo}));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'nurturing-form-checkbox-agree-rodo',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_rodo})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Consent__["a" /* default */],{t:t,required:true,content:consents.rodo.text,title:consents.rodo.label}))),state.errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-gray',id:'contact-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'contact-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('contact.form.label.refresh'))):state.responseType!=='success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-gray'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',onClick:submitNurturingForm,disabled:sending},t('contact.form.label.showEmail'))),state.responseType&&state.responseType==='error'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error'),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+state.errorType))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Recaptcha__["a" /* default */],{ref:reCaptchaRef,language:language})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nurturing-form-info-box-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'icon-circle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_5__data_icons__["a" /* default */].social.email}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:t('contact.form.label.mailToDisclaimerText')}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{overflowWrap:'break-word'},href:'mailto:'+topics[state.selected_topic].key+'+'+(correlationId||'_default')+'@lemlock.pl?subject=Lemlock '+topics[state.selected_topic].name+' '+t('contact.form.label.mailToTitle')},topics[state.selected_topic].key,'+',correlationId||'_'+sessionId||'_default','@lemlock.pl'));};NurturingForm.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired,topics:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (NurturingForm);

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/headquarter-avatar-256.11306326.jpg";

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EbookHeader__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EbookContent__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Form__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_fetchCmsContent__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebook=function(_Component){_inherits(Ebook,_Component);function Ebook(props){_classCallCheck(this,Ebook);var _this=_possibleConstructorReturn(this,(Ebook.__proto__||Object.getPrototypeOf(Ebook)).call(this,props));_this.scrollToForm=_this.scrollToForm.bind(_this);return _this;}_createClass(Ebook,[{key:'scrollToForm',value:function scrollToForm(){var breakpoint=this.props.breakpoint;var ebookForm=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.ebook-form');if(!ebookForm.length){return;}if(breakpoint!=='phone'&&breakpoint!=='tablet'){return;}var ebookFormOffsetTop=ebookForm.offset().top;var ios=!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform);if(ios){window.scrollTo(0,ebookFormOffsetTop);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('html, body').animate({scrollTop:ebookFormOffsetTop},1000);}}},{key:'render',value:function render(){var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language,page=_props.page,subpage=_props.subpage,breakpoint=_props.breakpoint,consents=_props.consents,companyInfo=_props.companyInfo;var ebookClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('container-ebook',{open:page===__WEBPACK_IMPORTED_MODULE_5__config_pages__["d" /* PAGE_EBOOK */]});var ebooks=t('ebook.list');var ebookIndex=null;var ebook=null;if(subpage!==null){ebookIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(ebooks,function(o){return o.slug===subpage;});if(ebookIndex!==-1){ebook=ebooks[ebookIndex];}}if(ebook===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:ebookClassName,id:ebookClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EbookHeader__["a" /* default */],{t:t,subpage:subpage,language:language,breakpoint:breakpoint,scrollToForm:this.scrollToForm,ebook:ebook,showShadow:ebookIndex===0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EbookContent__["a" /* default */],{t:t,openPage:openPage,language:language,breakpoint:breakpoint,scrollToForm:this.scrollToForm,ebook:ebook,consents:consents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Form__["a" /* default */],{type:'bottom',t:t,language:language,formName:'ebook-bottom',typeButton:'offer',consents:consents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:this.props.claim,companyInfo:companyInfo}));}}]);return Ebook;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Ebook.defaultProps={subpage:null,companyInfo:null};Ebook.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,claim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_10__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (Ebook);

/***/ }),
/* 515 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(517),
    baseMatchesProperty = __webpack_require__(530),
    identity = __webpack_require__(541),
    isArray = __webpack_require__(14),
    property = __webpack_require__(542);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(518),
    getMatchData = __webpack_require__(529),
    matchesStrictComparable = __webpack_require__(117);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(46),
    baseIsEqual = __webpack_require__(114);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(46),
    equalArrays = __webpack_require__(115),
    equalByTag = __webpack_require__(525),
    equalObjects = __webpack_require__(528),
    getTag = __webpack_require__(36),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(50),
    isTypedArray = __webpack_require__(93);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(49),
    setCacheAdd = __webpack_require__(521),
    setCacheHas = __webpack_require__(522);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 521 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 522 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 524 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    Uint8Array = __webpack_require__(103),
    eq = __webpack_require__(47),
    equalArrays = __webpack_require__(115),
    mapToArray = __webpack_require__(526),
    setToArray = __webpack_require__(527);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(101);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(116),
    keys = __webpack_require__(35);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(114),
    get = __webpack_require__(531),
    hasIn = __webpack_require__(538),
    isKey = __webpack_require__(59),
    isStrictComparable = __webpack_require__(116),
    matchesStrictComparable = __webpack_require__(117),
    toKey = __webpack_require__(39);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(118);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(533);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(534);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(49);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(536);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    arrayMap = __webpack_require__(537),
    isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(38);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(539),
    hasPath = __webpack_require__(540);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(119),
    isArguments = __webpack_require__(91),
    isArray = __webpack_require__(14),
    isIndex = __webpack_require__(92),
    isLength = __webpack_require__(52),
    toKey = __webpack_require__(39);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(543),
    basePropertyDeep = __webpack_require__(544),
    isKey = __webpack_require__(59),
    toKey = __webpack_require__(39);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(118);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(546);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(547);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20),
    isSymbol = __webpack_require__(38);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var EbookHeader=function EbookHeader(_ref){var t=_ref.t,breakpoint=_ref.breakpoint,scrollToForm=_ref.scrollToForm,ebook=_ref.ebook,showShadow=_ref.showShadow;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-ebook-header',id:'container-ebook-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-ebook-header',id:'page-ebook-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-header',id:'ebook-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-header-title',id:'ebook-header-title'},ebook.header.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-header-subtitle',id:'ebook-header-subtitle'},ebook.header.subtitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-header-image-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('ebook-header-image',{shadow:showShadow}),id:'ebook-header-image',onClick:scrollToForm},(breakpoint==='widescreen'||breakpoint==='desktop'||breakpoint==='laptop')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip'},t('ebook.tooltip')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(549)("./"+ebook.header.cover.image),alt:ebook.header.cover.alt}))))));};EbookHeader.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,scrollToForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,ebook:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,showShadow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EbookHeader);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./gdpr-all-about-cover-de.jpg": 550,
	"./gdpr-all-about-cover-de@2x.jpg": 551,
	"./gdpr-all-about-cover-en.jpg": 552,
	"./gdpr-all-about-cover-en@2x.jpg": 553,
	"./gdpr-for-marketing-cover-de.png": 554,
	"./gdpr-for-marketing-cover-en.png": 555,
	"./podejscia-do-cyberbezpieczenstwa-cover-pl.png": 556,
	"./rodo-w-marketingu-cover-pl.png": 557,
	"./views-on-cybersecurity-cover-de.png": 558,
	"./views-on-cybersecurity-cover-en.png": 559,
	"./wszystko-o-rodo-cover-pl.jpg": 560,
	"./wszystko-o-rodo-cover-pl@2x.jpg": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 549;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr-all-about-cover-de.caa62562.jpg";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr-all-about-cover-de@2x.c6aecae3.jpg";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr-all-about-cover-en.caa62562.jpg";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr-all-about-cover-en@2x.c6aecae3.jpg";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr-for-marketing-cover-de.bd6600b2.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gdpr-for-marketing-cover-en.9b8635d6.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/podejscia-do-cyberbezpieczenstwa-cover-pl.509b0da7.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rodo-w-marketingu-cover-pl.6f27f683.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/views-on-cybersecurity-cover-de.47750ad7.png";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/views-on-cybersecurity-cover-en.49682a2d.png";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wszystko-o-rodo-cover-pl.1cd2d253.jpg";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wszystko-o-rodo-cover-pl@2x.c5f20719.jpg";

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EbookForm__ = __webpack_require__(563);
var EbookContent=function EbookContent(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,breakpoint=_ref.breakpoint,scrollToForm=_ref.scrollToForm,ebook=_ref.ebook,consents=_ref.consents;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-ebook-content',id:'container-ebook-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-ebook-content',id:'page-ebook-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-content',id:'ebook-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-content-title',id:'ebook-content-title'},ebook.content.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ebook-content-list',onClick:scrollToForm},(breakpoint==='widescreen'||breakpoint==='desktop'||breakpoint==='laptop')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip'},t('ebook.tooltip')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_List__["a" /* default */],{data:ebook.content.list}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EbookForm__["a" /* default */],{t:t,openPage:openPage,language:language,ebook:ebook,consents:consents}))));};EbookContent.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,breakpoint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,scrollToForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,ebook:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (EbookContent);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Consent__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Recaptcha__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_sentry__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_pages__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable camelcase *//* eslint-disable max-len */var EbookForm=function(_Component){_inherits(EbookForm,_Component);function EbookForm(props){_classCallCheck(this,EbookForm);var _this=_possibleConstructorReturn(this,(EbookForm.__proto__||Object.getPrototypeOf(EbookForm)).call(this,props));_this.state={formType:'LemlockEbookContactForm',name:'',surname:'',email:'',company:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,sending:false,error:{name:false,surname:false,email:false,company:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:null,errorType:null};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleRecaptchaError=_this.handleRecaptchaError.bind(_this);_this.handleServerError=_this.handleServerError.bind(_this);_this.reCaptchaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();return _this;}_createClass(EbookForm,[{key:'handleRecaptchaError',value:function handleRecaptchaError(){this.setState({responseType:'error',errorType:'recaptcha_error'});}},{key:'handleServerError',value:function handleServerError(){this.setState({responseType:'error',errorType:'server_error'});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.type==='checkbox'?e.target.checked:e.target.value));}},{key:'handleSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _this2=this;var params,language,_state,name,surname,email,company,agreement_data,agreement_marketing,agreement_rodo,errorAll,error,emailRegExp,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();params={};if(window.location.search!==''){params=JSON.parse('{"'+decodeURI(window.location.search.substring(1)).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');}language=this.props.language;_state=this.state,name=_state.name,surname=_state.surname,email=_state.email,company=_state.company,agreement_data=_state.agreement_data,agreement_marketing=_state.agreement_marketing,agreement_rodo=_state.agreement_rodo;errorAll=false;error={name:false,surname:false,email:false,company:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false};error.name=name==='';errorAll=errorAll||error.name;error.surname=surname==='';errorAll=errorAll||error.surname;emailRegExp=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;// eslint-disable-line max-len
error.email=!emailRegExp.test(email);errorAll=errorAll||error.email;error.company=company==='';errorAll=errorAll||error.company;error.agreement_data=!agreement_data;errorAll=errorAll||error.agreement_data;error.agreement_rodo=!agreement_rodo;errorAll=errorAll||error.agreement_rodo;error.agreement_marketing=!agreement_marketing;errorAll=errorAll||error.agreement_marketing;this.setState({error:error});token='';if(!(errorAll===false&&this.state.sending===false)){_context.next=28;break;}_context.next=27;return this.reCaptchaRef.current.executeAsync();case 27:token=_context.sent;case 28:if(errorAll===false&&this.state.sending===false&&token!==''){this.setState({sending:true},function(){__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:Object.assign({form_name:'Krótki formularz wyceny',type:_this2.state.formType,name:name.substring(0,50),surname:surname.substring(0,50),email:email.substring(0,100),company:company.substring(0,100),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,slug:_this2.props.ebook.slug,recaptcha:token,gdpr_all_about:_this2.props.ebook.id==='gdpr_all_about',gdpr_for_marketing:_this2.props.ebook.id==='gdpr_for_marketing',views_on_cybersecurity:_this2.props.ebook.id==='views_on_cybersecurity',referrer:document.referrer},params),headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){if(response.data&&response.data.success){_this2.setState({name:'',surname:'',email:'',company:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,error:{name:false,surname:false,email:false,company:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:'success',errorType:null});_this2.props.openPage(__WEBPACK_IMPORTED_MODULE_8__config_pages__["h" /* PAGE_OFFER */],null,null,language,true,{ebook:'download'});}else{_this2.setState({error:Object.assign({},_this2.state.error,{name:!!response.data.error_name,surname:!!response.data.error_surname,email:!!response.data.error_email,company:!!response.data.error_company,agreement_data:!!response.data.error_agreement_data,agreement_marketing:!!response.data.error_agreement_marketing,agreement_rodo:!!response.data.error_agreement_rodo}),responseType:'error',errorType:response.data.error});}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_7__lib_sentry__["a" /* default */].captureException(err);var response=err.response;if(response.data.error==='RECAPTCHA_LOW_SCORE'||'RECAPTCHA_VALIDATION_ERROR'){_this2.handleRecaptchaError();}else{_this2.handleServerError();}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{form_info:JSON.stringify(Object.assign({type:_this2.state.formType,name:name.substring(0,50),surname:surname.substring(0,50),email:email.substring(0,100),company:company.substring(0,100),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,slug:_this2.props.ebook.slug,recaptcha:token,gdpr_all_about:_this2.props.ebook.id==='gdpr_all_about',gdpr_for_marketing:_this2.props.ebook.id==='gdpr_for_marketing',views_on_cybersecurity:_this2.props.ebook.id==='views_on_cybersecurity',referrer:document.referrer},params))},headers:{'X-Requested-With':'XMLHttpRequest'}});}).finally(function(){_this2.setState({sending:false});if(_this2.reCaptchaRef)_this2.reCaptchaRef.current.reset();});});}else{this.setState({responseType:'error',errorType:'general_error'});}case 29:case'end':return _context.stop();}}},_callee,this);}));function handleSubmit(_x){return _ref.apply(this,arguments);}return handleSubmit;}()},{key:'render',value:function render(){var _state2=this.state,responseType=_state2.responseType,errorType=_state2.errorType,error=_state2.error;var _props=this.props,t=_props.t,consents=_props.consents,language=_props.language;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{method:'post',action:'',acceptCharset:'utf-8',className:'ebook-form',id:'ebook-form',onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ebook-form-title'},t('ebook.form.title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'ebook-form-input-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'name',id:'ebook-form-input-field-01',value:this.state.name,placeholder:t('ebook.form.placeholder.name')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.name}),onChange:this.handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'ebook-form-input-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'surname',id:'ebook-form-input-field-02',value:this.state.surname,placeholder:t('ebook.form.placeholder.surname')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.surname}),onChange:this.handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'ebook-form-input-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',name:'email',id:'ebook-form-input-field-03',value:this.state.email,placeholder:t('ebook.form.placeholder.email')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.email}),onChange:this.handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'ebook-form-input-04'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'company',id:'ebook-form-input-field-04',value:this.state.company,placeholder:t('ebook.form.placeholder.company')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.company}),onChange:this.handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'ebook-form-checkbox-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_data',id:'ebook_form_input_agreement_data',checked:this.state.agreement_data,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'ebook_form_input_agreement_data',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_data})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.contact.text,title:consents.contact.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'ebook-form-checkbox-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_marketing',id:'ebook_form_input_agreement_marketing',checked:this.state.agreement_marketing,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'ebook_form_input_agreement_marketing',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_marketing})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.marketing.text,title:consents.marketing.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'ebook-form-checkbox-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_rodo',id:'ebook_form_input_agreement_rodo',checked:this.state.agreement_rodo,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'ebook_form_input_agreement_rodo',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_rodo})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.rodo.text,title:consents.rodo.label})),errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-blue',id:'ebook-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'ebook-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('ebook.form.label.refresh'))):responseType!=='success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-blue',id:'ebook-form-button-submit-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:this.state.sending,type:'submit',id:'ebook-form-button-submit'},t('ebook.form.label.button'))),responseType&&(responseType==='success'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message',responseType),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message',responseType)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+responseType))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error'),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+errorType)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Recaptcha__["a" /* default */],{ref:this.reCaptchaRef,language:language}));}}]);return EbookForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);EbookForm.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,ebook:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape().isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (EbookForm);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EbookDownload=function(_Component){_inherits(EbookDownload,_Component);function EbookDownload(props){_classCallCheck(this,EbookDownload);var _this=_possibleConstructorReturn(this,(EbookDownload.__proto__||Object.getPrototypeOf(EbookDownload)).call(this,props));_this.state={open:false,show:false};return _this;}_createClass(EbookDownload,[{key:'componentWillMount',value:function componentWillMount(){if(typeof this.props.query.ebook!=='undefined'&&this.props.query.ebook==='download'){this.setState({show:true,open:true});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(typeof nextProps.query.ebook!=='undefined'&&nextProps.query.ebook==='download'){this.setState({show:true,open:true});}else{this.setState({open:false},function(){setTimeout(function(){return _this2.setState({show:false});},550);});}}},{key:'render',value:function render(){var _state=this.state,open=_state.open,show=_state.show;if(open===false&&show===false){return null;}var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language,page=_props.page,subpage=_props.subpage;var downloadClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-ebook-download',{open:this.state.open});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:downloadClassName,id:'container-ebook-download'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-ebook-download',id:'page-ebook-download'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ebook-download-text',id:'ebook-download-text',dangerouslySetInnerHTML:{__html:t('ebook.download.text')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:page,subpage:subpage,className:'ebook-download-close',id:'ebook-download-close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line-1',id:'ebook-download-line-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line-2',id:'ebook-download-line-2'})))));}}]);return EbookDownload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EbookDownload.defaultProps={subpage:null,query:{}};EbookDownload.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,query:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};/* harmony default export */ __webpack_exports__["a"] = (EbookDownload);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_regexContent__ = __webpack_require__(120);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* eslint-disable */var PrivacyPolicy=function PrivacyPolicy(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,claim=_ref.claim,companyInfo=_ref.companyInfo;var privacyPolicyClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()("container-privacy-policy",{open:page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["i" /* PAGE_PRIVACY */]});var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),data=_useState2[0],setData=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_fetchCmsContent__["h" /* getCmsStatic */])(page,language);case 2:response=_context.sent;setData(response);case 4:case"end":return _context.stop();}}},_callee,_this);}));return function fetchContent(){return _ref2.apply(this,arguments);};}();fetchContent();},[language,page]);var content=void 0;if(data){content=Object(__WEBPACK_IMPORTED_MODULE_7__lib_regexContent__["a" /* regexContent */])(data,language);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:privacyPolicyClassName,id:privacyPolicyClassName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"page-privacy-policy",id:"page-privacy-policy"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section-title",id:"section-title-privacy-policy"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",{dangerouslySetInnerHTML:{__html:t("privacy.title")}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"privacy-policy-content",id:"privacy-policy-content"},content&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""+content.key},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{className:"static-content"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{dangerouslySetInnerHTML:{__html:content.content}}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo}));};PrivacyPolicy.defaultProps={companyInfo:null};PrivacyPolicy.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,claim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_6__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (PrivacyPolicy);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_regexContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__ = __webpack_require__(10);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* eslint-disable */var LegalNotice=function LegalNotice(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,claim=_ref.claim,companyInfo=_ref.companyInfo;var legalNoticeClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()("container-legal-notice",{open:page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["g" /* PAGE_LEGAL */]});var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),data=_useState2[0],setData=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__["h" /* getCmsStatic */])(page,language);case 2:response=_context.sent;setData(response);case 4:case"end":return _context.stop();}}},_callee,_this);}));return function fetchContent(){return _ref2.apply(this,arguments);};}();fetchContent();},[language,page]);var content=void 0;if(data){content=Object(__WEBPACK_IMPORTED_MODULE_6__lib_regexContent__["a" /* regexContent */])(data,language);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:legalNoticeClassName,id:legalNoticeClassName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"layout"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"page-legal-notice",id:"page-legal-notice"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section-title",id:"section-title-legal-notice"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",{dangerouslySetInnerHTML:{__html:t("legal.title")}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"legal-notice-content",id:"legal-notice-content"},content&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:""+content.key},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{className:"static-content"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{dangerouslySetInnerHTML:{__html:content.content}})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo}));};LegalNotice.defaultProps={companyInfo:null};LegalNotice.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,claim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (LegalNotice);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebinarHeader__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WebinarContent__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Form__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_fetchCmsContent__ = __webpack_require__(10);
var Webinar=function Webinar(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,page=_ref.page,subpage=_ref.subpage,consents=_ref.consents,claim=_ref.claim,companyInfo=_ref.companyInfo;var webinarClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('container-webinar',{open:page===__WEBPACK_IMPORTED_MODULE_4__config_pages__["k" /* PAGE_WEBINAR */]});var webinars=t('webinar.list');var webinarIndex=null;var webinar=null;if(subpage!==null){webinarIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(webinars,function(o){return o.slug===subpage;});if(webinarIndex!==-1){webinar=webinars[webinarIndex];}}if(webinar===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:webinarClassName,id:'container-webinar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__WebinarHeader__["a" /* default */],{webinar:webinar}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WebinarContent__["a" /* default */],{t:t,openPage:openPage,language:language,webinar:webinar,consents:consents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Form__["a" /* default */],{type:'bottom',t:t,language:language,formName:'webinar-bottom',typeButton:'offer',consents:consents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo}));};Webinar.defaultProps={subpage:null,companyInfo:null};Webinar.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired,claim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_9__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (Webinar);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var WebinarHeader=function WebinarHeader(_ref){var webinar=_ref.webinar;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-webinar-header',id:'container-webinar-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-webinar-header',id:'page-webinar-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-header-logo-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-header-logo',id:'webinar-header-logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-header',id:'webinar-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-header-title',id:'webinar-header-title'},webinar.header.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-header-subtitle',id:'webinar-header-subtitle'},webinar.header.subtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-header-date',id:'webinar-header-date'},webinar.header.date)))));};WebinarHeader.propTypes={webinar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired};/* harmony default export */ __webpack_exports__["a"] = (WebinarHeader);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WebinarForm__ = __webpack_require__(570);
var WebinarContent=function WebinarContent(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,webinar=_ref.webinar,consents=_ref.consents;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-webinar-content',id:'container-webinar-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-webinar-content',id:'page-webinar-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-content',id:'webinar-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-content-title',id:'webinar-content-title'},webinar.content.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'webinar-content-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_List__["a" /* default */],{data:webinar.content.list})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-content-bottom',id:'webinar-content-bottom',dangerouslySetInnerHTML:{__html:webinar.content.bottom_text}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__WebinarForm__["a" /* default */],{t:t,openPage:openPage,language:language,webinar:webinar,consents:consents}))));};WebinarContent.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,webinar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (WebinarContent);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Consent__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Recaptcha__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_pages__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_clarity__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_sentry__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable camelcase *//* eslint-disable max-len */var WebinarForm=function(_Component){_inherits(WebinarForm,_Component);function WebinarForm(props){_classCallCheck(this,WebinarForm);var _this=_possibleConstructorReturn(this,(WebinarForm.__proto__||Object.getPrototypeOf(WebinarForm)).call(this,props));_this.state={formType:'LemlockContactForm',name:'',surname:'',email:'',company:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,sending:false,error:{name:false,surname:false,email:false,company:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:null,errorType:null};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleRecaptchaError=_this.handleRecaptchaError.bind(_this);_this.handleServerError=_this.handleServerError.bind(_this);_this.reCaptchaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();return _this;}_createClass(WebinarForm,[{key:'handleRecaptchaError',value:function handleRecaptchaError(){this.setState({responseType:'error',errorType:'recaptcha_error'});}},{key:'handleServerError',value:function handleServerError(){this.setState({responseType:'error',errorType:'server'});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.type==='checkbox'?e.target.checked:e.target.value));}},{key:'handleSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _this2=this;var params,language,_state,name,surname,email,company,agreement_data,agreement_marketing,agreement_rodo,errorAll,error,emailRegExp,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();params={};if(window.location.search!==''){params=JSON.parse('{"'+decodeURI(window.location.search.substring(1)).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');}language=this.props.language;_state=this.state,name=_state.name,surname=_state.surname,email=_state.email,company=_state.company,agreement_data=_state.agreement_data,agreement_marketing=_state.agreement_marketing,agreement_rodo=_state.agreement_rodo;errorAll=false;error={name:false,surname:false,email:false,company:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false};error.name=name==='';errorAll=errorAll||error.name;error.surname=surname==='';errorAll=errorAll||error.surname;emailRegExp=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;// eslint-disable-line max-len
error.email=!emailRegExp.test(email);errorAll=errorAll||error.email;error.company=company==='';errorAll=errorAll||error.company;error.agreement_data=!agreement_data;errorAll=errorAll||error.agreement_data;error.agreement_rodo=!agreement_rodo;errorAll=errorAll||error.agreement_rodo;this.setState({error:error});token='';if(!(errorAll===false&&this.state.sending===false)){_context.next=26;break;}_context.next=25;return this.reCaptchaRef.current.executeAsync();case 25:token=_context.sent;case 26:if(errorAll===false&&this.state.sending===false&&token!==''){this.setState({sending:true},function(){__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:Object.assign({form_name:'Webinar formularz wyceny',type:_this2.state.formType,name:name.substring(0,50),surname:surname.substring(0,50),email:email.substring(0,100),company:company.substring(0,100),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,slug:_this2.props.webinar.slug,eventForm:'webinar',clarity_project_id:__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].getProjectId(),recaptcha:token,referrer:document.referrer,session_id:sessionStorage.getItem('session_id')},params),headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].setCorrelationId(response);__WEBPACK_IMPORTED_MODULE_8__helpers_clarity__["a" /* default */].setCustomAttributes(window.location.pathname);if(response.data&&response.data.success){_this2.setState({name:'',surname:'',email:'',company:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,error:{name:false,surname:false,email:false,company:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:'success',errorType:null});_this2.props.openPage(__WEBPACK_IMPORTED_MODULE_7__config_pages__["h" /* PAGE_OFFER */],null,null,language,true,{webinar:'subscribed'});}else{_this2.setState({error:Object.assign({},_this2.state.error,{name:!!response.data.error_name,surname:!!response.data.error_surname,email:!!response.data.error_email,company:!!response.data.error_company,agreement_data:!!response.data.error_agreement_data,agreement_marketing:!!response.data.error_agreement_marketing,agreement_rodo:!!response.data.error_agreement_rodo}),responseType:'error',errorType:response.data.error});}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_9__lib_sentry__["a" /* default */].captureException(err);var response=err.response;if(response.data.error==='RECAPTCHA_LOW_SCORE'||'RECAPTCHA_VALIDATION_ERROR'){_this2.handleRecaptchaError();}else{_this2.handleServerError();}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{form_info:JSON.stringify(Object.assign({form_name:'Webinar formularz wyceny',type:_this2.state.formType,name:name.substring(0,50),surname:surname.substring(0,50),email:email.substring(0,100),company:company.substring(0,100),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,slug:_this2.props.webinar.slug,eventForm:'webinar',recaptcha:token,referrer:document.referrer},params))},headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'}});}).finally(function(){_this2.setState({sending:false});if(_this2.reCaptchaRef)_this2.reCaptchaRef.current.reset();});});}else{this.setState({responseType:'error',errorType:'general_error'});}case 27:case'end':return _context.stop();}}},_callee,this);}));function handleSubmit(_x){return _ref.apply(this,arguments);}return handleSubmit;}()},{key:'render',value:function render(){var _state2=this.state,responseType=_state2.responseType,errorType=_state2.errorType,error=_state2.error;var _props=this.props,t=_props.t,consents=_props.consents,language=_props.language;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{method:'post',action:'',acceptCharset:'utf-8',className:'webinar-form',id:'webinar-form',onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'webinar-form-title'},t('webinar.form.title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'webinar-form-input-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'name',id:'webinar-form-input-field-01',value:this.state.name,placeholder:t('webinar.form.placeholder.name')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.name}),onChange:this.handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'webinar-form-input-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'surname',id:'webinar-form-input-field-02',value:this.state.surname,placeholder:t('webinar.form.placeholder.surname')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.surname}),onChange:this.handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'webinar-form-input-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',name:'email',id:'webinar-form-input-field-03',value:this.state.email,placeholder:t('webinar.form.placeholder.email')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.email}),onChange:this.handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-input',id:'webinar-form-input-04'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'company',id:'webinar-form-input-field-04',value:this.state.company,placeholder:t('webinar.form.placeholder.company')+' *',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.company}),onChange:this.handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'webinar-form-checkbox-01'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_data',id:'webinar_form_input_agreement_data',checked:this.state.agreement_data,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'webinar_form_input_agreement_data',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_data})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.contact.text,title:consents.contact.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'webinar-form-checkbox-02'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_marketing',id:'webinar_form_input_agreement_marketing',checked:this.state.agreement_marketing,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'webinar_form_input_agreement_marketing',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_marketing})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,content:consents.marketing.text,title:consents.marketing.label})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-checkbox',id:'webinar-form-checkbox-03'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'agreement_rodo',id:'webinar_form_input_agreement_rodo',checked:this.state.agreement_rodo,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'webinar_form_input_agreement_rodo',className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()({error:error.agreement_rodo})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Consent__["a" /* default */],{t:t,required:true,content:consents.rodo.text,title:consents.rodo.label})),errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-blue',id:'webinar-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'webinar-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('webinar.form.label.refresh'))):responseType!=='success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-button form-button-blue',id:'webinar-form-button-submit-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:this.state.sending,type:'submit',id:'webinar-form-button-submit'},t('webinar.form.label.button'))),responseType&&(responseType==='success'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message',responseType),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message',responseType)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+responseType))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error'),id:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-message','error')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,t('form.message.'+errorType)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Recaptcha__["a" /* default */],{ref:this.reCaptchaRef,language:language}));}}]);return WebinarForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);WebinarForm.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,webinar:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape().isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (WebinarForm);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WebinarSubscribed=function(_Component){_inherits(WebinarSubscribed,_Component);function WebinarSubscribed(props){_classCallCheck(this,WebinarSubscribed);var _this=_possibleConstructorReturn(this,(WebinarSubscribed.__proto__||Object.getPrototypeOf(WebinarSubscribed)).call(this,props));_this.state={open:false,show:false};return _this;}_createClass(WebinarSubscribed,[{key:'componentWillMount',value:function componentWillMount(){if(typeof this.props.query.webinar!=='undefined'&&this.props.query.webinar==='subscribed'){this.setState({show:true,open:true});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(typeof nextProps.query.webinar!=='undefined'&&nextProps.query.webinar==='subscribed'){this.setState({show:true,open:true});}else{this.setState({open:false},function(){setTimeout(function(){return _this2.setState({show:false});},550);});}}},{key:'render',value:function render(){var _state=this.state,open=_state.open,show=_state.show;if(open===false&&show===false){return null;}var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language,page=_props.page,subpage=_props.subpage;var downloadClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('container-webinar-subscribed',{open:this.state.open});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:downloadClassName,id:'container-webinar-subscribed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-webinar-subscribed',id:'page-webinar-subscribed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webinar-subscribed-text',id:'webinar-subscribed-text',dangerouslySetInnerHTML:{__html:t('webinar.subscribed.text')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Link__["a" /* default */],{openPage:openPage,language:language,page:page,subpage:subpage,className:'webinar-subscribed-close',id:'webinar-subscribed-close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line-1',id:'webinar-subscribed-line-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line-2',id:'webinar-subscribed-line-2'})))));}}]);return WebinarSubscribed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WebinarSubscribed.defaultProps={subpage:null,query:{}};WebinarSubscribed.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subpage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,query:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};/* harmony default export */ __webpack_exports__["a"] = (WebinarSubscribed);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__about_AboutHeader__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__about_AboutValues__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__about_AboutMissionVision__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__about_AboutPerspectives__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__about_AboutTeam__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__about_AboutClutch__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__about_AboutTeamImage__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_directusLink__ = __webpack_require__(18);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var About=function About(_ref){var t=_ref.t,openPage=_ref.openPage,language=_ref.language,claim=_ref.claim,companyInfo=_ref.companyInfo;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),content=_useState2[0],setContent=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10__helpers_fetchCmsContent__["b" /* getAboutContent */])();case 2:data=_context.sent;setContent(data);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function fetchContent(){return _ref2.apply(this,arguments);};}();fetchContent();},[]);var values=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){if(!content)return[];var valueItems=content.values.map(function(el){return el.brand_value_id;});return valueItems.map(function(el){return Object.assign({icon:el.icon},__WEBPACK_IMPORTED_MODULE_12__helpers_directusLink__["a" /* default */].getTranslationByLang(el.translations,language,['name','description']));});},[content,language]);var contentTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){if(!content)return{};return __WEBPACK_IMPORTED_MODULE_12__helpers_directusLink__["a" /* default */].getTranslationByLang(content.translations,language,['about','vision','story','mission']);},[content,language]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-about'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__about_AboutHeader__["a" /* default */],{t:t,text:contentTranslation.about||''}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__about_AboutTeam__["a" /* default */],{t:t,story:contentTranslation.story||''}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__about_AboutValues__["a" /* default */],{t:t,values:values}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__about_AboutMissionVision__["a" /* default */],{t:t,mission:contentTranslation.mission||'',vision:contentTranslation.vision||''}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__about_AboutPerspectives__["a" /* default */],{t:t,language:language}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__about_AboutTeamImage__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__about_AboutClutch__["a" /* default */],{t:t}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:claim,companyInfo:companyInfo}));};About.defaultProps={companyInfo:null};About.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,claim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_10__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var AboutHeader=function AboutHeader(_ref){var text=_ref.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-titles',dangerouslySetInnerHTML:{__html:text}});};AboutHeader.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AboutHeader);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_directusLink__ = __webpack_require__(18);
var AboutValues=function AboutValues(_ref){var t=_ref.t,values=_ref.values;var list=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return values.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'about-value about-value-'+(i+1),style:{top:el.x,left:el.y}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-values-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__helpers_directusLink__["a" /* default */].getLinkImage(el.icon),alt:el.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,el.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:el.description}}));});},[values]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-values'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-values-content'},list[0],list[1],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-values-circle1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-values-circle2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-values-circle3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,t('about.values.title'))))),list[2],list[3]));};AboutValues.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,values:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (AboutValues);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_icons__ = __webpack_require__(12);
var AboutMissionVision=function AboutMissionVision(_ref){var t=_ref.t,mission=_ref.mission,vision=_ref.vision;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-mission-vision'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-mission-vision-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-mission-vision-texts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-mission',dangerouslySetInnerHTML:{__html:mission}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-vision',dangerouslySetInnerHTML:{__html:vision}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-verified'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-verified-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,t('about.mission_vision.verified.text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'about-verified-icon',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_2__data_icons__["a" /* default */].about.lock}})))));};AboutMissionVision.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,mission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,vision:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AboutMissionVision);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_CapitalText__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_directusLink__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_about_blank_webp__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_about_blank_webp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_about_blank_webp__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* eslint-disable max-len */var getCMSlinkImage=function getCMSlinkImage(id){var extention=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return "https://directus.sagiton.pl"+'/assets/'+id+extention;};var AboutPerspectives=function AboutPerspectives(_ref){var t=_ref.t,language=_ref.language;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),employees=_useState2[0],setEmplyee=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var fetchData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_fetchCmsContent__["e" /* getCMSEmployee */])();case 2:data=_context.sent;setEmplyee(data);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function fetchData(){return _ref2.apply(this,arguments);};}();fetchData();},[]);var employeesByTranslation=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return employees.map(function(_ref3){var translations=_ref3.translations,employee=_objectWithoutProperties(_ref3,['translations']);var translation=__WEBPACK_IMPORTED_MODULE_6__helpers_directusLink__["a" /* default */].getTranslationByLang(translations,language,['position']);return Object.assign({},employee,translation);});},[language,employees]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'about-perspectives-title'},t('about.perspectives.title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives-people'},employeesByTranslation.map(function(elem){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives-person',key:elem.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'about-perspectives-image',src:elem.photo?getCMSlinkImage(elem.photo):__WEBPACK_IMPORTED_MODULE_7__assets_images_about_blank_webp___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives-icon'},elem.icon?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'about-perspectives-image',src:getCMSlinkImage(elem.icon),alt:''}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives-image'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'about-perspectives-person-occupation'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_CapitalText__["a" /* default */],{text:typeof elem.position==='string'?elem.position:''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-perspectives-data'},__WEBPACK_IMPORTED_MODULE_3__data_icons__["a" /* default */].social.linkedin?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'about-perspectives-data-icon',href:elem.linkedin,target:'_blank',rel:'noopener noreferrer',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_3__data_icons__["a" /* default */].social.linkedin}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'about-perspectives-person-name'},elem.name||'',elem.name&&elem.surname?' ':'',elem.surname||''))));})));};AboutPerspectives.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AboutPerspectives);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CapitalText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* eslint-disable no-nested-ternary */function CapitalText(_ref){var text=_ref.text;if(!text)return' ';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,text[0].toUpperCase()+text.slice(1,text.length));}CapitalText.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/blank.f8fffb99.webp";

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_icons__ = __webpack_require__(12);
// import Text from '../../helpers/Text';
var AboutTeam=function AboutTeam(_ref){var t=_ref.t,story=_ref.story;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-team'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-team-texts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'about-team-title'},t('about.team.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-team-content',dangerouslySetInnerHTML:{__html:story}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'about-team-icon',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_2__data_icons__["a" /* default */].about.lemlock}}));};AboutTeam.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,story:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AboutTeam);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* componentDidMount() {
    const script = document.createElement('script');

    script.id = 'clutch-widget-script';
    script.src = 'https://widget.clutch.co/static/js/widget.js';
    script.async = true;

    document.body.appendChild(script);
}
<div
    className="clutch-widget"
    data-url="https://widget.clutch.co"
    data-widget-type="4"
    data-expandifr="true"
    data-height="auto"
    data-snippets="true"
    data-clutchcompany-id="751898"
/> */var AboutClutch=function AboutClutch(_ref){var t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-clutch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,t('about.clutch.title'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-clutch-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://clutch.co/profile/lemlock#highlights',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{srcSet:__webpack_require__(581),media:'(max-width: 767px)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{srcSet:__webpack_require__(582),media:'(min-width: 768px) and (max-width: 1023px)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{srcSet:__webpack_require__(121),media:'(min-width: 1024px)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(121),alt:'Clutch'})))));};AboutClutch.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AboutClutch);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clutch-mobile.a9941388.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clutch-tablet.5ff9d516.png";

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AboutTeamImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function AboutTeamImage(){return  false?React.createElement('div',{className:'about-team-image-de'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-team-image'});}

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_sentry__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__estimation_EstimationForm__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_scrollToElement__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_clarity__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable camelcase *//* eslint-disable max-len */var formConvertObjectToString=function formConvertObjectToString(objElem){if(objElem===undefined||objElem===null){return'brak danych';}return Object.keys(objElem).filter(function(key){return objElem[key];}).join(', ');};var Estimation=function(_Component){_inherits(Estimation,_Component);function Estimation(props){_classCallCheck(this,Estimation);var _this=_possibleConstructorReturn(this,(Estimation.__proto__||Object.getPrototypeOf(Estimation)).call(this,props));_this.state={formType:'LemlockContactForm',radioButton:'',improve:null,decrease:null,name:'',email:'',phone:'',message:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,sending:false,error:{name:false,email:false,phone:false,message:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:null,errorType:null,pricings:[]};_this.handleChangeRadio=_this.handleChangeRadio.bind(_this);_this.handleChangeCheckbox=_this.handleChangeCheckbox.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleRecaptchaError=_this.handleRecaptchaError.bind(_this);_this.handleServerError=_this.handleServerError.bind(_this);_this.fetchPricings=_this.fetchPricings.bind(_this);_this.isFirstLoad=false;_this.reCaptchaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();return _this;}_createClass(Estimation,[{key:'componentWillMount',value:function componentWillMount(){this.setState(this.initialState());}},{key:'componentDidMount',value:function componentDidMount(){this.fetchPricings();this.isFirstLoad=true;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.preloaderDone!==prevProps.preloaderDone&&this.props.preloaderDone===true){if(this.isFirstLoad&&this.state.radioButton===''){window.scrollTo({top:0,left:0,behavior:'smooth'});this.isFirstLoad=false;}else if(this.isFirstLoad&&this.state.radioButton!==''){Object(__WEBPACK_IMPORTED_MODULE_8__helpers_scrollToElement__["a" /* scrollToElement */])('pricing-scroll');this.isFirstLoad=false;}}}},{key:'initialState',value:function initialState(){var t=this.props.t;var improve={};t('estimation.improve').forEach(function(section){improve[section.slug]={};section.option.forEach(function(elem){improve[section.slug][elem.slug]=false;});});var decrease={};t('estimation.decrease').forEach(function(section){decrease[section.slug]={};section.option.forEach(function(elem){decrease[section.slug][elem.slug]=false;});});return{radioButton:'',improve:improve,decrease:decrease,name:'',email:'',phone:'',message:'',agreement_data:false,agreement_marketing:false,agreement_rodo:false,error:{name:false,email:false,message:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false},responseType:null,errorType:null};}},{key:'fetchPricings',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var pricings,searchParams;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__["j" /* getPricings */])(this.props.language);case 2:pricings=_context.sent;this.setState({pricings:pricings});searchParams=new URLSearchParams(window.location.search);this.setState({radioButton:searchParams.get('pricing')||''});case 6:case'end':return _context.stop();}}},_callee,this);}));function fetchPricings(){return _ref.apply(this,arguments);}return fetchPricings;}()},{key:'handleRecaptchaError',value:function handleRecaptchaError(){this.setState({responseType:'error',errorType:'recaptcha_error'});}},{key:'handleServerError',value:function handleServerError(){this.setState({responseType:'error',errorType:'server_error'});}},{key:'handleChangeRadio',value:function handleChangeRadio(e){this.setState({radioButton:e.target.value,responseType:null});}},{key:'handleChangeCheckbox',value:function handleChangeCheckbox(part,section){var _this2=this;return function(e){_this2.setState(_defineProperty({},part,Object.assign({},_this2.state[part],_defineProperty({},section,Object.assign({},_this2.state[part][section],_defineProperty({},e.target.name,e.target.checked))))));};}},{key:'handleChange',value:function handleChange(e){switch(e.target.type){case'checkbox':{this.setState(_defineProperty({},e.target.name,e.target.checked));break;}case'textarea':{this.setState(_defineProperty({},e.target.name,e.target.value.substring(0,10000)));break;}default:{this.setState(_defineProperty({},e.target.name,e.target.value));break;}}}},{key:'handleSubmit',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var _this3=this;var params,language,_state,radioButton,improve,decrease,name,email,phone,message,agreement_data,agreement_marketing,agreement_rodo,errorAll,error,emailRegExp,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:e.preventDefault();params={};if(window.location.search!==''){params=JSON.parse('{"'+decodeURI(window.location.search.substring(1)).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');}language=this.props.language;_state=this.state,radioButton=_state.radioButton,improve=_state.improve,decrease=_state.decrease,name=_state.name,email=_state.email,phone=_state.phone,message=_state.message,agreement_data=_state.agreement_data,agreement_marketing=_state.agreement_marketing,agreement_rodo=_state.agreement_rodo;errorAll=false;error={name:false,email:false,agreement_data:false,agreement_marketing:false,agreement_rodo:false};error.radioButton=!radioButton;errorAll=errorAll||error.radioButton;error.name=name==='';errorAll=errorAll||error.name;emailRegExp=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;// eslint-disable-line max-len
error.email=!emailRegExp.test(email);errorAll=errorAll||error.email;error.agreement_data=!agreement_data;errorAll=errorAll||error.agreement_data;error.agreement_rodo=!agreement_rodo;errorAll=errorAll||error.agreement_rodo;this.setState({error:error});token='';if(!(errorAll===false&&this.state.sending===false)){_context2.next=24;break;}_context2.next=23;return this.reCaptchaRef.current.executeAsync();case 23:token=_context2.sent;case 24:if(errorAll===false&&this.state.sending===false&&token!==''&&token!==''){this.setState({sending:true},function(){__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:Object.assign({form_name:'Formularz wyceny',type:_this3.state.formType,improve:radioButton==='improve'?Object.entries(improve).map(function(imp){return formConvertObjectToString(imp[1]);}).filter(function(v){return v!=='';}).join(', '):'brak danych',decrease:radioButton==='decrease'?Object.entries(decrease).map(function(dec){return formConvertObjectToString(dec[1]);}).filter(function(v){return v!=='';}).join(', '):'brak danych',name:name.substring(0,50),email:email.substring(0,100),phone:phone.substring(0,20),message:message.substring(0,10000),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,clarity_project_id:__WEBPACK_IMPORTED_MODULE_9__helpers_clarity__["a" /* default */].getProjectId(),session_id:sessionStorage.getItem('session_id'),recaptcha:token,referrer:document.referrer},params),headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){__WEBPACK_IMPORTED_MODULE_9__helpers_clarity__["a" /* default */].setCorrelationId(response);__WEBPACK_IMPORTED_MODULE_9__helpers_clarity__["a" /* default */].setCustomAttributes(window.location.pathname);if(response.data&&response.data.success){_this3.setState(Object.assign({},_this3.initialState(),{radioButton:radioButton,responseType:'success'}));}else{_this3.setState({error:{name:!!response.data.error_name,email:!!response.data.error_email,phone:!!response.data.error_phone,message:!!response.data.error_message,agreement_data:!!response.data.error_agreement_data,agreement_marketing:!!response.data.error_agreement_marketing,agreement_rodo:!!response.data.error_agreement_rodo},responseType:'error',errorType:response.data.error});}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__lib_sentry__["a" /* default */].captureException(err);var response=err.response;if(response.data.error==='RECAPTCHA_LOW_SCORE'||'RECAPTCHA_VALIDATION_ERROR'){_this3.handleRecaptchaError();}else{_this3.handleServerError();}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:"https://opportunity.sagiton.pl/api/opportunity",data:{form_info:JSON.stringify(Object.assign({form_name:'Formularz wyceny',type:_this3.state.formType,improve:radioButton==='improve'?Object.entries(improve).map(function(imp){return formConvertObjectToString(imp[1]);}).filter(function(v){return v!=='';}).join(', '):'brak danych',decrease:radioButton==='decrease'?Object.entries(decrease).map(function(dec){return formConvertObjectToString(dec[1]);}).filter(function(v){return v!=='';}).join(', '):'brak danych',name:name.substring(0,50),email:email.substring(0,100),phone:phone.substring(0,20),message:message.substring(0,10000),agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,language:language,recaptcha:token,referrer:document.referrer},params))},headers:{'X-Requested-With':'XMLHttpRequest'}});}).finally(function(){if(_this3.reCaptchaRef)_this3.reCaptchaRef.current.reset();_this3.setState({sending:false});});});}else{this.setState({responseType:'error',errorType:'general_error'});}case 25:case'end':return _context2.stop();}}},_callee2,this);}));function handleSubmit(_x){return _ref2.apply(this,arguments);}return handleSubmit;}()},{key:'render',value:function render(){var _state2=this.state,radioButton=_state2.radioButton,improve=_state2.improve,decrease=_state2.decrease,responseType=_state2.responseType,errorType=_state2.errorType,error=_state2.error;var _props=this.props,t=_props.t,openPage=_props.openPage,language=_props.language,consents=_props.consents,companyInfo=_props.companyInfo;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-estimation'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'estimation-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'estimation-header-title'},t('estimation.header.main'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__estimation_EstimationForm__["a" /* default */],{t:t,improve:improve,decrease:decrease,improveSlug:'improve',decreaseSlug:'decrease',radioButton:radioButton,handleSubmit:this.handleSubmit,handleChangeRadio:this.handleChangeRadio,handleChangeCheckbox:this.handleChangeCheckbox,handleChange:this.handleChange,name:this.state.name,email:this.state.email,phone:this.state.phone,message:this.state.message,agreement_data:this.state.agreement_data,agreement_marketing:this.state.agreement_marketing,agreement_rodo:this.state.agreement_rodo,error:error,responseType:responseType,errorType:errorType,consents:consents,sending:this.state.sending,pricings:this.state.pricings,language:language,ref:this.reCaptchaRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Footer__["a" /* default */],{t:t,openPage:openPage,language:language,claim:this.props.claim,companyInfo:companyInfo}));}}]);return Estimation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Estimation.defaultProps={companyInfo:null};Estimation.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,openPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,language:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,preloaderDone:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,consents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(Object).isRequired,claim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,companyInfo:__WEBPACK_IMPORTED_MODULE_7__helpers_fetchCmsContent__["a" /* companyInfoPropsType */]};/* harmony default export */ __webpack_exports__["a"] = (Estimation);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_FormOptions__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_FormInputs__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EstimationHeader__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Recaptcha__ = __webpack_require__(23);
/* eslint-disable camelcase *//* eslint-disable max-len */var EstimationForm=Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function(_ref,ref){var t=_ref.t,radioButton=_ref.radioButton,handleSubmit=_ref.handleSubmit,handleChangeRadio=_ref.handleChangeRadio,handleChange=_ref.handleChange,name=_ref.name,email=_ref.email,phone=_ref.phone,message=_ref.message,agreement_data=_ref.agreement_data,agreement_marketing=_ref.agreement_marketing,agreement_rodo=_ref.agreement_rodo,error=_ref.error,responseType=_ref.responseType,errorType=_ref.errorType,consents=_ref.consents,sending=_ref.sending,pricings=_ref.pricings,language=_ref.language;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{method:'post',action:'',acceptCharset:'utf-8',className:'estimation-form',onSubmit:handleSubmit,noValidate:true},pricings&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_FormOptions__["a" /* default */],{t:t,options:pricings,handleChangeRadio:handleChangeRadio,error:error,radioButton:radioButton,language:language}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'show-form':radioButton.trim().length>0},{'hide-form':radioButton.trim().length===0})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EstimationHeader__["a" /* default */],{t:t}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_FormInputs__["a" /* default */],{t:t,handleChange:handleChange,name:name,email:email,phone:phone,message:message,agreement_data:agreement_data,agreement_marketing:agreement_marketing,agreement_rodo:agreement_rodo,error:error,responseType:responseType,errorType:errorType,consents:consents,sending:sending}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Recaptcha__["a" /* default */],{ref:ref,language:language}))));});EstimationForm.defaultProps={responseType:null,errorType:null};EstimationForm.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,radioButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeRadio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,phone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,agreement_data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,agreement_marketing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,agreement_rodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,responseType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,errorType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired,sending:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,pricings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()).isRequired,language:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EstimationForm);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormOption__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pricing_Pricing__ = __webpack_require__(588);
var FormOptions=function FormOptions(_ref){var t=_ref.t,options=_ref.options,handleChangeRadio=_ref.handleChangeRadio,error=_ref.error,radioButton=_ref.radioButton;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'estimation-form-options'},options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormOption__["a" /* default */],{key:index,option:option,t:t,error:error,handleChangeRadio:handleChangeRadio,radioButton:radioButton,total:options.length});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pricing-scroll'}),radioButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pricing_Pricing__["a" /* default */],{currentPricing:options.find(function(option){return option.key===radioButton;})})));};FormOptions.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,brochure_cta_text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),brochure:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({brochure:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,brochure_cta_text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,button_cta_text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,duration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subtitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),features:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})}))}))})).isRequired,handleChangeRadio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,radioButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FormOptions);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_scrollToElement__ = __webpack_require__(122);
var API_URL="https://directus.sagiton.pl";var FormOption=function FormOption(_ref){var option=_ref.option,handleChangeRadio=_ref.handleChangeRadio,error=_ref.error,radioButton=_ref.radioButton,total=_ref.total;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('estimation-form-container',{'animation-in':radioButton===option.translations.name},{'container-2':total===2},{'container-3':total>=3&&total%3===0},{'container-4':total>=3&&total%3===1},{'container-5':total>=3&&total%3===2})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'radioButton',id:option.key,value:option.key,onChange:function onChange(e){handleChangeRadio(e);Object(__WEBPACK_IMPORTED_MODULE_4__helpers_scrollToElement__["a" /* scrollToElement */])('pricing-scroll');},checked:radioButton===option.key,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('estimation-form-input',{error:error.name})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:option.key,className:'estimation-form-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icon',alt:'pricing type icon',src:API_URL+'/assets/'+option.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},option.translations.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'check',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_3__data_icons__["a" /* default */].estimation.check}}))));};FormOption.propTypes={option:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pricingItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape())}).isRequired,handleChangeRadio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,radioButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FormOption);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureSet__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Brochure__ = __webpack_require__(590);
var API_URL="https://directus.sagiton.pl";var Pricing=function Pricing(_ref){var currentPricing=_ref.currentPricing;var items=currentPricing.items,brochure=currentPricing.brochure;var shortText=currentPricing.translations.brochure_cta_text;var allFeatureSets=new Set();items.forEach(function(item){allFeatureSets.add(item.translations.title);});var scrollToElement=function scrollToElement(id){var element=document.getElementById(id);element.scrollIntoView({behavior:'smooth'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-container'},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'pricing-plan-'+index,className:'pricing-plan'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-plan-title item-'+index%3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:item.translations.title}}),item.translations.subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-plan-subtitle',dangerouslySetInnerHTML:{__html:item.translations.subtitle}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-plan-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-amount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price-currency'},'\u20AC'),item.translations.price),item.translations.duration&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,item.translations.duration)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Array.from(allFeatureSets.values()).map(function(featureSet,featureIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-plan-feature-set',key:'feature-set-'+featureIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeatureSet__["a" /* default */],{featureSet:featureSet,featureIndex:featureIndex,item:featureIndex<=index?items[featureIndex]:null}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-plan-button-wrapper item-'+index%3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return scrollToElement('estimation-form-inputs-bg');},className:'pricing-plan-button '},item.translations.button_cta_text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pricing-plan-brochure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:API_URL+'/assets/'+item.translations.brochure,target:'_blank',rel:'noopener noreferrer'},item.translations.brochure_cta_text)));})),brochure&&brochure.type==='file'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Brochure__["a" /* default */],{brochure:brochure,shortText:shortText}));};Pricing.propTypes={currentPricing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()).isRequired,brochure:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()}),translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({shortText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Pricing);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/* eslint-disable max-len */var FeatureSet=function FeatureSet(_ref){var featureSet=_ref.featureSet,featureIndex=_ref.featureIndex,item=_ref.item;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),listOpen=_useState2[0],setListOpen=_useState2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feature-set-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'feature-set-button',onClick:function onClick(){return setListOpen(!listOpen);},disabled:!item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feature-set-button-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:featureSet}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'feature-set-button-subtext'},'features')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('feature-set-button-arrow',{'dropdown-open':listOpen})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('features-dropdown',{'dropdown-open':listOpen})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({'dropdown-hidden':!listOpen})},item?item.features.map(function(feature){return feature.translations.tooltip?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'feature-'+featureIndex+'-'+feature.translations.name,className:'dropdown-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'with-tooltip'},feature.translations.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dropdown-item-tooltip'},feature.translations.tooltip,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{x:'0px',y:'0px',viewBox:'0 0 255 255'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'0,0 127.5,127.5 255,0'}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'feature-'+featureIndex+'-'+feature.translations.name,className:'dropdown-item'},feature.translations.name);}):null)));};FeatureSet.propTypes={featureSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,featureIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()};FeatureSet.defaultProps={item:null};/* harmony default export */ __webpack_exports__["a"] = (FeatureSet);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Brochure;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var API_URL="https://directus.sagiton.pl";function Brochure(_ref){var brochure=_ref.brochure,shortText=_ref.shortText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brochure'},shortText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'brochure-short-text'},shortText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:API_URL+'/assets/'+brochure.file.filename_disk,download:brochure.file.filename_download,className:'brochure-link',target:'_blank',rel:'noopener noreferrer'},brochure.translations.text));}Brochure.propTypes={brochure:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()}).isRequired,shortText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Brochure.defaultProps={shortText:null};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Consent__ = __webpack_require__(22);
/* eslint-disable camelcase *//* eslint-disable max-len */var FormInputs=function FormInputs(_ref){var t=_ref.t,handleChange=_ref.handleChange,name=_ref.name,email=_ref.email,phone=_ref.phone,message=_ref.message,agreement_data=_ref.agreement_data,agreement_marketing=_ref.agreement_marketing,agreement_rodo=_ref.agreement_rodo,error=_ref.error,responseType=_ref.responseType,errorType=_ref.errorType,consents=_ref.consents,sending=_ref.sending;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'estimation-form-inputs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'estimation-form-inputs-bg',id:'estimation-form-inputs-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__webpack_require__(108),alt:'Lemlock threats'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-input-field-01'},t('estimation.form.name')+' *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'name',id:'contact-form-input-field-01',value:name,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.name}),onChange:handleChange,maxLength:50})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-input-field-02'},t('estimation.form.mail')+' *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',name:'email',id:'contact-form-input-field-02',value:email,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.email}),onChange:handleChange,maxLength:100})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-input',id:'contact-form-input-03'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-input-field-03'},t('estimation.form.phone')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'phone',id:'contact-form-input-field-03',value:phone,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.phone}),onChange:handleChange,maxLength:20})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-textarea',id:'contact-form-textarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-textarea-field'},t('estimation.form.message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'message',id:'contact-form-textarea-field',value:message,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.message}),onChange:handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-checkboxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-checkbox',id:'contact-form-checkbox-01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'agreement_data',id:'contact-form-checkbox-agree-data',checked:agreement_data,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-checkbox-agree-data',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.agreement_data})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Consent__["a" /* default */],{t:t,required:true,content:consents.contact.text,title:consents.contact.label})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-checkbox',id:'contact-form-checkbox-02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'agreement_marketing',id:'contact-form-checkbox-agree-marketing',checked:agreement_marketing,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-checkbox-agree-marketing',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.agreement_marketing})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Consent__["a" /* default */],{t:t,content:consents.marketing.text,title:consents.marketing.label})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-checkbox',id:'contact-form-checkbox-03'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'agreement_rodo',id:'contact-form-checkbox-agree-rodo',checked:agreement_rodo,onChange:handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'contact-form-checkbox-agree-rodo',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()({error:error.agreement_rodo})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Consent__["a" /* default */],{t:t,required:true,content:consents.rodo.text,title:consents.rodo.label}))),errorType==='recaptcha_error'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-button form-button-gray',id:'contact-form-button-refresh-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'contact-form-button-refresh',onClick:function onClick(){return window.location.reload();}},t('estimation.form.refresh'))):responseType!=='success'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-button form-button-gray',id:'contact-form-button-submit-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:sending,type:'submit',id:'contact-form-button-submit'},t('estimation.form.send'))),responseType&&(responseType==='success'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-message',responseType),id:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-message',responseType)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('form.message.'+responseType))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-message','error'),id:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-message','error')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('form.message.'+errorType)))));};FormInputs.defaultProps={responseType:null,errorType:null};FormInputs.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,phone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,agreement_data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,agreement_marketing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,agreement_rodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,responseType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,errorType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,consents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(Object).isRequired,sending:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FormInputs);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var EstimationHeader=function EstimationHeader(_ref){var t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'estimation-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'estimation-header-title'},t('estimation.header.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'estimation-header-subtitle'},t('estimation.header.subtitle')));};EstimationHeader.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EstimationHeader);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.f46caab4.js